(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4155],{

/***/ 58978:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){return function(){"use strict";var e={27:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.FORM_BASE_URL=t.POPUP_SIZE=t.SLIDER_WIDTH=t.SLIDER_POSITION=t.SIDETAB_ATTRIBUTE=t.WIDGET_ATTRIBUTE=t.SLIDER_ATTRIBUTE=t.POPUP_ATTRIBUTE=t.POPOVER_ATTRIBUTE=void 0,t.POPOVER_ATTRIBUTE="data-tf-popover",t.POPUP_ATTRIBUTE="data-tf-popup",t.SLIDER_ATTRIBUTE="data-tf-slider",t.WIDGET_ATTRIBUTE="data-tf-widget",t.SIDETAB_ATTRIBUTE="data-tf-sidetab",t.SLIDER_POSITION="right",t.SLIDER_WIDTH=800,t.POPUP_SIZE=100,t.FORM_BASE_URL="https://form.typeform.com"},528:function(e,t,n){var o=this&&this.__assign||function(){return(o=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.createPopover=void 0;var r=n(747),i=n(320),a=function(e,t){var n=e.parentNode;n&&(n.removeChild(e),n.appendChild(t))},u=function(e,t){void 0===e&&(e="div"),void 0===t&&(t="tf-v1-popover-button-icon");var n=document.createElement(e);return n.className=t+" tf-v1-close-icon",n.innerHTML="&times;",n.dataset.testid=t,n},s={buttonColor:"#3a7685"};t.createPopover=function(e,t){void 0===t&&(t={});var n,c,d,l=o(o({},s),t),f=r.createIframe(e,"popover",l),p=f.iframe,v=f.embedId,m=f.refresh,h=function(e,t){var n=document.createElement("div");return n.className="tf-v1-popover",n.dataset.testid="tf-v1-popover",r.setElementSize(n,{width:e,height:t})}(l.width,l.height),b=function(){var e=document.createElement("div");return e.className="tf-v1-popover-wrapper",e.dataset.testid="tf-v1-popover-wrapper",e}(),y=function(e,t){var n=r.getTextColor(t),o=document.createElement("div");o.className="tf-v1-popover-button-icon";var i='<svg class="default" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5\n    9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75\n    7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25\n    7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125\n    17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="'+n+'"></path>\n  </svg>',a=null==e?void 0:e.startsWith("http");return o.innerHTML=a?"<img alt='popover trigger icon button' src='"+e+"'/>":null!=e?e:i,o.dataset.testid="default-icon",o}(l.customIcon,l.buttonColor||s.buttonColor),g=function(){var e=document.createElement("div");e.className="tf-v1-spinner";var t=document.createElement("div");return t.className="tf-v1-popover-button-icon",t.dataset.testid="spinner-icon",t.append(e),t}(),w=u(),O=u("a","tf-v1-popover-close"),_=function(e){var t=r.getTextColor(e),n=document.createElement("button");return n.className="tf-v1-popover-button",n.dataset.testid="tf-v1-popover-button",n.style.backgroundColor=e,n.style.color=t,n}(l.buttonColor||s.buttonColor);(l.container||document.body).append(h),b.append(p),h.append(_),h.append(O),_.append(y);var E=function(){c&&c.parentNode&&(c.classList.add("closing"),setTimeout((function(){r.unmountElement(c)}),250))};l.tooltip&&l.tooltip.length>0&&(c=function(e,t){var n=document.createElement("span");n.className="tf-v1-popover-tooltip-close",n.dataset.testid="tf-v1-popover-tooltip-close",n.innerHTML="&times;",n.onclick=t;var o=document.createElement("div");o.className="tf-v1-popover-tooltip-text",o.innerHTML=e;var r=document.createElement("div");return r.className="tf-v1-popover-tooltip",r.dataset.testid="tf-v1-popover-tooltip",r.appendChild(o),r.appendChild(n),r}(l.tooltip,E),h.append(c)),l.notificationDays&&(l.enableSandbox||i.canBuildNotificationDot(e))&&(d=i.buildNotificationDot(),_.append(d)),p.onload=function(){h.classList.add("open"),b.style.opacity="1",O.style.opacity="1",a(g,w),r.addCustomKeyboardListener(j)};var P=r.makeAutoResize(h),C=function(){r.isOpen(b)||(E(),d&&(d.classList.add("closing"),l.notificationDays&&!l.enableSandbox&&i.saveNotificationDotHideUntilTime(e,l.notificationDays),setTimeout((function(){r.unmountElement(d)}),250)),P(),window.addEventListener("resize",P),setTimeout((function(){r.isInPage(b)?(b.style.opacity="0",O.style.opacity="0",b.style.display="flex",setTimeout((function(){h.classList.add("open"),b.style.opacity="1",O.style.opacity="1"})),a(y,w)):(h.append(b),a(y,g),b.style.opacity="0",O.style.opacity="0")})))},j=function(){var e;r.isOpen(h)&&(null===(e=t.onClose)||void 0===e||e.call(t),setTimeout((function(){l.keepSession?b.style.display="none":r.unmountElement(b),h.classList.remove("open"),a(w,y)}),250))};r.setAutoClose(v,l.autoClose,j);var I=function(){r.isOpen(b)?j():C()};return _.onclick=I,O.onclick=j,l.open&&!r.isOpen(b)&&(n=r.handleCustomOpen(C,l.open,l.openValue)),{open:C,close:j,toggle:I,refresh:m,unmount:function(){r.unmountElement(h),window.removeEventListener("resize",P),l.open&&(null==n?void 0:n.remove)&&n.remove()}}}},797:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(528),t),r(n(100),t)},320:function(e,t){var n=this&&this.__assign||function(){return(n=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.buildNotificationDot=t.canBuildNotificationDot=t.saveNotificationDotHideUntilTime=void 0;var o="tfNotificationData",r=function(){var e=localStorage.getItem(o);return e?JSON.parse(e):{}},i=function(e){e&&localStorage.setItem(o,JSON.stringify(e))};t.saveNotificationDotHideUntilTime=function(e,t){var o,a=new Date;a.setDate(a.getDate()+t),i(n(n({},r()),((o={})[e]={hideUntilTime:a.getTime()},o)))},t.canBuildNotificationDot=function(e){var t=function(e){var t;return(null===(t=r()[e])||void 0===t?void 0:t.hideUntilTime)||0}(e);return(new Date).getTime()>t&&(t&&function(e){var t=r();delete t[e],i(t)}(e),!0)},t.buildNotificationDot=function(){var e=document.createElement("span");return e.className="tf-v1-popover-unread-dot",e.dataset.testid="tf-v1-popover-unread-dot",e}},100:function(e,t){Object.defineProperty(t,"__esModule",{value:!0})},630:function(e,t,n){var o=this&&this.__rest||function(e,t){var n={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(e);r<o.length;r++)t.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(e,o[r])&&(n[o[r]]=e[o[r]])}return n};Object.defineProperty(t,"__esModule",{value:!0}),t.createPopup=void 0;var r=n(747),i=n(27),a=n(747);t.createPopup=function(e,t){if(void 0===t&&(t={}),!r.hasDom())return{open:function(){},close:function(){},toggle:function(){},refresh:function(){},unmount:function(){}};var n,u=t.width,s=t.height,c=t.size,d=void 0===c?i.POPUP_SIZE:c,l=t.onClose,f=o(t,["width","height","size","onClose"]),p=r.createIframe(e,"popup",f),v=p.iframe,m=p.embedId,h=p.refresh,b=document.body.style.overflow,y=function(){var e=document.createElement("div");return e.className="tf-v1-popup",e.dataset.testid="tf-v1-popup",e.style.opacity="0",e}(),g=function(){var e=document.createElement("div");return e.className="tf-v1-spinner",e}(),w=function(e,t,n){var o=document.createElement("div");return o.className="tf-v1-iframe-wrapper",o.style.opacity="0",r.isDefined(e)&&r.isDefined(t)?r.setElementSize(o,{width:e,height:t}):(o.style.width="calc("+n+"% - 80px)",o.style.height="calc("+n+"% - 80px)",o)}(u,s,d);w.append(v),y.append(g),y.append(w);var O=f.container||document.body;v.onload=function(){w.style.opacity="1",setTimeout((function(){g.style.display="none"}),250),r.addCustomKeyboardListener(P)};var _=a.makeAutoResize(y),E=function(){a.isOpen(y)||(a.isInPage(y)?y.style.display="flex":(g.style.display="block",O.append(y)),document.body.style.overflow="hidden",_(),window.addEventListener("resize",_),setTimeout((function(){y.style.opacity="1"})))},P=function(){a.isOpen(y)&&(null==l||l(),y.style.opacity="0",document.body.style.overflow=b,setTimeout((function(){f.keepSession?y.style.display="none":C()}),250))};w.append(function(e){var t=document.createElement("a");return t.className="tf-v1-close tf-v1-close-icon",t.innerHTML="&times;",t.onclick=e,t}(P)),r.setAutoClose(m,f.autoClose,P),f.open&&!a.isOpen(y)&&(n=r.handleCustomOpen(E,f.open,f.openValue));var C=function(){r.unmountElement(y),window.removeEventListener("resize",_),f.open&&(null==n?void 0:n.remove)&&n.remove()};return{open:E,close:P,toggle:function(){a.isOpen(y)?P():E()},refresh:h,unmount:C}}},970:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(630),t),r(n(394),t)},394:function(e,t){Object.defineProperty(t,"__esModule",{value:!0})},382:function(e,t,n){var o=this&&this.__assign||function(){return(o=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.createSidetab=void 0;var r=n(747),i={buttonColor:"#3a7685",buttonText:"Launch me"},a=function(e,t){void 0===e&&(e="div"),void 0===t&&(t="tf-v1-sidetab-button-icon");var n=document.createElement(e);return n.className=t+" tf-v1-close-icon",n.innerHTML="&times;",n.dataset.testid=t,n},u=function(e,t){var n=e.parentNode;n&&(n.removeChild(e),n.appendChild(t))};t.createSidetab=function(e,t){void 0===t&&(t={});var n,s=o(o({},i),t),c=r.createIframe(e,"side-tab",s),d=c.iframe,l=c.embedId,f=c.refresh,p=function(e,t){var n=document.createElement("div");return n.className="tf-v1-sidetab",n.dataset.testid="tf-v1-sidetab",r.setElementSize(n,{width:e,height:t})}(s.width,s.height),v=function(){var e=document.createElement("div");return e.className="tf-v1-sidetab-wrapper",e.dataset.testid="tf-v1-sidetab-wrapper",e}(),m=function(){var e=document.createElement("div");e.className="tf-v1-spinner";var t=document.createElement("div");return t.className="tf-v1-sidetab-button-icon",t.dataset.testid="spinner-icon",t.append(e),t}(),h=function(e){var t=r.getTextColor(e),n=document.createElement("button");return n.className="tf-v1-sidetab-button",n.style.backgroundColor=e,n.style.color=t,n}(s.buttonColor||i.buttonColor),b=function(e){var t=document.createElement("span");return t.className="tf-v1-sidetab-button-text",t.innerHTML=e,t}(s.buttonText||i.buttonText),y=function(e,t){var n=r.getTextColor(t),o=document.createElement("div");o.className="tf-v1-sidetab-button-icon";var i='<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="'+n+'"></path>\n  </svg>',a=null==e?void 0:e.startsWith("http");return o.innerHTML=a?"<img alt='popover trigger icon button' src='"+e+"'/>":null!=e?e:i,o.dataset.testid="default-icon",o}(s.customIcon,s.buttonColor||i.buttonColor),g=a(),w=a("a","tf-v1-sidetab-close");(s.container||document.body).append(p),v.append(d),p.append(h),p.append(w),h.append(y),h.append(b),setTimeout((function(){p.classList.add("ready")}),250),d.onload=function(){p.classList.add("open"),u(m,g),r.addCustomKeyboardListener(E)};var O=r.makeAutoResize(p),_=function(){r.isOpen(v)||(O(),window.addEventListener("resize",O),r.isInPage(v)?(v.style.display="flex",p.classList.add("open"),u(y,g)):(p.append(v),u(y,m)))},E=function(){var e;r.isOpen(v)&&(null===(e=s.onClose)||void 0===e||e.call(s),p.classList.remove("open"),setTimeout((function(){s.keepSession?v.style.display="none":r.unmountElement(v),u(g,y)}),250))};r.setAutoClose(l,s.autoClose,E);var P=function(){r.isOpen(v)?E():_()};return h.onclick=P,w.onclick=E,s.open&&!r.isOpen(v)&&(n=r.handleCustomOpen(_,s.open,s.openValue)),{open:_,close:E,toggle:P,refresh:f,unmount:function(){r.unmountElement(p),window.removeEventListener("resize",O),s.open&&(null==n?void 0:n.remove)&&n.remove()}}}},434:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(382),t),r(n(668),t)},668:function(e,t){Object.defineProperty(t,"__esModule",{value:!0})},603:function(e,t,n){var o=this&&this.__rest||function(e,t){var n={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(e);r<o.length;r++)t.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(e,o[r])&&(n[o[r]]=e[o[r]])}return n};Object.defineProperty(t,"__esModule",{value:!0}),t.createSlider=void 0;var r=n(747),i=n(27);t.createSlider=function(e,t){if(void 0===t&&(t={}),!r.hasDom())return{open:function(){},close:function(){},toggle:function(){},refresh:function(){},unmount:function(){}};var n,a=t.position,u=void 0===a?i.SLIDER_POSITION:a,s=t.width,c=void 0===s?i.SLIDER_WIDTH:s,d=t.onClose,l=o(t,["position","width","onClose"]),f=r.createIframe(e,"slider",l),p=f.iframe,v=f.embedId,m=f.refresh,h=document.body.style.overflow,b=function(e){var t=document.createElement("div");return t.className="tf-v1-slider "+e,t.dataset.testid="tf-v1-slider",t.style.opacity="0",t}(u),y=function(){var e=document.createElement("div");return e.className="tf-v1-spinner",e}(),g=function(e,t){var n=document.createElement("div");return n.className="tf-v1-iframe-wrapper",n.style[e]="-100%",r.setElementSize(n,{width:t})}(u,c);g.append(p),b.append(y),b.append(g);var w=l.container||document.body;p.onload=function(){g.style[u]="0",setTimeout((function(){y.style.display="none"}),500),r.addCustomKeyboardListener(E)};var O=r.makeAutoResize(b),_=function(){r.isOpen(b)||(O(),window.addEventListener("resize",O),r.isInPage(b)?(b.style.display="flex",setTimeout((function(){g.style[u]="0"}))):(w.append(b),y.style.display="block"),document.body.style.overflow="hidden",setTimeout((function(){b.style.opacity="1"})))},E=function(){r.isOpen(b)&&(null==d||d(),b.style.opacity="0",g.style[u]="-100%",document.body.style.overflow=h,setTimeout((function(){l.keepSession?b.style.display="none":P()}),500))};r.setAutoClose(v,l.autoClose,E),g.append(function(e){var t=document.createElement("a");return t.className="tf-v1-close tf-v1-close-icon",t.innerHTML="&times;",t.onclick=e,t}(E)),l.open&&!r.isOpen(b)&&(n=r.handleCustomOpen(_,l.open,l.openValue));var P=function(){r.unmountElement(b),window.removeEventListener("resize",O),l.open&&(null==n?void 0:n.remove)&&n.remove()};return{open:_,close:E,toggle:function(){r.isOpen(b)?E():_()},refresh:m,unmount:P}}},331:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(603),t),r(n(162),t)},162:function(e,t){Object.defineProperty(t,"__esModule",{value:!0})},718:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.createWidget=void 0;var o=n(747),r=n(554),i=n(313);t.createWidget=function(e,t){if(!o.hasDom())return{refresh:function(){},unmount:function(){}};var n=t;t.inlineOnMobile||!t.forceTouch&&!o.isFullscreen()||(n.enableFullscreen=!0,n.forceTouch=!0);var a=o.createIframe(e,"widget",n),u=a.embedId,s=a.iframe,c=a.refresh,d=i.buildWidget(s,t.width,t.height);if(n.autoResize){var l="string"==typeof n.autoResize?n.autoResize.split(",").map((function(e){return parseInt(e)})):[],f=l[0],p=l[1];window.addEventListener("message",r.getFormHeightChangedHandler(u,(function(e){var n=Math.max(e.height+20,f||0);p&&(n=Math.min(n,p)),t.container.style.height=n+"px"})))}var v,m=function(){return t.container.append(d)};if(t.container.innerHTML="",t.lazy?o.lazyInitialize(t.container,m):m(),n.enableFullscreen){var h=t.container,b=o.makeAutoResize(h),y=h.style.height;window.addEventListener("message",r.getWelcomeScreenHiddenHandler(u,(function(){h.classList.add("tf-v1-widget-fullscreen"),b(),window.addEventListener("resize",b)})));var g=((v=document.createElement("a")).className="tf-v1-widget-close tf-v1-close-icon",v.innerHTML="&times;",v);g.onclick=function(){var e;if(window.removeEventListener("resize",b),h.style.height=y,null===(e=t.onClose)||void 0===e||e.call(t),h.classList.remove("tf-v1-widget-fullscreen"),t.keepSession){var n=document.createElement("div");n.className="tf-v1-widget-iframe-overlay",n.onclick=function(){h.classList.add("tf-v1-widget-fullscreen"),o.unmountElement(n)},d.append(n)}else t.container.innerHTML="",m(),h.append(g)},h.append(g)}return{refresh:c,unmount:function(){return o.unmountElement(d)}}}},419:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.buildWidget=void 0;var o=n(747);t.buildWidget=function(e,t,n){var r=document.createElement("div");return r.className="tf-v1-widget",r.dataset.testid="tf-v1-widget",r.append(e),o.setElementSize(r,{width:t,height:n})}},313:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(419),t)},321:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(718),t),r(n(58),t)},58:function(e,t){Object.defineProperty(t,"__esModule",{value:!0})},920:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(797),t),r(n(970),t),r(n(331),t),r(n(321),t),r(n(434),t)},626:function(e,t,n){var o=this&&this.__assign||function(){return(o=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.buildIframeSrc=void 0;var r=n(27),i=n(527),a=n(346),u=n(698),s={widget:"embed-widget",popup:"popup-blank",slider:"popup-drawer",popover:"popup-popover","side-tab":"popup-side-panel"};t.buildIframeSrc=function(e){var t=e.formId,n=e.type,c=e.embedId,d=e.options,l=function(e,t,n){var r=n.transitiveSearchParams,i=n.source,a=n.medium,c=n.mediumVersion,d=n.hideFooter,l=n.hideHeaders,f=n.opacity,p=n.disableTracking,v=n.enableSandbox,m=n.disableAutoFocus,h=n.shareGaInstance,b=n.forceTouch,y=n.enableFullscreen,g=n.tracking,w=n.redirectTarget,O=u.getTransitiveSearchParams(r);return o(o(o({},{"typeform-embed-id":t,"typeform-embed":s[e],"typeform-source":i,"typeform-medium":a,"typeform-medium-version":c,"embed-hide-footer":d?"true":void 0,"embed-hide-headers":l?"true":void 0,"embed-opacity":f,"disable-tracking":p||v?"true":void 0,"disable-auto-focus":m?"true":void 0,"__dangerous-disable-submissions":v?"true":void 0,"share-ga-instance":h?"true":void 0,"force-touch":b?"true":void 0,"add-placeholder-ws":"widget"===e&&y?"true":void 0,"typeform-embed-redirect-target":w}),O),g)}(n,c,function(e){return o(o({},{source:null===(t=null===window||void 0===window?void 0:window.location)||void 0===t?void 0:t.hostname.replace(/^www\./,""),medium:"embed-sdk",mediumVersion:"next"}),i.removeUndefinedKeys(e));var t}(d)),f=function(e,t){void 0===t&&(t=!1);var n=t?"c":"to";return new URL(e.startsWith("http://")||e.startsWith("https://")?e:r.FORM_BASE_URL+"/"+n+"/"+e)}(t,d.chat);if(Object.entries(l).filter((function(e){var t=e[1];return a.isDefined(t)})).forEach((function(e){var t=e[0],n=e[1];f.searchParams.set(t,n)})),d.hidden){var p=new URL(r.FORM_BASE_URL);Object.entries(d.hidden).filter((function(e){var t=e[1];return a.isDefined(t)})).forEach((function(e){var t=e[0],n=e[1];p.searchParams.set(t,n)}));var v=p.searchParams.toString();v&&(f.hash=v)}return f.href}},972:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.handleCustomOpen=void 0;var n={remove:function(){}};t.handleCustomOpen=function(e,t,o){switch(t){case"load":return e(),n;case"exit":return o?function(e,t){var n=0,o=function(r){r.clientY<e&&r.clientY<n?(document.removeEventListener("mousemove",o,!0),t()):n=r.clientY};return document.addEventListener("mousemove",o,!0),{remove:function(){return document.removeEventListener("mousemove",o,!0)}}}(o,e):n;case"time":return setTimeout((function(){e()}),o),n;case"scroll":return o?function(e,t){function n(){var o=window.pageYOffset||document.documentElement.scrollTop,r=document.documentElement.clientTop||0,i=document.documentElement.scrollHeight,a=o-r,u=a/i*100,s=a+window.innerHeight>=i;(u>=e||s)&&(t(),document.removeEventListener("scroll",n))}return document.addEventListener("scroll",n),{remove:function(){return document.removeEventListener("scroll",n)}}}(o,e):n;default:return n}}},553:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.createIframe=void 0;var o=n(626),r=n(747),i=n(866),a=n(554),u=n(256),s=n(144),c=n(511);t.createIframe=function(e,t,n){var d=i.generateEmbedId(),l=n.iframeProps,f=void 0===l?{}:l,p=n.onReady,v=n.onQuestionChanged,m=n.onHeightChanged,h=n.onSubmit,b=n.onEndingButtonClick,y=n.shareGaInstance,g=o.buildIframeSrc({formId:e,embedId:d,type:t,options:n}),w=document.createElement("iframe");return w.src=g,w.dataset.testid="iframe",w.style.border="0px",w.allow="microphone; camera",Object.keys(f).forEach((function(e){w.setAttribute(e,f[e])})),w.addEventListener("load",u.triggerIframeRedraw,{once:!0}),window.addEventListener("message",a.getFormReadyHandler(d,p)),window.addEventListener("message",a.getFormQuestionChangedHandler(d,v)),window.addEventListener("message",a.getFormHeightChangedHandler(d,m)),window.addEventListener("message",a.getFormSubmitHandler(d,h)),window.addEventListener("message",a.getFormThemeHandler(d)),window.addEventListener("message",a.getThankYouScreenButtonClickHandler(d,b)),"widget"!==t&&window.addEventListener("message",s.dispatchCustomKeyEventFromIframe),y&&window.addEventListener("message",a.getFormReadyHandler(d,(function(){r.setupGaInstance(w,d,y)}))),{iframe:w,embedId:d,refresh:function(){return c.refreshIframe(w)}}}},866:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.generateEmbedId=void 0,t.generateEmbedId=function(){var e=Math.random();return String(e).split(".")[1]}},554:function(e,t){var n=this&&this.__rest||function(e,t){var n={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(e);r<o.length;r++)t.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(e,o[r])&&(n[o[r]]=e[o[r]])}return n};function o(e,t,o){return function(r){var i=r.data,a=i.type,u=i.embedId,s=n(i,["type","embedId"]);a===e&&u===t&&(null==o||o(s))}}Object.defineProperty(t,"__esModule",{value:!0}),t.getThankYouScreenButtonClickHandler=t.getFormThemeHandler=t.getWelcomeScreenHiddenHandler=t.getFormSubmitHandler=t.getFormHeightChangedHandler=t.getFormQuestionChangedHandler=t.getFormReadyHandler=void 0,t.getFormReadyHandler=function(e,t){return o("form-ready",e,t)},t.getFormQuestionChangedHandler=function(e,t){return o("form-screen-changed",e,t)},t.getFormHeightChangedHandler=function(e,t){return o("form-height-changed",e,t)},t.getFormSubmitHandler=function(e,t){return o("form-submit",e,t)},t.getWelcomeScreenHiddenHandler=function(e,t){return o("welcome-screen-hidden",e,t)},t.getFormThemeHandler=function(e){return o("form-theme",e,(function(e){var t;if(null==e?void 0:e.theme){var n=document.querySelector(".tf-v1-close-icon");n&&(n.style.color=null===(t=e.theme)||void 0===t?void 0:t.color)}}))},t.getThankYouScreenButtonClickHandler=function(e,t){return o("thank-you-screen-button-click",e,t)}},339:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(553),t),r(n(144),t)},511:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.refreshIframe=void 0,t.refreshIframe=function(e){if(e){var t=e.src;if(t.includes("&refresh")){var n=t.split("&refresh#");e.src=n.join("#")}else(n=t.split("#"))[0]=n[0]+"&refresh",e.src=n.join("#")}}},144:function(e,t){var n=this&&this.__awaiter||function(e,t,n,o){return new(n||(n=Promise))((function(r,i){function a(e){try{s(o.next(e))}catch(e){i(e)}}function u(e){try{s(o.throw(e))}catch(e){i(e)}}function s(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,u)}s((o=o.apply(e,t||[])).next())}))},o=this&&this.__generator||function(e,t){var n,o,r,i,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:u(0),throw:u(1),return:u(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function u(i){return function(u){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,o=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!((r=(r=a.trys).length>0&&r[r.length-1])||6!==i[0]&&2!==i[0])){a=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){a.label=i[1];break}if(6===i[0]&&a.label<r[1]){a.label=r[1],r=i;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(i);break}r[2]&&a.ops.pop(),a.trys.pop();continue}i=t.call(e,a)}catch(e){i=[6,e],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,u])}}};Object.defineProperty(t,"__esModule",{value:!0}),t.dispatchCustomKeyEventFromIframe=t.removeCustomKeyboardListener=t.addCustomKeyboardListener=void 0;var r="Escape",i=function(e,i){return n(void 0,void 0,void 0,(function(){return o(this,(function(n){return e.code===r&&"function"==typeof i&&(i(),t.removeCustomKeyboardListener()),[2]}))}))};t.addCustomKeyboardListener=function(e){return window.document.addEventListener("keydown",(function(t){return i(t,e)}))},t.removeCustomKeyboardListener=function(){return window.document.removeEventListener("keydown",i)},t.dispatchCustomKeyEventFromIframe=function(e){"form-close"===e.data.type&&window.document.dispatchEvent(new KeyboardEvent("keydown",{code:r}))}},256:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.triggerIframeRedraw=void 0,t.triggerIframeRedraw=function(){this.style.transform="translateZ(0)"}},939:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.getTextColor=void 0;var o=n(938);t.getTextColor=function(e){if(!e)return"#FFFFFF";var t=e.startsWith("#")?o.hexRgb(e):function(e){var t={red:0,green:0,blue:0},n=e.match(/\d+/g);return n&&(t.red=parseInt(n[0],10),t.green=parseInt(n[0],10),t.blue=parseInt(n[0],10)),t}(e),n=t.red,r=t.green,i=t.blue;return Math.round((299*n+587*r+114*i)/1e3)>125?"#000000":"#FFFFFF"}},698:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.getTransitiveSearchParams=void 0,t.getTransitiveSearchParams=function(e){var t=new URL(window.location.href),n={};return e&&e.length>0&&e.forEach((function(e){t.searchParams.has(e)&&(n[e]=t.searchParams.get(e))})),n}},252:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.hasDom=void 0,t.hasDom=function(){return"undefined"!=typeof document&&"undefined"!=typeof window}},938:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.hexRgb=void 0;var n=new RegExp("[^#a-f\\d]","gi"),o=new RegExp("^#?[a-f\\d]{3}[a-f\\d]?$|^#?[a-f\\d]{6}([a-f\\d]{2})?$","i");t.hexRgb=function(e){if("string"!=typeof e||n.test(e)||!o.test(e))throw new TypeError("Expected a valid hex string");8===(e=e.replace(/^#/,"")).length&&(e=e.slice(0,6)),4===e.length&&(e=e.slice(0,3)),3===e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]);var t=Number.parseInt(e,16);return{red:t>>16,green:t>>8&255,blue:255&t}}},71:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.includeCss=void 0,t.includeCss=function(e){var t=function(e){return"https://embed.typeform.com/next/css/"+e}(e);if(!document.querySelector('link[href="'+t+'"]')){var n=document.createElement("link");n.rel="stylesheet",n.href=t,document.head.append(n)}}},747:function(e,t,n){var o=this&&this.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),r=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||o(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),r(n(626),t),r(n(339),t),r(n(252),t),r(n(71),t),r(n(346),t),r(n(377),t),r(n(563),t),r(n(527),t),r(n(533),t),r(n(451),t),r(n(972),t),r(n(748),t),r(n(392),t),r(n(939),t),r(n(917),t),r(n(987),t),r(n(318),t)},346:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.isDefined=void 0,t.isDefined=function(e){return null!=e}},987:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.isVisible=t.isInPage=t.isOpen=void 0,t.isOpen=function(e){return t.isInPage(e)&&t.isVisible(e)},t.isInPage=function(e){return!!e.parentNode},t.isVisible=function(e){return"none"!==e.style.display}},917:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.lazyInitialize=void 0,t.lazyInitialize=function(e,t){var n=new IntersectionObserver((function(e){e.forEach((function(e){e.isIntersecting&&(t(),n.unobserve(e.target))}))}));n.observe(e)}},377:function(e,t){var n=this&&this.__assign||function(){return(n=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.loadOptionsFromAttributes=t.transformAttributeValue=t.camelCaseToKebabCase=void 0,t.camelCaseToKebabCase=function(e){return e.split("").map((function(e,t){return e.toUpperCase()===e?(0!==t?"-":"")+e.toLowerCase():e})).join("")};var o=function(e){return e||void 0},r=function(e){return""===e||"yes"===e||"true"===e},i=function(e){var t=e?parseInt(e,10):NaN;return isNaN(t)?void 0:t},a="%ESCAPED_COMMA%";t.transformAttributeValue=function(e,t){var u,s;switch(t){case"string":return o(e);case"boolean":return r(e);case"integer":return i(e);case"function":return function(e){var t=e&&e in window?window[e]:void 0;return"function"==typeof t?t:void 0}(e);case"array":return function(e){if(e)return e.replace(/\s/g,"").replace(/\\,/g,a).split(",").filter((function(e){return!!e})).map((function(e){return e.replace(a,",")}))}(e);case"record":return function(e){if(e)return e.replace(/\\,/g,a).split(",").filter((function(e){return!!e})).map((function(e){return e.replace(a,",")})).reduce((function(e,t){var o,r=t.match(/^([^=]+)=(.*)$/);if(r){var i=r[1],a=r[2];return n(n({},e),((o={})[i.trim()]=a,o))}return e}),{})}(e);case"integerOrBoolean":return null!==(u=i(e))&&void 0!==u?u:r(e);case"stringOrBoolean":return null!==(s=o(e))&&void 0!==s?s:r(e);default:throw new Error("Invalid attribute transformation "+t)}},t.loadOptionsFromAttributes=function(e,o){return Object.keys(o).reduce((function(r,i){var a;return n(n({},r),((a={})[i]=t.transformAttributeValue(e.getAttribute("data-tf-"+t.camelCaseToKebabCase(i)),o[i]),a))}),{})}},318:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.makeAutoResize=void 0;var o=n(563);t.makeAutoResize=function(e){return function(){e&&o.isMobile()&&e.style.setProperty("height",window.innerHeight+"px","important")}}},563:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.isFullscreen=t.isMobile=t.isBigScreen=void 0,t.isBigScreen=function(){return window.screen.width>=1024&&window.screen.height>=768},t.isMobile=function(){return/mobile|tablet|android/i.test(navigator.userAgent.toLowerCase())},t.isFullscreen=function(){return t.isMobile()&&!t.isBigScreen()}},527:function(e,t,n){var o=this&&this.__assign||function(){return(o=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.removeUndefinedKeys=void 0;var r=n(346);t.removeUndefinedKeys=function(e){return Object.entries(e).filter((function(e){var t=e[1];return r.isDefined(t)})).reduce((function(e,t){var n,r=t[0],i=t[1];return o(o({},e),((n={})[r]=i,n))}),{})}},748:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.setAutoClose=void 0;var o=n(554);t.setAutoClose=function(e,t,n){if(t&&n){var r="number"==typeof t?t:0;window.addEventListener("message",o.getFormSubmitHandler(e,(function(){return setTimeout(n,r)})))}}},533:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.setElementSize=void 0,t.setElementSize=function(e,t){var n=t.width,o=t.height;return n&&(e.style.width=n+"px"),o&&(e.style.height=o+"px"),e}},392:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.setupGaInstance=t.sendGaIdMessage=void 0,t.sendGaIdMessage=function(e,t,n){var o={embedId:e,gaClientId:t};setTimeout((function(){n&&n.contentWindow&&n.contentWindow.postMessage({type:"ga-client-id",data:o},"*")}),0)};var n=function(e){console.error(e)};t.setupGaInstance=function(e,o,r){try{var i=window[window.GoogleAnalyticsObject],a="string"==typeof r?r:void 0,u=function(e,t){return t?e.find((function(e){return e.get("trackingId")===t})):e[0]}(i.getAll(),a);u?t.sendGaIdMessage(o,u.get("clientId"),e):n("Whoops! You enabled the shareGaInstance feature in your typeform embed but the tracker with ID "+a+" was not found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page and use correct tracker ID. ")}catch(e){n("Whoops! You enabled the shareGaInstance feature in your typeform embed but the Google Analytics object has not been found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page. "),n(e)}}},451:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.unmountElement=void 0,t.unmountElement=function(e){var t;null===(t=e.parentNode)||void 0===t||t.removeChild(e)}}},t={};return function n(o){if(t[o])return t[o].exports;var r=t[o]={exports:{}};return e[o].call(r.exports,r,r.exports,n),r.exports}(920)}()}));

/***/ }),

/***/ 27185:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(30260);
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(97991);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),

/***/ 97991:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(9065);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 51842:
/***/ (function(module) {

"use strict";


module.exports = direction

var RTL = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC'
var LTR =
  'A-Za-z\u00C0-\u00D6\u00D8-\u00F6' +
  '\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C' +
  '\uFE00-\uFE6F\uFEFD-\uFFFF'

var rtl = new RegExp('^[^' + LTR + ']*[' + RTL + ']')
var ltr = new RegExp('^[^' + RTL + ']*[' + LTR + ']')

function direction(value) {
  value = String(value || '')

  if (rtl.test(value)) {
    return 'rtl'
  }

  if (ltr.test(value)) {
    return 'ltr'
  }

  return 'neutral'
}


/***/ }),

/***/ 3341:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 41069:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
var findWithRegex = function findWithRegex(regex, contentBlock, callback) {
  // Get the text from the contentBlock
  var text = contentBlock.getText();
  var matchArr = void 0;
  var start = void 0; // eslint-disable-line
  // Go through all matches in the text and return the indizes to the callback
  while ((matchArr = regex.exec(text)) !== null) {
    // eslint-disable-line
    if (matchArr.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
};

exports.Z = findWithRegex;

/***/ }),

/***/ 53670:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 55626:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);

var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};

var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};

var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};

for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }

  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }

  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}

function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}

function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, { byKey: true }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      var optional = value.endsWith('?') && value.length > 1;

      if (optional) {
        value = value.slice(0, -1);
      }

      var name = toKeyName(value);
      var modifier = MODIFIERS[name];

      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }

      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;

    if (expected == null) {
      continue;
    }

    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }

    if (actual == null && expected === false) {
      continue;
    }

    if (actual !== expected) {
      return false;
    }
  }

  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}

function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isCodeHotkey;
exports.TB = isKeyHotkey;
__webpack_unused_export__ = parseHotkey;
__webpack_unused_export__ = compareHotkey;
__webpack_unused_export__ = toKeyCode;
__webpack_unused_export__ = toKeyName;

/***/ }),

/***/ 45869:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);

var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};

var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};

var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};

for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }

  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }

  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}

function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}

function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, { byKey: true }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      var optional = value.endsWith('?') && value.length > 1;

      if (optional) {
        value = value.slice(0, -1);
      }

      var name = toKeyName(value);
      var modifier = MODIFIERS[name];

      if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
        throw new TypeError('Unknown modifier: "' + value + '"');
      }

      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }

      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;

    if (expected == null) {
      continue;
    }

    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }

    if (actual == null && expected === false) {
      continue;
    }

    if (actual !== expected) {
      return false;
    }
  }

  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}

function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

exports.ZP = isHotkey;
__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isCodeHotkey;
__webpack_unused_export__ = isKeyHotkey;
__webpack_unused_export__ = parseHotkey;
__webpack_unused_export__ = compareHotkey;
__webpack_unused_export__ = toKeyCode;
__webpack_unused_export__ = toKeyName;

/***/ }),

/***/ 27499:
/***/ (function(module) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ 45586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(13807);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),

/***/ 87423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var convert = __webpack_require__(5710),
    func = convert('trimEnd', __webpack_require__(79455));

func.placeholder = __webpack_require__(84859);
module.exports = func;


/***/ }),

/***/ 84419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var convert = __webpack_require__(5710),
    func = convert('trimStart', __webpack_require__(64096));

func.placeholder = __webpack_require__(84859);
module.exports = func;


/***/ }),

/***/ 38209:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(66292),
    isObject = __webpack_require__(36838);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 79455:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(73150),
    castSlice = __webpack_require__(20167),
    charsEndIndex = __webpack_require__(45586),
    stringToArray = __webpack_require__(30078),
    toString = __webpack_require__(8389),
    trimmedEndIndex = __webpack_require__(82996);

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.slice(0, trimmedEndIndex(string) + 1);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

  return castSlice(strSymbols, 0, end).join('');
}

module.exports = trimEnd;


/***/ }),

/***/ 9065:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 93241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ML": function() { return /* reexport */ GovlaunchEditor; },
  "Lk": function() { return /* reexport */ EditorWithToolbars; },
  "u_": function() { return /* reexport */ SlateEditor; }
});

// UNUSED EXPORTS: AtomicBlockIdentifiers, BatchProviders, Debounce, DisruptorSuggestionItem, DisruptorsEditor, DisruptorsProvider, EditorMention, EditorStateUtils, EntityTypeIdentifiers, InlineMentions, MentionSuggestion, MentionTypes, PersistencyUtils, PromiseProvider, ReplyDisruptorsEditor, StandardInlineToolbar, StandardMentionSuggestionItem, StandardMentions, StandardMentionsPopover, StandardSideToolbar, getReadTime, insertAtomicBlock, insertEditorBlock, isEditorStateEmpty, trim, useSlate

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/composeEventHandlers.js
/**
 * @param   {[]Function} composing
 * @returns {Function}
 */ 
function composeEventHandlers() {
    for(var _len = arguments.length, composing = new Array(_len), _key = 0; _key < _len; _key++){
        composing[_key] = arguments[_key];
    }
    return function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var lastReturnValue;
        composing.some(function(fn) {
            if (fn && typeof fn === "function") {
                lastReturnValue = fn.apply(void 0, [
                    event
                ].concat((0,_to_consumable_array/* default */.Z)(args)));
            }
            return event.defaultPrevented;
        });
        return lastReturnValue;
    };
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/findEntitiesByType.js
/**
 * @param   {String} entityType
 * @returns {Function}
 */ function findEntitiesByType(entityType) {
    return function(contentBlock, callback, contentState) {
        return contentBlock.findEntityRanges(function(character) {
            return character.getEntity() !== null && contentState.getEntity(character.getEntity()).getType() === entityType;
        }, callback);
    };
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/getYoutubeId.js
/**
 * https://gist.github.com/takien/4077195#gistcomment-2184219
 * @param   {String} urlString
 * @returns {String}
 */ function getYoutubeId(urlString) {
    var urlAfterSplit = urlString.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== urlAfterSplit[2] ? urlAfterSplit[2].split(/[^0-9a-z_-]/i)[0] : null;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/draft-js@0.11.7_sfoxds7t5ydpegc3knd667wn6m/node_modules/draft-js/lib/Draft.js
var Draft = __webpack_require__(12727);
;// CONCATENATED MODULE: ./node_modules/.pnpm/immutable@4.1.0/node_modules/immutable/dist/immutable.es.js
/**
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var DELETE = 'delete';

// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;

// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};

// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
  return { value: false };
}

function SetRef(ref) {
  if (ref) {
    ref.value = true;
  }
}

// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}

function ensureSize(iter) {
  if (iter.size === undefined) {
    iter.size = iter.__iterate(returnTrue);
  }
  return iter.size;
}

function wrapIndex(iter, index) {
  // This implements "is array index" which the ECMAString spec defines as:
  //
  //     A String property name P is an array index if and only if
  //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
  //     to 2^32−1.
  //
  // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
  if (typeof index !== 'number') {
    var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
    if ('' + uint32Index !== index || uint32Index === 4294967295) {
      return NaN;
    }
    index = uint32Index;
  }
  return index < 0 ? ensureSize(iter) + index : index;
}

function returnTrue() {
  return true;
}

function wholeSlice(begin, end, size) {
  return (
    ((begin === 0 && !isNeg(begin)) ||
      (size !== undefined && begin <= -size)) &&
    (end === undefined || (size !== undefined && end >= size))
  );
}

function resolveBegin(begin, size) {
  return resolveIndex(begin, size, 0);
}

function resolveEnd(end, size) {
  return resolveIndex(end, size, size);
}

function resolveIndex(index, size, defaultIndex) {
  // Sanitize indices using this shorthand for ToInt32(argument)
  // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
  return index === undefined
    ? defaultIndex
    : isNeg(index)
    ? size === Infinity
      ? size
      : Math.max(0, size + index) | 0
    : size === undefined || size === index
    ? index
    : Math.min(size, index) | 0;
}

function isNeg(value) {
  // Account for -0 which is negative, but not less than 0.
  return value < 0 || (value === 0 && 1 / value === -Infinity);
}

var IS_COLLECTION_SYMBOL = '@@__IMMUTABLE_ITERABLE__@@';

function isCollection(maybeCollection) {
  return Boolean(maybeCollection && maybeCollection[IS_COLLECTION_SYMBOL]);
}

var IS_KEYED_SYMBOL = '@@__IMMUTABLE_KEYED__@@';

function isKeyed(maybeKeyed) {
  return Boolean(maybeKeyed && maybeKeyed[IS_KEYED_SYMBOL]);
}

var IS_INDEXED_SYMBOL = '@@__IMMUTABLE_INDEXED__@@';

function isIndexed(maybeIndexed) {
  return Boolean(maybeIndexed && maybeIndexed[IS_INDEXED_SYMBOL]);
}

function isAssociative(maybeAssociative) {
  return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}

var Collection = function Collection(value) {
  return isCollection(value) ? value : Seq(value);
};

var KeyedCollection = /*@__PURE__*/(function (Collection) {
  function KeyedCollection(value) {
    return isKeyed(value) ? value : KeyedSeq(value);
  }

  if ( Collection ) KeyedCollection.__proto__ = Collection;
  KeyedCollection.prototype = Object.create( Collection && Collection.prototype );
  KeyedCollection.prototype.constructor = KeyedCollection;

  return KeyedCollection;
}(Collection));

var IndexedCollection = /*@__PURE__*/(function (Collection) {
  function IndexedCollection(value) {
    return isIndexed(value) ? value : IndexedSeq(value);
  }

  if ( Collection ) IndexedCollection.__proto__ = Collection;
  IndexedCollection.prototype = Object.create( Collection && Collection.prototype );
  IndexedCollection.prototype.constructor = IndexedCollection;

  return IndexedCollection;
}(Collection));

var SetCollection = /*@__PURE__*/(function (Collection) {
  function SetCollection(value) {
    return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
  }

  if ( Collection ) SetCollection.__proto__ = Collection;
  SetCollection.prototype = Object.create( Collection && Collection.prototype );
  SetCollection.prototype.constructor = SetCollection;

  return SetCollection;
}(Collection));

Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;

var IS_SEQ_SYMBOL = '@@__IMMUTABLE_SEQ__@@';

function isSeq(maybeSeq) {
  return Boolean(maybeSeq && maybeSeq[IS_SEQ_SYMBOL]);
}

var IS_RECORD_SYMBOL = '@@__IMMUTABLE_RECORD__@@';

function isRecord(maybeRecord) {
  return Boolean(maybeRecord && maybeRecord[IS_RECORD_SYMBOL]);
}

function isImmutable(maybeImmutable) {
  return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}

var IS_ORDERED_SYMBOL = '@@__IMMUTABLE_ORDERED__@@';

function isOrdered(maybeOrdered) {
  return Boolean(maybeOrdered && maybeOrdered[IS_ORDERED_SYMBOL]);
}

var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;

var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';

var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

var Iterator = function Iterator(next) {
  this.next = next;
};

Iterator.prototype.toString = function toString () {
  return '[Iterator]';
};

Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;

Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
  return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function () {
  return this;
};

function iteratorValue(type, k, v, iteratorResult) {
  var value = type === 0 ? k : type === 1 ? v : [k, v];
  iteratorResult
    ? (iteratorResult.value = value)
    : (iteratorResult = {
        value: value,
        done: false,
      });
  return iteratorResult;
}

function iteratorDone() {
  return { value: undefined, done: true };
}

function hasIterator(maybeIterable) {
  if (Array.isArray(maybeIterable)) {
    // IE11 trick as it does not support `Symbol.iterator`
    return true;
  }

  return !!getIteratorFn(maybeIterable);
}

function isIterator(maybeIterator) {
  return maybeIterator && typeof maybeIterator.next === 'function';
}

function getIterator(iterable) {
  var iteratorFn = getIteratorFn(iterable);
  return iteratorFn && iteratorFn.call(iterable);
}

function getIteratorFn(iterable) {
  var iteratorFn =
    iterable &&
    ((REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

function isEntriesIterable(maybeIterable) {
  var iteratorFn = getIteratorFn(maybeIterable);
  return iteratorFn && iteratorFn === maybeIterable.entries;
}

function isKeysIterable(maybeIterable) {
  var iteratorFn = getIteratorFn(maybeIterable);
  return iteratorFn && iteratorFn === maybeIterable.keys;
}

var immutable_es_hasOwnProperty = Object.prototype.hasOwnProperty;

function isArrayLike(value) {
  if (Array.isArray(value) || typeof value === 'string') {
    return true;
  }

  return (
    value &&
    typeof value === 'object' &&
    Number.isInteger(value.length) &&
    value.length >= 0 &&
    (value.length === 0
      ? // Only {length: 0} is considered Array-like.
        Object.keys(value).length === 1
      : // An object is only Array-like if it has a property where the last value
        // in the array-like may be found (which could be undefined).
        value.hasOwnProperty(value.length - 1))
  );
}

var Seq = /*@__PURE__*/(function (Collection) {
  function Seq(value) {
    return value === undefined || value === null
      ? emptySequence()
      : isImmutable(value)
      ? value.toSeq()
      : seqFromValue(value);
  }

  if ( Collection ) Seq.__proto__ = Collection;
  Seq.prototype = Object.create( Collection && Collection.prototype );
  Seq.prototype.constructor = Seq;

  Seq.prototype.toSeq = function toSeq () {
    return this;
  };

  Seq.prototype.toString = function toString () {
    return this.__toString('Seq {', '}');
  };

  Seq.prototype.cacheResult = function cacheResult () {
    if (!this._cache && this.__iterateUncached) {
      this._cache = this.entrySeq().toArray();
      this.size = this._cache.length;
    }
    return this;
  };

  // abstract __iterateUncached(fn, reverse)

  Seq.prototype.__iterate = function __iterate (fn, reverse) {
    var cache = this._cache;
    if (cache) {
      var size = cache.length;
      var i = 0;
      while (i !== size) {
        var entry = cache[reverse ? size - ++i : i++];
        if (fn(entry[1], entry[0], this) === false) {
          break;
        }
      }
      return i;
    }
    return this.__iterateUncached(fn, reverse);
  };

  // abstract __iteratorUncached(type, reverse)

  Seq.prototype.__iterator = function __iterator (type, reverse) {
    var cache = this._cache;
    if (cache) {
      var size = cache.length;
      var i = 0;
      return new Iterator(function () {
        if (i === size) {
          return iteratorDone();
        }
        var entry = cache[reverse ? size - ++i : i++];
        return iteratorValue(type, entry[0], entry[1]);
      });
    }
    return this.__iteratorUncached(type, reverse);
  };

  return Seq;
}(Collection));

var KeyedSeq = /*@__PURE__*/(function (Seq) {
  function KeyedSeq(value) {
    return value === undefined || value === null
      ? emptySequence().toKeyedSeq()
      : isCollection(value)
      ? isKeyed(value)
        ? value.toSeq()
        : value.fromEntrySeq()
      : isRecord(value)
      ? value.toSeq()
      : keyedSeqFromValue(value);
  }

  if ( Seq ) KeyedSeq.__proto__ = Seq;
  KeyedSeq.prototype = Object.create( Seq && Seq.prototype );
  KeyedSeq.prototype.constructor = KeyedSeq;

  KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq () {
    return this;
  };

  return KeyedSeq;
}(Seq));

var IndexedSeq = /*@__PURE__*/(function (Seq) {
  function IndexedSeq(value) {
    return value === undefined || value === null
      ? emptySequence()
      : isCollection(value)
      ? isKeyed(value)
        ? value.entrySeq()
        : value.toIndexedSeq()
      : isRecord(value)
      ? value.toSeq().entrySeq()
      : indexedSeqFromValue(value);
  }

  if ( Seq ) IndexedSeq.__proto__ = Seq;
  IndexedSeq.prototype = Object.create( Seq && Seq.prototype );
  IndexedSeq.prototype.constructor = IndexedSeq;

  IndexedSeq.of = function of (/*...values*/) {
    return IndexedSeq(arguments);
  };

  IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq () {
    return this;
  };

  IndexedSeq.prototype.toString = function toString () {
    return this.__toString('Seq [', ']');
  };

  return IndexedSeq;
}(Seq));

var SetSeq = /*@__PURE__*/(function (Seq) {
  function SetSeq(value) {
    return (
      isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)
    ).toSetSeq();
  }

  if ( Seq ) SetSeq.__proto__ = Seq;
  SetSeq.prototype = Object.create( Seq && Seq.prototype );
  SetSeq.prototype.constructor = SetSeq;

  SetSeq.of = function of (/*...values*/) {
    return SetSeq(arguments);
  };

  SetSeq.prototype.toSetSeq = function toSetSeq () {
    return this;
  };

  return SetSeq;
}(Seq));

Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;

Seq.prototype[IS_SEQ_SYMBOL] = true;

// #pragma Root Sequences

var ArraySeq = /*@__PURE__*/(function (IndexedSeq) {
  function ArraySeq(array) {
    this._array = array;
    this.size = array.length;
  }

  if ( IndexedSeq ) ArraySeq.__proto__ = IndexedSeq;
  ArraySeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  ArraySeq.prototype.constructor = ArraySeq;

  ArraySeq.prototype.get = function get (index, notSetValue) {
    return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
  };

  ArraySeq.prototype.__iterate = function __iterate (fn, reverse) {
    var array = this._array;
    var size = array.length;
    var i = 0;
    while (i !== size) {
      var ii = reverse ? size - ++i : i++;
      if (fn(array[ii], ii, this) === false) {
        break;
      }
    }
    return i;
  };

  ArraySeq.prototype.__iterator = function __iterator (type, reverse) {
    var array = this._array;
    var size = array.length;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var ii = reverse ? size - ++i : i++;
      return iteratorValue(type, ii, array[ii]);
    });
  };

  return ArraySeq;
}(IndexedSeq));

var ObjectSeq = /*@__PURE__*/(function (KeyedSeq) {
  function ObjectSeq(object) {
    var keys = Object.keys(object).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []
    );
    this._object = object;
    this._keys = keys;
    this.size = keys.length;
  }

  if ( KeyedSeq ) ObjectSeq.__proto__ = KeyedSeq;
  ObjectSeq.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
  ObjectSeq.prototype.constructor = ObjectSeq;

  ObjectSeq.prototype.get = function get (key, notSetValue) {
    if (notSetValue !== undefined && !this.has(key)) {
      return notSetValue;
    }
    return this._object[key];
  };

  ObjectSeq.prototype.has = function has (key) {
    return immutable_es_hasOwnProperty.call(this._object, key);
  };

  ObjectSeq.prototype.__iterate = function __iterate (fn, reverse) {
    var object = this._object;
    var keys = this._keys;
    var size = keys.length;
    var i = 0;
    while (i !== size) {
      var key = keys[reverse ? size - ++i : i++];
      if (fn(object[key], key, this) === false) {
        break;
      }
    }
    return i;
  };

  ObjectSeq.prototype.__iterator = function __iterator (type, reverse) {
    var object = this._object;
    var keys = this._keys;
    var size = keys.length;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var key = keys[reverse ? size - ++i : i++];
      return iteratorValue(type, key, object[key]);
    });
  };

  return ObjectSeq;
}(KeyedSeq));
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;

var CollectionSeq = /*@__PURE__*/(function (IndexedSeq) {
  function CollectionSeq(collection) {
    this._collection = collection;
    this.size = collection.length || collection.size;
  }

  if ( IndexedSeq ) CollectionSeq.__proto__ = IndexedSeq;
  CollectionSeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  CollectionSeq.prototype.constructor = CollectionSeq;

  CollectionSeq.prototype.__iterateUncached = function __iterateUncached (fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var collection = this._collection;
    var iterator = getIterator(collection);
    var iterations = 0;
    if (isIterator(iterator)) {
      var step;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
    }
    return iterations;
  };

  CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var collection = this._collection;
    var iterator = getIterator(collection);
    if (!isIterator(iterator)) {
      return new Iterator(iteratorDone);
    }
    var iterations = 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, iterations++, step.value);
    });
  };

  return CollectionSeq;
}(IndexedSeq));

// # pragma Helper functions

var EMPTY_SEQ;

function emptySequence() {
  return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}

function keyedSeqFromValue(value) {
  var seq = maybeIndexedSeqFromValue(value);
  if (seq) {
    return seq.fromEntrySeq();
  }
  if (typeof value === 'object') {
    return new ObjectSeq(value);
  }
  throw new TypeError(
    'Expected Array or collection object of [k, v] entries, or keyed object: ' +
      value
  );
}

function indexedSeqFromValue(value) {
  var seq = maybeIndexedSeqFromValue(value);
  if (seq) {
    return seq;
  }
  throw new TypeError(
    'Expected Array or collection object of values: ' + value
  );
}

function seqFromValue(value) {
  var seq = maybeIndexedSeqFromValue(value);
  if (seq) {
    return isEntriesIterable(value)
      ? seq.fromEntrySeq()
      : isKeysIterable(value)
      ? seq.toSetSeq()
      : seq;
  }
  if (typeof value === 'object') {
    return new ObjectSeq(value);
  }
  throw new TypeError(
    'Expected Array or collection object of values, or keyed object: ' + value
  );
}

function maybeIndexedSeqFromValue(value) {
  return isArrayLike(value)
    ? new ArraySeq(value)
    : hasIterator(value)
    ? new CollectionSeq(value)
    : undefined;
}

var IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@';

function isMap(maybeMap) {
  return Boolean(maybeMap && maybeMap[IS_MAP_SYMBOL]);
}

function isOrderedMap(maybeOrderedMap) {
  return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}

function isValueObject(maybeValue) {
  return Boolean(
    maybeValue &&
      typeof maybeValue.equals === 'function' &&
      typeof maybeValue.hashCode === 'function'
  );
}

/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */
function is(valueA, valueB) {
  if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
    return true;
  }
  if (!valueA || !valueB) {
    return false;
  }
  if (
    typeof valueA.valueOf === 'function' &&
    typeof valueB.valueOf === 'function'
  ) {
    valueA = valueA.valueOf();
    valueB = valueB.valueOf();
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
  }
  return !!(
    isValueObject(valueA) &&
    isValueObject(valueB) &&
    valueA.equals(valueB)
  );
}

var imul =
  typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2
    ? Math.imul
    : function imul(a, b) {
        a |= 0; // int
        b |= 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return (c * d + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0)) | 0; // int
      };

// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
  return ((i32 >>> 1) & 0x40000000) | (i32 & 0xbfffffff);
}

var defaultValueOf = Object.prototype.valueOf;

function hash(o) {
  if (o == null) {
    return hashNullish(o);
  }

  if (typeof o.hashCode === 'function') {
    // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode(o));
  }

  var v = immutable_es_valueOf(o);

  if (v == null) {
    return hashNullish(v);
  }

  switch (typeof v) {
    case 'boolean':
      // The hash values for built-in constants are a 1 value for each 5-byte
      // shift region expect for the first, which encodes the value. This
      // reduces the odds of a hash collision for these common values.
      return v ? 0x42108421 : 0x42108420;
    case 'number':
      return hashNumber(v);
    case 'string':
      return v.length > STRING_HASH_CACHE_MIN_STRLEN
        ? cachedHashString(v)
        : hashString(v);
    case 'object':
    case 'function':
      return hashJSObj(v);
    case 'symbol':
      return hashSymbol(v);
    default:
      if (typeof v.toString === 'function') {
        return hashString(v.toString());
      }
      throw new Error('Value type ' + typeof v + ' cannot be hashed.');
  }
}

function hashNullish(nullish) {
  return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}

// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
  if (n !== n || n === Infinity) {
    return 0;
  }
  var hash = n | 0;
  if (hash !== n) {
    hash ^= n * 0xffffffff;
  }
  while (n > 0xffffffff) {
    n /= 0xffffffff;
    hash ^= n;
  }
  return smi(hash);
}

function cachedHashString(string) {
  var hashed = stringHashCache[string];
  if (hashed === undefined) {
    hashed = hashString(string);
    if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
      STRING_HASH_CACHE_SIZE = 0;
      stringHashCache = {};
    }
    STRING_HASH_CACHE_SIZE++;
    stringHashCache[string] = hashed;
  }
  return hashed;
}

// http://jsperf.com/hashing-strings
function hashString(string) {
  // This is the hash from JVM
  // The hash code for a string is computed as
  // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
  // where s[i] is the ith character of the string and n is the length of
  // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
  // (exclusive) by dropping high bits.
  var hashed = 0;
  for (var ii = 0; ii < string.length; ii++) {
    hashed = (31 * hashed + string.charCodeAt(ii)) | 0;
  }
  return smi(hashed);
}

function hashSymbol(sym) {
  var hashed = symbolMap[sym];
  if (hashed !== undefined) {
    return hashed;
  }

  hashed = nextHash();

  symbolMap[sym] = hashed;

  return hashed;
}

function hashJSObj(obj) {
  var hashed;
  if (usingWeakMap) {
    hashed = weakMap.get(obj);
    if (hashed !== undefined) {
      return hashed;
    }
  }

  hashed = obj[UID_HASH_KEY];
  if (hashed !== undefined) {
    return hashed;
  }

  if (!canDefineProperty) {
    hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
    if (hashed !== undefined) {
      return hashed;
    }

    hashed = getIENodeHash(obj);
    if (hashed !== undefined) {
      return hashed;
    }
  }

  hashed = nextHash();

  if (usingWeakMap) {
    weakMap.set(obj, hashed);
  } else if (isExtensible !== undefined && isExtensible(obj) === false) {
    throw new Error('Non-extensible objects are not allowed as keys.');
  } else if (canDefineProperty) {
    Object.defineProperty(obj, UID_HASH_KEY, {
      enumerable: false,
      configurable: false,
      writable: false,
      value: hashed,
    });
  } else if (
    obj.propertyIsEnumerable !== undefined &&
    obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable
  ) {
    // Since we can't define a non-enumerable property on the object
    // we'll hijack one of the less-used non-enumerable properties to
    // save our hash on it. Since this is a function it will not show up in
    // `JSON.stringify` which is what we want.
    obj.propertyIsEnumerable = function () {
      return this.constructor.prototype.propertyIsEnumerable.apply(
        this,
        arguments
      );
    };
    obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
  } else if (obj.nodeType !== undefined) {
    // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
  } else {
    throw new Error('Unable to set a non-enumerable property on object.');
  }

  return hashed;
}

// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;

// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = (function () {
  try {
    Object.defineProperty({}, '@', {});
    return true;
  } catch (e) {
    return false;
  }
})();

// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
  if (node && node.nodeType > 0) {
    switch (node.nodeType) {
      case 1: // Element
        return node.uniqueID;
      case 9: // Document
        return node.documentElement && node.documentElement.uniqueID;
    }
  }
}

function immutable_es_valueOf(obj) {
  return obj.valueOf !== defaultValueOf && typeof obj.valueOf === 'function'
    ? obj.valueOf(obj)
    : obj;
}

function nextHash() {
  var nextHash = ++_objHashUID;
  if (_objHashUID & 0x40000000) {
    _objHashUID = 0;
  }
  return nextHash;
}

// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) {
  weakMap = new WeakMap();
}

var symbolMap = Object.create(null);

var _objHashUID = 0;

var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') {
  UID_HASH_KEY = Symbol(UID_HASH_KEY);
}

var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};

var ToKeyedSequence = /*@__PURE__*/(function (KeyedSeq) {
  function ToKeyedSequence(indexed, useKeys) {
    this._iter = indexed;
    this._useKeys = useKeys;
    this.size = indexed.size;
  }

  if ( KeyedSeq ) ToKeyedSequence.__proto__ = KeyedSeq;
  ToKeyedSequence.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
  ToKeyedSequence.prototype.constructor = ToKeyedSequence;

  ToKeyedSequence.prototype.get = function get (key, notSetValue) {
    return this._iter.get(key, notSetValue);
  };

  ToKeyedSequence.prototype.has = function has (key) {
    return this._iter.has(key);
  };

  ToKeyedSequence.prototype.valueSeq = function valueSeq () {
    return this._iter.valueSeq();
  };

  ToKeyedSequence.prototype.reverse = function reverse () {
    var this$1$1 = this;

    var reversedSequence = reverseFactory(this, true);
    if (!this._useKeys) {
      reversedSequence.valueSeq = function () { return this$1$1._iter.toSeq().reverse(); };
    }
    return reversedSequence;
  };

  ToKeyedSequence.prototype.map = function map (mapper, context) {
    var this$1$1 = this;

    var mappedSequence = mapFactory(this, mapper, context);
    if (!this._useKeys) {
      mappedSequence.valueSeq = function () { return this$1$1._iter.toSeq().map(mapper, context); };
    }
    return mappedSequence;
  };

  ToKeyedSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._iter.__iterate(function (v, k) { return fn(v, k, this$1$1); }, reverse);
  };

  ToKeyedSequence.prototype.__iterator = function __iterator (type, reverse) {
    return this._iter.__iterator(type, reverse);
  };

  return ToKeyedSequence;
}(KeyedSeq));
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;

var ToIndexedSequence = /*@__PURE__*/(function (IndexedSeq) {
  function ToIndexedSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  if ( IndexedSeq ) ToIndexedSequence.__proto__ = IndexedSeq;
  ToIndexedSequence.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  ToIndexedSequence.prototype.constructor = ToIndexedSequence;

  ToIndexedSequence.prototype.includes = function includes (value) {
    return this._iter.includes(value);
  };

  ToIndexedSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    var i = 0;
    reverse && ensureSize(this);
    return this._iter.__iterate(
      function (v) { return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1); },
      reverse
    );
  };

  ToIndexedSequence.prototype.__iterator = function __iterator (type, reverse) {
    var this$1$1 = this;

    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    var i = 0;
    reverse && ensureSize(this);
    return new Iterator(function () {
      var step = iterator.next();
      return step.done
        ? step
        : iteratorValue(
            type,
            reverse ? this$1$1.size - ++i : i++,
            step.value,
            step
          );
    });
  };

  return ToIndexedSequence;
}(IndexedSeq));

var ToSetSequence = /*@__PURE__*/(function (SetSeq) {
  function ToSetSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  if ( SetSeq ) ToSetSequence.__proto__ = SetSeq;
  ToSetSequence.prototype = Object.create( SetSeq && SetSeq.prototype );
  ToSetSequence.prototype.constructor = ToSetSequence;

  ToSetSequence.prototype.has = function has (key) {
    return this._iter.includes(key);
  };

  ToSetSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._iter.__iterate(function (v) { return fn(v, v, this$1$1); }, reverse);
  };

  ToSetSequence.prototype.__iterator = function __iterator (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      var step = iterator.next();
      return step.done
        ? step
        : iteratorValue(type, step.value, step.value, step);
    });
  };

  return ToSetSequence;
}(SetSeq));

var FromEntriesSequence = /*@__PURE__*/(function (KeyedSeq) {
  function FromEntriesSequence(entries) {
    this._iter = entries;
    this.size = entries.size;
  }

  if ( KeyedSeq ) FromEntriesSequence.__proto__ = KeyedSeq;
  FromEntriesSequence.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
  FromEntriesSequence.prototype.constructor = FromEntriesSequence;

  FromEntriesSequence.prototype.entrySeq = function entrySeq () {
    return this._iter.toSeq();
  };

  FromEntriesSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._iter.__iterate(function (entry) {
      // Check if entry exists first so array access doesn't throw for holes
      // in the parent iteration.
      if (entry) {
        validateEntry(entry);
        var indexedCollection = isCollection(entry);
        return fn(
          indexedCollection ? entry.get(1) : entry[1],
          indexedCollection ? entry.get(0) : entry[0],
          this$1$1
        );
      }
    }, reverse);
  };

  FromEntriesSequence.prototype.__iterator = function __iterator (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      while (true) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedCollection = isCollection(entry);
          return iteratorValue(
            type,
            indexedCollection ? entry.get(0) : entry[0],
            indexedCollection ? entry.get(1) : entry[1],
            step
          );
        }
      }
    });
  };

  return FromEntriesSequence;
}(KeyedSeq));

ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;

function flipFactory(collection) {
  var flipSequence = makeSequence(collection);
  flipSequence._iter = collection;
  flipSequence.size = collection.size;
  flipSequence.flip = function () { return collection; };
  flipSequence.reverse = function () {
    var reversedSequence = collection.reverse.apply(this); // super.reverse()
    reversedSequence.flip = function () { return collection.reverse(); };
    return reversedSequence;
  };
  flipSequence.has = function (key) { return collection.includes(key); };
  flipSequence.includes = function (key) { return collection.has(key); };
  flipSequence.cacheResult = cacheResultThrough;
  flipSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    return collection.__iterate(function (v, k) { return fn(k, v, this$1$1) !== false; }, reverse);
  };
  flipSequence.__iteratorUncached = function (type, reverse) {
    if (type === ITERATE_ENTRIES) {
      var iterator = collection.__iterator(type, reverse);
      return new Iterator(function () {
        var step = iterator.next();
        if (!step.done) {
          var k = step.value[0];
          step.value[0] = step.value[1];
          step.value[1] = k;
        }
        return step;
      });
    }
    return collection.__iterator(
      type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
      reverse
    );
  };
  return flipSequence;
}

function mapFactory(collection, mapper, context) {
  var mappedSequence = makeSequence(collection);
  mappedSequence.size = collection.size;
  mappedSequence.has = function (key) { return collection.has(key); };
  mappedSequence.get = function (key, notSetValue) {
    var v = collection.get(key, NOT_SET);
    return v === NOT_SET
      ? notSetValue
      : mapper.call(context, v, key, collection);
  };
  mappedSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    return collection.__iterate(
      function (v, k, c) { return fn(mapper.call(context, v, k, c), k, this$1$1) !== false; },
      reverse
    );
  };
  mappedSequence.__iteratorUncached = function (type, reverse) {
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    return new Iterator(function () {
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      var key = entry[0];
      return iteratorValue(
        type,
        key,
        mapper.call(context, entry[1], key, collection),
        step
      );
    });
  };
  return mappedSequence;
}

function reverseFactory(collection, useKeys) {
  var this$1$1 = this;

  var reversedSequence = makeSequence(collection);
  reversedSequence._iter = collection;
  reversedSequence.size = collection.size;
  reversedSequence.reverse = function () { return collection; };
  if (collection.flip) {
    reversedSequence.flip = function () {
      var flipSequence = flipFactory(collection);
      flipSequence.reverse = function () { return collection.flip(); };
      return flipSequence;
    };
  }
  reversedSequence.get = function (key, notSetValue) { return collection.get(useKeys ? key : -1 - key, notSetValue); };
  reversedSequence.has = function (key) { return collection.has(useKeys ? key : -1 - key); };
  reversedSequence.includes = function (value) { return collection.includes(value); };
  reversedSequence.cacheResult = cacheResultThrough;
  reversedSequence.__iterate = function (fn, reverse) {
    var this$1$1 = this;

    var i = 0;
    reverse && ensureSize(collection);
    return collection.__iterate(
      function (v, k) { return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1); },
      !reverse
    );
  };
  reversedSequence.__iterator = function (type, reverse) {
    var i = 0;
    reverse && ensureSize(collection);
    var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
    return new Iterator(function () {
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      return iteratorValue(
        type,
        useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++,
        entry[1],
        step
      );
    });
  };
  return reversedSequence;
}

function filterFactory(collection, predicate, context, useKeys) {
  var filterSequence = makeSequence(collection);
  if (useKeys) {
    filterSequence.has = function (key) {
      var v = collection.get(key, NOT_SET);
      return v !== NOT_SET && !!predicate.call(context, v, key, collection);
    };
    filterSequence.get = function (key, notSetValue) {
      var v = collection.get(key, NOT_SET);
      return v !== NOT_SET && predicate.call(context, v, key, collection)
        ? v
        : notSetValue;
    };
  }
  filterSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    var iterations = 0;
    collection.__iterate(function (v, k, c) {
      if (predicate.call(context, v, k, c)) {
        iterations++;
        return fn(v, useKeys ? k : iterations - 1, this$1$1);
      }
    }, reverse);
    return iterations;
  };
  filterSequence.__iteratorUncached = function (type, reverse) {
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var iterations = 0;
    return new Iterator(function () {
      while (true) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        var value = entry[1];
        if (predicate.call(context, value, key, collection)) {
          return iteratorValue(type, useKeys ? key : iterations++, value, step);
        }
      }
    });
  };
  return filterSequence;
}

function countByFactory(collection, grouper, context) {
  var groups = immutable_es_Map().asMutable();
  collection.__iterate(function (v, k) {
    groups.update(grouper.call(context, v, k, collection), 0, function (a) { return a + 1; });
  });
  return groups.asImmutable();
}

function groupByFactory(collection, grouper, context) {
  var isKeyedIter = isKeyed(collection);
  var groups = (isOrdered(collection) ? OrderedMap() : immutable_es_Map()).asMutable();
  collection.__iterate(function (v, k) {
    groups.update(
      grouper.call(context, v, k, collection),
      function (a) { return ((a = a || []), a.push(isKeyedIter ? [k, v] : v), a); }
    );
  });
  var coerce = collectionClass(collection);
  return groups.map(function (arr) { return reify(collection, coerce(arr)); }).asImmutable();
}

function sliceFactory(collection, begin, end, useKeys) {
  var originalSize = collection.size;

  if (wholeSlice(begin, end, originalSize)) {
    return collection;
  }

  var resolvedBegin = resolveBegin(begin, originalSize);
  var resolvedEnd = resolveEnd(end, originalSize);

  // begin or end will be NaN if they were provided as negative numbers and
  // this collection's size is unknown. In that case, cache first so there is
  // a known size and these do not resolve to NaN.
  if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
    return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
  }

  // Note: resolvedEnd is undefined when the original sequence's length is
  // unknown and this slice did not supply an end and should contain all
  // elements after resolvedBegin.
  // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
  var resolvedSize = resolvedEnd - resolvedBegin;
  var sliceSize;
  if (resolvedSize === resolvedSize) {
    sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
  }

  var sliceSeq = makeSequence(collection);

  // If collection.size is undefined, the size of the realized sliceSeq is
  // unknown at this point unless the number of items to slice is 0
  sliceSeq.size =
    sliceSize === 0 ? sliceSize : (collection.size && sliceSize) || undefined;

  if (!useKeys && isSeq(collection) && sliceSize >= 0) {
    sliceSeq.get = function (index, notSetValue) {
      index = wrapIndex(this, index);
      return index >= 0 && index < sliceSize
        ? collection.get(index + resolvedBegin, notSetValue)
        : notSetValue;
    };
  }

  sliceSeq.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    if (sliceSize === 0) {
      return 0;
    }
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var skipped = 0;
    var isSkipping = true;
    var iterations = 0;
    collection.__iterate(function (v, k) {
      if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
        iterations++;
        return (
          fn(v, useKeys ? k : iterations - 1, this$1$1) !== false &&
          iterations !== sliceSize
        );
      }
    });
    return iterations;
  };

  sliceSeq.__iteratorUncached = function (type, reverse) {
    if (sliceSize !== 0 && reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    // Don't bother instantiating parent iterator if taking 0.
    if (sliceSize === 0) {
      return new Iterator(iteratorDone);
    }
    var iterator = collection.__iterator(type, reverse);
    var skipped = 0;
    var iterations = 0;
    return new Iterator(function () {
      while (skipped++ < resolvedBegin) {
        iterator.next();
      }
      if (++iterations > sliceSize) {
        return iteratorDone();
      }
      var step = iterator.next();
      if (useKeys || type === ITERATE_VALUES || step.done) {
        return step;
      }
      if (type === ITERATE_KEYS) {
        return iteratorValue(type, iterations - 1, undefined, step);
      }
      return iteratorValue(type, iterations - 1, step.value[1], step);
    });
  };

  return sliceSeq;
}

function takeWhileFactory(collection, predicate, context) {
  var takeSequence = makeSequence(collection);
  takeSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterations = 0;
    collection.__iterate(
      function (v, k, c) { return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1); }
    );
    return iterations;
  };
  takeSequence.__iteratorUncached = function (type, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var iterating = true;
    return new Iterator(function () {
      if (!iterating) {
        return iteratorDone();
      }
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      var k = entry[0];
      var v = entry[1];
      if (!predicate.call(context, v, k, this$1$1)) {
        iterating = false;
        return iteratorDone();
      }
      return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
    });
  };
  return takeSequence;
}

function skipWhileFactory(collection, predicate, context, useKeys) {
  var skipSequence = makeSequence(collection);
  skipSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var isSkipping = true;
    var iterations = 0;
    collection.__iterate(function (v, k, c) {
      if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
        iterations++;
        return fn(v, useKeys ? k : iterations - 1, this$1$1);
      }
    });
    return iterations;
  };
  skipSequence.__iteratorUncached = function (type, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var skipping = true;
    var iterations = 0;
    return new Iterator(function () {
      var step;
      var k;
      var v;
      do {
        step = iterator.next();
        if (step.done) {
          if (useKeys || type === ITERATE_VALUES) {
            return step;
          }
          if (type === ITERATE_KEYS) {
            return iteratorValue(type, iterations++, undefined, step);
          }
          return iteratorValue(type, iterations++, step.value[1], step);
        }
        var entry = step.value;
        k = entry[0];
        v = entry[1];
        skipping && (skipping = predicate.call(context, v, k, this$1$1));
      } while (skipping);
      return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
    });
  };
  return skipSequence;
}

function concatFactory(collection, values) {
  var isKeyedCollection = isKeyed(collection);
  var iters = [collection]
    .concat(values)
    .map(function (v) {
      if (!isCollection(v)) {
        v = isKeyedCollection
          ? keyedSeqFromValue(v)
          : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedCollection) {
        v = KeyedCollection(v);
      }
      return v;
    })
    .filter(function (v) { return v.size !== 0; });

  if (iters.length === 0) {
    return collection;
  }

  if (iters.length === 1) {
    var singleton = iters[0];
    if (
      singleton === collection ||
      (isKeyedCollection && isKeyed(singleton)) ||
      (isIndexed(collection) && isIndexed(singleton))
    ) {
      return singleton;
    }
  }

  var concatSeq = new ArraySeq(iters);
  if (isKeyedCollection) {
    concatSeq = concatSeq.toKeyedSeq();
  } else if (!isIndexed(collection)) {
    concatSeq = concatSeq.toSetSeq();
  }
  concatSeq = concatSeq.flatten(true);
  concatSeq.size = iters.reduce(function (sum, seq) {
    if (sum !== undefined) {
      var size = seq.size;
      if (size !== undefined) {
        return sum + size;
      }
    }
  }, 0);
  return concatSeq;
}

function flattenFactory(collection, depth, useKeys) {
  var flatSequence = makeSequence(collection);
  flatSequence.__iterateUncached = function (fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterations = 0;
    var stopped = false;
    function flatDeep(iter, currentDepth) {
      iter.__iterate(function (v, k) {
        if ((!depth || currentDepth < depth) && isCollection(v)) {
          flatDeep(v, currentDepth + 1);
        } else {
          iterations++;
          if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) {
            stopped = true;
          }
        }
        return !stopped;
      }, reverse);
    }
    flatDeep(collection, 0);
    return iterations;
  };
  flatSequence.__iteratorUncached = function (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(type, reverse);
    var stack = [];
    var iterations = 0;
    return new Iterator(function () {
      while (iterator) {
        var step = iterator.next();
        if (step.done !== false) {
          iterator = stack.pop();
          continue;
        }
        var v = step.value;
        if (type === ITERATE_ENTRIES) {
          v = v[1];
        }
        if ((!depth || stack.length < depth) && isCollection(v)) {
          stack.push(iterator);
          iterator = v.__iterator(type, reverse);
        } else {
          return useKeys ? step : iteratorValue(type, iterations++, v, step);
        }
      }
      return iteratorDone();
    });
  };
  return flatSequence;
}

function flatMapFactory(collection, mapper, context) {
  var coerce = collectionClass(collection);
  return collection
    .toSeq()
    .map(function (v, k) { return coerce(mapper.call(context, v, k, collection)); })
    .flatten(true);
}

function interposeFactory(collection, separator) {
  var interposedSequence = makeSequence(collection);
  interposedSequence.size = collection.size && collection.size * 2 - 1;
  interposedSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    var iterations = 0;
    collection.__iterate(
      function (v) { return (!iterations || fn(separator, iterations++, this$1$1) !== false) &&
        fn(v, iterations++, this$1$1) !== false; },
      reverse
    );
    return iterations;
  };
  interposedSequence.__iteratorUncached = function (type, reverse) {
    var iterator = collection.__iterator(ITERATE_VALUES, reverse);
    var iterations = 0;
    var step;
    return new Iterator(function () {
      if (!step || iterations % 2) {
        step = iterator.next();
        if (step.done) {
          return step;
        }
      }
      return iterations % 2
        ? iteratorValue(type, iterations++, separator)
        : iteratorValue(type, iterations++, step.value, step);
    });
  };
  return interposedSequence;
}

function sortFactory(collection, comparator, mapper) {
  if (!comparator) {
    comparator = defaultComparator;
  }
  var isKeyedCollection = isKeyed(collection);
  var index = 0;
  var entries = collection
    .toSeq()
    .map(function (v, k) { return [k, v, index++, mapper ? mapper(v, k, collection) : v]; })
    .valueSeq()
    .toArray();
  entries
    .sort(function (a, b) { return comparator(a[3], b[3]) || a[2] - b[2]; })
    .forEach(
      isKeyedCollection
        ? function (v, i) {
            entries[i].length = 2;
          }
        : function (v, i) {
            entries[i] = v[1];
          }
    );
  return isKeyedCollection
    ? KeyedSeq(entries)
    : isIndexed(collection)
    ? IndexedSeq(entries)
    : SetSeq(entries);
}

function maxFactory(collection, comparator, mapper) {
  if (!comparator) {
    comparator = defaultComparator;
  }
  if (mapper) {
    var entry = collection
      .toSeq()
      .map(function (v, k) { return [v, mapper(v, k, collection)]; })
      .reduce(function (a, b) { return (maxCompare(comparator, a[1], b[1]) ? b : a); });
    return entry && entry[0];
  }
  return collection.reduce(function (a, b) { return (maxCompare(comparator, a, b) ? b : a); });
}

function maxCompare(comparator, a, b) {
  var comp = comparator(b, a);
  // b is considered the new max if the comparator declares them equal, but
  // they are not equal and b is in fact a nullish value.
  return (
    (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) ||
    comp > 0
  );
}

function zipWithFactory(keyIter, zipper, iters, zipAll) {
  var zipSequence = makeSequence(keyIter);
  var sizes = new ArraySeq(iters).map(function (i) { return i.size; });
  zipSequence.size = zipAll ? sizes.max() : sizes.min();
  // Note: this a generic base implementation of __iterate in terms of
  // __iterator which may be more generically useful in the future.
  zipSequence.__iterate = function (fn, reverse) {
    /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */
    // indexed:
    var iterator = this.__iterator(ITERATE_VALUES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      if (fn(step.value, iterations++, this) === false) {
        break;
      }
    }
    return iterations;
  };
  zipSequence.__iteratorUncached = function (type, reverse) {
    var iterators = iters.map(
      function (i) { return ((i = Collection(i)), getIterator(reverse ? i.reverse() : i)); }
    );
    var iterations = 0;
    var isDone = false;
    return new Iterator(function () {
      var steps;
      if (!isDone) {
        steps = iterators.map(function (i) { return i.next(); });
        isDone = zipAll ? steps.every(function (s) { return s.done; }) : steps.some(function (s) { return s.done; });
      }
      if (isDone) {
        return iteratorDone();
      }
      return iteratorValue(
        type,
        iterations++,
        zipper.apply(
          null,
          steps.map(function (s) { return s.value; })
        )
      );
    });
  };
  return zipSequence;
}

// #pragma Helper Functions

function reify(iter, seq) {
  return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}

function validateEntry(entry) {
  if (entry !== Object(entry)) {
    throw new TypeError('Expected [K, V] tuple: ' + entry);
  }
}

function collectionClass(collection) {
  return isKeyed(collection)
    ? KeyedCollection
    : isIndexed(collection)
    ? IndexedCollection
    : SetCollection;
}

function makeSequence(collection) {
  return Object.create(
    (isKeyed(collection)
      ? KeyedSeq
      : isIndexed(collection)
      ? IndexedSeq
      : SetSeq
    ).prototype
  );
}

function cacheResultThrough() {
  if (this._iter.cacheResult) {
    this._iter.cacheResult();
    this.size = this._iter.size;
    return this;
  }
  return Seq.prototype.cacheResult.call(this);
}

function defaultComparator(a, b) {
  if (a === undefined && b === undefined) {
    return 0;
  }

  if (a === undefined) {
    return 1;
  }

  if (b === undefined) {
    return -1;
  }

  return a > b ? 1 : a < b ? -1 : 0;
}

function arrCopy(arr, offset) {
  offset = offset || 0;
  var len = Math.max(0, arr.length - offset);
  var newArr = new Array(len);
  for (var ii = 0; ii < len; ii++) {
    newArr[ii] = arr[ii + offset];
  }
  return newArr;
}

function invariant(condition, error) {
  if (!condition) { throw new Error(error); }
}

function assertNotInfinite(size) {
  invariant(
    size !== Infinity,
    'Cannot perform this action with an infinite size.'
  );
}

function coerceKeyPath(keyPath) {
  if (isArrayLike(keyPath) && typeof keyPath !== 'string') {
    return keyPath;
  }
  if (isOrdered(keyPath)) {
    return keyPath.toArray();
  }
  throw new TypeError(
    'Invalid keyPath: expected Ordered Collection or Array: ' + keyPath
  );
}

var immutable_es_toString = Object.prototype.toString;

function isPlainObject(value) {
  // The base prototype's toString deals with Argument objects and native namespaces like Math
  if (
    !value ||
    typeof value !== 'object' ||
    immutable_es_toString.call(value) !== '[object Object]'
  ) {
    return false;
  }

  var proto = Object.getPrototypeOf(value);
  if (proto === null) {
    return true;
  }

  // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
  var parentProto = proto;
  var nextProto = Object.getPrototypeOf(proto);
  while (nextProto !== null) {
    parentProto = nextProto;
    nextProto = Object.getPrototypeOf(parentProto);
  }
  return parentProto === proto;
}

/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */
function isDataStructure(value) {
  return (
    typeof value === 'object' &&
    (isImmutable(value) || Array.isArray(value) || isPlainObject(value))
  );
}

function quoteString(value) {
  try {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  } catch (_ignoreError) {
    return JSON.stringify(value);
  }
}

function has(collection, key) {
  return isImmutable(collection)
    ? collection.has(key)
    : isDataStructure(collection) && immutable_es_hasOwnProperty.call(collection, key);
}

function get(collection, key, notSetValue) {
  return isImmutable(collection)
    ? collection.get(key, notSetValue)
    : !has(collection, key)
    ? notSetValue
    : typeof collection.get === 'function'
    ? collection.get(key)
    : collection[key];
}

function shallowCopy(from) {
  if (Array.isArray(from)) {
    return arrCopy(from);
  }
  var to = {};
  for (var key in from) {
    if (immutable_es_hasOwnProperty.call(from, key)) {
      to[key] = from[key];
    }
  }
  return to;
}

function remove(collection, key) {
  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot update non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    if (!collection.remove) {
      throw new TypeError(
        'Cannot update immutable value without .remove() method: ' + collection
      );
    }
    return collection.remove(key);
  }
  if (!immutable_es_hasOwnProperty.call(collection, key)) {
    return collection;
  }
  var collectionCopy = shallowCopy(collection);
  if (Array.isArray(collectionCopy)) {
    collectionCopy.splice(key, 1);
  } else {
    delete collectionCopy[key];
  }
  return collectionCopy;
}

function set(collection, key, value) {
  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot update non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    if (!collection.set) {
      throw new TypeError(
        'Cannot update immutable value without .set() method: ' + collection
      );
    }
    return collection.set(key, value);
  }
  if (immutable_es_hasOwnProperty.call(collection, key) && value === collection[key]) {
    return collection;
  }
  var collectionCopy = shallowCopy(collection);
  collectionCopy[key] = value;
  return collectionCopy;
}

function updateIn$1(collection, keyPath, notSetValue, updater) {
  if (!updater) {
    updater = notSetValue;
    notSetValue = undefined;
  }
  var updatedValue = updateInDeeply(
    isImmutable(collection),
    collection,
    coerceKeyPath(keyPath),
    0,
    notSetValue,
    updater
  );
  return updatedValue === NOT_SET ? notSetValue : updatedValue;
}

function updateInDeeply(
  inImmutable,
  existing,
  keyPath,
  i,
  notSetValue,
  updater
) {
  var wasNotSet = existing === NOT_SET;
  if (i === keyPath.length) {
    var existingValue = wasNotSet ? notSetValue : existing;
    var newValue = updater(existingValue);
    return newValue === existingValue ? existing : newValue;
  }
  if (!wasNotSet && !isDataStructure(existing)) {
    throw new TypeError(
      'Cannot update within non-data-structure value in path [' +
        keyPath.slice(0, i).map(quoteString) +
        ']: ' +
        existing
    );
  }
  var key = keyPath[i];
  var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
  var nextUpdated = updateInDeeply(
    nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting),
    nextExisting,
    keyPath,
    i + 1,
    notSetValue,
    updater
  );
  return nextUpdated === nextExisting
    ? existing
    : nextUpdated === NOT_SET
    ? remove(existing, key)
    : set(
        wasNotSet ? (inImmutable ? emptyMap() : {}) : existing,
        key,
        nextUpdated
      );
}

function setIn$1(collection, keyPath, value) {
  return updateIn$1(collection, keyPath, NOT_SET, function () { return value; });
}

function setIn(keyPath, v) {
  return setIn$1(this, keyPath, v);
}

function removeIn(collection, keyPath) {
  return updateIn$1(collection, keyPath, function () { return NOT_SET; });
}

function deleteIn(keyPath) {
  return removeIn(this, keyPath);
}

function update$1(collection, key, notSetValue, updater) {
  return updateIn$1(collection, [key], notSetValue, updater);
}

function update(key, notSetValue, updater) {
  return arguments.length === 1
    ? key(this)
    : update$1(this, key, notSetValue, updater);
}

function updateIn(keyPath, notSetValue, updater) {
  return updateIn$1(this, keyPath, notSetValue, updater);
}

function merge$1() {
  var iters = [], len = arguments.length;
  while ( len-- ) iters[ len ] = arguments[ len ];

  return mergeIntoKeyedWith(this, iters);
}

function mergeWith$1(merger) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  if (typeof merger !== 'function') {
    throw new TypeError('Invalid merger function: ' + merger);
  }
  return mergeIntoKeyedWith(this, iters, merger);
}

function mergeIntoKeyedWith(collection, collections, merger) {
  var iters = [];
  for (var ii = 0; ii < collections.length; ii++) {
    var collection$1 = KeyedCollection(collections[ii]);
    if (collection$1.size !== 0) {
      iters.push(collection$1);
    }
  }
  if (iters.length === 0) {
    return collection;
  }
  if (
    collection.toSeq().size === 0 &&
    !collection.__ownerID &&
    iters.length === 1
  ) {
    return collection.constructor(iters[0]);
  }
  return collection.withMutations(function (collection) {
    var mergeIntoCollection = merger
      ? function (value, key) {
          update$1(collection, key, NOT_SET, function (oldVal) { return oldVal === NOT_SET ? value : merger(oldVal, value, key); }
          );
        }
      : function (value, key) {
          collection.set(key, value);
        };
    for (var ii = 0; ii < iters.length; ii++) {
      iters[ii].forEach(mergeIntoCollection);
    }
  });
}

function merge(collection) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

  return mergeWithSources(collection, sources);
}

function mergeWith(merger, collection) {
  var sources = [], len = arguments.length - 2;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 2 ];

  return mergeWithSources(collection, sources, merger);
}

function mergeDeep$1(collection) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

  return mergeDeepWithSources(collection, sources);
}

function mergeDeepWith$1(merger, collection) {
  var sources = [], len = arguments.length - 2;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 2 ];

  return mergeDeepWithSources(collection, sources, merger);
}

function mergeDeepWithSources(collection, sources, merger) {
  return mergeWithSources(collection, sources, deepMergerWith(merger));
}

function mergeWithSources(collection, sources, merger) {
  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot merge into non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    return typeof merger === 'function' && collection.mergeWith
      ? collection.mergeWith.apply(collection, [ merger ].concat( sources ))
      : collection.merge
      ? collection.merge.apply(collection, sources)
      : collection.concat.apply(collection, sources);
  }
  var isArray = Array.isArray(collection);
  var merged = collection;
  var Collection = isArray ? IndexedCollection : KeyedCollection;
  var mergeItem = isArray
    ? function (value) {
        // Copy on write
        if (merged === collection) {
          merged = shallowCopy(merged);
        }
        merged.push(value);
      }
    : function (value, key) {
        var hasVal = immutable_es_hasOwnProperty.call(merged, key);
        var nextVal =
          hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
          // Copy on write
          if (merged === collection) {
            merged = shallowCopy(merged);
          }
          merged[key] = nextVal;
        }
      };
  for (var i = 0; i < sources.length; i++) {
    Collection(sources[i]).forEach(mergeItem);
  }
  return merged;
}

function deepMergerWith(merger) {
  function deepMerger(oldValue, newValue, key) {
    return isDataStructure(oldValue) &&
      isDataStructure(newValue) &&
      areMergeable(oldValue, newValue)
      ? mergeWithSources(oldValue, [newValue], deepMerger)
      : merger
      ? merger(oldValue, newValue, key)
      : newValue;
  }
  return deepMerger;
}

/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */
function areMergeable(oldDataStructure, newDataStructure) {
  var oldSeq = Seq(oldDataStructure);
  var newSeq = Seq(newDataStructure);
  // This logic assumes that a sequence can only fall into one of the three
  // categories mentioned above (since there's no `isSetLike()` method).
  return (
    isIndexed(oldSeq) === isIndexed(newSeq) &&
    isKeyed(oldSeq) === isKeyed(newSeq)
  );
}

function mergeDeep() {
  var iters = [], len = arguments.length;
  while ( len-- ) iters[ len ] = arguments[ len ];

  return mergeDeepWithSources(this, iters);
}

function mergeDeepWith(merger) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return mergeDeepWithSources(this, iters, merger);
}

function mergeIn(keyPath) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return updateIn$1(this, keyPath, emptyMap(), function (m) { return mergeWithSources(m, iters); });
}

function mergeDeepIn(keyPath) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return updateIn$1(this, keyPath, emptyMap(), function (m) { return mergeDeepWithSources(m, iters); }
  );
}

function withMutations(fn) {
  var mutable = this.asMutable();
  fn(mutable);
  return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}

function asMutable() {
  return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}

function asImmutable() {
  return this.__ensureOwner();
}

function wasAltered() {
  return this.__altered;
}

var immutable_es_Map = /*@__PURE__*/(function (KeyedCollection) {
  function Map(value) {
    return value === undefined || value === null
      ? emptyMap()
      : isMap(value) && !isOrdered(value)
      ? value
      : emptyMap().withMutations(function (map) {
          var iter = KeyedCollection(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v, k) { return map.set(k, v); });
        });
  }

  if ( KeyedCollection ) Map.__proto__ = KeyedCollection;
  Map.prototype = Object.create( KeyedCollection && KeyedCollection.prototype );
  Map.prototype.constructor = Map;

  Map.of = function of () {
    var keyValues = [], len = arguments.length;
    while ( len-- ) keyValues[ len ] = arguments[ len ];

    return emptyMap().withMutations(function (map) {
      for (var i = 0; i < keyValues.length; i += 2) {
        if (i + 1 >= keyValues.length) {
          throw new Error('Missing value for key: ' + keyValues[i]);
        }
        map.set(keyValues[i], keyValues[i + 1]);
      }
    });
  };

  Map.prototype.toString = function toString () {
    return this.__toString('Map {', '}');
  };

  // @pragma Access

  Map.prototype.get = function get (k, notSetValue) {
    return this._root
      ? this._root.get(0, undefined, k, notSetValue)
      : notSetValue;
  };

  // @pragma Modification

  Map.prototype.set = function set (k, v) {
    return updateMap(this, k, v);
  };

  Map.prototype.remove = function remove (k) {
    return updateMap(this, k, NOT_SET);
  };

  Map.prototype.deleteAll = function deleteAll (keys) {
    var collection = Collection(keys);

    if (collection.size === 0) {
      return this;
    }

    return this.withMutations(function (map) {
      collection.forEach(function (key) { return map.remove(key); });
    });
  };

  Map.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._root = null;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyMap();
  };

  // @pragma Composition

  Map.prototype.sort = function sort (comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator));
  };

  Map.prototype.sortBy = function sortBy (mapper, comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator, mapper));
  };

  Map.prototype.map = function map (mapper, context) {
    var this$1$1 = this;

    return this.withMutations(function (map) {
      map.forEach(function (value, key) {
        map.set(key, mapper.call(context, value, key, this$1$1));
      });
    });
  };

  // @pragma Mutability

  Map.prototype.__iterator = function __iterator (type, reverse) {
    return new MapIterator(this, type, reverse);
  };

  Map.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    var iterations = 0;
    this._root &&
      this._root.iterate(function (entry) {
        iterations++;
        return fn(entry[1], entry[0], this$1$1);
      }, reverse);
    return iterations;
  };

  Map.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyMap();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeMap(this.size, this._root, ownerID, this.__hash);
  };

  return Map;
}(KeyedCollection));

immutable_es_Map.isMap = isMap;

var MapPrototype = immutable_es_Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function (result, arr) {
  return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function (obj) {
  return obj.asImmutable();
};

// #pragma Trie Nodes

var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
  this.ownerID = ownerID;
  this.entries = entries;
};

ArrayMapNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  var entries = this.entries;
  for (var ii = 0, len = entries.length; ii < len; ii++) {
    if (is(key, entries[ii][0])) {
      return entries[ii][1];
    }
  }
  return notSetValue;
};

ArrayMapNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  var removed = value === NOT_SET;

  var entries = this.entries;
  var idx = 0;
  var len = entries.length;
  for (; idx < len; idx++) {
    if (is(key, entries[idx][0])) {
      break;
    }
  }
  var exists = idx < len;

  if (exists ? entries[idx][1] === value : removed) {
    return this;
  }

  SetRef(didAlter);
  (removed || !exists) && SetRef(didChangeSize);

  if (removed && entries.length === 1) {
    return; // undefined
  }

  if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
    return createNodes(ownerID, entries, key, value);
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newEntries = isEditable ? entries : arrCopy(entries);

  if (exists) {
    if (removed) {
      idx === len - 1
        ? newEntries.pop()
        : (newEntries[idx] = newEntries.pop());
    } else {
      newEntries[idx] = [key, value];
    }
  } else {
    newEntries.push([key, value]);
  }

  if (isEditable) {
    this.entries = newEntries;
    return this;
  }

  return new ArrayMapNode(ownerID, newEntries);
};

var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
  this.ownerID = ownerID;
  this.bitmap = bitmap;
  this.nodes = nodes;
};

BitmapIndexedNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
  var bitmap = this.bitmap;
  return (bitmap & bit) === 0
    ? notSetValue
    : this.nodes[popCount(bitmap & (bit - 1))].get(
        shift + SHIFT,
        keyHash,
        key,
        notSetValue
      );
};

BitmapIndexedNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var bit = 1 << keyHashFrag;
  var bitmap = this.bitmap;
  var exists = (bitmap & bit) !== 0;

  if (!exists && value === NOT_SET) {
    return this;
  }

  var idx = popCount(bitmap & (bit - 1));
  var nodes = this.nodes;
  var node = exists ? nodes[idx] : undefined;
  var newNode = updateNode(
    node,
    ownerID,
    shift + SHIFT,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );

  if (newNode === node) {
    return this;
  }

  if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
    return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
  }

  if (
    exists &&
    !newNode &&
    nodes.length === 2 &&
    isLeafNode(nodes[idx ^ 1])
  ) {
    return nodes[idx ^ 1];
  }

  if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
    return newNode;
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newBitmap = exists ? (newNode ? bitmap : bitmap ^ bit) : bitmap | bit;
  var newNodes = exists
    ? newNode
      ? setAt(nodes, idx, newNode, isEditable)
      : spliceOut(nodes, idx, isEditable)
    : spliceIn(nodes, idx, newNode, isEditable);

  if (isEditable) {
    this.bitmap = newBitmap;
    this.nodes = newNodes;
    return this;
  }

  return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};

var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
  this.ownerID = ownerID;
  this.count = count;
  this.nodes = nodes;
};

HashArrayMapNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var node = this.nodes[idx];
  return node
    ? node.get(shift + SHIFT, keyHash, key, notSetValue)
    : notSetValue;
};

HashArrayMapNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var removed = value === NOT_SET;
  var nodes = this.nodes;
  var node = nodes[idx];

  if (removed && !node) {
    return this;
  }

  var newNode = updateNode(
    node,
    ownerID,
    shift + SHIFT,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );
  if (newNode === node) {
    return this;
  }

  var newCount = this.count;
  if (!node) {
    newCount++;
  } else if (!newNode) {
    newCount--;
    if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
      return packNodes(ownerID, nodes, newCount, idx);
    }
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newNodes = setAt(nodes, idx, newNode, isEditable);

  if (isEditable) {
    this.count = newCount;
    this.nodes = newNodes;
    return this;
  }

  return new HashArrayMapNode(ownerID, newCount, newNodes);
};

var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
  this.ownerID = ownerID;
  this.keyHash = keyHash;
  this.entries = entries;
};

HashCollisionNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  var entries = this.entries;
  for (var ii = 0, len = entries.length; ii < len; ii++) {
    if (is(key, entries[ii][0])) {
      return entries[ii][1];
    }
  }
  return notSetValue;
};

HashCollisionNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }

  var removed = value === NOT_SET;

  if (keyHash !== this.keyHash) {
    if (removed) {
      return this;
    }
    SetRef(didAlter);
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
  }

  var entries = this.entries;
  var idx = 0;
  var len = entries.length;
  for (; idx < len; idx++) {
    if (is(key, entries[idx][0])) {
      break;
    }
  }
  var exists = idx < len;

  if (exists ? entries[idx][1] === value : removed) {
    return this;
  }

  SetRef(didAlter);
  (removed || !exists) && SetRef(didChangeSize);

  if (removed && len === 2) {
    return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newEntries = isEditable ? entries : arrCopy(entries);

  if (exists) {
    if (removed) {
      idx === len - 1
        ? newEntries.pop()
        : (newEntries[idx] = newEntries.pop());
    } else {
      newEntries[idx] = [key, value];
    }
  } else {
    newEntries.push([key, value]);
  }

  if (isEditable) {
    this.entries = newEntries;
    return this;
  }

  return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};

var ValueNode = function ValueNode(ownerID, keyHash, entry) {
  this.ownerID = ownerID;
  this.keyHash = keyHash;
  this.entry = entry;
};

ValueNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};

ValueNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  var removed = value === NOT_SET;
  var keyMatch = is(key, this.entry[0]);
  if (keyMatch ? value === this.entry[1] : removed) {
    return this;
  }

  SetRef(didAlter);

  if (removed) {
    SetRef(didChangeSize);
    return; // undefined
  }

  if (keyMatch) {
    if (ownerID && ownerID === this.ownerID) {
      this.entry[1] = value;
      return this;
    }
    return new ValueNode(ownerID, this.keyHash, [key, value]);
  }

  SetRef(didChangeSize);
  return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
};

// #pragma Iterators

ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate =
  function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  };

BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate =
  function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  };

// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function (fn, reverse) {
  return fn(this.entry);
};

var MapIterator = /*@__PURE__*/(function (Iterator) {
  function MapIterator(map, type, reverse) {
    this._type = type;
    this._reverse = reverse;
    this._stack = map._root && mapIteratorFrame(map._root);
  }

  if ( Iterator ) MapIterator.__proto__ = Iterator;
  MapIterator.prototype = Object.create( Iterator && Iterator.prototype );
  MapIterator.prototype.constructor = MapIterator;

  MapIterator.prototype.next = function next () {
    var type = this._type;
    var stack = this._stack;
    while (stack) {
      var node = stack.node;
      var index = stack.index++;
      var maxIndex = (void 0);
      if (node.entry) {
        if (index === 0) {
          return mapIteratorValue(type, node.entry);
        }
      } else if (node.entries) {
        maxIndex = node.entries.length - 1;
        if (index <= maxIndex) {
          return mapIteratorValue(
            type,
            node.entries[this._reverse ? maxIndex - index : index]
          );
        }
      } else {
        maxIndex = node.nodes.length - 1;
        if (index <= maxIndex) {
          var subNode = node.nodes[this._reverse ? maxIndex - index : index];
          if (subNode) {
            if (subNode.entry) {
              return mapIteratorValue(type, subNode.entry);
            }
            stack = this._stack = mapIteratorFrame(subNode, stack);
          }
          continue;
        }
      }
      stack = this._stack = this._stack.__prev;
    }
    return iteratorDone();
  };

  return MapIterator;
}(Iterator));

function mapIteratorValue(type, entry) {
  return iteratorValue(type, entry[0], entry[1]);
}

function mapIteratorFrame(node, prev) {
  return {
    node: node,
    index: 0,
    __prev: prev,
  };
}

function makeMap(size, root, ownerID, hash) {
  var map = Object.create(MapPrototype);
  map.size = size;
  map._root = root;
  map.__ownerID = ownerID;
  map.__hash = hash;
  map.__altered = false;
  return map;
}

var EMPTY_MAP;
function emptyMap() {
  return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}

function updateMap(map, k, v) {
  var newRoot;
  var newSize;
  if (!map._root) {
    if (v === NOT_SET) {
      return map;
    }
    newSize = 1;
    newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
  } else {
    var didChangeSize = MakeRef();
    var didAlter = MakeRef();
    newRoot = updateNode(
      map._root,
      map.__ownerID,
      0,
      undefined,
      k,
      v,
      didChangeSize,
      didAlter
    );
    if (!didAlter.value) {
      return map;
    }
    newSize = map.size + (didChangeSize.value ? (v === NOT_SET ? -1 : 1) : 0);
  }
  if (map.__ownerID) {
    map.size = newSize;
    map._root = newRoot;
    map.__hash = undefined;
    map.__altered = true;
    return map;
  }
  return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}

function updateNode(
  node,
  ownerID,
  shift,
  keyHash,
  key,
  value,
  didChangeSize,
  didAlter
) {
  if (!node) {
    if (value === NOT_SET) {
      return node;
    }
    SetRef(didAlter);
    SetRef(didChangeSize);
    return new ValueNode(ownerID, keyHash, [key, value]);
  }
  return node.update(
    ownerID,
    shift,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );
}

function isLeafNode(node) {
  return (
    node.constructor === ValueNode || node.constructor === HashCollisionNode
  );
}

function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
  if (node.keyHash === keyHash) {
    return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
  }

  var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
  var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

  var newNode;
  var nodes =
    idx1 === idx2
      ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)]
      : ((newNode = new ValueNode(ownerID, keyHash, entry)),
        idx1 < idx2 ? [node, newNode] : [newNode, node]);

  return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
}

function createNodes(ownerID, entries, key, value) {
  if (!ownerID) {
    ownerID = new OwnerID();
  }
  var node = new ValueNode(ownerID, hash(key), [key, value]);
  for (var ii = 0; ii < entries.length; ii++) {
    var entry = entries[ii];
    node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
  }
  return node;
}

function packNodes(ownerID, nodes, count, excluding) {
  var bitmap = 0;
  var packedII = 0;
  var packedNodes = new Array(count);
  for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
    var node = nodes[ii];
    if (node !== undefined && ii !== excluding) {
      bitmap |= bit;
      packedNodes[packedII++] = node;
    }
  }
  return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}

function expandNodes(ownerID, nodes, bitmap, including, node) {
  var count = 0;
  var expandedNodes = new Array(SIZE);
  for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
    expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
  }
  expandedNodes[including] = node;
  return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}

function popCount(x) {
  x -= (x >> 1) & 0x55555555;
  x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
  x = (x + (x >> 4)) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
}

function setAt(array, idx, val, canEdit) {
  var newArray = canEdit ? array : arrCopy(array);
  newArray[idx] = val;
  return newArray;
}

function spliceIn(array, idx, val, canEdit) {
  var newLen = array.length + 1;
  if (canEdit && idx + 1 === newLen) {
    array[idx] = val;
    return array;
  }
  var newArray = new Array(newLen);
  var after = 0;
  for (var ii = 0; ii < newLen; ii++) {
    if (ii === idx) {
      newArray[ii] = val;
      after = -1;
    } else {
      newArray[ii] = array[ii + after];
    }
  }
  return newArray;
}

function spliceOut(array, idx, canEdit) {
  var newLen = array.length - 1;
  if (canEdit && idx === newLen) {
    array.pop();
    return array;
  }
  var newArray = new Array(newLen);
  var after = 0;
  for (var ii = 0; ii < newLen; ii++) {
    if (ii === idx) {
      after = 1;
    }
    newArray[ii] = array[ii + after];
  }
  return newArray;
}

var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

var IS_LIST_SYMBOL = '@@__IMMUTABLE_LIST__@@';

function isList(maybeList) {
  return Boolean(maybeList && maybeList[IS_LIST_SYMBOL]);
}

var List = /*@__PURE__*/(function (IndexedCollection) {
  function List(value) {
    var empty = emptyList();
    if (value === undefined || value === null) {
      return empty;
    }
    if (isList(value)) {
      return value;
    }
    var iter = IndexedCollection(value);
    var size = iter.size;
    if (size === 0) {
      return empty;
    }
    assertNotInfinite(size);
    if (size > 0 && size < SIZE) {
      return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
    }
    return empty.withMutations(function (list) {
      list.setSize(size);
      iter.forEach(function (v, i) { return list.set(i, v); });
    });
  }

  if ( IndexedCollection ) List.__proto__ = IndexedCollection;
  List.prototype = Object.create( IndexedCollection && IndexedCollection.prototype );
  List.prototype.constructor = List;

  List.of = function of (/*...values*/) {
    return this(arguments);
  };

  List.prototype.toString = function toString () {
    return this.__toString('List [', ']');
  };

  // @pragma Access

  List.prototype.get = function get (index, notSetValue) {
    index = wrapIndex(this, index);
    if (index >= 0 && index < this.size) {
      index += this._origin;
      var node = listNodeFor(this, index);
      return node && node.array[index & MASK];
    }
    return notSetValue;
  };

  // @pragma Modification

  List.prototype.set = function set (index, value) {
    return updateList(this, index, value);
  };

  List.prototype.remove = function remove (index) {
    return !this.has(index)
      ? this
      : index === 0
      ? this.shift()
      : index === this.size - 1
      ? this.pop()
      : this.splice(index, 1);
  };

  List.prototype.insert = function insert (index, value) {
    return this.splice(index, 0, value);
  };

  List.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = this._origin = this._capacity = 0;
      this._level = SHIFT;
      this._root = this._tail = this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyList();
  };

  List.prototype.push = function push (/*...values*/) {
    var values = arguments;
    var oldSize = this.size;
    return this.withMutations(function (list) {
      setListBounds(list, 0, oldSize + values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(oldSize + ii, values[ii]);
      }
    });
  };

  List.prototype.pop = function pop () {
    return setListBounds(this, 0, -1);
  };

  List.prototype.unshift = function unshift (/*...values*/) {
    var values = arguments;
    return this.withMutations(function (list) {
      setListBounds(list, -values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(ii, values[ii]);
      }
    });
  };

  List.prototype.shift = function shift () {
    return setListBounds(this, 1);
  };

  // @pragma Composition

  List.prototype.concat = function concat (/*...collections*/) {
    var arguments$1 = arguments;

    var seqs = [];
    for (var i = 0; i < arguments.length; i++) {
      var argument = arguments$1[i];
      var seq = IndexedCollection(
        typeof argument !== 'string' && hasIterator(argument)
          ? argument
          : [argument]
      );
      if (seq.size !== 0) {
        seqs.push(seq);
      }
    }
    if (seqs.length === 0) {
      return this;
    }
    if (this.size === 0 && !this.__ownerID && seqs.length === 1) {
      return this.constructor(seqs[0]);
    }
    return this.withMutations(function (list) {
      seqs.forEach(function (seq) { return seq.forEach(function (value) { return list.push(value); }); });
    });
  };

  List.prototype.setSize = function setSize (size) {
    return setListBounds(this, 0, size);
  };

  List.prototype.map = function map (mapper, context) {
    var this$1$1 = this;

    return this.withMutations(function (list) {
      for (var i = 0; i < this$1$1.size; i++) {
        list.set(i, mapper.call(context, list.get(i), i, this$1$1));
      }
    });
  };

  // @pragma Iteration

  List.prototype.slice = function slice (begin, end) {
    var size = this.size;
    if (wholeSlice(begin, end, size)) {
      return this;
    }
    return setListBounds(
      this,
      resolveBegin(begin, size),
      resolveEnd(end, size)
    );
  };

  List.prototype.__iterator = function __iterator (type, reverse) {
    var index = reverse ? this.size : 0;
    var values = iterateList(this, reverse);
    return new Iterator(function () {
      var value = values();
      return value === DONE
        ? iteratorDone()
        : iteratorValue(type, reverse ? --index : index++, value);
    });
  };

  List.prototype.__iterate = function __iterate (fn, reverse) {
    var index = reverse ? this.size : 0;
    var values = iterateList(this, reverse);
    var value;
    while ((value = values()) !== DONE) {
      if (fn(value, reverse ? --index : index++, this) === false) {
        break;
      }
    }
    return index;
  };

  List.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyList();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeList(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      ownerID,
      this.__hash
    );
  };

  return List;
}(IndexedCollection));

List.isList = isList;

var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function (result, arr) {
  return result.push(arr);
};
ListPrototype['@@transducer/result'] = function (obj) {
  return obj.asImmutable();
};

var VNode = function VNode(array, ownerID) {
  this.array = array;
  this.ownerID = ownerID;
};

// TODO: seems like these methods are very similar

VNode.prototype.removeBefore = function removeBefore (ownerID, level, index) {
  if (index === level ? 1 << level : this.array.length === 0) {
    return this;
  }
  var originIndex = (index >>> level) & MASK;
  if (originIndex >= this.array.length) {
    return new VNode([], ownerID);
  }
  var removingFirst = originIndex === 0;
  var newChild;
  if (level > 0) {
    var oldChild = this.array[originIndex];
    newChild =
      oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
    if (newChild === oldChild && removingFirst) {
      return this;
    }
  }
  if (removingFirst && !newChild) {
    return this;
  }
  var editable = editableVNode(this, ownerID);
  if (!removingFirst) {
    for (var ii = 0; ii < originIndex; ii++) {
      editable.array[ii] = undefined;
    }
  }
  if (newChild) {
    editable.array[originIndex] = newChild;
  }
  return editable;
};

VNode.prototype.removeAfter = function removeAfter (ownerID, level, index) {
  if (index === (level ? 1 << level : 0) || this.array.length === 0) {
    return this;
  }
  var sizeIndex = ((index - 1) >>> level) & MASK;
  if (sizeIndex >= this.array.length) {
    return this;
  }

  var newChild;
  if (level > 0) {
    var oldChild = this.array[sizeIndex];
    newChild =
      oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
    if (newChild === oldChild && sizeIndex === this.array.length - 1) {
      return this;
    }
  }

  var editable = editableVNode(this, ownerID);
  editable.array.splice(sizeIndex + 1);
  if (newChild) {
    editable.array[sizeIndex] = newChild;
  }
  return editable;
};

var DONE = {};

function iterateList(list, reverse) {
  var left = list._origin;
  var right = list._capacity;
  var tailPos = getTailOffset(right);
  var tail = list._tail;

  return iterateNodeOrLeaf(list._root, list._level, 0);

  function iterateNodeOrLeaf(node, level, offset) {
    return level === 0
      ? iterateLeaf(node, offset)
      : iterateNode(node, level, offset);
  }

  function iterateLeaf(node, offset) {
    var array = offset === tailPos ? tail && tail.array : node && node.array;
    var from = offset > left ? 0 : left - offset;
    var to = right - offset;
    if (to > SIZE) {
      to = SIZE;
    }
    return function () {
      if (from === to) {
        return DONE;
      }
      var idx = reverse ? --to : from++;
      return array && array[idx];
    };
  }

  function iterateNode(node, level, offset) {
    var values;
    var array = node && node.array;
    var from = offset > left ? 0 : (left - offset) >> level;
    var to = ((right - offset) >> level) + 1;
    if (to > SIZE) {
      to = SIZE;
    }
    return function () {
      while (true) {
        if (values) {
          var value = values();
          if (value !== DONE) {
            return value;
          }
          values = null;
        }
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        values = iterateNodeOrLeaf(
          array && array[idx],
          level - SHIFT,
          offset + (idx << level)
        );
      }
    };
  }
}

function makeList(origin, capacity, level, root, tail, ownerID, hash) {
  var list = Object.create(ListPrototype);
  list.size = capacity - origin;
  list._origin = origin;
  list._capacity = capacity;
  list._level = level;
  list._root = root;
  list._tail = tail;
  list.__ownerID = ownerID;
  list.__hash = hash;
  list.__altered = false;
  return list;
}

var EMPTY_LIST;
function emptyList() {
  return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}

function updateList(list, index, value) {
  index = wrapIndex(list, index);

  if (index !== index) {
    return list;
  }

  if (index >= list.size || index < 0) {
    return list.withMutations(function (list) {
      index < 0
        ? setListBounds(list, index).set(0, value)
        : setListBounds(list, 0, index + 1).set(index, value);
    });
  }

  index += list._origin;

  var newTail = list._tail;
  var newRoot = list._root;
  var didAlter = MakeRef();
  if (index >= getTailOffset(list._capacity)) {
    newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
  } else {
    newRoot = updateVNode(
      newRoot,
      list.__ownerID,
      list._level,
      index,
      value,
      didAlter
    );
  }

  if (!didAlter.value) {
    return list;
  }

  if (list.__ownerID) {
    list._root = newRoot;
    list._tail = newTail;
    list.__hash = undefined;
    list.__altered = true;
    return list;
  }
  return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}

function updateVNode(node, ownerID, level, index, value, didAlter) {
  var idx = (index >>> level) & MASK;
  var nodeHas = node && idx < node.array.length;
  if (!nodeHas && value === undefined) {
    return node;
  }

  var newNode;

  if (level > 0) {
    var lowerNode = node && node.array[idx];
    var newLowerNode = updateVNode(
      lowerNode,
      ownerID,
      level - SHIFT,
      index,
      value,
      didAlter
    );
    if (newLowerNode === lowerNode) {
      return node;
    }
    newNode = editableVNode(node, ownerID);
    newNode.array[idx] = newLowerNode;
    return newNode;
  }

  if (nodeHas && node.array[idx] === value) {
    return node;
  }

  if (didAlter) {
    SetRef(didAlter);
  }

  newNode = editableVNode(node, ownerID);
  if (value === undefined && idx === newNode.array.length - 1) {
    newNode.array.pop();
  } else {
    newNode.array[idx] = value;
  }
  return newNode;
}

function editableVNode(node, ownerID) {
  if (ownerID && node && ownerID === node.ownerID) {
    return node;
  }
  return new VNode(node ? node.array.slice() : [], ownerID);
}

function listNodeFor(list, rawIndex) {
  if (rawIndex >= getTailOffset(list._capacity)) {
    return list._tail;
  }
  if (rawIndex < 1 << (list._level + SHIFT)) {
    var node = list._root;
    var level = list._level;
    while (node && level > 0) {
      node = node.array[(rawIndex >>> level) & MASK];
      level -= SHIFT;
    }
    return node;
  }
}

function setListBounds(list, begin, end) {
  // Sanitize begin & end using this shorthand for ToInt32(argument)
  // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
  if (begin !== undefined) {
    begin |= 0;
  }
  if (end !== undefined) {
    end |= 0;
  }
  var owner = list.__ownerID || new OwnerID();
  var oldOrigin = list._origin;
  var oldCapacity = list._capacity;
  var newOrigin = oldOrigin + begin;
  var newCapacity =
    end === undefined
      ? oldCapacity
      : end < 0
      ? oldCapacity + end
      : oldOrigin + end;
  if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
    return list;
  }

  // If it's going to end after it starts, it's empty.
  if (newOrigin >= newCapacity) {
    return list.clear();
  }

  var newLevel = list._level;
  var newRoot = list._root;

  // New origin might need creating a higher root.
  var offsetShift = 0;
  while (newOrigin + offsetShift < 0) {
    newRoot = new VNode(
      newRoot && newRoot.array.length ? [undefined, newRoot] : [],
      owner
    );
    newLevel += SHIFT;
    offsetShift += 1 << newLevel;
  }
  if (offsetShift) {
    newOrigin += offsetShift;
    oldOrigin += offsetShift;
    newCapacity += offsetShift;
    oldCapacity += offsetShift;
  }

  var oldTailOffset = getTailOffset(oldCapacity);
  var newTailOffset = getTailOffset(newCapacity);

  // New size might need creating a higher root.
  while (newTailOffset >= 1 << (newLevel + SHIFT)) {
    newRoot = new VNode(
      newRoot && newRoot.array.length ? [newRoot] : [],
      owner
    );
    newLevel += SHIFT;
  }

  // Locate or create the new tail.
  var oldTail = list._tail;
  var newTail =
    newTailOffset < oldTailOffset
      ? listNodeFor(list, newCapacity - 1)
      : newTailOffset > oldTailOffset
      ? new VNode([], owner)
      : oldTail;

  // Merge Tail into tree.
  if (
    oldTail &&
    newTailOffset > oldTailOffset &&
    newOrigin < oldCapacity &&
    oldTail.array.length
  ) {
    newRoot = editableVNode(newRoot, owner);
    var node = newRoot;
    for (var level = newLevel; level > SHIFT; level -= SHIFT) {
      var idx = (oldTailOffset >>> level) & MASK;
      node = node.array[idx] = editableVNode(node.array[idx], owner);
    }
    node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
  }

  // If the size has been reduced, there's a chance the tail needs to be trimmed.
  if (newCapacity < oldCapacity) {
    newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
  }

  // If the new origin is within the tail, then we do not need a root.
  if (newOrigin >= newTailOffset) {
    newOrigin -= newTailOffset;
    newCapacity -= newTailOffset;
    newLevel = SHIFT;
    newRoot = null;
    newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
  } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
    offsetShift = 0;

    // Identify the new top root node of the subtree of the old root.
    while (newRoot) {
      var beginIndex = (newOrigin >>> newLevel) & MASK;
      if ((beginIndex !== newTailOffset >>> newLevel) & MASK) {
        break;
      }
      if (beginIndex) {
        offsetShift += (1 << newLevel) * beginIndex;
      }
      newLevel -= SHIFT;
      newRoot = newRoot.array[beginIndex];
    }

    // Trim the new sides of the new root.
    if (newRoot && newOrigin > oldOrigin) {
      newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
    }
    if (newRoot && newTailOffset < oldTailOffset) {
      newRoot = newRoot.removeAfter(
        owner,
        newLevel,
        newTailOffset - offsetShift
      );
    }
    if (offsetShift) {
      newOrigin -= offsetShift;
      newCapacity -= offsetShift;
    }
  }

  if (list.__ownerID) {
    list.size = newCapacity - newOrigin;
    list._origin = newOrigin;
    list._capacity = newCapacity;
    list._level = newLevel;
    list._root = newRoot;
    list._tail = newTail;
    list.__hash = undefined;
    list.__altered = true;
    return list;
  }
  return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}

function getTailOffset(size) {
  return size < SIZE ? 0 : ((size - 1) >>> SHIFT) << SHIFT;
}

var OrderedMap = /*@__PURE__*/(function (Map) {
  function OrderedMap(value) {
    return value === undefined || value === null
      ? emptyOrderedMap()
      : isOrderedMap(value)
      ? value
      : emptyOrderedMap().withMutations(function (map) {
          var iter = KeyedCollection(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v, k) { return map.set(k, v); });
        });
  }

  if ( Map ) OrderedMap.__proto__ = Map;
  OrderedMap.prototype = Object.create( Map && Map.prototype );
  OrderedMap.prototype.constructor = OrderedMap;

  OrderedMap.of = function of (/*...values*/) {
    return this(arguments);
  };

  OrderedMap.prototype.toString = function toString () {
    return this.__toString('OrderedMap {', '}');
  };

  // @pragma Access

  OrderedMap.prototype.get = function get (k, notSetValue) {
    var index = this._map.get(k);
    return index !== undefined ? this._list.get(index)[1] : notSetValue;
  };

  // @pragma Modification

  OrderedMap.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._map.clear();
      this._list.clear();
      this.__altered = true;
      return this;
    }
    return emptyOrderedMap();
  };

  OrderedMap.prototype.set = function set (k, v) {
    return updateOrderedMap(this, k, v);
  };

  OrderedMap.prototype.remove = function remove (k) {
    return updateOrderedMap(this, k, NOT_SET);
  };

  OrderedMap.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._list.__iterate(
      function (entry) { return entry && fn(entry[1], entry[0], this$1$1); },
      reverse
    );
  };

  OrderedMap.prototype.__iterator = function __iterator (type, reverse) {
    return this._list.fromEntrySeq().__iterator(type, reverse);
  };

  OrderedMap.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    var newList = this._list.__ensureOwner(ownerID);
    if (!ownerID) {
      if (this.size === 0) {
        return emptyOrderedMap();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      this._map = newMap;
      this._list = newList;
      return this;
    }
    return makeOrderedMap(newMap, newList, ownerID, this.__hash);
  };

  return OrderedMap;
}(immutable_es_Map));

OrderedMap.isOrderedMap = isOrderedMap;

OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

function makeOrderedMap(map, list, ownerID, hash) {
  var omap = Object.create(OrderedMap.prototype);
  omap.size = map ? map.size : 0;
  omap._map = map;
  omap._list = list;
  omap.__ownerID = ownerID;
  omap.__hash = hash;
  omap.__altered = false;
  return omap;
}

var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
  return (
    EMPTY_ORDERED_MAP ||
    (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()))
  );
}

function updateOrderedMap(omap, k, v) {
  var map = omap._map;
  var list = omap._list;
  var i = map.get(k);
  var has = i !== undefined;
  var newMap;
  var newList;
  if (v === NOT_SET) {
    // removed
    if (!has) {
      return omap;
    }
    if (list.size >= SIZE && list.size >= map.size * 2) {
      newList = list.filter(function (entry, idx) { return entry !== undefined && i !== idx; });
      newMap = newList
        .toKeyedSeq()
        .map(function (entry) { return entry[0]; })
        .flip()
        .toMap();
      if (omap.__ownerID) {
        newMap.__ownerID = newList.__ownerID = omap.__ownerID;
      }
    } else {
      newMap = map.remove(k);
      newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
    }
  } else if (has) {
    if (v === list.get(i)[1]) {
      return omap;
    }
    newMap = map;
    newList = list.set(i, [k, v]);
  } else {
    newMap = map.set(k, list.size);
    newList = list.set(list.size, [k, v]);
  }
  if (omap.__ownerID) {
    omap.size = newMap.size;
    omap._map = newMap;
    omap._list = newList;
    omap.__hash = undefined;
    omap.__altered = true;
    return omap;
  }
  return makeOrderedMap(newMap, newList);
}

var IS_STACK_SYMBOL = '@@__IMMUTABLE_STACK__@@';

function isStack(maybeStack) {
  return Boolean(maybeStack && maybeStack[IS_STACK_SYMBOL]);
}

var Stack = /*@__PURE__*/(function (IndexedCollection) {
  function Stack(value) {
    return value === undefined || value === null
      ? emptyStack()
      : isStack(value)
      ? value
      : emptyStack().pushAll(value);
  }

  if ( IndexedCollection ) Stack.__proto__ = IndexedCollection;
  Stack.prototype = Object.create( IndexedCollection && IndexedCollection.prototype );
  Stack.prototype.constructor = Stack;

  Stack.of = function of (/*...values*/) {
    return this(arguments);
  };

  Stack.prototype.toString = function toString () {
    return this.__toString('Stack [', ']');
  };

  // @pragma Access

  Stack.prototype.get = function get (index, notSetValue) {
    var head = this._head;
    index = wrapIndex(this, index);
    while (head && index--) {
      head = head.next;
    }
    return head ? head.value : notSetValue;
  };

  Stack.prototype.peek = function peek () {
    return this._head && this._head.value;
  };

  // @pragma Modification

  Stack.prototype.push = function push (/*...values*/) {
    var arguments$1 = arguments;

    if (arguments.length === 0) {
      return this;
    }
    var newSize = this.size + arguments.length;
    var head = this._head;
    for (var ii = arguments.length - 1; ii >= 0; ii--) {
      head = {
        value: arguments$1[ii],
        next: head,
      };
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pushAll = function pushAll (iter) {
    iter = IndexedCollection(iter);
    if (iter.size === 0) {
      return this;
    }
    if (this.size === 0 && isStack(iter)) {
      return iter;
    }
    assertNotInfinite(iter.size);
    var newSize = this.size;
    var head = this._head;
    iter.__iterate(function (value) {
      newSize++;
      head = {
        value: value,
        next: head,
      };
    }, /* reverse */ true);
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pop = function pop () {
    return this.slice(1);
  };

  Stack.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._head = undefined;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyStack();
  };

  Stack.prototype.slice = function slice (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    var resolvedBegin = resolveBegin(begin, this.size);
    var resolvedEnd = resolveEnd(end, this.size);
    if (resolvedEnd !== this.size) {
      // super.slice(begin, end);
      return IndexedCollection.prototype.slice.call(this, begin, end);
    }
    var newSize = this.size - resolvedBegin;
    var head = this._head;
    while (resolvedBegin--) {
      head = head.next;
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  // @pragma Mutability

  Stack.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyStack();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeStack(this.size, this._head, ownerID, this.__hash);
  };

  // @pragma Iteration

  Stack.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return new ArraySeq(this.toArray()).__iterate(
        function (v, k) { return fn(v, k, this$1$1); },
        reverse
      );
    }
    var iterations = 0;
    var node = this._head;
    while (node) {
      if (fn(node.value, iterations++, this) === false) {
        break;
      }
      node = node.next;
    }
    return iterations;
  };

  Stack.prototype.__iterator = function __iterator (type, reverse) {
    if (reverse) {
      return new ArraySeq(this.toArray()).__iterator(type, reverse);
    }
    var iterations = 0;
    var node = this._head;
    return new Iterator(function () {
      if (node) {
        var value = node.value;
        node = node.next;
        return iteratorValue(type, iterations++, value);
      }
      return iteratorDone();
    });
  };

  return Stack;
}(IndexedCollection));

Stack.isStack = isStack;

var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function (result, arr) {
  return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function (obj) {
  return obj.asImmutable();
};

function makeStack(size, head, ownerID, hash) {
  var map = Object.create(StackPrototype);
  map.size = size;
  map._head = head;
  map.__ownerID = ownerID;
  map.__hash = hash;
  map.__altered = false;
  return map;
}

var EMPTY_STACK;
function emptyStack() {
  return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}

var IS_SET_SYMBOL = '@@__IMMUTABLE_SET__@@';

function isSet(maybeSet) {
  return Boolean(maybeSet && maybeSet[IS_SET_SYMBOL]);
}

function isOrderedSet(maybeOrderedSet) {
  return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}

function deepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (
    !isCollection(b) ||
    (a.size !== undefined && b.size !== undefined && a.size !== b.size) ||
    (a.__hash !== undefined &&
      b.__hash !== undefined &&
      a.__hash !== b.__hash) ||
    isKeyed(a) !== isKeyed(b) ||
    isIndexed(a) !== isIndexed(b) ||
    isOrdered(a) !== isOrdered(b)
  ) {
    return false;
  }

  if (a.size === 0 && b.size === 0) {
    return true;
  }

  var notAssociative = !isAssociative(a);

  if (isOrdered(a)) {
    var entries = a.entries();
    return (
      b.every(function (v, k) {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done
    );
  }

  var flipped = false;

  if (a.size === undefined) {
    if (b.size === undefined) {
      if (typeof a.cacheResult === 'function') {
        a.cacheResult();
      }
    } else {
      flipped = true;
      var _ = a;
      a = b;
      b = _;
    }
  }

  var allEqual = true;
  var bSize = b.__iterate(function (v, k) {
    if (
      notAssociative
        ? !a.has(v)
        : flipped
        ? !is(v, a.get(k, NOT_SET))
        : !is(a.get(k, NOT_SET), v)
    ) {
      allEqual = false;
      return false;
    }
  });

  return allEqual && a.size === bSize;
}

function mixin(ctor, methods) {
  var keyCopier = function (key) {
    ctor.prototype[key] = methods[key];
  };
  Object.keys(methods).forEach(keyCopier);
  Object.getOwnPropertySymbols &&
    Object.getOwnPropertySymbols(methods).forEach(keyCopier);
  return ctor;
}

function toJS(value) {
  if (!value || typeof value !== 'object') {
    return value;
  }
  if (!isCollection(value)) {
    if (!isDataStructure(value)) {
      return value;
    }
    value = Seq(value);
  }
  if (isKeyed(value)) {
    var result$1 = {};
    value.__iterate(function (v, k) {
      result$1[k] = toJS(v);
    });
    return result$1;
  }
  var result = [];
  value.__iterate(function (v) {
    result.push(toJS(v));
  });
  return result;
}

var immutable_es_Set = /*@__PURE__*/(function (SetCollection) {
  function Set(value) {
    return value === undefined || value === null
      ? emptySet()
      : isSet(value) && !isOrdered(value)
      ? value
      : emptySet().withMutations(function (set) {
          var iter = SetCollection(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v) { return set.add(v); });
        });
  }

  if ( SetCollection ) Set.__proto__ = SetCollection;
  Set.prototype = Object.create( SetCollection && SetCollection.prototype );
  Set.prototype.constructor = Set;

  Set.of = function of (/*...values*/) {
    return this(arguments);
  };

  Set.fromKeys = function fromKeys (value) {
    return this(KeyedCollection(value).keySeq());
  };

  Set.intersect = function intersect (sets) {
    sets = Collection(sets).toArray();
    return sets.length
      ? SetPrototype.intersect.apply(Set(sets.pop()), sets)
      : emptySet();
  };

  Set.union = function union (sets) {
    sets = Collection(sets).toArray();
    return sets.length
      ? SetPrototype.union.apply(Set(sets.pop()), sets)
      : emptySet();
  };

  Set.prototype.toString = function toString () {
    return this.__toString('Set {', '}');
  };

  // @pragma Access

  Set.prototype.has = function has (value) {
    return this._map.has(value);
  };

  // @pragma Modification

  Set.prototype.add = function add (value) {
    return updateSet(this, this._map.set(value, value));
  };

  Set.prototype.remove = function remove (value) {
    return updateSet(this, this._map.remove(value));
  };

  Set.prototype.clear = function clear () {
    return updateSet(this, this._map.clear());
  };

  // @pragma Composition

  Set.prototype.map = function map (mapper, context) {
    var this$1$1 = this;

    // keep track if the set is altered by the map function
    var didChanges = false;

    var newMap = updateSet(
      this,
      this._map.mapEntries(function (ref) {
        var v = ref[1];

        var mapped = mapper.call(context, v, v, this$1$1);

        if (mapped !== v) {
          didChanges = true;
        }

        return [mapped, mapped];
      }, context)
    );

    return didChanges ? newMap : this;
  };

  Set.prototype.union = function union () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    iters = iters.filter(function (x) { return x.size !== 0; });
    if (iters.length === 0) {
      return this;
    }
    if (this.size === 0 && !this.__ownerID && iters.length === 1) {
      return this.constructor(iters[0]);
    }
    return this.withMutations(function (set) {
      for (var ii = 0; ii < iters.length; ii++) {
        SetCollection(iters[ii]).forEach(function (value) { return set.add(value); });
      }
    });
  };

  Set.prototype.intersect = function intersect () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) { return SetCollection(iter); });
    var toRemove = [];
    this.forEach(function (value) {
      if (!iters.every(function (iter) { return iter.includes(value); })) {
        toRemove.push(value);
      }
    });
    return this.withMutations(function (set) {
      toRemove.forEach(function (value) {
        set.remove(value);
      });
    });
  };

  Set.prototype.subtract = function subtract () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) { return SetCollection(iter); });
    var toRemove = [];
    this.forEach(function (value) {
      if (iters.some(function (iter) { return iter.includes(value); })) {
        toRemove.push(value);
      }
    });
    return this.withMutations(function (set) {
      toRemove.forEach(function (value) {
        set.remove(value);
      });
    });
  };

  Set.prototype.sort = function sort (comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator));
  };

  Set.prototype.sortBy = function sortBy (mapper, comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator, mapper));
  };

  Set.prototype.wasAltered = function wasAltered () {
    return this._map.wasAltered();
  };

  Set.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._map.__iterate(function (k) { return fn(k, k, this$1$1); }, reverse);
  };

  Set.prototype.__iterator = function __iterator (type, reverse) {
    return this._map.__iterator(type, reverse);
  };

  Set.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    if (!ownerID) {
      if (this.size === 0) {
        return this.__empty();
      }
      this.__ownerID = ownerID;
      this._map = newMap;
      return this;
    }
    return this.__make(newMap, ownerID);
  };

  return Set;
}(SetCollection));

immutable_es_Set.isSet = isSet;

var SetPrototype = immutable_es_Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function (result, arr) {
  return result.add(arr);
};
SetPrototype['@@transducer/result'] = function (obj) {
  return obj.asImmutable();
};

SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;

function updateSet(set, newMap) {
  if (set.__ownerID) {
    set.size = newMap.size;
    set._map = newMap;
    return set;
  }
  return newMap === set._map
    ? set
    : newMap.size === 0
    ? set.__empty()
    : set.__make(newMap);
}

function makeSet(map, ownerID) {
  var set = Object.create(SetPrototype);
  set.size = map ? map.size : 0;
  set._map = map;
  set.__ownerID = ownerID;
  return set;
}

var EMPTY_SET;
function emptySet() {
  return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}

/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */
var Range = /*@__PURE__*/(function (IndexedSeq) {
  function Range(start, end, step) {
    if (!(this instanceof Range)) {
      return new Range(start, end, step);
    }
    invariant(step !== 0, 'Cannot step a Range by 0');
    start = start || 0;
    if (end === undefined) {
      end = Infinity;
    }
    step = step === undefined ? 1 : Math.abs(step);
    if (end < start) {
      step = -step;
    }
    this._start = start;
    this._end = end;
    this._step = step;
    this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
    if (this.size === 0) {
      if (EMPTY_RANGE) {
        return EMPTY_RANGE;
      }
      EMPTY_RANGE = this;
    }
  }

  if ( IndexedSeq ) Range.__proto__ = IndexedSeq;
  Range.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  Range.prototype.constructor = Range;

  Range.prototype.toString = function toString () {
    if (this.size === 0) {
      return 'Range []';
    }
    return (
      'Range [ ' +
      this._start +
      '...' +
      this._end +
      (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]'
    );
  };

  Range.prototype.get = function get (index, notSetValue) {
    return this.has(index)
      ? this._start + wrapIndex(this, index) * this._step
      : notSetValue;
  };

  Range.prototype.includes = function includes (searchValue) {
    var possibleIndex = (searchValue - this._start) / this._step;
    return (
      possibleIndex >= 0 &&
      possibleIndex < this.size &&
      possibleIndex === Math.floor(possibleIndex)
    );
  };

  Range.prototype.slice = function slice (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    begin = resolveBegin(begin, this.size);
    end = resolveEnd(end, this.size);
    if (end <= begin) {
      return new Range(0, 0);
    }
    return new Range(
      this.get(begin, this._end),
      this.get(end, this._end),
      this._step
    );
  };

  Range.prototype.indexOf = function indexOf (searchValue) {
    var offsetValue = searchValue - this._start;
    if (offsetValue % this._step === 0) {
      var index = offsetValue / this._step;
      if (index >= 0 && index < this.size) {
        return index;
      }
    }
    return -1;
  };

  Range.prototype.lastIndexOf = function lastIndexOf (searchValue) {
    return this.indexOf(searchValue);
  };

  Range.prototype.__iterate = function __iterate (fn, reverse) {
    var size = this.size;
    var step = this._step;
    var value = reverse ? this._start + (size - 1) * step : this._start;
    var i = 0;
    while (i !== size) {
      if (fn(value, reverse ? size - ++i : i++, this) === false) {
        break;
      }
      value += reverse ? -step : step;
    }
    return i;
  };

  Range.prototype.__iterator = function __iterator (type, reverse) {
    var size = this.size;
    var step = this._step;
    var value = reverse ? this._start + (size - 1) * step : this._start;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var v = value;
      value += reverse ? -step : step;
      return iteratorValue(type, reverse ? size - ++i : i++, v);
    });
  };

  Range.prototype.equals = function equals (other) {
    return other instanceof Range
      ? this._start === other._start &&
          this._end === other._end &&
          this._step === other._step
      : deepEqual(this, other);
  };

  return Range;
}(IndexedSeq));

var EMPTY_RANGE;

function getIn$1(collection, searchKeyPath, notSetValue) {
  var keyPath = coerceKeyPath(searchKeyPath);
  var i = 0;
  while (i !== keyPath.length) {
    collection = get(collection, keyPath[i++], NOT_SET);
    if (collection === NOT_SET) {
      return notSetValue;
    }
  }
  return collection;
}

function getIn(searchKeyPath, notSetValue) {
  return getIn$1(this, searchKeyPath, notSetValue);
}

function hasIn$1(collection, keyPath) {
  return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}

function hasIn(searchKeyPath) {
  return hasIn$1(this, searchKeyPath);
}

function toObject() {
  assertNotInfinite(this.size);
  var object = {};
  this.__iterate(function (v, k) {
    object[k] = v;
  });
  return object;
}

// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;

Collection.Iterator = Iterator;

mixin(Collection, {
  // ### Conversion to other types

  toArray: function toArray() {
    assertNotInfinite(this.size);
    var array = new Array(this.size || 0);
    var useTuples = isKeyed(this);
    var i = 0;
    this.__iterate(function (v, k) {
      // Keyed collections produce an array of tuples.
      array[i++] = useTuples ? [k, v] : v;
    });
    return array;
  },

  toIndexedSeq: function toIndexedSeq() {
    return new ToIndexedSequence(this);
  },

  toJS: function toJS$1() {
    return toJS(this);
  },

  toKeyedSeq: function toKeyedSeq() {
    return new ToKeyedSequence(this, true);
  },

  toMap: function toMap() {
    // Use Late Binding here to solve the circular dependency.
    return immutable_es_Map(this.toKeyedSeq());
  },

  toObject: toObject,

  toOrderedMap: function toOrderedMap() {
    // Use Late Binding here to solve the circular dependency.
    return OrderedMap(this.toKeyedSeq());
  },

  toOrderedSet: function toOrderedSet() {
    // Use Late Binding here to solve the circular dependency.
    return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
  },

  toSet: function toSet() {
    // Use Late Binding here to solve the circular dependency.
    return immutable_es_Set(isKeyed(this) ? this.valueSeq() : this);
  },

  toSetSeq: function toSetSeq() {
    return new ToSetSequence(this);
  },

  toSeq: function toSeq() {
    return isIndexed(this)
      ? this.toIndexedSeq()
      : isKeyed(this)
      ? this.toKeyedSeq()
      : this.toSetSeq();
  },

  toStack: function toStack() {
    // Use Late Binding here to solve the circular dependency.
    return Stack(isKeyed(this) ? this.valueSeq() : this);
  },

  toList: function toList() {
    // Use Late Binding here to solve the circular dependency.
    return List(isKeyed(this) ? this.valueSeq() : this);
  },

  // ### Common JavaScript methods and properties

  toString: function toString() {
    return '[Collection]';
  },

  __toString: function __toString(head, tail) {
    if (this.size === 0) {
      return head + tail;
    }
    return (
      head +
      ' ' +
      this.toSeq().map(this.__toStringMapper).join(', ') +
      ' ' +
      tail
    );
  },

  // ### ES6 Collection methods (ES6 Array and Map)

  concat: function concat() {
    var values = [], len = arguments.length;
    while ( len-- ) values[ len ] = arguments[ len ];

    return reify(this, concatFactory(this, values));
  },

  includes: function includes(searchValue) {
    return this.some(function (value) { return is(value, searchValue); });
  },

  entries: function entries() {
    return this.__iterator(ITERATE_ENTRIES);
  },

  every: function every(predicate, context) {
    assertNotInfinite(this.size);
    var returnValue = true;
    this.__iterate(function (v, k, c) {
      if (!predicate.call(context, v, k, c)) {
        returnValue = false;
        return false;
      }
    });
    return returnValue;
  },

  filter: function filter(predicate, context) {
    return reify(this, filterFactory(this, predicate, context, true));
  },

  find: function find(predicate, context, notSetValue) {
    var entry = this.findEntry(predicate, context);
    return entry ? entry[1] : notSetValue;
  },

  forEach: function forEach(sideEffect, context) {
    assertNotInfinite(this.size);
    return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
  },

  join: function join(separator) {
    assertNotInfinite(this.size);
    separator = separator !== undefined ? '' + separator : ',';
    var joined = '';
    var isFirst = true;
    this.__iterate(function (v) {
      isFirst ? (isFirst = false) : (joined += separator);
      joined += v !== null && v !== undefined ? v.toString() : '';
    });
    return joined;
  },

  keys: function keys() {
    return this.__iterator(ITERATE_KEYS);
  },

  map: function map(mapper, context) {
    return reify(this, mapFactory(this, mapper, context));
  },

  reduce: function reduce$1(reducer, initialReduction, context) {
    return reduce(
      this,
      reducer,
      initialReduction,
      context,
      arguments.length < 2,
      false
    );
  },

  reduceRight: function reduceRight(reducer, initialReduction, context) {
    return reduce(
      this,
      reducer,
      initialReduction,
      context,
      arguments.length < 2,
      true
    );
  },

  reverse: function reverse() {
    return reify(this, reverseFactory(this, true));
  },

  slice: function slice(begin, end) {
    return reify(this, sliceFactory(this, begin, end, true));
  },

  some: function some(predicate, context) {
    return !this.every(not(predicate), context);
  },

  sort: function sort(comparator) {
    return reify(this, sortFactory(this, comparator));
  },

  values: function values() {
    return this.__iterator(ITERATE_VALUES);
  },

  // ### More sequential methods

  butLast: function butLast() {
    return this.slice(0, -1);
  },

  isEmpty: function isEmpty() {
    return this.size !== undefined ? this.size === 0 : !this.some(function () { return true; });
  },

  count: function count(predicate, context) {
    return ensureSize(
      predicate ? this.toSeq().filter(predicate, context) : this
    );
  },

  countBy: function countBy(grouper, context) {
    return countByFactory(this, grouper, context);
  },

  equals: function equals(other) {
    return deepEqual(this, other);
  },

  entrySeq: function entrySeq() {
    var collection = this;
    if (collection._cache) {
      // We cache as an entries array, so we can just return the cache!
      return new ArraySeq(collection._cache);
    }
    var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
    entriesSequence.fromEntrySeq = function () { return collection.toSeq(); };
    return entriesSequence;
  },

  filterNot: function filterNot(predicate, context) {
    return this.filter(not(predicate), context);
  },

  findEntry: function findEntry(predicate, context, notSetValue) {
    var found = notSetValue;
    this.__iterate(function (v, k, c) {
      if (predicate.call(context, v, k, c)) {
        found = [k, v];
        return false;
      }
    });
    return found;
  },

  findKey: function findKey(predicate, context) {
    var entry = this.findEntry(predicate, context);
    return entry && entry[0];
  },

  findLast: function findLast(predicate, context, notSetValue) {
    return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
  },

  findLastEntry: function findLastEntry(predicate, context, notSetValue) {
    return this.toKeyedSeq()
      .reverse()
      .findEntry(predicate, context, notSetValue);
  },

  findLastKey: function findLastKey(predicate, context) {
    return this.toKeyedSeq().reverse().findKey(predicate, context);
  },

  first: function first(notSetValue) {
    return this.find(returnTrue, null, notSetValue);
  },

  flatMap: function flatMap(mapper, context) {
    return reify(this, flatMapFactory(this, mapper, context));
  },

  flatten: function flatten(depth) {
    return reify(this, flattenFactory(this, depth, true));
  },

  fromEntrySeq: function fromEntrySeq() {
    return new FromEntriesSequence(this);
  },

  get: function get(searchKey, notSetValue) {
    return this.find(function (_, key) { return is(key, searchKey); }, undefined, notSetValue);
  },

  getIn: getIn,

  groupBy: function groupBy(grouper, context) {
    return groupByFactory(this, grouper, context);
  },

  has: function has(searchKey) {
    return this.get(searchKey, NOT_SET) !== NOT_SET;
  },

  hasIn: hasIn,

  isSubset: function isSubset(iter) {
    iter = typeof iter.includes === 'function' ? iter : Collection(iter);
    return this.every(function (value) { return iter.includes(value); });
  },

  isSuperset: function isSuperset(iter) {
    iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
    return iter.isSubset(this);
  },

  keyOf: function keyOf(searchValue) {
    return this.findKey(function (value) { return is(value, searchValue); });
  },

  keySeq: function keySeq() {
    return this.toSeq().map(keyMapper).toIndexedSeq();
  },

  last: function last(notSetValue) {
    return this.toSeq().reverse().first(notSetValue);
  },

  lastKeyOf: function lastKeyOf(searchValue) {
    return this.toKeyedSeq().reverse().keyOf(searchValue);
  },

  max: function max(comparator) {
    return maxFactory(this, comparator);
  },

  maxBy: function maxBy(mapper, comparator) {
    return maxFactory(this, comparator, mapper);
  },

  min: function min(comparator) {
    return maxFactory(
      this,
      comparator ? neg(comparator) : defaultNegComparator
    );
  },

  minBy: function minBy(mapper, comparator) {
    return maxFactory(
      this,
      comparator ? neg(comparator) : defaultNegComparator,
      mapper
    );
  },

  rest: function rest() {
    return this.slice(1);
  },

  skip: function skip(amount) {
    return amount === 0 ? this : this.slice(Math.max(0, amount));
  },

  skipLast: function skipLast(amount) {
    return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
  },

  skipWhile: function skipWhile(predicate, context) {
    return reify(this, skipWhileFactory(this, predicate, context, true));
  },

  skipUntil: function skipUntil(predicate, context) {
    return this.skipWhile(not(predicate), context);
  },

  sortBy: function sortBy(mapper, comparator) {
    return reify(this, sortFactory(this, comparator, mapper));
  },

  take: function take(amount) {
    return this.slice(0, Math.max(0, amount));
  },

  takeLast: function takeLast(amount) {
    return this.slice(-Math.max(0, amount));
  },

  takeWhile: function takeWhile(predicate, context) {
    return reify(this, takeWhileFactory(this, predicate, context));
  },

  takeUntil: function takeUntil(predicate, context) {
    return this.takeWhile(not(predicate), context);
  },

  update: function update(fn) {
    return fn(this);
  },

  valueSeq: function valueSeq() {
    return this.toIndexedSeq();
  },

  // ### Hashable Object

  hashCode: function hashCode() {
    return this.__hash || (this.__hash = hashCollection(this));
  },

  // ### Internal

  // abstract __iterate(fn, reverse)

  // abstract __iterator(type, reverse)
});

var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function () {
  return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;

mixin(KeyedCollection, {
  // ### More sequential methods

  flip: function flip() {
    return reify(this, flipFactory(this));
  },

  mapEntries: function mapEntries(mapper, context) {
    var this$1$1 = this;

    var iterations = 0;
    return reify(
      this,
      this.toSeq()
        .map(function (v, k) { return mapper.call(context, [k, v], iterations++, this$1$1); })
        .fromEntrySeq()
    );
  },

  mapKeys: function mapKeys(mapper, context) {
    var this$1$1 = this;

    return reify(
      this,
      this.toSeq()
        .flip()
        .map(function (k, v) { return mapper.call(context, k, v, this$1$1); })
        .flip()
    );
  },
});

var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function (v, k) { return quoteString(k) + ': ' + quoteString(v); };

mixin(IndexedCollection, {
  // ### Conversion to other types

  toKeyedSeq: function toKeyedSeq() {
    return new ToKeyedSequence(this, false);
  },

  // ### ES6 Collection methods (ES6 Array and Map)

  filter: function filter(predicate, context) {
    return reify(this, filterFactory(this, predicate, context, false));
  },

  findIndex: function findIndex(predicate, context) {
    var entry = this.findEntry(predicate, context);
    return entry ? entry[0] : -1;
  },

  indexOf: function indexOf(searchValue) {
    var key = this.keyOf(searchValue);
    return key === undefined ? -1 : key;
  },

  lastIndexOf: function lastIndexOf(searchValue) {
    var key = this.lastKeyOf(searchValue);
    return key === undefined ? -1 : key;
  },

  reverse: function reverse() {
    return reify(this, reverseFactory(this, false));
  },

  slice: function slice(begin, end) {
    return reify(this, sliceFactory(this, begin, end, false));
  },

  splice: function splice(index, removeNum /*, ...values*/) {
    var numArgs = arguments.length;
    removeNum = Math.max(removeNum || 0, 0);
    if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
      return this;
    }
    // If index is negative, it should resolve relative to the size of the
    // collection. However size may be expensive to compute if not cached, so
    // only call count() if the number is in fact negative.
    index = resolveBegin(index, index < 0 ? this.count() : this.size);
    var spliced = this.slice(0, index);
    return reify(
      this,
      numArgs === 1
        ? spliced
        : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
    );
  },

  // ### More collection methods

  findLastIndex: function findLastIndex(predicate, context) {
    var entry = this.findLastEntry(predicate, context);
    return entry ? entry[0] : -1;
  },

  first: function first(notSetValue) {
    return this.get(0, notSetValue);
  },

  flatten: function flatten(depth) {
    return reify(this, flattenFactory(this, depth, false));
  },

  get: function get(index, notSetValue) {
    index = wrapIndex(this, index);
    return index < 0 ||
      this.size === Infinity ||
      (this.size !== undefined && index > this.size)
      ? notSetValue
      : this.find(function (_, key) { return key === index; }, undefined, notSetValue);
  },

  has: function has(index) {
    index = wrapIndex(this, index);
    return (
      index >= 0 &&
      (this.size !== undefined
        ? this.size === Infinity || index < this.size
        : this.indexOf(index) !== -1)
    );
  },

  interpose: function interpose(separator) {
    return reify(this, interposeFactory(this, separator));
  },

  interleave: function interleave(/*...collections*/) {
    var collections = [this].concat(arrCopy(arguments));
    var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
    var interleaved = zipped.flatten(true);
    if (zipped.size) {
      interleaved.size = zipped.size * collections.length;
    }
    return reify(this, interleaved);
  },

  keySeq: function keySeq() {
    return Range(0, this.size);
  },

  last: function last(notSetValue) {
    return this.get(-1, notSetValue);
  },

  skipWhile: function skipWhile(predicate, context) {
    return reify(this, skipWhileFactory(this, predicate, context, false));
  },

  zip: function zip(/*, ...collections */) {
    var collections = [this].concat(arrCopy(arguments));
    return reify(this, zipWithFactory(this, defaultZipper, collections));
  },

  zipAll: function zipAll(/*, ...collections */) {
    var collections = [this].concat(arrCopy(arguments));
    return reify(this, zipWithFactory(this, defaultZipper, collections, true));
  },

  zipWith: function zipWith(zipper /*, ...collections */) {
    var collections = arrCopy(arguments);
    collections[0] = this;
    return reify(this, zipWithFactory(this, zipper, collections));
  },
});

var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;

mixin(SetCollection, {
  // ### ES6 Collection methods (ES6 Array and Map)

  get: function get(value, notSetValue) {
    return this.has(value) ? value : notSetValue;
  },

  includes: function includes(value) {
    return this.has(value);
  },

  // ### More sequential methods

  keySeq: function keySeq() {
    return this.valueSeq();
  },
});

var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;

// Mixin subclasses

mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);

// #pragma Helper functions

function reduce(collection, reducer, reduction, context, useFirst, reverse) {
  assertNotInfinite(collection.size);
  collection.__iterate(function (v, k, c) {
    if (useFirst) {
      useFirst = false;
      reduction = v;
    } else {
      reduction = reducer.call(context, reduction, v, k, c);
    }
  }, reverse);
  return reduction;
}

function keyMapper(v, k) {
  return k;
}

function entryMapper(v, k) {
  return [k, v];
}

function not(predicate) {
  return function () {
    return !predicate.apply(this, arguments);
  };
}

function neg(predicate) {
  return function () {
    return -predicate.apply(this, arguments);
  };
}

function defaultZipper() {
  return arrCopy(arguments);
}

function defaultNegComparator(a, b) {
  return a < b ? 1 : a > b ? -1 : 0;
}

function hashCollection(collection) {
  if (collection.size === Infinity) {
    return 0;
  }
  var ordered = isOrdered(collection);
  var keyed = isKeyed(collection);
  var h = ordered ? 1 : 0;
  var size = collection.__iterate(
    keyed
      ? ordered
        ? function (v, k) {
            h = (31 * h + hashMerge(hash(v), hash(k))) | 0;
          }
        : function (v, k) {
            h = (h + hashMerge(hash(v), hash(k))) | 0;
          }
      : ordered
      ? function (v) {
          h = (31 * h + hash(v)) | 0;
        }
      : function (v) {
          h = (h + hash(v)) | 0;
        }
  );
  return murmurHashOfSize(size, h);
}

function murmurHashOfSize(size, h) {
  h = imul(h, 0xcc9e2d51);
  h = imul((h << 15) | (h >>> -15), 0x1b873593);
  h = imul((h << 13) | (h >>> -13), 5);
  h = ((h + 0xe6546b64) | 0) ^ size;
  h = imul(h ^ (h >>> 16), 0x85ebca6b);
  h = imul(h ^ (h >>> 13), 0xc2b2ae35);
  h = smi(h ^ (h >>> 16));
  return h;
}

function hashMerge(a, b) {
  return (a ^ (b + 0x9e3779b9 + (a << 6) + (a >> 2))) | 0; // int
}

var OrderedSet = /*@__PURE__*/(function (Set) {
  function OrderedSet(value) {
    return value === undefined || value === null
      ? emptyOrderedSet()
      : isOrderedSet(value)
      ? value
      : emptyOrderedSet().withMutations(function (set) {
          var iter = SetCollection(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v) { return set.add(v); });
        });
  }

  if ( Set ) OrderedSet.__proto__ = Set;
  OrderedSet.prototype = Object.create( Set && Set.prototype );
  OrderedSet.prototype.constructor = OrderedSet;

  OrderedSet.of = function of (/*...values*/) {
    return this(arguments);
  };

  OrderedSet.fromKeys = function fromKeys (value) {
    return this(KeyedCollection(value).keySeq());
  };

  OrderedSet.prototype.toString = function toString () {
    return this.__toString('OrderedSet {', '}');
  };

  return OrderedSet;
}(immutable_es_Set));

OrderedSet.isOrderedSet = isOrderedSet;

var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;

OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;

function makeOrderedSet(map, ownerID) {
  var set = Object.create(OrderedSetPrototype);
  set.size = map ? map.size : 0;
  set._map = map;
  set.__ownerID = ownerID;
  return set;
}

var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
  return (
    EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()))
  );
}

function throwOnInvalidDefaultValues(defaultValues) {
  if (isRecord(defaultValues)) {
    throw new Error(
      'Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.'
    );
  }

  if (isImmutable(defaultValues)) {
    throw new Error(
      'Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.'
    );
  }

  if (defaultValues === null || typeof defaultValues !== 'object') {
    throw new Error(
      'Can not call `Record` with a non-object as default values. Use a plain javascript object instead.'
    );
  }
}

var Record = function Record(defaultValues, name) {
  var hasInitialized;

  throwOnInvalidDefaultValues(defaultValues);

  var RecordType = function Record(values) {
    var this$1$1 = this;

    if (values instanceof RecordType) {
      return values;
    }
    if (!(this instanceof RecordType)) {
      return new RecordType(values);
    }
    if (!hasInitialized) {
      hasInitialized = true;
      var keys = Object.keys(defaultValues);
      var indices = (RecordTypePrototype._indices = {});
      // Deprecated: left to attempt not to break any external code which
      // relies on a ._name property existing on record instances.
      // Use Record.getDescriptiveName() instead
      RecordTypePrototype._name = name;
      RecordTypePrototype._keys = keys;
      RecordTypePrototype._defaultValues = defaultValues;
      for (var i = 0; i < keys.length; i++) {
        var propName = keys[i];
        indices[propName] = i;
        if (RecordTypePrototype[propName]) {
          /* eslint-disable no-console */
          typeof console === 'object' &&
            console.warn &&
            console.warn(
              'Cannot define ' +
                recordName(this) +
                ' with property "' +
                propName +
                '" since that property name is part of the Record API.'
            );
          /* eslint-enable no-console */
        } else {
          setProp(RecordTypePrototype, propName);
        }
      }
    }
    this.__ownerID = undefined;
    this._values = List().withMutations(function (l) {
      l.setSize(this$1$1._keys.length);
      KeyedCollection(values).forEach(function (v, k) {
        l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
      });
    });
    return this;
  };

  var RecordTypePrototype = (RecordType.prototype =
    Object.create(RecordPrototype));
  RecordTypePrototype.constructor = RecordType;

  if (name) {
    RecordType.displayName = name;
  }

  return RecordType;
};

Record.prototype.toString = function toString () {
  var str = recordName(this) + ' { ';
  var keys = this._keys;
  var k;
  for (var i = 0, l = keys.length; i !== l; i++) {
    k = keys[i];
    str += (i ? ', ' : '') + k + ': ' + quoteString(this.get(k));
  }
  return str + ' }';
};

Record.prototype.equals = function equals (other) {
  return (
    this === other ||
    (isRecord(other) && recordSeq(this).equals(recordSeq(other)))
  );
};

Record.prototype.hashCode = function hashCode () {
  return recordSeq(this).hashCode();
};

// @pragma Access

Record.prototype.has = function has (k) {
  return this._indices.hasOwnProperty(k);
};

Record.prototype.get = function get (k, notSetValue) {
  if (!this.has(k)) {
    return notSetValue;
  }
  var index = this._indices[k];
  var value = this._values.get(index);
  return value === undefined ? this._defaultValues[k] : value;
};

// @pragma Modification

Record.prototype.set = function set (k, v) {
  if (this.has(k)) {
    var newValues = this._values.set(
      this._indices[k],
      v === this._defaultValues[k] ? undefined : v
    );
    if (newValues !== this._values && !this.__ownerID) {
      return makeRecord(this, newValues);
    }
  }
  return this;
};

Record.prototype.remove = function remove (k) {
  return this.set(k);
};

Record.prototype.clear = function clear () {
  var newValues = this._values.clear().setSize(this._keys.length);

  return this.__ownerID ? this : makeRecord(this, newValues);
};

Record.prototype.wasAltered = function wasAltered () {
  return this._values.wasAltered();
};

Record.prototype.toSeq = function toSeq () {
  return recordSeq(this);
};

Record.prototype.toJS = function toJS$1 () {
  return toJS(this);
};

Record.prototype.entries = function entries () {
  return this.__iterator(ITERATE_ENTRIES);
};

Record.prototype.__iterator = function __iterator (type, reverse) {
  return recordSeq(this).__iterator(type, reverse);
};

Record.prototype.__iterate = function __iterate (fn, reverse) {
  return recordSeq(this).__iterate(fn, reverse);
};

Record.prototype.__ensureOwner = function __ensureOwner (ownerID) {
  if (ownerID === this.__ownerID) {
    return this;
  }
  var newValues = this._values.__ensureOwner(ownerID);
  if (!ownerID) {
    this.__ownerID = ownerID;
    this._values = newValues;
    return this;
  }
  return makeRecord(this, newValues, ownerID);
};

Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject =
  CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function () {
  return this.toString();
};

function makeRecord(likeRecord, values, ownerID) {
  var record = Object.create(Object.getPrototypeOf(likeRecord));
  record._values = values;
  record.__ownerID = ownerID;
  return record;
}

function recordName(record) {
  return record.constructor.displayName || record.constructor.name || 'Record';
}

function recordSeq(record) {
  return keyedSeqFromValue(record._keys.map(function (k) { return [k, record.get(k)]; }));
}

function setProp(prototype, name) {
  try {
    Object.defineProperty(prototype, name, {
      get: function () {
        return this.get(name);
      },
      set: function (value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      },
    });
  } catch (error) {
    // Object.defineProperty failed. Probably IE8.
  }
}

/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */
var Repeat = /*@__PURE__*/(function (IndexedSeq) {
  function Repeat(value, times) {
    if (!(this instanceof Repeat)) {
      return new Repeat(value, times);
    }
    this._value = value;
    this.size = times === undefined ? Infinity : Math.max(0, times);
    if (this.size === 0) {
      if (EMPTY_REPEAT) {
        return EMPTY_REPEAT;
      }
      EMPTY_REPEAT = this;
    }
  }

  if ( IndexedSeq ) Repeat.__proto__ = IndexedSeq;
  Repeat.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  Repeat.prototype.constructor = Repeat;

  Repeat.prototype.toString = function toString () {
    if (this.size === 0) {
      return 'Repeat []';
    }
    return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
  };

  Repeat.prototype.get = function get (index, notSetValue) {
    return this.has(index) ? this._value : notSetValue;
  };

  Repeat.prototype.includes = function includes (searchValue) {
    return is(this._value, searchValue);
  };

  Repeat.prototype.slice = function slice (begin, end) {
    var size = this.size;
    return wholeSlice(begin, end, size)
      ? this
      : new Repeat(
          this._value,
          resolveEnd(end, size) - resolveBegin(begin, size)
        );
  };

  Repeat.prototype.reverse = function reverse () {
    return this;
  };

  Repeat.prototype.indexOf = function indexOf (searchValue) {
    if (is(this._value, searchValue)) {
      return 0;
    }
    return -1;
  };

  Repeat.prototype.lastIndexOf = function lastIndexOf (searchValue) {
    if (is(this._value, searchValue)) {
      return this.size;
    }
    return -1;
  };

  Repeat.prototype.__iterate = function __iterate (fn, reverse) {
    var size = this.size;
    var i = 0;
    while (i !== size) {
      if (fn(this._value, reverse ? size - ++i : i++, this) === false) {
        break;
      }
    }
    return i;
  };

  Repeat.prototype.__iterator = function __iterator (type, reverse) {
    var this$1$1 = this;

    var size = this.size;
    var i = 0;
    return new Iterator(function () { return i === size
        ? iteratorDone()
        : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value); }
    );
  };

  Repeat.prototype.equals = function equals (other) {
    return other instanceof Repeat
      ? is(this._value, other._value)
      : deepEqual(other);
  };

  return Repeat;
}(IndexedSeq));

var EMPTY_REPEAT;

function fromJS(value, converter) {
  return fromJSWith(
    [],
    converter || defaultConverter,
    value,
    '',
    converter && converter.length > 2 ? [] : undefined,
    { '': value }
  );
}

function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
  if (
    typeof value !== 'string' &&
    !isImmutable(value) &&
    (isArrayLike(value) || hasIterator(value) || isPlainObject(value))
  ) {
    if (~stack.indexOf(value)) {
      throw new TypeError('Cannot convert circular structure to Immutable');
    }
    stack.push(value);
    keyPath && key !== '' && keyPath.push(key);
    var converted = converter.call(
      parentValue,
      key,
      Seq(value).map(function (v, k) { return fromJSWith(stack, converter, v, k, keyPath, value); }
      ),
      keyPath && keyPath.slice()
    );
    stack.pop();
    keyPath && keyPath.pop();
    return converted;
  }
  return value;
}

function defaultConverter(k, v) {
  // Effectively the opposite of "Collection.toSeq()"
  return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}

var version = "4.1.0";

var Immutable = {
  version: version,

  Collection: Collection,
  // Note: Iterable is deprecated
  Iterable: Collection,

  Seq: Seq,
  Map: immutable_es_Map,
  OrderedMap: OrderedMap,
  List: List,
  Stack: Stack,
  Set: immutable_es_Set,
  OrderedSet: OrderedSet,

  Record: Record,
  Range: Range,
  Repeat: Repeat,

  is: is,
  fromJS: fromJS,
  hash: hash,

  isImmutable: isImmutable,
  isCollection: isCollection,
  isKeyed: isKeyed,
  isIndexed: isIndexed,
  isAssociative: isAssociative,
  isOrdered: isOrdered,
  isValueObject: isValueObject,
  isPlainObject: isPlainObject,
  isSeq: isSeq,
  isList: isList,
  isMap: isMap,
  isOrderedMap: isOrderedMap,
  isStack: isStack,
  isSet: isSet,
  isOrderedSet: isOrderedSet,
  isRecord: isRecord,

  get: get,
  getIn: getIn$1,
  has: has,
  hasIn: hasIn$1,
  merge: merge,
  mergeDeep: mergeDeep$1,
  mergeWith: mergeWith,
  mergeDeepWith: mergeDeepWith$1,
  remove: remove,
  removeIn: removeIn,
  set: set,
  setIn: setIn$1,
  update: update$1,
  updateIn: updateIn$1,
};

// Note: Iterable is deprecated
var Iterable = (/* unused pure expression or super */ null && (Collection));

/* harmony default export */ var immutable_es = ((/* unused pure expression or super */ null && (Immutable)));


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/insertAtomicBlock.js




/**
 * https://github.com/facebook/draft-js/issues/543#issuecomment-234807541
 * @param {EditorState} editorState
 * @param {String}      blockType
 * @param {Object}      data
 */ function insertAtomicBlock(editorState, blockType, data) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var afterRemoval = Draft.Modifier.removeRange(contentState, selectionState, "backward");
    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = Draft.Modifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();
    var insertingContentBlock = new Draft.ContentBlock({
        key: (0,Draft.genKey)(),
        type: "atomic",
        text: "",
        characterList: List(),
        data: new immutable_es_Map((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
            blockType: blockType
        }))
    });
    var emptyUnstyledBlock = new Draft.ContentBlock({
        key: (0,Draft.genKey)(),
        type: "unstyled",
        text: "",
        characterList: List()
    });
    var afterReplace = Draft.Modifier.replaceWithFragment(Draft.Modifier.setBlockType(afterSplit, insertionTarget, "atomic"), insertionTarget, Draft.BlockMapBuilder.createFromArray([
        insertingContentBlock,
        emptyUnstyledBlock
    ]));
    var newContent = afterReplace.merge({
        selectionBefore: selectionState,
        selectionAfter: afterReplace.getSelectionAfter().set("hasFocus", true)
    });
    return Draft.EditorState.push(editorState, newContent, "insert-fragment");
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/isBlockActive.js
/**
 * @param   {EditorState} editorState
 * @param   {String}      maybeActiveBlock
 * @returns {Boolean}
 */ function isBlockActive(editorState, maybeActiveBlock) {
    var selection = editorState.getSelection();
    var blockForKey = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
    if (blockForKey.getType() === "atomic" && blockForKey.getData().get("blockType") === maybeActiveBlock) {
        return true;
    }
    return blockForKey.getType() === maybeActiveBlock;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/AtomicBlockIdentifiers.js
var AtomicBlockIdentifiers_AtomicBlockIdentifiers = {
    YOUTUBE_VIDEO: "youtube",
    IMAGE: "image",
    DIVIDER: "divider",
    GOOGLE_SPREADSHEET: "googleSpreadsheet",
    GOOGLE_FORMS: "googleForms",
    TYPEFORM: "typeform",
    AIRTABLE: "airtable",
    SIMPLECAST: "simplecast",
    SOCIAL_MEDIAS: "socialMedias",
    NEWSLETTER: "newsletter",
    CUSTOM_BUTTON: "customButton",
    GOVLAUNCH_PROJECT: "govlaunchProject"
};
/* harmony default export */ var src_AtomicBlockIdentifiers = (AtomicBlockIdentifiers_AtomicBlockIdentifiers);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/isEditorStateEmpty.js

var blockIdentifiers = [
    src_AtomicBlockIdentifiers.YOUTUBE_VIDEO,
    src_AtomicBlockIdentifiers.IMAGE, 
];
/**
 * @param   {EditorState} editorState
 * @returns {Boolean}
 */ function isEditorStateEmpty(editorState) {
    return !editorState.getCurrentContent().getBlocksAsArray().some(function(block) {
        var isContentBlock = block.getType() === "atomic" && blockIdentifiers.includes(block.getData().get("blockType"));
        if (isContentBlock) {
            return true;
        } else {
            return block.getText().length > 0;
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/isInlineStyleActive.js
/**
 * @param   {EditorState} editorState
 * @param   {String}      maybeActiveStyle
 * @returns {Boolean}
 */ function isInlineStyleActive(editorState, maybeActiveStyle) {
    return editorState.getCurrentInlineStyle().includes(maybeActiveStyle);
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/isSelectedBlockEmpty.js
/**
 * @param  {EditorState} editorState
 * @return {Boolean}
 */ function isSelectedBlockEmpty(editorState) {
    var selectionState = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var currentContentBlock = currentContent.getBlockForKey(selectionState.getFocusKey());
    return currentContentBlock.getText().length === 0;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/getCurrentEntity.js
/**
 * @param   {EditorState} editorState
 * @returns {Boolean}
 */ function getCurrentEntity(editorState) {
    var contentState = editorState.getCurrentContent();
    var currentSelection = editorState.getSelection();
    var anchorKey = currentSelection.getAnchorKey();
    var anchorBlock = contentState.getBlockForKey(anchorKey);
    var entityKey = anchorBlock.getEntityAt(currentSelection.isBackward ? currentSelection.anchorOffset - 1 : currentSelection.anchorOffset);
    if (entityKey) {
        return contentState.getEntity(entityKey);
    }
    return null;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/isSelectingEntity.js

/**
 * @param {EditorState} editorState
 * @param {String}      entityType
 */ function isSelectingEntity(editorState, entityType) {
    var maybeCurrentEntity = getCurrentEntity(editorState);
    return maybeCurrentEntity ? maybeCurrentEntity.getType() === entityType : false;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/resetBlockStyle.js


/**
 * Copyright (c) 2016 Icelab. License: MIT
 * @link https://github.com/icelab/draft-js-block-breakout-plugin
 */ function resetBlockStyle(editorState, selection, contentState, currentBlock, blockType) {
    var emptyBlockKey = (0,Draft.genKey)();
    var emptyBlock = new Draft.ContentBlock({
        key: emptyBlockKey,
        text: "",
        type: blockType,
        depth: 0,
        characterList: List(),
        inlineStyleRanges: []
    });
    var blockMap = contentState.getBlockMap();
    var blocksBefore = blockMap.toSeq().takeUntil(function(maybeBlock) {
        return maybeBlock === currentBlock;
    });
    var blocksAfter = blockMap.toSeq().skipUntil(function(maybeBlock) {
        return maybeBlock === currentBlock;
    }).rest();
    var nextBlocks = blocksBefore.concat([
        [
            currentBlock.getKey(),
            currentBlock
        ],
        [
            emptyBlockKey,
            emptyBlock
        ]
    ], blocksAfter).toOrderedMap();
    var newContentState = contentState.merge({
        blockMap: nextBlocks,
        selectionBefore: selection,
        selectionAfter: selection.merge({
            anchorKey: emptyBlockKey,
            anchorOffset: 0,
            focusKey: emptyBlockKey,
            focusOffset: 0,
            isBackward: false
        })
    });
    var resetState = Draft.EditorState.push(editorState, newContentState, "split-block");
    var emptySelection = Draft.SelectionState.createEmpty(emptyBlockKey);
    return Draft.EditorState.setInlineStyleOverride(Draft.EditorState.forceSelection(resetState, emptySelection), OrderedSet([]));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/shouldDisplayPlaceholder.js
/**
 * @param   {EditorState} editorState
 * @returns {Boolean}
 */ function shouldDisplayPlaceholder(editorState) {
    var contentState = editorState.getCurrentContent();
    return contentState.hasText() === false && contentState.getBlockMap().first().getType() === "unstyled";
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/toggleBlockType.js

/**
 * @param {EditorState} editorState
 * @param {Function}    onChange
 */ function toggleBlockType(editorState, onChange) {
    return function(blockStyle) {
        return function() {
            var afterBlockToggle = Draft.RichUtils.toggleBlockType(editorState, blockStyle);
            onChange(afterBlockToggle);
        };
    };
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/toggleInlineStyle.js

/**
 * @param {EditorState} editorState
 * @param {Function}    onChange
 */ function toggleInlineStyle(editorState, onChange) {
    return function(inlineStyle) {
        return function() {
            var afterStyleToggle = Draft.RichUtils.toggleInlineStyle(editorState, inlineStyle);
            onChange(afterStyleToggle);
        };
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/trimEnd.js
var fp_trimEnd = __webpack_require__(87423);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/trimStart.js
var fp_trimStart = __webpack_require__(84419);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/trim.js



/**
 * @param   {EditorState} editorState
 * @returns {EditorState}
 */ function trim(editorState) {
    return moveSelectionToEnd(trimContent(trimRight(trimLeft(editorState))));
};
/**
 * @param   {EditorState} editorState
 * @returns {EditorState}
 */ function trimContent(editorState) {
    var contentState = editorState.getCurrentContent();
    var firstBlock = trimBlock(contentState, contentState.getFirstBlock());
    var lastBlock = trimBlock(firstBlock, contentState.getLastBlock());
    return EditorState.push(editorState, lastBlock);
}
/**
 * @param   {ContentState} contentState
 * @param   {ContentBlock} block
 * @returns {ContentState}
 */ function trimBlock(contentState, block) {
    return Modifier.replaceText(contentState, new SelectionState({
        anchorKey: block.getKey(),
        anchorOffset: 0,
        focusKey: block.getKey(),
        focusOffset: block.getLength()
    }), trimStart(trimEnd(block.getText())));
}
/**
 * @param   {EditorState} editorState
 * @returns {EditorState}
 */ function trimLeft(editorState) {
    var contentState = editorState.getCurrentContent();
    var emptyBlocks = contentState.getBlockMap().takeUntil(function(currentBlock) {
        return currentBlock.getText() !== "" && currentBlock.getType() !== "atomic";
    });
    if (emptyBlocks.count() > 0) {
        var lastEmptyBlock = emptyBlocks.last();
        var blockAfter = contentState.getBlockAfter(lastEmptyBlock.getKey());
        if (!blockAfter) {
            return editorState;
        }
        var afterCut = cutSelection(editorState, editorState.getSelection().merge({
            anchorKey: emptyBlocks.first().getKey(),
            anchorOffset: 0,
            focusKey: emptyBlocks.last().getKey(),
            focusOffset: 0
        }));
        return EditorState.push(editorState, afterCut.getCurrentContent().merge({
            blockMap: afterCut.getCurrentContent().getBlockMap().remove(emptyBlocks.first().getKey())
        }), "remove-range");
    }
    return editorState;
}
/**
 * @param   {EditorState} editorState
 * @returns {EditorState}
 */ function trimRight(editorState) {
    var contentState = editorState.getCurrentContent();
    var emptyBlocks = contentState.getBlockMap().reverse().takeUntil(function(currentBlock) {
        var blockBefore = contentState.getBlockBefore(currentBlock.getKey());
        if (blockBefore) {
            return currentBlock.getText() !== "" && currentBlock.getType() !== "atomic" && blockBefore.getType() !== "atomic";
        }
        return currentBlock.getText() !== "" && currentBlock.getType() !== "atomic";
    });
    if (emptyBlocks.count() === 0) {
        return editorState;
    }
    var blockBefore = contentState.getBlockBefore(emptyBlocks.last().getKey());
    if (blockBefore) {
        return cutSelection(editorState, editorState.getSelection().merge({
            anchorKey: emptyBlocks.last().getKey(),
            anchorOffset: 0,
            focusKey: blockBefore.getKey(),
            focusOffset: 0
        }));
    }
    return editorState;
}
/**
 * @param   {EditorState}    editorState
 * @param   {SelectionState} removeSelection
 * @returns {EditorState}
 */ function cutSelection(editorState, removeSelection) {
    var withoutSelection = Modifier.removeRange(editorState.getCurrentContent(), removeSelection, "forward");
    return EditorState.push(editorState, withoutSelection, "remove-range");
}
/**
 * @param   {EditorState} editorState
 * @returns {EditorState}
 */ function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var blockMap = content.getBlockMap();
    var key = blockMap.last().getKey();
    var length = blockMap.last().getLength();
    return EditorState.acceptSelection(editorState, editorState.getSelection().merge({
        anchorKey: key,
        anchorOffset: length,
        focusKey: key,
        focusOffset: length
    }));
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/index.js


















// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(96404);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(99951);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(84443);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38975);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(48465);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(20597);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/mentions/BatchProviders.js








var BatchProviders = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BatchProviders, Component);
    var _super = (0,_create_super/* default */.Z)(BatchProviders);
    function BatchProviders() {
        (0,_class_call_check/* default */.Z)(this, BatchProviders);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            suggestionsForQuery: new Map()
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(nextSuggestions) {
            _this.setState(function(param) {
                var suggestionsForQuery = param.suggestionsForQuery;
                var query = _this.props.query;
                var pastSuggestions = suggestionsForQuery.get(query);
                return {
                    suggestionsForQuery: suggestionsForQuery.set(query, Array.isArray(pastSuggestions) ? pastSuggestions.concat(nextSuggestions) : nextSuggestions)
                };
            }, function() {
                var _props = _this.props, query = _props.query, onChange = _props.onChange;
                var suggestionsForQuery = _this.state.suggestionsForQuery;
                onChange(suggestionsForQuery.get(query));
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "render", function() {
            var _props = _this.props, query = _props.query, children = _props.children;
            return children({
                query: query,
                onChange: _this.handleChange
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(BatchProviders, [
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var query = this.props.query;
                if (query !== nextProps.query) {
                    this.setState({
                        suggestionsForQuery: new Map()
                    });
                }
            }
        }
    ]);
    return BatchProviders;
}(react.Component);
(0,_define_property/* default */.Z)(BatchProviders, "propTypes", {
    query: (prop_types_default()).string.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).func.isRequired
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/Debounce.js








var Debounce = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Debounce, Component);
    var _super = (0,_create_super/* default */.Z)(Debounce);
    function Debounce() {
        (0,_class_call_check/* default */.Z)(this, Debounce);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "shouldComponentUpdate", function() {
            return false;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "scheduleUpdate", function() {
            if (_this.didUnmount === false) {
                _this.forceUpdate();
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "didUnmount", false);
        return _this;
    }
    (0,_create_class/* default */.Z)(Debounce, [
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps() {
                if (this.lastScheduledTimeout) {
                    clearTimeout(this.lastScheduledTimeout);
                }
                var ms = this.props.ms;
                this.lastScheduledTimeout = setTimeout(this.scheduleUpdate, ms);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.didUnmount = true;
                clearTimeout(this.lastScheduledTimeout);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children;
            }
        }
    ]);
    return Debounce;
}(react.Component);
(0,_define_property/* default */.Z)(Debounce, "propTypes", {
    ms: (prop_types_default()).number.isRequired,
    children: (prop_types_default()).any.isRequired
});


// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/EditorMention.js





/**
 * @type {Object}
 */ var EditorMentionRecord = Record({
    type: "",
    displayText: "",
    metadata: null,
    mutability: "SEGMENTED"
});
var EditorMention = /*#__PURE__*/ function(EditorMentionRecord) {
    "use strict";
    (0,_inherits/* default */.Z)(EditorMention, EditorMentionRecord);
    var _super = (0,_create_super/* default */.Z)(EditorMention);
    function EditorMention() {
        (0,_class_call_check/* default */.Z)(this, EditorMention);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(EditorMention, [
        {
            /**
   * @returns {EditorMention}
   */ key: "getDisplayText",
            value: function getDisplayText() {
                return this.get("displayText");
            }
        },
        {
            /**
   * @returns {String}
   */ key: "getType",
            value: function getType() {
                return this.get("type");
            }
        },
        {
            /**
   * @returns {*}
   */ key: "getMetadata",
            value: function getMetadata() {
                return this.get("metadata");
            }
        },
        {
            /**
   * @returns {String}
   */ key: "getMutability",
            value: function getMutability() {
                return this.get("mutability");
            }
        }
    ], [
        {
            key: "create",
            value: /**
   * @param   {String} type
   * @param   {String} displayText
   * @param   {*}      metadata
   * @param   {String} mutability
   * @returns {EditorMention}
   */ function create(type, displayText, metadata) {
                var mutability = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "SEGMENTED";
                return new EditorMention({
                    type: type,
                    displayText: displayText,
                    metadata: metadata,
                    mutability: mutability
                });
            }
        },
        {
            key: "createWithoutMetadata",
            value: /**
   * @param {String} type
   * @param {String} displayText
   * @param {String} mutability
   */ function createWithoutMetadata(type, displayText) {
                var mutability = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "SEGMENTED";
                return new EditorMention({
                    type: type,
                    displayText: displayText,
                    mutability: mutability
                });
            }
        }
    ]);
    return EditorMention;
}(EditorMentionRecord);


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/OnEditorEvent.js
/* eslint-disable no-restricted-syntax */ /* eslint-disable no-unused-vars */ 











/**
 * @type {[]String}
 */ var SAFE_EVENT_HANDLERS = [
    "onUpArrow",
    "onDownArrow",
    "onEscape",
    "onDownArrow",
    "onRightArrow",
    "handleReturn",
    "onTab", 
];
/**
 * @param   {[]String} eventKeys
 * @returns {Object}
 */ function generateSafeEventsPropTypes(eventKeys) {
    return eventKeys.reduce(function(propTypes, eventKey) {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, propTypes), (0,_define_property/* default */.Z)({}, eventKey, (prop_types_default()).func));
    }, {});
}
var _handlersMap = new Map();
var OnEditorEvent = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(OnEditorEvent, Component);
    var _super = (0,_create_super/* default */.Z)(OnEditorEvent);
    function OnEditorEvent() {
        (0,_class_call_check/* default */.Z)(this, OnEditorEvent);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "shouldComponentUpdate", function() {
            return false;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "getEventKeys", function(fromProps) {
            return Object.keys(fromProps).filter(function(maybeSafeEventKey) {
                return SAFE_EVENT_HANDLERS.includes(maybeSafeEventKey);
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "attachEventCallbacks", function(eventsConfiguration) {
            var eventsKeys = _this.getEventKeys(eventsConfiguration);
            eventsKeys.forEach(function(eventKey) {
                var eventCallback = eventsConfiguration[eventKey];
                _this.wrapAndRegisterEventCallback(eventKey, eventCallback);
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "detachEventCallbacks", function(eventsConfiguration) {
            var eventsKeys = _this.getEventKeys(eventsConfiguration);
            eventsKeys.forEach(function(eventKey) {
                var previouslySetEventCallbacks = _handlersMap.get(eventKey);
                previouslySetEventCallbacks.forEach(function(eventCallback) {
                    if (eventCallback === eventsConfiguration[eventKey]) {
                        previouslySetEventCallbacks.delete(eventCallback);
                    }
                });
                _handlersMap.set(eventKey, previouslySetEventCallbacks);
            });
        });
        /**
   * @param {String}   eventKey
   * @param {Function} eventCallback
   */ (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "wrapAndRegisterEventCallback", function(eventKey, eventCallback) {
            if (_handlersMap.has(eventKey)) {
                _handlersMap.set(eventKey, _handlersMap.get(eventKey).add(eventCallback));
                return;
            }
            _handlersMap.set(eventKey, new Set([
                eventCallback
            ]));
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(OnEditorEvent, [
        {
            key: "componentWillMount",
            value: function componentWillMount() {
                this.attachEventCallbacks(this.props);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                this.detachEventCallbacks(this.props);
                this.attachEventCallbacks(nextProps);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.detachEventCallbacks(this.props);
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return OnEditorEvent;
}(react.Component);
(0,_define_property/* default */.Z)(OnEditorEvent, "propTypes", generateSafeEventsPropTypes(SAFE_EVENT_HANDLERS));
// if (process.env.NODE_ENV !== "production") {
//   module.hot.dispose(() => {
//     _handlersMap = new Map();
//   });
// }

/**
 * @param   {Set} callbackSet
 * @returns {[]Function}
 */ function iterateCallbackSet(callbackSet) {
    var eventCallbacks = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = callbackSet[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var eventCallback = _step.value;
            eventCallbacks.push(eventCallback);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return eventCallbacks;
}
/**
 * @type {Function}
 */ var noop = function() {};
/**
 * @param   {?String} forKey
 * @returns {Object|[]Function}
 */ function getRegisteredEvents(forKey) {
    if (forKey) {
        if (_handlersMap.has(forKey)) {
            var eventCallbacksForKey = _handlersMap.get(forKey);
            return composeEventHandlers.apply(void 0, (0,_to_consumable_array/* default */.Z)(iterateCallbackSet(eventCallbacksForKey)));
        }
        return noop;
    }
    var registeredEvents = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = _handlersMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var eventKey = _step.value;
            var eventCallbacksForKey1 = _handlersMap.get(eventKey);
            registeredEvents[eventKey] = composeEventHandlers.apply(void 0, (0,_to_consumable_array/* default */.Z)(iterateCallbackSet(eventCallbacksForKey1)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return registeredEvents;
}
/**
 * @param   {String} forKey
 * @returns {Function}
 */ function callRegisteredEvents(forKey) {
    return function(keyboardEvent) {
        var handleEventFn = getRegisteredEvents(forKey);
        return handleEventFn(keyboardEvent);
    };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/MentionSelectionKeyboardOps.js




function MentionSelectionKeyboardOps(param) {
    var handleEscape = param.handleEscape, handleMoveToNext = param.handleMoveToNext, handleMoveToPrevious = param.handleMoveToPrevious, handleAcceptSuggestion = param.handleAcceptSuggestion;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OnEditorEvent, {
        onEscape: handleEscape,
        onDownArrow: handleMoveToNext,
        onUpArrow: handleMoveToPrevious,
        handleReturn: handleAcceptSuggestion,
        onTab: handleAcceptSuggestion
    });
};
MentionSelectionKeyboardOps.propTypes = {
    handleEscape: (prop_types_default()).func.isRequired,
    handleMoveToNext: (prop_types_default()).func.isRequired,
    handleMoveToPrevious: (prop_types_default()).func.isRequired,
    handleAcceptSuggestion: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/utils/computeStartRangeRectBounds.js
/**
 * @param {*}      global
 * @param {Number} startOffset
 */ function computeStartRangeRectBounds(global, startOffset) {
    var globalSelection = global.getSelection();
    if (globalSelection.rangeCount === 0) {
        return null;
    }
    var rangeClone = globalSelection.getRangeAt(0).cloneRange();
    if (startOffset >= 0) {
        rangeClone.setStart(rangeClone.startContainer, startOffset);
    }
    var boundingRect = rangeClone.getBoundingClientRect();
    return {
        top: boundingRect.bottom + window.pageYOffset,
        left: boundingRect.left + window.pageXOffset
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/draft-js@0.11.7_sfoxds7t5ydpegc3knd667wn6m/node_modules/draft-js/lib/DraftOffsetKey.js
var DraftOffsetKey = __webpack_require__(31494);
var DraftOffsetKey_default = /*#__PURE__*/__webpack_require__.n(DraftOffsetKey);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/utils/findOffsetKeysLeaves.js

/**
 * @param   {EditorState} editorState
 * @param   {[]Record}    offsetKeys
 * @returns {[]Record}
 */ function findOffsetKeysLeaves(editorState, offsetKeys) {
    var currentSelection = editorState.getSelection();
    var anchorKey = currentSelection.getAnchorKey();
    return offsetKeys.map((DraftOffsetKey_default()).decode).filter(function(decodedOffsetKey) {
        return decodedOffsetKey.blockKey === anchorKey;
    }).map(function(decodedOffsetKey) {
        return editorState.getBlockTree(decodedOffsetKey.blockKey).getIn([
            decodedOffsetKey.decoratorKey,
            "leaves",
            decodedOffsetKey.leafKey, 
        ]);
    }).filter(Boolean);
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/utils/findSelectionBoundsWithinLeaves.js
/**
 * @param {SelectionState} currentSelection
 * @param {[]Record}       leaves
 */ function findSelectionBoundsWithinLeaves(currentSelection, leaves) {
    var anchorOffset = currentSelection.getAnchorOffset();
    var leave = leaves.find(function(param) {
        var start = param.start, end = param.end;
        if (anchorOffset >= start && anchorOffset <= end) {
            return true;
        }
        return false;
    });
    return leave || null;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/utils/hasEntityAtSelection.js
/**
 * @param   {EditorState}    editorState
 * @param   {SelectionState} currentSelection
 * @returns {Boolean}
 */ function hasEntityAtSelection(editorState, currentSelection) {
    var contentState = editorState.getCurrentContent();
    var startKey = currentSelection.getStartKey();
    var blockAtStartKey = contentState.getBlockForKey(startKey);
    var startOffset = currentSelection.getStartOffset();
    return blockAtStartKey.getEntityAt(startOffset - 1) ? true : false;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/utils/withoutAt.js
/**
 * @param   {String} stringWithAt
 * @returns {String}
 */ function withoutAt(stringWithAt) {
    var lastAtIndex = stringWithAt.indexOf("@");
    return lastAtIndex >= 0 ? stringWithAt.substring(lastAtIndex + 1, stringWithAt.length) : stringWithAt;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/utils/index.js







;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/MentionSpanOffsetTracker.js
/**
 * MentionSpanOffsetTracker:

 * We're using Draft.js decorators to render a <span> around each @mention. That leaves
 * us with a block containing:
 *
 * <div data-offset-key="btpje-0-0">
 *   <span data-offset-key="btpje-0-0">Lorem</span>
 *   <span data-offset-key="btpje-1-0"> @ipsum</span>
 *   <span data-offset-key="btpje-2-0"> dolor</span>
 * </div>
 *
 * So, in order detect if the selection is within one of those rendered <span>s, we need to track
 * the `offsetKey` that Draft assigns to 'em, and based on that, we'll know if we should display
 * some portal offering suggestions for such query. This makes the whole process much easier and
 * safe when it comes to detecting the selection (cursor) within those mentions.
 */ var MentionSpanOffsetTracker = {
    /**
   * @private
   * @param {[]String}
   */ _offsetKeys: [],
    /**
   * @param {String} offsetKey
   */ putOffsetKey: function putOffsetKey(offsetKey) {
        this._offsetKeys = this._offsetKeys.concat(offsetKey);
    },
    /**
   * @param {String} offsetKey
   */ delOffsetKey: function delOffsetKey(offsetKey) {
        this._offsetKeys = this._offsetKeys.filter(function(maybeOffsetKey) {
            return offsetKey !== maybeOffsetKey;
        });
    },
    /**
   * @returns {[]String}
   */ getOffsetKeys: function getOffsetKeys() {
        return this._offsetKeys;
    },
    reset: function reset() {
        this._offsetKeys = [];
    }
};
/* harmony default export */ var mentions_MentionSpanOffsetTracker = (MentionSpanOffsetTracker);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/MentionTypeaheadState.js










var MentionTypeaheadState = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(MentionTypeaheadState, Component);
    var _super = (0,_create_super/* default */.Z)(MentionTypeaheadState);
    function MentionTypeaheadState() {
        (0,_class_call_check/* default */.Z)(this, MentionTypeaheadState);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            top: -9999,
            left: -9999,
            visible: false,
            mentionQuery: ""
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "calculateAndSetState", function(editorState) {
            var currentSelection = editorState.getSelection();
            var originalContent = editorState.getCurrentContent();
            if (currentSelection.isCollapsed() === false || currentSelection.getHasFocus() === false) {
                _this.resetState();
                return;
            }
            if (hasEntityAtSelection(editorState, currentSelection)) {
                _this.resetState();
                return;
            }
            var foundBounds = findSelectionBoundsWithinLeaves(currentSelection, findOffsetKeysLeaves(editorState, mentions_MentionSpanOffsetTracker.getOffsetKeys()));
            if (foundBounds === null) {
                _this.resetState();
                return;
            }
            var anchorKey = currentSelection.getAnchorKey();
            var currentBlock = originalContent.getBlockForKey(anchorKey);
            var plainString = currentBlock.getText();
            var mentionQuery;
            var queryUntilCursor = _this.props.queryUntilCursor;
            if (queryUntilCursor) {
                mentionQuery = plainString.substring(foundBounds.start, Math.min(foundBounds.end, currentSelection.getAnchorOffset()));
            } else {
                mentionQuery = plainString.substring(foundBounds.start, foundBounds.end);
            }
            var lastAtIndex = mentionQuery.lastIndexOf("@");
            var activeSelectionRect = computeStartRangeRectBounds(window, lastAtIndex);
            if (activeSelectionRect === null) {
                _this.resetState();
                return;
            }
            _this.setState({
                top: activeSelectionRect.top,
                left: activeSelectionRect.left,
                mentionQuery: mentionQuery.substring(lastAtIndex, mentionQuery.length),
                visible: true
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "resetState", function() {
            return _this.setState({
                top: -9999,
                left: -9999,
                visible: false,
                mentionQuery: ""
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(MentionTypeaheadState, [
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(param) {
                var editorState = param.editorState;
                var _this = this;
                this.setState(null, function() {
                    _this.calculateAndSetState(editorState);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var _state = this.state, top = _state.top, left = _state.left, visible = _state.visible, mentionQuery = _state.mentionQuery;
                return children({
                    top: top,
                    left: left,
                    visible: visible,
                    mentionQuery: mentionQuery,
                    resetState: this.resetState
                });
            }
        }
    ]);
    return MentionTypeaheadState;
}(react.Component);
(0,_define_property/* default */.Z)(MentionTypeaheadState, "propTypes", {
    queryUntilCursor: (prop_types_default()).bool,
    editorState: (prop_types_default()).object.isRequired,
    children: (prop_types_default()).func.isRequired
});
(0,_define_property/* default */.Z)(MentionTypeaheadState, "defaultProps", {
    queryUntilCursor: false
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/CssLayers.js
/**
 * @type {Object}
 */ var CssLayers = {
    INLINE_TOOLBAR: 9000,
    INLINE_TOOLBAR_LINK_INPUT: 9001,
    SIDE_TOOLBAR: 9002,
    SIDE_CONTENT_CIRCLE: 9004,
    MENTIONS: 9004
};
/* harmony default export */ var src_CssLayers = (CssLayers);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/index.js
var react_dom = __webpack_require__(87995);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/MentionsPortal.js






function MentionsPortal(param) {
    var top = param.top, left = param.left, css = param.css, children = param.children;
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (0,src_object_spread/* default */.Z)({
            position: "absolute",
            zIndex: src_CssLayers.MENTIONS
        }, css),
        style: {
            top: top,
            left: left
        },
        children: children
    }), document.body);
};
MentionsPortal.propTypes = {
    top: (prop_types_default()).number.isRequired,
    left: (prop_types_default()).number.isRequired,
    css: (prop_types_default()).object,
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/SelectedSuggestionIndex.js








/**
 * @param   {Boolean} firstInitial
 * @param   {Number}  suggestionsCount
 * @returns {Number}
 */ function getSafeInitialSelectedIndex(firstInitial, suggestionsCount) {
    if (firstInitial) {
        return suggestionsCount > 0 ? 0 : -1;
    } else {
        return -1;
    }
}
var SelectedSuggestionIndex = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SelectedSuggestionIndex, Component);
    var _super = (0,_create_super/* default */.Z)(SelectedSuggestionIndex);
    function SelectedSuggestionIndex() {
        (0,_class_call_check/* default */.Z)(this, SelectedSuggestionIndex);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            selectedSuggestionIndex: getSafeInitialSelectedIndex(_this.props.firstInitial, _this.props.suggestionsCount)
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "normalizeSelectedIndex", function(selectedIndex, suggestionsCount) {
            var potentialIndex = selectedIndex % suggestionsCount;
            return potentialIndex < 0 ? suggestionsCount - 1 : potentialIndex;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "moveToSelectedIndex", function(nextSelectedIndex) {
            var suggestionsCount = _this.props.suggestionsCount;
            _this.setState({
                selectedSuggestionIndex: _this.normalizeSelectedIndex(nextSelectedIndex, suggestionsCount)
            });
        });
        /**
   * @param {SyntheticKeyboardEvent}
   */ (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleMoveToNextSuggestion", function(event) {
            event.preventDefault();
            var selectedSuggestionIndex = _this.state.selectedSuggestionIndex;
            _this.moveToSelectedIndex(selectedSuggestionIndex + 1);
        });
        /**
   * @param {SyntheticKeyboardEvent}
   */ (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleMoveToPreviousSuggestion", function(event) {
            event.preventDefault();
            var selectedSuggestionIndex = _this.state.selectedSuggestionIndex;
            _this.moveToSelectedIndex(selectedSuggestionIndex - 1);
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SelectedSuggestionIndex, [
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var firstInitial = nextProps.firstInitial, suggestionsCount = nextProps.suggestionsCount;
                if (firstInitial) {
                    this.setState({
                        selectedSuggestionIndex: suggestionsCount > 0 ? 0 : -1
                    });
                } else {
                    this.setState({
                        selectedSuggestionIndex: -1
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var selectedSuggestionIndex = this.state.selectedSuggestionIndex;
                var children = this.props.children;
                return children({
                    selectedSuggestionIndex: selectedSuggestionIndex,
                    moveToPreviousSuggestion: this.handleMoveToPreviousSuggestion,
                    moveToNextSuggestion: this.handleMoveToNextSuggestion
                });
            }
        }
    ]);
    return SelectedSuggestionIndex;
}(react.Component);
(0,_define_property/* default */.Z)(SelectedSuggestionIndex, "propTypes", {
    children: (prop_types_default()).func.isRequired,
    firstInitial: (prop_types_default()).bool,
    suggestionsCount: (prop_types_default()).number.isRequired
});
(0,_define_property/* default */.Z)(SelectedSuggestionIndex, "defaultProps", {
    firstInitial: false
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/EntityTypeIdentifiers.js
/**
 * @type {Object}
 */ var EntityTypeIdentifiers = {
    MENTION: "MENTION",
    LINK: "LINK"
};
/* harmony default export */ var src_EntityTypeIdentifiers = (EntityTypeIdentifiers);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/insertMentionEntity.js


/**
 * @param {EditorState}    editorState
 * @param {SelectionState} mentionSelection
 * @param {String}         displayText
 * @param {?Object}        data
 * @param {String}         mutability
 * @param {EditorState}
 */ function insertMentionEntity(editorState, mentionSelection, displayText, data) {
    var mutability = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "SEGMENTED";
    var originalContent = editorState.getCurrentContent();
    var contentStateWithMention = originalContent.createEntity(src_EntityTypeIdentifiers.MENTION, mutability, data);
    var replacedContent = Draft.Modifier.replaceText(editorState.getCurrentContent(), mentionSelection, displayText, null, contentStateWithMention.getLastCreatedEntityKey());
    return Draft.EditorState.push(editorState, replacedContent, "apply-entity");
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/InlineMentions.js
















var InlineMentions = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(InlineMentions, Component);
    var _super = (0,_create_super/* default */.Z)(InlineMentions);
    function InlineMentions() {
        (0,_class_call_check/* default */.Z)(this, InlineMentions);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            offeredSuggestions: []
        });
        /**
   * @param   {EditorState} editorState
   * @param   {String}      mentionQuery
   * @returns {SelectionState}
   */ (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "projectMentionSelection", function(editorState, mentionQuery) {
            var originalContent = editorState.getCurrentContent();
            var selectionAfter = originalContent.getSelectionAfter();
            return selectionAfter.set("anchorOffset", selectionAfter.getFocusOffset() - mentionQuery.length);
        });
        /**
   * @param {MentionSuggestion} mentionSuggestion
   * @param {String}            mentionQuery
   */ (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "acceptSuggestion", function(mentionSuggestion, mentionQuery) {
            var _props = _this.props, editorState = _props.editorState, onChange = _props.onChange;
            var editorMention = mentionSuggestion.getEditorMention();
            var nextState = insertMentionEntity(editorState, _this.projectMentionSelection(editorState, mentionQuery), editorMention.getDisplayText(), editorMention, editorMention.getMutability());
            onChange(nextState);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleAcceptSuggestionAtIndex", function(acceptingSuggestionIndex, mentionQuery) {
            return function(event) {
                var offeredSuggestions = _this.state.offeredSuggestions;
                if (acceptingSuggestionIndex !== -1 && offeredSuggestions[acceptingSuggestionIndex]) {
                    event.preventDefault();
                    _this.acceptSuggestion(offeredSuggestions[acceptingSuggestionIndex], mentionQuery);
                    return true;
                }
                return false;
            };
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleAcceptSuggestion", function(mentionSuggestion, mentionQuery) {
            _this.acceptSuggestion(mentionSuggestion, mentionQuery);
            return true;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleOfferSuggestions", function(nextSuggestions) {
            return _this.setState({
                offeredSuggestions: nextSuggestions
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleResetState", function() {
            return _this.setState({
                offeredSuggestions: []
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleContainerMouseDown", function(event) {
            event.preventDefault();
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(InlineMentions, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, editorState = _props.editorState, children = _props.children;
                var offeredSuggestions = this.state.offeredSuggestions;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MentionTypeaheadState, {
                    editorState: editorState,
                    children: function(param) {
                        var top = param.top, left = param.left, visible = param.visible, mentionQuery = param.mentionQuery, resetState = param.resetState;
                        return visible ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MentionsPortal, {
                            top: top,
                            left: left,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectedSuggestionIndex, {
                                firstInitial: true,
                                suggestionsCount: offeredSuggestions.length,
                                children: function(param) {
                                    var selectedSuggestionIndex = param.selectedSuggestionIndex, moveToPreviousSuggestion = param.moveToPreviousSuggestion, moveToNextSuggestion = param.moveToNextSuggestion;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            offeredSuggestions.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MentionSelectionKeyboardOps, {
                                                handleEscape: composeEventHandlers(_this.handleResetState, resetState),
                                                handleMoveToNext: moveToNextSuggestion,
                                                handleMoveToPrevious: moveToPreviousSuggestion,
                                                handleAcceptSuggestion: _this.handleAcceptSuggestionAtIndex(selectedSuggestionIndex, mentionQuery)
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                onMouseDown: _this.handleContainerMouseDown,
                                                children: children({
                                                    mentionQuery: withoutAt(mentionQuery),
                                                    offeredSuggestions: offeredSuggestions,
                                                    acceptSuggestion: function(suggestionBeingAccepted) {
                                                        return _this.handleAcceptSuggestion(suggestionBeingAccepted, mentionQuery);
                                                    },
                                                    selectedSuggestionIndex: selectedSuggestionIndex,
                                                    offerSuggestions: _this.handleOfferSuggestions,
                                                    resetState: _this.handleResetState,
                                                    visible: visible
                                                })
                                            })
                                        ]
                                    });
                                }
                            })
                        }) : null;
                    }
                });
            }
        }
    ]);
    return InlineMentions;
}(react.Component);
(0,_define_property/* default */.Z)(InlineMentions, "propTypes", {
    editorState: (prop_types_default()).object.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).func.isRequired
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/palette.js
var blue = "#0071bb";
var primary = "#0071bb";
var darkSkyBlue = "#48a0da";
var lightBlue = "#dbecf7";
var sealBlue = "#a5adba";
var lightestBlue = "#ebf4fa";
var lightSealBlue = "#e4e7ec";
var lightestSealBlue = "#f2f4f8";
var mediumBlue = "#dbebf6";
var success = "#5ad269";
var greenSuccess = "#28d094";
var infoBlue = "#4bcae1";
var lightGreen = "#4be1ab";
var lightestGreen = "#a5f0d5";
var red = "#ff7171";
var orange = "#f1aa4e";
var mediumGray = "#797979";
var lightGray = "#d8d8d8";
var lightestGray = "#f2f2f2";
var darkGray = "#666666";
var washGray = "#fafafa";
var lightRed = "#ffdfdf";
var palette_text = "#212121";
var darkSkyLightBlue = "#48a0d9";
var disruptiveBlue = "#005aee";

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/Mention.js




function Mention(param) {
    var offsetKey = param.offsetKey, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        "data-offset-key": offsetKey,
        css: {
            fontSize: 14,
            borderRadius: 2,
            backgroundColor: lightestBlue,
            color: primary,
            display: "inline-flex"
        },
        children: children
    });
};
Mention.propTypes = {
    offsetKey: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/DidMountWillUnmount.js







var DidMountWillUnmount = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DidMountWillUnmount, Component);
    var _super = (0,_create_super/* default */.Z)(DidMountWillUnmount);
    function DidMountWillUnmount() {
        (0,_class_call_check/* default */.Z)(this, DidMountWillUnmount);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DidMountWillUnmount, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var didMount = this.props.didMount;
                didMount();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate() {
                return false;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var willUnmount = this.props.willUnmount;
                willUnmount();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return DidMountWillUnmount;
}(react.Component);
(0,_define_property/* default */.Z)(DidMountWillUnmount, "propTypes", {
    didMount: (prop_types_default()).func.isRequired,
    willUnmount: (prop_types_default()).func.isRequired
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/MentionSpanTag.js





function MentionSpanTag(param) {
    var offsetKey = param.offsetKey, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DidMountWillUnmount, {
                didMount: function() {
                    return mentions_MentionSpanOffsetTracker.putOffsetKey(offsetKey);
                },
                willUnmount: function() {
                    return mentions_MentionSpanOffsetTracker.delOffsetKey(offsetKey);
                }
            }),
            children
        ]
    });
};
MentionSpanTag.propTypes = {
    offsetKey: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).any.isRequired
};

// EXTERNAL MODULE: ./node_modules/.pnpm/find-with-regex@1.1.3_draft-js@0.11.7/node_modules/find-with-regex/build/index.js
var build = __webpack_require__(41069);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/MentionSpanDecoratorConfig.js


/**
 * @type {RegExp}
 */ var MENTION_SPAN_REGEX = /(?:\s|^)@[\w]*/g;
/**
 * @type {Object}
 */ var MentionSpanDecoratorConfig = {
    component: MentionSpanTag,
    strategy: function(block, callback) {
        (0,build/* default */.Z)(MENTION_SPAN_REGEX, block, callback);
    }
};
/* harmony default export */ var mentions_MentionSpanDecoratorConfig = (MentionSpanDecoratorConfig);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/MentionSuggestion.js





/**
 * @type {Object}
 */ var MentionSuggestionRecord = Record({
    editorMention: null,
    originalDataFromSource: null
});
var MentionSuggestion = /*#__PURE__*/ function(MentionSuggestionRecord) {
    "use strict";
    (0,_inherits/* default */.Z)(MentionSuggestion, MentionSuggestionRecord);
    var _super = (0,_create_super/* default */.Z)(MentionSuggestion);
    function MentionSuggestion() {
        (0,_class_call_check/* default */.Z)(this, MentionSuggestion);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MentionSuggestion, [
        {
            /**
   * @returns {EditorMention}
   */ key: "getEditorMention",
            value: function getEditorMention() {
                return this.get("editorMention");
            }
        },
        {
            /**
   * @returns {String}
   */ key: "getMentionType",
            value: function getMentionType() {
                return this.get("editorMention").get("type");
            }
        },
        {
            /**
   * @returns {EditorMention}
   */ key: "getOriginalData",
            value: function getOriginalData() {
                return this.get("originalDataFromSource");
            }
        }
    ], [
        {
            key: "wrap",
            value: /**
   * @param {EditorMention} editorMention
   * @param {*}             originalDataFromSource
   */ function wrap(editorMention, originalDataFromSource) {
                return new MentionSuggestion({
                    editorMention: editorMention,
                    originalDataFromSource: originalDataFromSource
                });
            }
        }
    ]);
    return MentionSuggestion;
}(MentionSuggestionRecord);


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/mentions/index.js








;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/mentions/DisruptorSuggestionItem.js





/**
 * @param {Boolean}           isSelected
 * @param {MentionSuggestion} suggestion
 * @param {Function}          acceptSuggestion
 */ function DisruptorSuggestionItem(param) {
    var isSelected = param.isSelected, suggestion = param.suggestion, acceptSuggestion = param.acceptSuggestion;
    var disruptor = suggestion.getOriginalData();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardMentionSuggestionItem, {
        isSelected: isSelected,
        suggestion: suggestion,
        acceptSuggestion: acceptSuggestion,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    src: disruptor.user.avatar,
                    css: {
                        marginRight: 15,
                        borderRadius: "100%",
                        border: "solid 2px #005aee",
                        width: 40,
                        height: 40
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 14,
                                color: isSelected ? "#ffffff" : "#212121"
                            },
                            children: disruptor.user.fullName
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                fontSize: 12,
                                color: isSelected ? "#ffffff" : "#797979"
                            },
                            children: [
                                disruptor.user.jobTitle,
                                ", ",
                                disruptor.company.name
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
DisruptorSuggestionItem.propTypes = {
    isSelected: (prop_types_default()).bool.isRequired,
    suggestion: prop_types_default().instanceOf(MentionSuggestion).isRequired,
    acceptSuggestion: (prop_types_default()).func.isRequired
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/apps/DisruptorsEditor.js







/**
 * @type {Function}
 */ var DisruptorsEditor_noop = function() {};
function DisruptorsEditor(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovlaunchEditor, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: function(param) {
            var editorKey = param.editorKey, editorState = param.editorState, focus = param.focus, focusEditor = param.focusEditor, onChange = param.onChange;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardSideToolbar, {
                        focus: focus,
                        editorKey: editorKey,
                        editorState: editorState,
                        focusEditor: focusEditor,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardInlineToolbar, {
                        editorState: editorState,
                        focusEditor: focusEditor,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardMentions, {
                        editorState: editorState,
                        onChange: onChange,
                        children: function(param) {
                            var query = param.query, suggestions = param.suggestions, selectedIndex = param.selectedIndex, onChange = param.onChange, acceptSuggestion = param.acceptSuggestion;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    suggestions.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardMentionsPopover, {
                                        children: suggestions.map(function(suggestion, index) {
                                            var isSelected = selectedIndex === index;
                                            var type = suggestion.getMentionType();
                                            if (type === mentions_MentionTypes.DISRUPTOR) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisruptorSuggestionItem, {
                                                    isSelected: isSelected,
                                                    suggestion: suggestion,
                                                    acceptSuggestion: acceptSuggestion
                                                }, index);
                                            }
                                            return null;
                                        }).filter(Boolean)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Debounce, {
                                        ms: 100,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisruptorsProvider, {
                                            query: query,
                                            onChange: onChange
                                        })
                                    })
                                ]
                            });
                        }
                    }),
                    children({
                        editorKey: editorKey,
                        editorState: editorState,
                        focus: focus,
                        focusEditor: focusEditor,
                        onChange: onChange
                    })
                ]
            });
        }
    }));
};
DisruptorsEditor.propTypes = {
    children: (prop_types_default()).func
};
DisruptorsEditor.defaultProps = {
    children: DisruptorsEditor_noop
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/apps/EditorWithToolbars.js





function EditorWithToolbars(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovlaunchEditor, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: function(param) {
            var editorKey = param.editorKey, editorState = param.editorState, focus = param.focus, focusEditor = param.focusEditor, onChange = param.onChange;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardSideToolbar, {
                        focus: focus,
                        editorKey: editorKey,
                        editorState: editorState,
                        focusEditor: focusEditor,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardInlineToolbar, {
                        editorState: editorState,
                        focusEditor: focusEditor,
                        onChange: onChange
                    })
                ]
            });
        }
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/mentions/MentionTypes.js
/**
 * @type {Object}
 */ var MentionTypes = {
    DISRUPTOR: "disruptor"
};
/* harmony default export */ var mentions_MentionTypes = (MentionTypes);

// EXTERNAL MODULE: ./node_modules/.pnpm/algoliasearch@4.14.2/node_modules/algoliasearch/dist/algoliasearch.umd.js
var algoliasearch_umd = __webpack_require__(64434);
var algoliasearch_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_umd);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/getEnvironment.js
/**
 * @returns {String}
 */ function getEnvironment() {
    if (true) {
        return "production";
    } else {}
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/mentions/algoliaIndexes.js


var algoliaClient = algoliasearch_umd_default()("EKEGGUH63H", "6790da914deade8cab2915997c0aab5b");
/**
 * @type {algolia.AlgoliaIndex}
 */ var disruptors = algoliaClient.initIndex("disruptors_".concat(getEnvironment()));


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/mentions/DisruptorsProvider.js











var DisruptorsProvider = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DisruptorsProvider, Component);
    var _super = (0,_create_super/* default */.Z)(DisruptorsProvider);
    function DisruptorsProvider() {
        (0,_class_call_check/* default */.Z)(this, DisruptorsProvider);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "shouldComponentUpdate", function(nextProps) {
            return _this.props.query !== nextProps.query;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "emitSuggestions", function(query) {
            var onChange = _this.props.onChange;
            if (!query) {
                onChange([]);
                return;
            }
            disruptors.search(query, function(err, content) {
                if (err) {
                    return;
                }
                var nextSuggestions = content.hits.filter(function(disruptor) {
                    return disruptor.user.fullName;
                }).map(function(disruptor) {
                    var user = disruptor.user;
                    return MentionSuggestion.wrap(EditorMention.create(mentions_MentionTypes.DISRUPTOR, user.fullName, {
                        _id: user._id,
                        slug: user.slug,
                        email: user.email
                    }), disruptor);
                });
                onChange(nextSuggestions);
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "render", function() {
            return null;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(DisruptorsProvider, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var query = this.props.query;
                this.emitSuggestions(query);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var query = this.props.query;
                this.emitSuggestions(query);
            }
        }
    ]);
    return DisruptorsProvider;
}(react.Component);
(0,_define_property/* default */.Z)(DisruptorsProvider, "propTypes", {
    query: (prop_types_default()).string.isRequired,
    onChange: (prop_types_default()).func.isRequired
});


// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string@7.1.1/node_modules/query-string/index.js
var query_string = __webpack_require__(11059);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/Airtable.js







function Airtable(param) {
    var block = param.block;
    var blockData = block.getData();
    var embedUrl = blockData.get("src");
    var width = blockData.get("width");
    var height = blockData.get("height");
    var parsed = query_string.parseUrl(embedUrl);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
        children: function(isMobile) {
            var embedQuery = query_string.stringify((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, parsed.query), {
                layout: isMobile ? "card" : undefined
            }));
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    overflow: "hidden",
                    marginTop: 10
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                    src: "".concat(parsed.url, "?").concat(embedQuery),
                    frameBorder: "0",
                    css: {
                        width: "100%"
                    },
                    style: {
                        width: width,
                        height: height
                    }
                })
            });
        }
    });
};
Airtable.propTypes = {
    block: (prop_types_default()).object.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/Divider.js



function Divider() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
        css: {
            margin: 0,
            padding: 0,
            border: "none",
            width: "100%",
            borderBottom: "1px solid ".concat(lightestSealBlue)
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/GoogleForms.js



function GoogleForms(param) {
    var block = param.block;
    var blockData = block.getData();
    var spreadsheetUrl = blockData.get("src");
    var width = blockData.get("width");
    var height = blockData.get("height");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            paddingTop: 20,
            paddingBottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
            src: spreadsheetUrl,
            frameBorder: "0",
            css: {
                width: "100%",
                height: 436
            },
            style: {
                width: width,
                height: height
            }
        })
    });
};
GoogleForms.propTypes = {
    block: (prop_types_default()).object.isRequired
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/EditorBlockHandling.js


/**
 * @param   {EditorState} editorState
 * @param   {Function}    onChange
 * @returns {Function}
 */ function handleSetBlockData(editorState, onChange) {
    return function(block, data) {
        var content = editorState.getCurrentContent();
        var currentSelection = new Draft.SelectionState({
            anchorKey: block.key,
            anchorOffset: 0,
            focusKey: block.key,
            focusOffset: block.getLength()
        });
        onChange(Draft.EditorState.push(editorState, Draft.Modifier.mergeBlockData(content, currentSelection, data), "change-block-data"));
    };
}
/**
 * @param   {EditorState} editorState
 * @param   {Function}    onChange
 * @returns {Function}
 */ function handleRemoveBlock(editorState, onChange) {
    return function(block) {
        var currentSelection = editorState.getSelection();
        var contentState = editorState.getCurrentContent();
        var keyAfter = contentState.getKeyAfter(block.key);
        var blockMap = contentState.getBlockMap().delete(block.key);
        onChange(Draft.EditorState.forceSelection(Draft.EditorState.push(editorState, contentState.merge({
            blockMap: blockMap,
            selectionAfter: currentSelection
        }), "remove-range"), new Draft.SelectionState({
            anchorKey: keyAfter,
            anchorOffset: 0,
            focusKey: keyAfter,
            focusOffset: block.getLength()
        })));
    };
}
function EditorBlockHandling(param) {
    var editorState = param.editorState, onChange = param.onChange, children = param.children;
    return children({
        removeBlock: handleRemoveBlock(editorState, onChange),
        setBlockData: handleSetBlockData(editorState, onChange)
    });
};
EditorBlockHandling.propTypes = {
    editorState: (prop_types_default()).object.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).func.isRequired
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(32699);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+cache@11.10.3/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 8 modules
var emotion_cache_browser_esm = __webpack_require__(15084);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+serialize@1.0.3/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(72447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+utils@1.1.0/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(33323);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+css@11.9.0_@babel+core@7.18.0/node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function emotion_css_create_instance_esm_merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = (0,emotion_cache_browser_esm/* default */.Z)(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {}

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered, undefined);
    (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return emotion_css_create_instance_esm_merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: emotion_utils_browser_esm/* getRegisteredStyles.bind */.fp.bind(null, cache.registered),
    merge: emotion_css_create_instance_esm_merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ var emotion_css_create_instance_esm = (createEmotion);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+css@11.9.0_@babel+core@7.18.0/node_modules/@emotion/css/dist/emotion-css.esm.js





var _createEmotion = emotion_css_create_instance_esm({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    emotion_css_esm_merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;



;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/GoogleSpreadsheet.js











function GoogleSpreadsheet(param) {
    var block = param.block, blockProps = param.blockProps;
    var blockData = block.getData();
    var spreadsheetUrl = blockData.get("src");
    var adjustedSize = blockData.get("adjustedSize");
    var displayHeaders = blockData.get("displayHeaders");
    var normalizedUrl = spreadsheetUrl.replace("&amp;", "&");
    var parsed = query_string.parseUrl(normalizedUrl);
    var options = {};
    if (!displayHeaders) {
        options = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
            widget: false,
            chrome: false
        });
    }
    var embedQuery = query_string.stringify((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        embedded: true
    }));
    var embedUrl = "".concat(parsed.url.replace("/pubhtml", "/pub"), "?").concat(embedQuery);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorBlockHandling, {
        editorState: blockProps.editorState,
        onChange: blockProps.onChange,
        children: function(param) {
            var setBlockData = param.setBlockData, removeBlock = param.removeBlock;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
                children: function(param) {
                    var bind = param.bind;
                    return blockProps.readOnly ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            paddingTop: 10
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                            src: embedUrl,
                            frameBorder: "0",
                            className: iframeClass,
                            style: {
                                height: adjustedSize || null
                            }
                        })
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, bind), {
                        css: {
                            paddingBottom: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                paddingTop: 10,
                                borderBottom: displayHeaders ? "none" : "solid 1px ".concat(palette/* lightSealBlue */.oz)
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        marginBottom: displayHeaders ? 0 : 10,
                                        display: "flex",
                                        width: "100%",
                                        userSelect: "none",
                                        border: "solid 1px $palette.lightSealBlue}",
                                        borderRadius: 4,
                                        borderBottomLeftRadius: displayHeaders ? 0 : 4,
                                        borderBottomRightRadius: displayHeaders ? 0 : 4,
                                        alignItems: "center",
                                        padding: 20
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        display: "flex",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                                            css: {
                                                                fontWeight: 600,
                                                                fontSize: 16
                                                            },
                                                            children: "Size"
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            css: {
                                                                marginLeft: 5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                                                onFocus: function() {
                                                                    return blockProps.setReadOnly(true);
                                                                },
                                                                onBlur: function() {
                                                                    return blockProps.setReadOnly(false);
                                                                },
                                                                onChange: function(event) {
                                                                    var size = parseInt(event.target.value);
                                                                    if (size) {
                                                                        setBlockData(block, {
                                                                            adjustedSize: (0,lodash.clamp)(size, 100, 800)
                                                                        });
                                                                    }
                                                                },
                                                                placeholder: "200",
                                                                css: {
                                                                    outline: "none",
                                                                    border: "solid 1px $palette.lightSealBlue}",
                                                                    borderRadius: 4,
                                                                    type: "text",
                                                                    padding: 5,
                                                                    width: 60,
                                                                    textAlign: "center",
                                                                    fontSize: 14
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        marginLeft: 10
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                                            css: {
                                                                fontWeight: 600
                                                            },
                                                            children: "Headers?"
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            css: {
                                                                marginLeft: 5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                                                type: "checkbox",
                                                                onFocus: function() {
                                                                    return blockProps.setReadOnly(true);
                                                                },
                                                                onBlur: function() {
                                                                    return blockProps.setReadOnly(false);
                                                                },
                                                                defaultChecked: displayHeaders,
                                                                onChange: function(event) {
                                                                    setBlockData(block, {
                                                                        displayHeaders: event.target.checked
                                                                    });
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: "#",
                                            css: {
                                                textDecoration: "none",
                                                color: palette/* mediumGray */.rF,
                                                marginLeft: "auto",
                                                "&:hover": {
                                                    color: "#000"
                                                }
                                            },
                                            onClick: function() {
                                                removeBlock(block);
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrashCan, {
                                                width: 18,
                                                height: 18
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                                    src: embedUrl,
                                    frameBorder: "0",
                                    className: iframeClass,
                                    style: {
                                        height: adjustedSize || null
                                    }
                                })
                            ]
                        })
                    }));
                }
            });
        }
    });
};
GoogleSpreadsheet.propTypes = {
    block: (prop_types_default()).object.isRequired,
    blockProps: (prop_types_default()).object.isRequired
};
var iframeClass = /*#__PURE__*/ css({
    width: "100%",
    height: 200
});
var TrashCan = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 459 459",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M76.5 408c0 28.05 22.95 51 51 51h204c28.05 0 51-22.95 51-51V102h-306v306zM408 25.5h-89.25L293.25 0h-127.5l-25.5 25.5H51v51h357v-51z"
        })
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/BlockquoteIcon.js




var BlockquoteIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 7,
        height: 4,
        viewBox: "0 0 7 4"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "a",
                    x1: "-15.842%",
                    x2: "109.964%",
                    y1: "13.157%",
                    y2: "116.349%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "0%",
                            stopColor: "#00B1FF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "72.016%",
                            stopColor: "#0060E7"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#0046DF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#D3E1EF"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-626 -708)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#a)",
                        d: "M0 85h1439v635H0z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 730,
                        height: 1584,
                        x: 65,
                        y: 458,
                        fill: "currentColor",
                        rx: 5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(387 695)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 258,
                                height: 32,
                                fill: "#212121",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "currentColor",
                                d: "M239 17l1.961-4h1.752l-1.34 4H239zm3.287 0l1.961-4H246l-1.345 4h-2.368z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_BlockquoteIcon = (BlockquoteIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/BoldIcon.js




var BoldIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 9,
        height: 11,
        viewBox: "0 0 9 11"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "a",
                    x1: "-15.842%",
                    x2: "109.964%",
                    y1: "13.157%",
                    y2: "116.349%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "0%",
                            stopColor: "#00B1FF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "72.016%",
                            stopColor: "#0060E7"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#0046DF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#D3E1EF"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-400 -706)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#a)",
                        d: "M0 85h1439v635H0z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 730,
                        height: 1584,
                        x: 65,
                        y: 458,
                        fill: "currentColor",
                        rx: 5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(387 695)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 258,
                                height: 32,
                                fill: "#212121",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M9 9h16.661v16.819H9z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "currentColor",
                                d: "M19.758 16.284c.694-.49 1.18-1.262 1.18-1.962 0-1.612-1.18-2.803-2.777-2.803h-4.304v9.81h4.86c1.458 0 2.568-1.191 2.568-2.663a2.633 2.633 0 0 0-1.527-2.382zM15.87 13.27h2.083c.555 0 1.041.491 1.041 1.052 0 .56-.486 1.05-1.04 1.05H15.87V13.27zm2.43 6.307h-2.43v-2.102h2.43c.556 0 1.042.49 1.042 1.051 0 .56-.417 1.051-1.042 1.051z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_BoldIcon = (BoldIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/BulletedListIcon.js




function BulletedListIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: 40,
        viewBox: "0 0 24 24",
        width: 17
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M2.5 7C1.121 7 0 5.879 0 4.5S1.121 2 2.5 2 5 3.121 5 4.5 3.879 7 2.5 7zm0-4C1.673 3 1 3.673 1 4.5S1.673 6 2.5 6 4 5.327 4 4.5 3.327 3 2.5 3zM2.5 15C1.121 15 0 13.879 0 12.5S1.121 10 2.5 10 5 11.121 5 12.5 3.879 15 2.5 15zm0-4c-.827 0-1.5.673-1.5 1.5S1.673 14 2.5 14 4 13.327 4 12.5 3.327 11 2.5 11zM2.5 23C1.121 23 0 21.879 0 20.5S1.121 18 2.5 18 5 19.121 5 20.5 3.879 23 2.5 23zm0-4c-.827 0-1.5.673-1.5 1.5S1.673 22 2.5 22 4 21.327 4 20.5 3.327 19 2.5 19zM23.5 5h-16a.5.5 0 010-1h16a.5.5 0 010 1zM23.5 13h-16a.5.5 0 010-1h16a.5.5 0 010 1zM23.5 21h-16a.5.5 0 010-1h16a.5.5 0 010 1z"
        })
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/DividerIcon.js




var DividerIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 34,
        height: 4,
        viewBox: "0 0 34 4"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    id: "a",
                    width: 180,
                    height: 41,
                    y: 10,
                    rx: 4
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(-136 -29)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                fill: "#FFF",
                                xlinkHref: "#a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 179,
                                height: 40,
                                x: 0.5,
                                y: 10.5,
                                stroke: "#F2F2F2",
                                rx: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        fill: "currentColor",
                        fillRule: "nonzero",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M3.89 1.617L2.474.203a.5.5 0 0 0-.707 0L.354 1.617a.5.5 0 0 0 0 .707l1.414 1.414a.5.5 0 0 0 .707 0l1.414-1.414a.5.5 0 0 0 0-.707zm29.698 0L32.173.203a.5.5 0 0 0-.707 0l-1.414 1.414a.5.5 0 0 0 0 .707l1.414 1.414a.5.5 0 0 0 .707 0l1.415-1.414a.5.5 0 0 0 0-.707z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M3.182 2.324a.5.5 0 0 1 .353-.853h26.87a.5.5 0 0 1 0 1H3.535a.498.498 0 0 1-.353-.147z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_DividerIcon = (DividerIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/H2Icon.js




var H2Icon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        width: 17,
        height: 9,
        viewBox: "0 0 17 9"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "a",
                    x1: "-15.842%",
                    x2: "109.964%",
                    y1: "13.157%",
                    y2: "116.349%",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0%",
                            stopColor: "#00B1FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "72.016%",
                            stopColor: "#0060E7"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "100%",
                            stopColor: "#0046DF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "100%",
                            stopColor: "#D3E1EF"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-540 -707)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        fill: "url(#a)",
                        d: "M0 85h1439v635H0z"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        width: 730,
                        height: 1584,
                        x: 65,
                        y: 458,
                        fill: "currentColor",
                        rx: 5
                    }),
                    /*#__PURE__*/ _jsxs("g", {
                        transform: "translate(387 695)",
                        children: [
                            /*#__PURE__*/ _jsx("rect", {
                                width: 258,
                                height: 32,
                                fill: "#212121",
                                rx: 4
                            }),
                            /*#__PURE__*/ _jsx("path", {
                                fill: "currentColor",
                                d: "M161.402 21H159.4v-3.736h-4.412V21H153v-8.867h1.988v3.483h4.412v-3.483h2.002V21zM170 21h-7.03v-1.489c3.823-2.685 4.944-3.59 4.944-4.68 0-.784-.743-1.156-1.513-1.156-1.064 0-1.876.399-2.506 1.024l-1.135-1.25c.91-.997 2.297-1.449 3.6-1.449 2.002 0 3.57 1.064 3.57 2.832 0 1.515-1.316 2.831-3.739 4.506H170V21z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_H2Icon = ((/* unused pure expression or super */ null && (H2Icon)));

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/H3Icon.js




var H3Icon = function(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: 17,
        height: 10,
        viewBox: "0 0 17 10"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8.423 9.826H6.415V5.747H1.993v4.079H0V.146h1.993v3.802h4.422V.145h2.008v9.68zm4.885.174c-1.713 0-3.004-.682-3.692-1.553l1.053-1.379c.632.697 1.656 1.103 2.569 1.103 1.137 0 1.769-.508 1.769-1.233 0-.77-.576-1.118-1.881-1.118-.394 0-1.025.015-1.166.03V3.99c.169.015.815.015 1.166.015 1.038 0 1.74-.32 1.74-1.03 0-.77-.772-1.147-1.74-1.147-.913 0-1.727.348-2.387 1.001l-.997-1.292C10.5.653 11.68 0 13.322 0c2.19 0 3.538 1.016 3.538 2.627 0 1.22-1.011 2.017-2.05 2.206.955.102 2.19.87 2.19 2.322C17 8.825 15.554 10 13.308 10z"
        })
    }));
};
/* harmony default export */ var icons_H3Icon = ((/* unused pure expression or super */ null && (H3Icon)));

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/ImageIcon.js




var ImageIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 20,
        viewBox: "0 0 24 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    id: "a",
                    width: 180,
                    height: 41,
                    y: 10,
                    rx: 4
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(-11 -21)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                fill: "#FFF",
                                xlinkHref: "#a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 179,
                                height: 40,
                                x: 0.5,
                                y: 10.5,
                                stroke: "#F2F2F2",
                                rx: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        stroke: "#F2F2F2",
                        d: "M1.314-17.686h16v16h-16z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        d: "M-3-10h30V6H-3z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        fill: "currentColor",
                        fillRule: "nonzero",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M21.5 2h-3.789L16.029.163A.496.496 0 0 0 15.661 0H8.339a.5.5 0 0 0-.369.163L6.289 2H2.5A2.503 2.503 0 0 0 0 4.5v13C0 18.878 1.122 20 2.5 20h19c1.378 0 2.5-1.122 2.5-2.5v-13C24 3.122 22.878 2 21.5 2zM12 4c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M12 17c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_ImageIcon = (ImageIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/ItalicIcon.js




var ItalicIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 9,
        height: 10,
        viewBox: "0 0 9 10"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "a",
                    x1: "-15.842%",
                    x2: "109.964%",
                    y1: "13.157%",
                    y2: "116.349%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "0%",
                            stopColor: "#00B1FF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "72.016%",
                            stopColor: "#0060E7"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#0046DF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#D3E1EF"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-434 -707)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#a)",
                        d: "M0 85h1439v635H0z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 730,
                        height: 1584,
                        x: 65,
                        y: 458,
                        fill: "currentColor",
                        rx: 5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(387 695)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 258,
                                height: 32,
                                fill: "#212121",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "currentColor",
                                d: "M50 12v2.143h1.65l-2.625 5.714H47V22h6v-2.143h-1.725l2.625-5.714H56V12z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_ItalicIcon = (ItalicIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/LinkIcon.js




var LinkIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 10,
        height: 11,
        viewBox: "0 0 10 11"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "a",
                    x1: "-15.842%",
                    x2: "109.964%",
                    y1: "13.157%",
                    y2: "116.349%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "0%",
                            stopColor: "#00B1FF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "72.016%",
                            stopColor: "#0060E7"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#0046DF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#D3E1EF"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-505 -706)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#a)",
                        d: "M0 85h1439v635H0z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 730,
                        height: 1584,
                        x: 65,
                        y: 458,
                        fill: "currentColor",
                        rx: 5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(387 695)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 258,
                                height: 32,
                                fill: "#212121",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "currentColor",
                                d: "M123.514 22h-1.627l.993-2.804h-1.627L120.277 22h-1.61l.977-2.804H118l.445-1.335h1.678l.925-2.722h-1.661l.428-1.319h1.712l.96-2.82h1.609l-.959 2.82h1.61l.958-2.82h1.627l-.993 2.82H128l-.394 1.32h-1.73l-.941 2.72h1.73l-.429 1.336h-1.763l-.96 2.804zm-.189-4.14l.942-2.72h-1.61l-.924 2.72h1.592z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_LinkIcon = (LinkIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/UnderlineIcon.js




var UnderlineIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 11,
        height: 13,
        viewBox: "0 0 11 13"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "a",
                    x1: "-15.842%",
                    x2: "109.964%",
                    y1: "13.157%",
                    y2: "116.349%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "0%",
                            stopColor: "#00B1FF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "72.016%",
                            stopColor: "#0060E7"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#0046DF"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "100%",
                            stopColor: "#D3E1EF"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-468 -706)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#a)",
                        d: "M0 85h1439v635H0z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 730,
                        height: 1584,
                        x: 65,
                        y: 458,
                        fill: "currentColor",
                        rx: 5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(387 695)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 258,
                                height: 32,
                                fill: "#212121",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "currentColor",
                                d: "M86.18 20.646c2.44 0 4.438-1.86 4.438-4.134V11h-1.85v5.512c0 1.31-1.183 2.411-2.589 2.411s-2.59-1.102-2.59-2.411V11h-1.85v5.512c0 2.274 1.999 4.134 4.44 4.134zM81 22.024v1.378h10.358v-1.378H81z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_UnderlineIcon = (UnderlineIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/VideoIcon.js




var VideoIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 20,
        viewBox: "0 0 24 20",
        style: {
            verticalAlign: "bottom"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    id: "a",
                    width: 180,
                    height: 41,
                    y: 10,
                    rx: 4
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(-53 -21)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                fill: "#FFF",
                                xlinkHref: "#a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 179,
                                height: 40,
                                x: 0.5,
                                y: 10.5,
                                stroke: "#F2F2F2",
                                rx: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "currentColor",
                        fillRule: "nonzero",
                        d: "M18.5 0h-13A5.506 5.506 0 0 0 0 5.5v9C0 17.533 2.467 20 5.5 20h13c3.033 0 5.5-2.467 5.5-5.5v-9C24 2.467 21.533 0 18.5 0zm-1.729 10.42l-7 4.5a.495.495 0 0 1-.511.019A.501.501 0 0 1 9 14.5v-9a.501.501 0 0 1 .77-.42l7 4.5a.498.498 0 0 1 .001.84z"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_VideoIcon = (VideoIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/XIcon.js




var XIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 18 18"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M9.707 9L17.853.854a.5.5 0 0 0-.707-.707L9 8.293.854.146a.5.5 0 0 0-.707.707L8.293 9 .147 17.146a.5.5 0 0 0 .707.708L9 9.707l8.146 8.146a.5.5 0 1 0 .708-.706L9.707 9z"
        })
    }));
};
/* harmony default export */ var icons_XIcon = (XIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/index.js
















var SpreadsheetIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 28 30",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M26.497 2.5h-8.498v-2a.499.499 0 0 0-.573-.494L1.286 2.379A1.508 1.508 0 0 0 .003 3.863v22.266c0 .738.55 1.376 1.281 1.484l16.141 2.373a.49.49 0 0 0 .4-.116.499.499 0 0 0 .173-.378v-2h8.498c.826 0 1.5-.672 1.5-1.5V4c0-.827-.674-1.5-1.5-1.5zm-9.498.5v25.913l-15.568-2.29a.503.503 0 0 1-.427-.494V3.863c0-.246.183-.46.427-.495l15.568-2.29V3zm1 3.998h2.5v1h-2.5v-1zm0 4.999h2.5v1h-2.5v-1zm0 4.998h2.5v1h-2.5v-1zm0 4.999h2.5v1h-2.5v-1zm8.997 3.999a.5.5 0 0 1-.5.5H18v-2.5h5.998a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-.999H18v-2h5.998a1 1 0 0 0 1-.999v-1a1 1 0 0 0-1-1H18v-1.999h5.998a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H18V8.998h5.998a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-.999H18V3.5h8.498a.5.5 0 0 1 .5.5v21.994zm-5.498-3v-1h2.5v1h-2.5zm0-4.998v-1h2.5v1h-2.5zm0-4.999v-1h2.5v1h-2.5zm0-4.998v-1h2.5v1h-2.5z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M8.148 14.996l-3.031 3.681a.5.5 0 1 0 .771.636l2.908-3.531 3.319 4.03a.498.498 0 0 0 .703.069.5.5 0 0 0 .068-.704l-3.443-4.181 3.443-4.181a.5.5 0 1 0-.771-.636l-3.32 4.03-2.907-3.53a.5.5 0 1 0-.771.636l3.031 3.68z"
                })
            ]
        })
    }));
};
var TypeformIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 19 30",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16 0h3v30h-3zM0 6.868h3.69V0h4.89v6.868H13v3.767H8.58v12.23c0 .532.022.99.065 1.374.043.385.143.71.3.975.158.266.393.465.709.598.314.133.743.2 1.287.2.343 0 .686-.007 1.03-.023A4.952 4.952 0 0 0 13 25.835v3.9c-.544.058-1.073.117-1.587.177-.527.059-1.057.088-1.588.088-1.287 0-2.324-.126-3.11-.376-.788-.251-1.402-.621-1.845-1.109-.444-.487-.744-1.1-.901-1.839-.158-.737-.25-1.58-.279-2.525V10.635H0V6.868"
            })
        })
    }));
};
var GoogleFormsIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 512 512",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M117.333 64H224v21.333H117.333zM117.333 106.667h21.333V128h-21.333zM160 106.667h21.333V128H160z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M455.541 88.459L370.208 3.125c-2-2-4.713-3.125-7.541-3.125H85.333c-17.673 0-32 14.327-32 32v448c0 17.673 14.327 32 32 32h341.333c17.673 0 32-14.327 32-32V96a10.66 10.66 0 0 0-3.125-7.541zM437.333 480c0 5.891-4.776 10.667-10.667 10.667H85.333c-5.891 0-10.667-4.776-10.667-10.667V32c0-5.891 4.776-10.667 10.667-10.667H358.25l79.083 79.083V480z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M384 85.333c-5.891 0-10.667-4.776-10.667-10.667v-64H352v64c0 17.673 14.327 32 32 32h21.333V85.333H384zM373.333 362.667h21.333V384h-21.333zM330.667 362.667H352V384h-21.333zM117.333 362.667H288V384H117.333zM117.333 416h277.333v21.333H117.333zM373.333 160H138.667c-11.782 0-21.333 9.551-21.333 21.333v128c0 11.782 9.551 21.333 21.333 21.333h234.667c11.782 0 21.333-9.551 21.333-21.333v-128c0-11.782-9.552-21.333-21.334-21.333zm0 149.333H138.667v-128h234.667v128z"
                })
            ]
        })
    }));
};
var AirtableIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 177 148",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M79 1.867L13.04 29.16c-3.668 1.518-3.63 6.729.061 8.192l66.235 26.266a24.575 24.575 0 0 0 18.12 0l66.236-26.267c3.69-1.462 3.73-6.672.06-8.19L97.794 1.866a24.578 24.578 0 0 0-18.795 0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M94.273 77.96v65.617c0 3.12 3.147 5.258 6.048 4.108l73.806-28.648a4.418 4.418 0 0 0 2.79-4.108V49.313c0-3.121-3.147-5.258-6.048-4.108L97.063 73.853a4.42 4.42 0 0 0-2.79 4.108"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M77.038 81.346L55.134 91.922l-2.224 1.075-46.238 22.155C3.742 116.566 0 114.43 0 111.174V49.588c0-1.178.604-2.195 1.414-2.96a5.024 5.024 0 0 1 1.12-.84c1.104-.663 2.68-.84 4.02-.31L76.67 73.26c3.564 1.414 3.844 6.408.368 8.087"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M77.038 81.346L55.134 91.922 1.414 46.627a5.024 5.024 0 0 1 1.12-.839c1.104-.663 2.68-.84 4.02-.31L76.67 73.26c3.564 1.414 3.844 6.408.368 8.087",
                    fillOpacity: 0.25
                })
            ]
        })
    }));
};
var SimplecastIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 86 84"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M85.01 0v83.99H.736V0H85.01zm-5.618 5.6H6.353v72.79h73.04V5.6z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M17.59 16.798V67.19h50.566zM64.182 52.432L32.401 20.758l3.972-3.96 31.783 31.674zM64.182 36.594l-15.89-15.837 3.972-3.96 15.892 15.838z"
                })
            ]
        })
    }));
};
var SocialMediaIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 481.6 481.6"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M381.6 309.4c-27.7 0-52.4 13.2-68.2 33.6l-132.3-73.9c3.1-8.9 4.8-18.5 4.8-28.4 0-10-1.7-19.5-4.9-28.5l132.2-73.8c15.7 20.5 40.5 33.8 68.3 33.8 47.4 0 86.1-38.6 86.1-86.1S429 0 381.5 0s-86.1 38.6-86.1 86.1c0 10 1.7 19.6 4.9 28.5l-132.1 73.8c-15.7-20.6-40.5-33.8-68.3-33.8-47.4 0-86.1 38.6-86.1 86.1s38.7 86.1 86.2 86.1c27.8 0 52.6-13.3 68.4-33.9l132.2 73.9c-3.2 9-5 18.7-5 28.7 0 47.4 38.6 86.1 86.1 86.1s86.1-38.6 86.1-86.1-38.7-86.1-86.2-86.1zm0-282.3c32.6 0 59.1 26.5 59.1 59.1s-26.5 59.1-59.1 59.1-59.1-26.5-59.1-59.1 26.6-59.1 59.1-59.1zM100 299.8c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.6 59.1-59.1 59.1zm281.6 154.7c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.5 59.1-59.1 59.1z"
            })
        })
    }));
};
var NewsletterIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 480 480"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M440 80H40C17.92 80.026.026 97.92 0 120v240c.026 22.08 17.92 39.974 40 40h400c22.08-.026 39.974-17.92 40-40V120c-.026-22.08-17.92-39.974-40-40zm24 280c0 13.255-10.745 24-24 24H40c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h400c13.255 0 24 10.745 24 24v240z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M446.856 115.88a8 8 0 00-10.976-2.736L260.576 218.32a39.88 39.88 0 01-41.152 0L44.12 113.144a8 8 0 00-8.24 13.712L211.2 232.04a55.897 55.897 0 0057.6 0l175.32-105.184a8 8 0 002.736-10.976zM40 144a8 8 0 00-8 8v208a8 8 0 0016 0V152a8 8 0 00-8-8zM440 144a8 8 0 00-8 8v208a8 8 0 0016 0V152a8 8 0 00-8-8z"
                })
            ]
        })
    }));
};
var CustomButtonIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "18px",
        height: "18px",
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M4 6C2.34315 6 1 4.65685 1 3C1 1.34315 2.34315 0 4 0H11C12.6569 0 14 1.34315 14 3C14 4.65685 12.6569 6 11 6H9V3.5C9 2.11929 7.88071 1 6.5 1C5.11929 1 4 2.11929 4 3.5V6Z",
                fill: "#cccccc"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M6.5 2C5.67157 2 5 2.67157 5 3.5V8.05001C3.85888 8.28164 3 9.29052 3 10.5C3 12.9853 5.01472 15 7.5 15H8C10.7614 15 13 12.7614 13 10V9.14706C13 7.96127 12.0387 7 10.8529 7H8V3.5C8 2.67157 7.32843 2 6.5 2Z",
                fill: "#cccccc"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/testId.js
/**
 * @param   {String} forIdentifier
 * @returns {Object}
 */ function genProps(forIdentifier) {
    if (forIdentifier) {
        return {
            testID: forIdentifier,
            // https://github.com/facebook/draft-js/blob/70178257f60c2bdb79b1b208cf8b7bbce09ab15e/src/component/base/DraftEditorProps.js#L103
            webDriverTestID: forIdentifier,
            "data-test-id": forIdentifier
        };
    }
    return {};
}
/**
 * @param   {String} actualIdentifier
 * @returns {Object}
 */ function testId(actualIdentifier) {
    if (true) {
        return {};
    }
    if (typeof actualIdentifier === "string") {
        return genProps(actualIdentifier);
    }
    return {};
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/Image.js










function Image(param) {
    var block = param.block, blockProps = param.blockProps;
    var imageUrl = block.getData().get("imageUrl");
    var imageAlt = block.getData().get("imageAlt");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorBlockHandling, {
        editorState: blockProps.editorState,
        onChange: blockProps.onChange,
        children: function(param) {
            var removeBlock = param.removeBlock;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
                children: function(param) {
                    var isHover = param.isHover, bindHover = param.bindHover;
                    return blockProps.readOnly ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                        src: imageUrl,
                        alt: imageAlt,
                        css: {
                            width: "100%",
                            objectFit: "cover",
                            userSelect: "none"
                        }
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("blocks/Image/hoverContainer")), {
                        css: {
                            position: "relative"
                        }
                    }), bindHover), {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("blocks/Image/img")), {
                                src: imageUrl,
                                alt: imageAlt,
                                css: {
                                    width: "100%",
                                    objectFit: "cover",
                                    userSelect: "none"
                                }
                            })),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                type: "button"
                            }, testId("blocks/Image/removeButton")), {
                                onClick: function() {
                                    return removeBlock(block);
                                },
                                css: {
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    border: "none",
                                    borderRadius: "100%",
                                    display: isHover ? "flex" : "none",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: 30,
                                    width: 30,
                                    margin: 10,
                                    padding: 10,
                                    backgroundColor: palette_text,
                                    color: "#fff",
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_XIcon, {})
                            }))
                        ]
                    }));
                }
            });
        }
    });
};
Image.propTypes = {
    block: (prop_types_default()).object.isRequired,
    blockProps: prop_types_default().shape({
        readOnly: (prop_types_default()).bool.isRequired,
        editorState: (prop_types_default()).object.isRequired,
        onChange: (prop_types_default()).func.isRequired
    }).isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/Typeform.js









var Typeform = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Typeform, Component);
    var _super = (0,_create_super/* default */.Z)(Typeform);
    function Typeform() {
        (0,_class_call_check/* default */.Z)(this, Typeform);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Typeform, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var block = this.props.block;
                var typeformEmbed = __webpack_require__(58978);
                this.reference = typeformEmbed.makePopup(block.getData().get("src"), {
                    mode: "popup",
                    autoClose: 3000,
                    hideHeaders: true,
                    hideFooters: true
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        position: "relative",
                        marginTop: 10
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                        type: "button",
                        css: {
                            border: "none",
                            padding: 10,
                            paddingLeft: 20,
                            paddingRight: 20,
                            borderRadius: 8,
                            fontSize: 14,
                            textAlign: "center",
                            outline: 0,
                            cursor: "pointer",
                            backgroundColor: palette/* innovatorBlue */.LD,
                            textTransform: "uppercase",
                            color: palette/* white */.ix
                        },
                        onClick: function() {
                            if (_this.reference) {
                                _this.reference.open();
                            }
                        },
                        children: "Launch and Answer"
                    })
                });
            }
        }
    ]);
    return Typeform;
}(react.Component);
(0,_define_property/* default */.Z)(Typeform, "propTypes", {
    block: (prop_types_default()).object.isRequired
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/Simplecast.js



function Simplecast(param) {
    var block = param.block;
    var blockData = block.getData();
    var embedUrl = blockData.get("src");
    var height = blockData.get("height");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            border: "1px solid #ccc",
            borderRadius: 4,
            overflow: "hidden",
            marginTop: 10,
            display: "flex"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
            src: embedUrl,
            frameBorder: "0",
            css: {
                width: "100%",
                height: height
            },
            style: {
                width: "100%",
                height: height
            }
        })
    });
};
Simplecast.propTypes = {
    block: (prop_types_default()).object.isRequired
};

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.7.2/node_modules/prop-types/index.js
var node_modules_prop_types = __webpack_require__(19036);
var node_modules_prop_types_default = /*#__PURE__*/__webpack_require__.n(node_modules_prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(3341);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
// EXTERNAL MODULE: ./node_modules/.pnpm/youtube-player@5.5.2/node_modules/youtube-player/dist/index.js
var dist = __webpack_require__(70905);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-youtube@7.14.0_react@17.0.2/node_modules/react-youtube/dist/index.esm.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function index_esm_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */

function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  } // Otherwise, a change in the start/end time playerVars also requires a player
  // update.


  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};
  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}
/**
 * Neutralize API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */


function filterResetOptions(opts) {
  return _objectSpread(_objectSpread({}, opts), {}, {
    height: 0,
    width: 0,
    playerVars: _objectSpread(_objectSpread({}, opts.playerVars), {}, {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}
/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */


function shouldResetPlayer(prevProps, props) {
  return prevProps.videoId !== props.videoId || !fast_deep_equal_default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}
/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */


function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id !== props.id || prevProps.className !== props.className || prevProps.opts.width !== props.opts.width || prevProps.opts.height !== props.opts.height || prevProps.title !== props.title;
}

var YouTube = /*#__PURE__*/function (_React$Component) {
  index_esm_inherits(YouTube, _React$Component);

  var _super = _createSuper(YouTube);

  /**
   * Expose PlayerState constants for convenience. These constants can also be
   * accessed through the global YT object after the YouTube IFrame API is instantiated.
   * https://developers.google.com/youtube/iframe_api_reference#onStateChange
   */
  function YouTube(props) {
    var _this;

    _classCallCheck(this, YouTube);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onPlayerReady", function (event) {
      return _this.props.onReady(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerError", function (event) {
      return _this.props.onError(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerStateChange", function (event) {
      _this.props.onStateChange(event);

      switch (event.data) {
        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);

          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);

          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);

          break;

        default:
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackRateChange", function (event) {
      return _this.props.onPlaybackRateChange(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackQualityChange", function (event) {
      return _this.props.onPlaybackQualityChange(event);
    });

    _defineProperty(_assertThisInitialized(_this), "createPlayer", function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return; // create player

      var playerOpts = _objectSpread(_objectSpread({}, _this.props.opts), {}, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });

      _this.internalPlayer = dist_default()(_this.container, playerOpts); // attach event handlers

      _this.internalPlayer.on('ready', _this.onPlayerReady);

      _this.internalPlayer.on('error', _this.onPlayerError);

      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);

      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);

      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    });

    _defineProperty(_assertThisInitialized(_this), "resetPlayer", function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    });

    _defineProperty(_assertThisInitialized(_this), "updatePlayer", function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
        if (_this.props.opts && _this.props.opts.width) iframe.setAttribute('width', _this.props.opts.width);else iframe.removeAttribute('width');
        if (_this.props.opts && _this.props.opts.height) iframe.setAttribute('height', _this.props.opts.height);else iframe.removeAttribute('height');
        if (typeof _this.props.title === 'string') iframe.setAttribute('title', _this.props.title);else iframe.setAttribute('title', 'YouTube video player');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
      return _this.internalPlayer;
    });

    _defineProperty(_assertThisInitialized(_this), "updateVideo", function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();

        return;
      } // set queueing options


      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };

      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;

        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }

        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      } // if autoplay is enabled loadVideoById


      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);

        return;
      } // default behaviour just cues the video


      _this.internalPlayer.cueVideoById(opts);
    });

    _defineProperty(_assertThisInitialized(_this), "refContainer", function (container) {
      _this.container = container;
    });

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  _createClass(YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all YouTube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }
    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/react.createElement("div", {
        className: this.props.containerClassName
      }, /*#__PURE__*/react.createElement("div", {
        id: this.props.id,
        className: this.props.className,
        ref: this.refContainer,
        loading: this.props.loading
      }));
    }
  }]);

  return YouTube;
}(react.Component);

_defineProperty(YouTube, "PlayerState", {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
});

YouTube.propTypes = {
  videoId: (node_modules_prop_types_default()).string,
  // custom ID for player element
  id: (node_modules_prop_types_default()).string,
  // custom class name for player element
  className: (node_modules_prop_types_default()).string,
  // custom class name for player container element
  containerClassName: (node_modules_prop_types_default()).string,
  // custom title for the iFrame, see https://www.w3.org/TR/WCAG20-TECHS/H64.html
  title: (node_modules_prop_types_default()).string,
  // custom loading for player element
  loading: node_modules_prop_types_default().oneOf(['lazy', 'eager', 'auto']),
  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: node_modules_prop_types_default().objectOf((node_modules_prop_types_default()).any),
  // event subscriptions
  onReady: (node_modules_prop_types_default()).func,
  onError: (node_modules_prop_types_default()).func,
  onPlay: (node_modules_prop_types_default()).func,
  onPause: (node_modules_prop_types_default()).func,
  onEnd: (node_modules_prop_types_default()).func,
  onStateChange: (node_modules_prop_types_default()).func,
  onPlaybackRateChange: (node_modules_prop_types_default()).func,
  onPlaybackQualityChange: (node_modules_prop_types_default()).func
};
YouTube.defaultProps = {
  videoId: null,
  id: null,
  className: null,
  loading: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {},
  title: null
};
/* harmony default export */ var index_esm = (YouTube);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/YouTubeVideo.js





var YouTubeVideo_iframeClass = /*#__PURE__*/ css({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
});
function YouTubeVideo(param) {
    var block = param.block;
    var videoId = block.getData().get("videoId");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            position: "relative",
            "& > div": {
                display: "block",
                position: "relative",
                width: "100%",
                height: 0,
                // https://css-tricks.com/aspect-ratio-boxes/
                paddingBottom: "56.25%"
            }
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm, {
            id: videoId,
            videoId: videoId,
            className: YouTubeVideo_iframeClass.toString(),
            opts: {
                width: "100%",
                height: "100%",
                playerVars: {
                    controls: 2,
                    modestbranding: 1,
                    showinfo: 0,
                    wmode: "transparent",
                    autohide: 1,
                    mode: "opaque",
                    rel: 0
                }
            }
        })
    });
};
YouTubeVideo.propTypes = {
    block: (prop_types_default()).object.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/Newsletter.js



function Newsletter(param) {
    var block = param.block;
    var blockData = block.getData();
    var callText = blockData.get("callText");
    var buttonText = blockData.get("buttonText");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            borderRadius: 4,
            overflow: "hidden",
            marginTop: 10,
            display: "grid",
            gridRowGap: 12,
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                css: {
                    width: "100%",
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: 1.33
                },
                children: callText
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    "data-intercom-target": "SubscribeForNewsletter",
                    type: "button",
                    css: {
                        margin: 0,
                        padding: 12,
                        color: "white",
                        fontSize: 14,
                        letterSpacing: 0.6,
                        backgroundColor: "#63cc99",
                        border: "none",
                        borderRadius: 4,
                        width: 210
                    },
                    children: buttonText
                })
            })
        ]
    });
};
Newsletter.propTypes = {
    block: (prop_types_default()).object.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/CustomButton.js



function CustomButton(param) {
    var block = param.block;
    var blockData = block.getData();
    var buttonText = blockData.get("buttonText");
    var buttonURL = blockData.get("buttonURL");
    var buttonColor = blockData.get("buttonColor");
    var buttonTextColor = blockData.get("buttonTextColor");
    var buttonBorderColor = blockData.get("buttonBorderColor");
    var buttonWidth = blockData.get("buttonWidth");
    var buttonTargetBlank = blockData.get("buttonTargetBlank");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            marginTop: 10,
            display: "flex",
            justifyContent: "center",
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: buttonURL,
            target: buttonTargetBlank ? "_blank" : "_self",
            rel: "noreferrer",
            type: "button",
            css: {
                margin: 0,
                padding: "5px 15px",
                color: buttonTextColor,
                fontSize: 20,
                letterSpacing: 0.6,
                backgroundColor: buttonColor,
                border: "1px solid",
                borderColor: buttonBorderColor,
                borderRadius: 4,
                minWidth: 200,
                width: buttonWidth ? "".concat(buttonWidth, "%") : undefined,
                textDecoration: "none"
            },
            children: buttonText
        })
    });
};
CustomButton.propTypes = {
    block: (prop_types_default()).object.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/removeBlockByKey.js

/**
 * @param   {EditorState}  editorState
 * @param   {ContentBlock} block
 * @returns {EditorState}
 */ function removeBlockByKey(editorState, block) {
    var selection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var keyAfter = content.getKeyAfter(block.getKey());
    var blockMap = content.getBlockMap().delete(block.getKey());
    // const emptyUnstyledBlock = new ContentBlock({
    //   key: genKey(),
    //   type: "unstyled",
    //   text: "",
    //   characterList: List(),
    // });
    var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
    });
    var newState = Draft.EditorState.push(editorState, withoutAtomicBlock, "remove-range");
    // If this is not the last block
    if (keyAfter) {
        var newSelection = new Draft.SelectionState({
            anchorKey: keyAfter,
            anchorOffset: 0,
            focusKey: keyAfter,
            focusOffset: block.getLength()
        });
        return Draft.EditorState.forceSelection(newState, newSelection);
    }
    return newState;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/GovlaunchProject.js





function GovlaunchProject(param) {
    var block = param.block, blockProps = param.blockProps;
    var blockData = block.getData();
    var slug = blockData.get("slug");
    var title = blockData.get("title");
    var countryCode = blockData.get("countryCode") || "US";
    var readOnly = blockProps.readOnly, editorState = blockProps.editorState, onChange = blockProps.onChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
        children: function(isMobile) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                "data-project-title": title,
                "data-project-slug": slug,
                css: {
                    paddingTop: 20,
                    paddingBottom: 20,
                    userSelect: readOnly ? "none" : null
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        position: "relative",
                        padding: isMobile ? 8 : 16,
                        border: "1px solid #BDDAFD",
                        backgroundColor: "#ffffff"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                            href: "/projects/".concat(slug),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            css: {
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                                userSelect: readOnly ? "none" : null
                            },
                            children: [
                                countryCode && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "https://static.govlaunch.com/flags/squared/".concat(countryCode, ".svg"),
                                    alt: "".concat(countryCode, " flag"),
                                    width: 64,
                                    height: 48,
                                    css: {
                                        width: 64,
                                        height: 48,
                                        marginRight: isMobile ? 12 : 24,
                                        aspectRatio: "4 / 3",
                                        alignSelf: "flex-start"
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    css: {
                                        margin: 0,
                                        color: "#086BE5",
                                        fontWeight: "bold",
                                        fontSize: isMobile ? 14 : 18,
                                        lineHeight: "24px"
                                    },
                                    children: title
                                })
                            ]
                        }),
                        !readOnly && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            type: "button",
                            onClick: function(event) {
                                event.preventDefault();
                                event.stopPropagation();
                                onChange(removeBlockByKey(editorState, block));
                            },
                            css: {
                                userSelect: "none",
                                border: "none",
                                position: "absolute",
                                top: -12,
                                right: -12,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 24,
                                height: 24,
                                color: "white",
                                fontSize: 14,
                                backgroundColor: "#FA1601",
                                borderRadius: "50%",
                                cursor: "pointer"
                            },
                            children: "✕"
                        })
                    ]
                })
            });
        }
    });
};
GovlaunchProject.propTypes = {
    block: (prop_types_default()).object.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/index.js













;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/EditorBlockStyles.js



var ParagraphStyle = /*#__PURE__*/ css({
    fontSize: "20px",
    lineHeight: "34px",
    marginTop: 25,
    "&:first-of-type": {
        marginTop: 0
    }
});
var ResetHeadingStyle = /*#__PURE__*/ css({
    margin: 0,
    padding: 0
});
var PlaceholderStyle = /*#__PURE__*/ css({
    "& .public-DraftEditorPlaceholder-root": {
        fontSize: 18,
        color: sealBlue,
        fontWeight: "normal",
        position: "absolute"
    }
});
var FigureResetStyle = /*#__PURE__*/ css({
    "& figure": {
        margin: 0
    },
    "& figure > hr": {
        marginTop: 30,
        marginBottom: 30
    }
});
var BlockquoteStyle = /*#__PURE__*/ css({
    fontSize: "22px",
    color: "#086BE5",
    "@media (max-width: 767px)": {
        margin: "35px 0px 35px 30px !important"
    },
    "@media (min-width: 767px)": {
        margin: "35px 0px 35px 60px !important"
    }
});
var H3Style = /*#__PURE__*/ css({
    fontWeight: 600,
    fontSize: "32px !important",
    marginTop: "50px !important",
    marginBottom: "0px !important"
});
var H4Style = /*#__PURE__*/ css({
    fontWeight: 700,
    fontSize: "24px !important",
    marginTop: "30px !important"
});
var H3H4ParagraphStyle = /*#__PURE__*/ css((0,_define_property/* default */.Z)({}, ".".concat(H3Style, " + .").concat(H4Style), {
    marginTop: 30
}));


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/EditorAreaFocusState.js
/* eslint-disable prefer-destructuring */ 







var EditorAreaFocusState = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(EditorAreaFocusState, Component);
    var _super = (0,_create_super/* default */.Z)(EditorAreaFocusState);
    function EditorAreaFocusState() {
        (0,_class_call_check/* default */.Z)(this, EditorAreaFocusState);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            focus: false
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleFocus", function() {
            var onFocus = _this.props.onFocus;
            _this.setState({
                focus: true
            }, function() {
                if (onFocus) {
                    onFocus();
                }
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleBlur", function() {
            var onBlur = _this.props.onBlur;
            _this.setState({
                focus: false
            }, function() {
                if (onBlur) {
                    onBlur();
                }
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(EditorAreaFocusState, [
        {
            key: "render",
            value: function render() {
                var focus = this.state.focus;
                var children = this.props.children;
                return children({
                    focus: focus,
                    bindFocus: {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }
                });
            }
        }
    ]);
    return EditorAreaFocusState;
}(react.Component);
(0,_define_property/* default */.Z)(EditorAreaFocusState, "propTypes", {
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    children: (prop_types_default()).func.isRequired
});
(0,_define_property/* default */.Z)(EditorAreaFocusState, "defaultProps", {
    onFocus: null,
    onBlur: null
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/entities/Link.js




function Link(param) {
    var entityKey = param.entityKey, contentState = param.contentState, children = param.children;
    var url = contentState.getEntity(entityKey).getData().url;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        css: {
            color: primary,
            textDecoration: "none",
            cursor: "pointer"
        },
        children: children
    });
};
Link.propTypes = {
    entityKey: (prop_types_default()).string.isRequired,
    contentState: (prop_types_default()).any.isRequired,
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/entities/index.js
/* eslint-disable import/prefer-default-export */ 


// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/socialMedia.js
var socialMedia = __webpack_require__(3907);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/SocialMediaInput.js






function SocialMediaInput(param) {
    var defaultValues = param.defaultValues, onInsert = param.onInsert;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
            onSubmit: function(event) {
                event.preventDefault();
                event.stopPropagation();
                var socialMedias = Object.keys(SocialMedias).map(function(socialMedia) {
                    return {
                        socialMedia: socialMedia,
                        url: (event.target.elements["url[".concat(socialMedia, "]")].value || "").trim()
                    };
                }).filter(function(param) {
                    var url = param.url;
                    return url !== "";
                });
                onInsert({
                    socialMedias: socialMedias
                });
            },
            css: {
                width: 300,
                padding: 8,
                display: "grid",
                gridRowGap: 8
            },
            children: [
                Object.entries(SocialMedias).map(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], name = _param[1].name;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "grid",
                            alignItems: "center",
                            gridTemplateColumns: "1fr 1fr"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                type: "url",
                                name: "url[".concat(key, "]"),
                                placeholder: "What's the URL?",
                                defaultValue: defaultValues !== null ? defaultValues[key] : "",
                                css: {
                                    margin: 0,
                                    padding: 8,
                                    border: "solid 1px ".concat(sealBlue),
                                    borderRadius: 2
                                }
                            })
                        ]
                    }, key);
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "submit",
                    css: {
                        margin: 0,
                        padding: 8,
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer"
                    },
                    children: "Submit"
                })
            ]
        })
    });
};
SocialMediaInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    defaultValues: prop_types_default().shape({
        twitter: (prop_types_default()).string,
        facebook: (prop_types_default()).string,
        instagram: (prop_types_default()).string,
        youtube: (prop_types_default()).string,
        applePodcast: (prop_types_default()).string,
        spotify: (prop_types_default()).string,
        googlePlay: (prop_types_default()).string,
        soundCloud: (prop_types_default()).string,
        deezer: (prop_types_default()).string,
        iHeartRadio: (prop_types_default()).string,
        overcast: (prop_types_default()).string,
        stitcher: (prop_types_default()).string,
        simplecast: (prop_types_default()).string
    })
};
SocialMediaInput.defaultProps = {
    defaultValues: null
};
var SocialMedias = {
    twitter: {
        name: "Twitter",
        icon: socialMedia/* TwitterIcon */.Zm,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    facebook: {
        name: "Facebook",
        icon: socialMedia/* FacebookIcon */.Vq,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    instagram: {
        name: "Instagram",
        icon: socialMedia/* InstagramIcon */.yu,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    youtube: {
        name: "YouTube",
        icon: socialMedia/* YouTubeIcon */.Fc,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    applePodcast: {
        name: "Apple Podcast",
        icon: socialMedia/* ApplePodcastIcon */._O,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    spotify: {
        name: "Spotify",
        icon: socialMedia/* SpotifyIcon */.ZZ,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    googlePlay: {
        name: "Google Play",
        icon: socialMedia/* GooglePlayIcon */.vr,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    soundCloud: {
        name: "SoundCloud",
        icon: socialMedia/* SoundCloudIcon */.qh,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    deezer: {
        name: "Deezer",
        icon: socialMedia/* DeezerIcon */.hG,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    iHeartRadio: {
        name: "iHeartRadio",
        icon: socialMedia/* IHeartRadioIcon */.df,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    overcast: {
        name: "Overcast",
        icon: socialMedia/* OvercastIcon */.KA,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    stitcher: {
        name: "Stitcher",
        icon: socialMedia/* SticherIcon */.hs,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    simplecast: {
        name: "Simplecast",
        icon: socialMedia/* SimplecastIcon */.sn,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    pandora: {
        name: "Pandora",
        icon: socialMedia/* PandoraIcon */.yY,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    amazonmusic: {
        name: "Amazon Music",
        icon: socialMedia/* AmazonMusicIcon */.H0,
        iconProps: {
            width: 32,
            height: 32
        }
    }
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/blocks/SocialMedias.js











function SocialMedias_SocialMedias(param) {
    var block = param.block, blockProps = param.blockProps;
    var blockData = block.getData();
    var editorState = blockProps.editorState, readOnly = blockProps.readOnly, setReadOnly = blockProps.setReadOnly, onChange = blockProps.onChange;
    var socialMedias = List.isList(blockData.get("socialMedias")) ? blockData.get("socialMedias").toJS() : blockData.get("socialMedias");
    if (!Array.isArray(socialMedias)) {
        return null;
    }
    if (socialMedias.length === 0) {
        return null;
    }
    var updateBlockData = function(modifiedData) {
        var content = editorState.getCurrentContent();
        var selection = new Draft.SelectionState({
            anchorKey: block.key,
            anchorOffset: 0,
            focusKey: block.key,
            focusOffset: block.getLength()
        });
        var nextContentState = Draft.Modifier.mergeBlockData(content, selection, modifiedData);
        return Draft.EditorState.push(editorState, nextContentState, "change-block-data");
    };
    var removeCurrentBlock = function() {
        var selection = editorState.getSelection();
        var content = editorState.getCurrentContent();
        var keyAfter = content.getKeyAfter(block.key);
        var blockMap = content.getBlockMap().delete(block.key);
        var withoutAtomicBlock = content.merge({
            blockMap: blockMap,
            selectionAfter: selection
        });
        var newState = Draft.EditorState.push(editorState, withoutAtomicBlock, "remove-range");
        // if this is not the last block
        if (keyAfter) {
            var newSelection = new Draft.SelectionState({
                anchorKey: keyAfter,
                anchorOffset: 0,
                focusKey: keyAfter,
                focusOffset: block.getLength()
            });
            return Draft.EditorState.forceSelection(newState, newSelection);
        }
        return newState;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            marginTop: 10
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "grid",
                gridRowGap: 16,
                gridColumnGap: 8,
                gridTemplateColumns: "repeat(auto-fit, 32px)",
                position: "relative"
            },
            children: [
                socialMedias.map(function(param) {
                    var socialMedia = param.socialMedia, url = param.url;
                    if (SocialMedias[socialMedia]) {
                        var Icon = SocialMedias[socialMedia].icon;
                        if (Icon) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: url,
                                rel: "noopener noreferrer",
                                target: "_blank",
                                title: SocialMedias[socialMedia].name,
                                css: {
                                    display: "inline-flex",
                                    userSelect: "none",
                                    "& > svg": {
                                        display: "block"
                                    }
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, (0,src_object_spread/* default */.Z)({}, SocialMedias[socialMedia].iconProps))
                            }, socialMedia);
                        }
                    }
                    return null;
                }).filter(Boolean),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: false,
                    children: function(param) {
                        var isOpen = param.value, setOpen = param.set;
                        if (readOnly && !isOpen) {
                            return null;
                        }
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                            isOpen: isOpen,
                            boxStyle: {
                                zIndex: 9999,
                                borderRadius: 4,
                                boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)"
                            },
                            onClickOutside: function() {
                                return setOpen(false);
                            },
                            render: function() {
                                var defaultValues = socialMedias.reduce(function(values, currentValue) {
                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), (0,_define_property/* default */.Z)({}, currentValue.socialMedia, currentValue.url));
                                }, {});
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaInput, {
                                    defaultValues: defaultValues,
                                    onInsert: function(blockData) {
                                        if (blockData.socialMedias.length === 0) {
                                            onChange(removeCurrentBlock());
                                        } else {
                                            onChange(updateBlockData(blockData));
                                            setOpen(false);
                                        }
                                        setTimeout(function() {
                                            setReadOnly(false);
                                        }, 1);
                                    }
                                });
                            },
                            children: function(param) {
                                var innerRef = param.innerRef;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                    onClick: function() {
                                        setOpen(!isOpen);
                                        setReadOnly(true);
                                    },
                                    ref: innerRef,
                                    type: "button",
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        margin: 0,
                                        color: "#333333",
                                        border: "none",
                                        borderRadius: "100%",
                                        width: 32,
                                        height: 32,
                                        outline: "none",
                                        cursor: "pointer",
                                        appearance: "button",
                                        "&:hover": {
                                            color: "rgba(0, 0, 0, 0.6)",
                                            backgroundColor: "#f1f1f1"
                                        },
                                        WebkitAppearance: "button",
                                        "& > svg": {
                                            width: 18,
                                            height: 18
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                        width: 12,
                                        height: 12,
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: 2,
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        style: {
                                            fill: "none"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                                        })
                                    })
                                });
                            }
                        });
                    }
                })
            ]
        })
    });
};
SocialMedias_SocialMedias.propTypes = {
    block: (prop_types_default()).object.isRequired,
    blockProps: (prop_types_default()).object.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/Editor.js
/* eslint-disable react/no-unused-class-component-methods */ 



























/**
 * @param   {Boolean} readOnly
 * @returns {CompositeDecorator}
 */ function getDecoratorsForState(readOnly) {
    var decorators = [
        {
            strategy: findEntitiesByType(src_EntityTypeIdentifiers.LINK),
            component: Link,
            props: {
                readOnly: readOnly
            }
        },
        {
            strategy: findEntitiesByType(src_EntityTypeIdentifiers.MENTION),
            component: Mention,
            props: {
                readOnly: readOnly
            }
        }, 
    ];
    if (readOnly === false) {
        decorators.push(mentions_MentionSpanDecoratorConfig);
    }
    return new Draft.CompositeDecorator(decorators);
}
/**
 * @type {Function}
 */ var Editor_noop = function() {};
var GovlaunchEditor = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(GovlaunchEditor, Component);
    var _super = (0,_create_super/* default */.Z)(GovlaunchEditor);
    function GovlaunchEditor(props) {
        (0,_class_call_check/* default */.Z)(this, GovlaunchEditor);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "setEditorRef", function(ref) {
            _this.editorRef = ref;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "setWrapperRef", function(ref) {
            _this.wrapperRef = ref;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "getCurrentBlock", function(editorState) {
            var selection = editorState.getSelection();
            var contentState = editorState.getCurrentContent();
            return contentState.getBlockForKey(selection.getEndKey());
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleKeyBinding", function(event) {
            if (event.metaKey && event.key === "h") {
                return "highlight";
            } else if (event.key === " ") {
                // Space
                var currentBlock = _this.getCurrentBlock(_this.props.editorState);
                if (currentBlock.getText() === "-") {
                    return "unordered-list";
                } else if (currentBlock.getText() === "1.") {
                    return "ordered-list";
                }
            }
            return (0,Draft.getDefaultKeyBinding)(event);
        });
        // https://github.com/facebook/draft-js/issues/915#issuecomment-272602852
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleKeyCommand", function(command, editorState) {
            var onChange = _this.props.onChange;
            if (command === "highlight") {
                onChange(Draft.RichUtils.toggleInlineStyle(editorState, "HIGHLIGHT"));
                return "handled";
            }
            if (command === "unordered-list" || command === "ordered-list") {
                var currentBlock = _this.getCurrentBlock(editorState);
                var currentText = currentBlock.getText();
                if (currentBlock.getType() === "unstyled" && currentBlock.getDepth() === 0 && (currentText.startsWith("-") || currentText.startsWith("1."))) {
                    editorState = Draft.RichUtils.toggleBlockType(editorState, "".concat(command, "-item"));
                    var blockSelection = new Draft.SelectionState({
                        anchorKey: currentBlock.getKey(),
                        anchorOffset: 0,
                        focusKey: currentBlock.getKey(),
                        focusOffset: currentBlock.getLength()
                    });
                    var content = Draft.Modifier.replaceText(editorState.getCurrentContent(), blockSelection, "");
                    editorState = Draft.EditorState.push(editorState, content);
                    editorState = Draft.EditorState.forceSelection(editorState, content.getSelectionAfter());
                    onChange(editorState);
                    return "handled";
                } else {
                    var content1 = Draft.Modifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), " ");
                    editorState = Draft.EditorState.forceSelection(Draft.EditorState.push(editorState, content1), content1.getSelectionAfter());
                    onChange(editorState);
                    return "handled";
                }
            }
            var nextState = Draft.RichUtils.handleKeyCommand(editorState, command);
            if (nextState) {
                onChange(nextState);
                return "handled";
            }
            return "not-handled";
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleReturn", function(event) {
            var _props = _this.props, editorState = _props.editorState, onChange = _props.onChange;
            var currentBlock = _this.getCurrentBlock(editorState);
            if (currentBlock.getType().endsWith("list-item") && currentBlock.getText() === "") {
                var nextState = Draft.RichUtils.toggleBlockType(editorState, currentBlock.getType());
                onChange(Draft.EditorState.forceSelection(nextState, nextState.getCurrentContent().getSelectionAfter()));
                return true;
            }
            var handleReturn = getRegisteredEvents("handleReturn");
            if (handleReturn && handleReturn(event)) {
                return true;
            }
            if (event.shiftKey) {
                var currentContent = editorState.getCurrentContent();
                var currentSelection = editorState.getSelection();
                var contentBlock = currentContent.getBlockMap().get(currentSelection.getFocusKey());
                // we'd like to allow multi-line blockquotes
                if (contentBlock.getType() === "blockquote") {
                    onChange(Draft.RichUtils.insertSoftNewline(editorState));
                    return true;
                }
                if (contentBlock.getText().charAt(currentSelection.focusOffset - 1) === "\n" || contentBlock.getText().charAt(currentSelection.focusOffset) === "\n") {
                    return false;
                }
                onChange(Draft.RichUtils.insertSoftNewline(editorState));
                return true;
            }
            if (currentBlock.getType().endsWith("list-item")) {
                return false;
            }
            var selection = editorState.getSelection();
            var contentState = editorState.getCurrentContent();
            var endOffset = selection.getEndOffset();
            if (endOffset === currentBlock.getLength()) {
                var nextState1 = resetBlockStyle(editorState, selection, contentState, currentBlock, "unstyled");
                onChange(nextState1);
                return true;
            }
            return false;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleFocusEditor", function() {
            if (_this.editorRef) {
                _this.editorRef.focus();
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleSetReadOnly", function(readOnly) {
            return _this.setState({
                readOnly: readOnly
            });
        });
        _this.editorKey = props.editorKey || (0,Draft.genKey)();
        _this.state = {
            readOnly: props.readOnly
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(GovlaunchEditor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var autoFocus = this.props.autoFocus;
                if (autoFocus) {
                    this.editorRef.focus();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, initialReadOnly = _props.readOnly, editorState = _props.editorState, placeholder = _props.placeholder, onChange = _props.onChange, onBlur = _props.onBlur, onFocus = _props.onFocus, minContentHeight = _props.minContentHeight, containerStyleOverrides = _props.containerStyle, actualBlockRendererFn = _props.blockRendererFn, children = _props.children;
                var readOnly = this.state.readOnly;
                var ContentHeightStyle = /*#__PURE__*/ css({
                    "& .public-DraftEditor-content": {
                        minHeight: minContentHeight
                    }
                });
                var modifiedState = Draft.EditorState.set(editorState, {
                    decorator: getDecoratorsForState(readOnly)
                });
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorAreaFocusState, {
                    onFocus: onFocus,
                    onBlur: onBlur,
                    children: function(param) {
                        var focus = param.focus, bindFocus = param.bindFocus;
                        var _obj;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("Editor/rootContainer"), bindFocus), {
                            ref: _this.setWrapperRef,
                            className: classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, PlaceholderStyle, true), (0,_define_property/* default */.Z)(_obj, FigureResetStyle, true), (0,_define_property/* default */.Z)(_obj, ContentHeightStyle, minContentHeight > 0), _obj)),
                            css: (0,src_object_spread/* default */.Z)({}, containerStyle, containerStyleOverrides),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Draft.Editor, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("Editor/root")), {
                                    ref: _this.setEditorRef,
                                    editorKey: _this.editorKey,
                                    readOnly: readOnly,
                                    // NOTE: we're toggling `placeholder` prop based on what `shouldDisplayPlaceholder`
                                    // tells us. Not sure if it's the best approach - but it works nicely for not
                                    // displaying the placeholder under certain conditions
                                    placeholder: shouldDisplayPlaceholder(editorState) ? placeholder : null,
                                    editorState: modifiedState,
                                    handleReturn: _this.handleReturn,
                                    handleKeyCommand: _this.handleKeyCommand,
                                    keyBindingFn: _this.handleKeyBinding,
                                    onChange: onChange,
                                    // NOTE: those handlers are actually "deprecated". We need to use `keyBindingFn` instead.
                                    // But, for some reason, it doesn't bubble up Up/Left/Down/Right/Esc so we don't actually
                                    // get the callbacks working. Let's keep those "deprecated" handlers and get rid of 'em
                                    // later in a future release of Draft.js
                                    onTab: callRegisteredEvents("onTab"),
                                    onUpArrow: callRegisteredEvents("onUpArrow"),
                                    onLeftArrow: callRegisteredEvents("onLeftArrow"),
                                    onDownArrow: callRegisteredEvents("onDownArrow"),
                                    onRightArrow: callRegisteredEvents("onRightArrow"),
                                    onEscape: callRegisteredEvents("onEscape"),
                                    stripPastedStyles: true,
                                    customStyleMap: {
                                        BOLD: {
                                            fontWeight: 600
                                        },
                                        HIGHLIGHT: {
                                            backgroundColor: mediumBlue
                                        }
                                    },
                                    blockRendererFn: blockRendererFn(actualBlockRendererFn, {
                                        readOnly: initialReadOnly,
                                        setReadOnly: _this.handleSetReadOnly,
                                        editorState: editorState,
                                        onChange: onChange
                                    }),
                                    blockStyleFn: function(block) {
                                        var _obj;
                                        return classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, ParagraphStyle, true), (0,_define_property/* default */.Z)(_obj, H3H4ParagraphStyle, true), (0,_define_property/* default */.Z)(_obj, ResetHeadingStyle, [
                                            "header-three",
                                            "header-four"
                                        ].includes(block.getType())), (0,_define_property/* default */.Z)(_obj, H3Style, block.getType() === "header-three"), (0,_define_property/* default */.Z)(_obj, H4Style, block.getType() === "header-four"), (0,_define_property/* default */.Z)(_obj, BlockquoteStyle, block.getType() === "blockquote"), _obj));
                                    }
                                })),
                                children({
                                    focus: focus,
                                    editorKey: _this.editorKey,
                                    editorState: editorState,
                                    focusEditor: _this.handleFocusEditor,
                                    onChange: onChange,
                                    readOnly: _this.state.readOnly
                                })
                            ]
                        }));
                    }
                });
            }
        }
    ]);
    return GovlaunchEditor;
}(react.Component);
(0,_define_property/* default */.Z)(GovlaunchEditor, "propTypes", {
    editorKey: (prop_types_default()).string,
    readOnly: (prop_types_default()).bool,
    editorState: (prop_types_default()).object.isRequired,
    containerStyle: (prop_types_default()).object,
    minContentHeight: (prop_types_default()).number,
    autoFocus: (prop_types_default()).bool,
    placeholder: (prop_types_default()).string,
    onChange: (prop_types_default()).func.isRequired,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    blockRendererFn: (prop_types_default()).func,
    children: (prop_types_default()).func
});
(0,_define_property/* default */.Z)(GovlaunchEditor, "defaultProps", {
    editorKey: null,
    containerStyle: {},
    placeholder: null,
    blockRendererFn: Editor_noop,
    minContentHeight: null,
    readOnly: false,
    autoFocus: false,
    children: Editor_noop,
    onFocus: Editor_noop,
    onBlur: Editor_noop
});

var containerStyle = {
    boxSizing: "border-box",
    position: "relative",
    cursor: "text"
};
/**
 * @param   {?Function} actualBlockRendererFn
 * @param   {Object}    blockProps
 * @returns {Function}
 */ function blockRendererFn(actualBlockRendererFn, blockProps) {
    return function(block) {
        if (actualBlockRendererFn && typeof actualBlockRendererFn === "function") {
            var actualRenderedBlock = actualBlockRendererFn(block, blockProps);
            if (actualRenderedBlock) {
                return actualRenderedBlock;
            }
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.IMAGE) {
            return {
                component: Image,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.YOUTUBE_VIDEO) {
            return {
                component: YouTubeVideo,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.GOOGLE_SPREADSHEET) {
            return {
                component: GoogleSpreadsheet,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.AIRTABLE) {
            return {
                component: Airtable,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.GOOGLE_FORMS) {
            return {
                component: GoogleForms,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.TYPEFORM) {
            return {
                component: Typeform,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.SIMPLECAST) {
            return {
                component: Simplecast,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.SOCIAL_MEDIAS) {
            return {
                component: SocialMedias_SocialMedias,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.NEWSLETTER) {
            return {
                component: Newsletter,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.DIVIDER) {
            return {
                component: Divider,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.CUSTOM_BUTTON) {
            return {
                component: CustomButton,
                editable: false,
                props: blockProps
            };
        }
        if (block.getType() === "atomic" && block.getData().get("blockType") === src_AtomicBlockIdentifiers.GOVLAUNCH_PROJECT) {
            return {
                component: GovlaunchProject,
                editable: false,
                props: blockProps
            };
        }
        return null;
    };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/EditorStateUtils.js





/**
 * @type {Function}
 */ var EditorStateUtils_noop = function() {};
var EditorStateUtils = {
    /**
   * @param   {EditorState} editorState
   * @returns {[]EditorMention}
   */ getMentions: function getMentions(editorState) {
        var contentState = editorState.getCurrentContent();
        var mentions = [];
        contentState.getBlocksAsArray().forEach(function(block) {
            block.findEntityRanges(function(character) {
                if (character.getEntity() !== null) {
                    var entity = contentState.getEntity(character.getEntity());
                    var entityType = entity.getType();
                    if (entityType === src_EntityTypeIdentifiers.MENTION) {
                        mentions.push(entity.getData());
                    }
                }
            }, EditorStateUtils_noop);
        });
        return mentions;
    },
    /**
   * @param   {EditorState} editorState
   * @returns {[]String}
   */ getLinkUrls: function getLinkUrls(editorState) {
        var links = [];
        var contentState = editorState.getCurrentContent();
        contentState.getBlocksAsArray().forEach(function(block) {
            block.findEntityRanges(function(character) {
                if (character.getEntity() !== null) {
                    var entity = contentState.getEntity(character.getEntity());
                    var entityType = entity.getType();
                    if (entityType === src_EntityTypeIdentifiers.LINK) {
                        links.push(entity.getData().url);
                    }
                }
            }, EditorStateUtils_noop);
        });
        return links;
    },
    /**
   * @param   {EditorState} editorState
   * @returns {[]String}
   */ getTextContentsBlocks: function getTextContentsBlocks(editorState) {
        return editorState.getCurrentContent().getBlocksAsArray().map(function(block) {
            return block.getText();
        }).filter(Boolean);
    },
    /**
   * @param   {EditorState} editorState
   * @returns {[]String}
   */ getImageUrls: function getImageUrls(editorState) {
        var blocks = editorState.getCurrentContent().getBlocksAsArray();
        return blocks.filter(function(block) {
            if (block.getType() === "atomic") {
                var blockType = block.getData().get("blockType");
                return blockType === src_AtomicBlockIdentifiers.IMAGE;
            } else {
                return false;
            }
        }).map(function(block) {
            return block.getData().get("imageUrl");
        });
    },
    /**
   * @param   {EditorState} editorState
   * @returns {[]String}
   */ getYouTubeUrls: function getYoutubeUrls(editorState) {
        var blocks = editorState.getCurrentContent().getBlocksAsArray();
        return blocks.filter(function(block) {
            if (block.getType() === "atomic") {
                var blockType = block.getData().get("blockType");
                return blockType === src_AtomicBlockIdentifiers.YOUTUBE_VIDEO;
            } else {
                return false;
            }
        }).map(function(block) {
            return block.getData().get("videoUrl");
        });
    },
    /**
   * @param   {EditorState} editorState
   * @returns {Boolean}
   */ isEditorStateEmpty: isEditorStateEmpty,
    /**
   * @param   {EditorMention} mention
   * @returns {EditorState}
   */ createWithMention: function createWithMention(mention) {
        var contentState = Draft.ContentState.createFromText(mention.getDisplayText());
        var editorState = Draft.EditorState.createWithContent(contentState);
        return insertMentionEntity(editorState, editorState.getSelection().merge({
            anchorOffset: 0,
            anchorKey: contentState.getFirstBlock().getKey(),
            focusOffset: mention.getDisplayText().length,
            focusKey: contentState.getLastBlock().getKey()
        }), mention.getDisplayText(), mention, mention.getMutability());
    }
};
/* harmony default export */ var src_EditorStateUtils = ((/* unused pure expression or super */ null && (EditorStateUtils)));

// EXTERNAL MODULE: ./node_modules/.pnpm/invariant@2.2.4/node_modules/invariant/browser.js
var browser = __webpack_require__(53670);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(30999);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(69259);
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/updateMutation.js
function updateMutation(mutation, originalOffset, originalLength, newLength, prefixLength, suffixLength) {
  // three cases we can reasonably adjust - disjoint mutations that
  // happen later on where the offset will need to be changed,
  // mutations that completely contain the new one where we can adjust
  // the length, and mutations that occur partially within the new one.
  var lengthDiff = newLength - originalLength;
  var mutationAfterChange = originalOffset + originalLength <= mutation.offset;

  if (mutationAfterChange) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + lengthDiff
    });
  }

  var mutationContainsChange = originalOffset >= mutation.offset && originalOffset + originalLength <= mutation.offset + mutation.length;

  if (mutationContainsChange) {
    return Object.assign({}, mutation, {
      length: mutation.length + lengthDiff
    });
  }

  var mutationWithinPrefixChange = mutation.offset >= originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && prefixLength > 0;

  if (mutationWithinPrefixChange) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength
    });
  }

  var mutationContainsPrefix = mutation.offset < originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && mutation.offset + mutation.length > originalOffset && prefixLength > 0;

  if (mutationContainsPrefix) {
    return [Object.assign({}, mutation, {
      length: originalOffset - mutation.offset
    }), Object.assign({}, mutation, {
      offset: originalOffset + prefixLength,
      length: mutation.offset - originalOffset + mutation.length
    })];
  }

  var mutationContainsSuffix = mutation.offset >= originalOffset && mutation.offset + mutation.length > originalOffset + originalLength && originalOffset + originalLength > mutation.offset && suffixLength > 0;

  if (mutationContainsSuffix) {
    return [Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength,
      length: originalOffset + originalLength - mutation.offset
    }), Object.assign({}, mutation, {
      offset: originalOffset + originalLength + prefixLength + suffixLength,
      length: mutation.offset + mutation.length - (originalOffset + originalLength)
    })];
  }

  return mutation;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/rangeSort.js
/* harmony default export */ var rangeSort = (function (r1, r2) {
  if (r1.offset === r2.offset) {
    return r2.length - r1.length;
  }

  return r1.offset - r2.offset;
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/encodeBlock.js



var ENTITY_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '\n': '<br/>'
};
/* harmony default export */ var encodeBlock = (function (block) {
  var blockText = (0,toConsumableArray/* default */.Z)(block.text);

  var entities = block.entityRanges.sort(rangeSort);
  var styles = block.inlineStyleRanges.sort(rangeSort);
  var resultText = '';

  var _loop = function _loop(index) {
    var _char = blockText[index];

    if (ENTITY_MAP[_char] !== undefined) {
      var encoded = ENTITY_MAP[_char];

      var resultIndex = (0,toConsumableArray/* default */.Z)(resultText).length;

      resultText += encoded;

      var updateForChar = function updateForChar(mutation) {
        return updateMutation(mutation, resultIndex, _char.length, encoded.length, 0, 0);
      };

      entities = entities.map(updateForChar);
      styles = styles.map(updateForChar);
    } else {
      resultText += _char;
    }
  };

  for (var index = 0; index < blockText.length; index++) {
    _loop(index);
  }

  return Object.assign({}, block, {
    text: resultText,
    inlineStyleRanges: styles,
    entityRanges: entities
  });
});
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(31307);
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/splitReactElement.js


 // see http://w3c.github.io/html/syntax.html#writing-html-documents-elements

var VOID_TAGS = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
function splitReactElement(element) {
  if (VOID_TAGS.indexOf(element.type) !== -1) {
    return server_browser.renderToStaticMarkup(element);
  }

  var tags = server_browser.renderToStaticMarkup(react.cloneElement(element, {}, '\r')).split('\r');
  browser_default()(tags.length > 1, "convertToHTML: Element of type ".concat(element.type, " must render children"));
  browser_default()(tags.length < 3, "convertToHTML: Element of type ".concat(element.type, " cannot use carriage return character"));
  return {
    start: tags[0],
    end: tags[1]
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/getElementHTML.js






function hasChildren(element) {
  return react.isValidElement(element) && react.Children.count(element.props.children) > 0;
}

function getElementHTML(element) {
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (element === undefined || element === null) {
    return element;
  }

  if (typeof element === 'string') {
    return element;
  }

  if (react.isValidElement(element)) {
    if (hasChildren(element)) {
      return server_browser.renderToStaticMarkup(element);
    }

    var tags = splitReactElement(element);

    if (text !== null && (0,esm_typeof/* default */.Z)(tags) === 'object') {
      var start = tags.start,
          end = tags.end;
      return start + text + end;
    }

    return tags;
  }

  browser_default()(Object.prototype.hasOwnProperty.call(element, 'start') && Object.prototype.hasOwnProperty.call(element, 'end'), 'convertToHTML: received conversion data without either an HTML string, ReactElement or an object with start/end tags');

  if (text !== null) {
    var _start = element.start,
        _end = element.end;
    return _start + text + _end;
  }

  return element;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/getElementTagLength.js




var getElementTagLength = function getElementTagLength(element) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';

  if (react.isValidElement(element)) {
    var splitElement = splitReactElement(element);

    if (typeof splitElement === 'string') {
      return 0;
    }

    var length = splitElement[type].length;
    var child = react.Children.toArray(element.props.children)[0];
    return length + (child && react.isValidElement(child) ? getElementTagLength(child, type) : 0);
  }

  if ((0,esm_typeof/* default */.Z)(element) === 'object') {
    return element[type] ? element[type].length : 0;
  }

  return 0;
};

/* harmony default export */ var util_getElementTagLength = (getElementTagLength);
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/blockEntities.js






var converter = function converter() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var originalText = arguments.length > 1 ? arguments[1] : undefined;
  return originalText;
};

/* harmony default export */ var blockEntities = (function (block, entityMap) {
  var entityConverter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : converter;

  var resultText = (0,toConsumableArray/* default */.Z)(block.text);

  var getEntityHTML = entityConverter;

  if (entityConverter.__isMiddleware) {
    getEntityHTML = entityConverter(converter);
  }

  if (Object.prototype.hasOwnProperty.call(block, 'entityRanges') && block.entityRanges.length > 0) {
    var entities = block.entityRanges.sort(rangeSort);
    var styles = block.inlineStyleRanges;

    var _loop = function _loop(index) {
      var entityRange = entities[index];
      var entity = entityMap[entityRange.key];
      var originalText = resultText.slice(entityRange.offset, entityRange.offset + entityRange.length).join('');
      var entityHTML = getEntityHTML(entity, originalText);
      var elementHTML = getElementHTML(entityHTML, originalText);
      var converted = void 0;

      if (!!elementHTML || elementHTML === '') {
        converted = (0,toConsumableArray/* default */.Z)(elementHTML);
      } else {
        converted = originalText;
      }

      var prefixLength = util_getElementTagLength(entityHTML, 'start');
      var suffixLength = util_getElementTagLength(entityHTML, 'end');

      var updateLaterMutation = function updateLaterMutation(mutation, mutationIndex) {
        if (mutationIndex > index || Object.prototype.hasOwnProperty.call(mutation, 'style')) {
          return updateMutation(mutation, entityRange.offset, entityRange.length, converted.length, prefixLength, suffixLength);
        }

        return mutation;
      };

      var updateLaterMutations = function updateLaterMutations(mutationList) {
        return mutationList.reduce(function (acc, mutation, mutationIndex) {
          var updatedMutation = updateLaterMutation(mutation, mutationIndex);

          if (Array.isArray(updatedMutation)) {
            return acc.concat(updatedMutation);
          }

          return acc.concat([updatedMutation]);
        }, []);
      };

      entities = updateLaterMutations(entities);
      styles = updateLaterMutations(styles);
      resultText = [].concat((0,toConsumableArray/* default */.Z)(resultText.slice(0, entityRange.offset)), (0,toConsumableArray/* default */.Z)(converted), (0,toConsumableArray/* default */.Z)(resultText.slice(entityRange.offset + entityRange.length)));
    };

    for (var index = 0; index < entities.length; index++) {
      _loop(index);
    }

    return Object.assign({}, block, {
      text: resultText.join(''),
      inlineStyleRanges: styles,
      entityRanges: entities
    });
  }

  return block;
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/styleObjectFunction.js
/* harmony default export */ var styleObjectFunction = (function (object) {
  return function (style) {
    if (typeof object === 'function') {
      return object(style);
    }

    return object[style];
  };
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/accumulateFunction.js
/* harmony default export */ var accumulateFunction = (function (newFn, rest) {
  return function () {
    var newResult = newFn.apply(void 0, arguments);

    if (newResult !== undefined && newResult !== null) {
      return newResult;
    }

    return rest.apply(void 0, arguments);
  };
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/default/defaultInlineHTML.js

function defaultInlineHTML(style) {
  switch (style) {
    case 'BOLD':
      return react.createElement("strong", null);

    case 'ITALIC':
      return react.createElement("em", null);

    case 'UNDERLINE':
      return react.createElement("u", null);

    case 'CODE':
      return react.createElement("code", null);

    default:
      return {
        start: '',
        end: ''
      };
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/blockInlineStyles.js








var subtractStyles = function subtractStyles(original, toRemove) {
  return original.filter(function (el) {
    return !toRemove.some(function (elToRemove) {
      return elToRemove.style === el.style;
    });
  });
};

var popEndingStyles = function popEndingStyles(styleStack, endingStyles) {
  return endingStyles.reduceRight(function (stack, style) {
    var styleToRemove = stack[stack.length - 1];
    browser_default()(styleToRemove.style === style.style, "Style ".concat(styleToRemove.style, " to be removed doesn't match expected ").concat(style.style));
    return stack.slice(0, -1);
  }, styleStack);
};

var characterStyles = function characterStyles(offset, ranges) {
  return ranges.filter(function (range) {
    return offset >= range.offset && offset < range.offset + range.length;
  });
};

var rangeIsSubset = function rangeIsSubset(firstRange, secondRange) {
  // returns true if the second range is a subset of the first
  var secondStartWithinFirst = firstRange.offset <= secondRange.offset;
  var secondEndWithinFirst = firstRange.offset + firstRange.length >= secondRange.offset + secondRange.length;
  return secondStartWithinFirst && secondEndWithinFirst;
};

var latestStyleLast = function latestStyleLast(s1, s2) {
  // make sure longer-lasting styles are added first
  var s2endIndex = s2.offset + s2.length;
  var s1endIndex = s1.offset + s1.length;
  return s2endIndex - s1endIndex;
};

var getStylesToReset = function getStylesToReset(remainingStyles, newStyles) {
  var i = 0;

  while (i < remainingStyles.length) {
    if (newStyles.every(rangeIsSubset.bind(null, remainingStyles[i]))) {
      i++;
    } else {
      return remainingStyles.slice(i);
    }
  }

  return [];
};

var appendStartMarkup = function appendStartMarkup(inlineHTML, string, styleRange) {
  return string + getElementHTML(inlineHTML(styleRange.style)).start;
};

var prependEndMarkup = function prependEndMarkup(inlineHTML, string, styleRange) {
  return getElementHTML(inlineHTML(styleRange.style)).end + string;
};

var defaultCustomInlineHTML = function defaultCustomInlineHTML(next) {
  return function (style) {
    return next(style);
  };
};

defaultCustomInlineHTML.__isMiddleware = true;
/* harmony default export */ var blockInlineStyles = (function (rawBlock) {
  var customInlineHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCustomInlineHTML;
  browser_default()(rawBlock !== null && rawBlock !== undefined, 'Expected raw block to be non-null');
  var inlineHTML;

  if (customInlineHTML.__isMiddleware === true) {
    inlineHTML = customInlineHTML(defaultInlineHTML);
  } else {
    inlineHTML = accumulateFunction(styleObjectFunction(customInlineHTML), styleObjectFunction(defaultInlineHTML));
  }

  var result = '';
  var styleStack = [];
  var sortedRanges = rawBlock.inlineStyleRanges.sort(rangeSort);

  var originalTextArray = (0,toConsumableArray/* default */.Z)(rawBlock.text);

  for (var i = 0; i < originalTextArray.length; i++) {
    var styles = characterStyles(i, sortedRanges);
    var endingStyles = subtractStyles(styleStack, styles);
    var newStyles = subtractStyles(styles, styleStack);
    var remainingStyles = subtractStyles(styleStack, endingStyles); // reset styles: look for any already existing styles that will need to
    // end before styles that are being added on this character. to solve this
    // close out those current tags and all nested children,
    // then open new ones nested within the new styles.

    var resetStyles = getStylesToReset(remainingStyles, newStyles);
    var openingStyles = resetStyles.concat(newStyles).sort(latestStyleLast);
    var openingStyleTags = openingStyles.reduce(appendStartMarkup.bind(null, inlineHTML), '');
    var endingStyleTags = endingStyles.concat(resetStyles).reduce(prependEndMarkup.bind(null, inlineHTML), '');
    result += endingStyleTags + openingStyleTags + originalTextArray[i];
    styleStack = popEndingStyles(styleStack, resetStyles.concat(endingStyles));
    styleStack = styleStack.concat(openingStyles);
    browser_default()(styleStack.length === styles.length, "Character ".concat(i, ": ").concat(styleStack.length - styles.length, " styles left on stack that should no longer be there"));
  }

  result = styleStack.reduceRight(function (res, openStyle) {
    return res + getElementHTML(inlineHTML(openStyle.style)).end;
  }, result);
  return result;
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/blockTypeObjectFunction.js
/* harmony default export */ var blockTypeObjectFunction = (function (typeObject) {
  return function (block) {
    if (typeof typeObject === 'function') {
      // handle case where typeObject is already a function
      return typeObject(block);
    }

    return typeObject[block.type];
  };
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/getBlockTags.js





function getBlockTags_hasChildren(element) {
  return react.isValidElement(element) && react.Children.count(element.props.children) > 0;
}

function getBlockTags(blockHTML) {
  browser_default()(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (typeof blockHTML === 'string') {
    return blockHTML;
  }

  if (react.isValidElement(blockHTML)) {
    if (getBlockTags_hasChildren(blockHTML)) {
      return server_browser.renderToStaticMarkup(blockHTML);
    }

    return splitReactElement(blockHTML);
  }

  if (Object.prototype.hasOwnProperty.call(blockHTML, 'element') && react.isValidElement(blockHTML.element)) {
    return Object.assign({}, blockHTML, splitReactElement(blockHTML.element));
  }

  browser_default()(Object.prototype.hasOwnProperty.call(blockHTML, 'start') && Object.prototype.hasOwnProperty.call(blockHTML, 'end'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');
  return blockHTML;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/getNestedBlockTags.js



function getNestedBlockTags(blockHTML, depth) {
  browser_default()(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (typeof blockHTML.nest === 'function') {
    var _splitReactElement = splitReactElement(blockHTML.nest(depth)),
        start = _splitReactElement.start,
        end = _splitReactElement.end;

    return Object.assign({}, blockHTML, {
      nestStart: start,
      nestEnd: end
    });
  }

  if (react.isValidElement(blockHTML.nest)) {
    var _splitReactElement2 = splitReactElement(blockHTML.nest),
        _start = _splitReactElement2.start,
        _end = _splitReactElement2.end;

    return Object.assign({}, blockHTML, {
      nestStart: _start,
      nestEnd: _end
    });
  }

  browser_default()(Object.prototype.hasOwnProperty.call(blockHTML, 'nestStart') && Object.prototype.hasOwnProperty.call(blockHTML, 'nestEnd'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');
  return blockHTML;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/default/defaultBlockHTML.js
 // based on Draft.js' custom list depth styling

var ORDERED_LIST_TYPES = ['1', 'a', 'i'];
/* harmony default export */ var defaultBlockHTML = ({
  unstyled: react.createElement("p", null),
  paragraph: react.createElement("p", null),
  'header-one': react.createElement("h1", null),
  'header-two': react.createElement("h2", null),
  'header-three': react.createElement("h3", null),
  'header-four': react.createElement("h4", null),
  'header-five': react.createElement("h5", null),
  'header-six': react.createElement("h6", null),
  'code-block': react.createElement("pre", null),
  blockquote: react.createElement("blockquote", null),
  'unordered-list-item': {
    element: react.createElement("li", null),
    nest: react.createElement("ul", null)
  },
  'ordered-list-item': {
    element: react.createElement("li", null),
    nest: function nest(depth) {
      var type = ORDERED_LIST_TYPES[depth % 3];
      return react.createElement("ol", {
        type: type
      });
    }
  },
  media: react.createElement("figure", null),
  atomic: react.createElement("figure", null)
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/convertToHTML.js
// import Immutable from 'immutable'; // eslint-disable-line no-unused-vars













var defaultEntityToHTML = function defaultEntityToHTML(entity, originalText) {
  return originalText;
};

var convertToHTML = function convertToHTML(_ref) {
  var _ref$styleToHTML = _ref.styleToHTML,
      styleToHTML = _ref$styleToHTML === void 0 ? {} : _ref$styleToHTML,
      _ref$blockToHTML = _ref.blockToHTML,
      blockToHTML = _ref$blockToHTML === void 0 ? {} : _ref$blockToHTML,
      _ref$entityToHTML = _ref.entityToHTML,
      entityToHTML = _ref$entityToHTML === void 0 ? defaultEntityToHTML : _ref$entityToHTML;
  return function (contentState) {
    browser_default()(contentState !== null && contentState !== undefined, 'Expected contentState to be non-null');
    var getBlockHTML;

    if (blockToHTML.__isMiddleware === true) {
      getBlockHTML = blockToHTML(blockTypeObjectFunction(defaultBlockHTML));
    } else {
      getBlockHTML = accumulateFunction(blockTypeObjectFunction(blockToHTML), blockTypeObjectFunction(defaultBlockHTML));
    }

    var rawState = (0,Draft.convertToRaw)(contentState);
    var listStack = [];
    var result = rawState.blocks.map(function (block) {
      var type = block.type,
          depth = block.depth;
      var closeNestTags = '';
      var openNestTags = '';
      var blockHTMLResult = getBlockHTML(block);

      if (!blockHTMLResult) {
        throw new Error("convertToHTML: missing HTML definition for block with type ".concat(block.type));
      }

      if (!blockHTMLResult.nest) {
        // this block can't be nested, so reset all nesting if necessary
        closeNestTags = listStack.reduceRight(function (string, nestedBlock) {
          return string + getNestedBlockTags(getBlockHTML(nestedBlock), depth).nestEnd;
        }, '');
        listStack = [];
      } else {
        while (depth + 1 !== listStack.length || type !== listStack[depth].type) {
          if (depth + 1 === listStack.length) {
            // depth is right but doesn't match type
            var blockToClose = listStack[depth];
            closeNestTags += getNestedBlockTags(getBlockHTML(blockToClose), depth).nestEnd;
            openNestTags += getNestedBlockTags(getBlockHTML(block), depth).nestStart;
            listStack[depth] = block;
          } else if (depth + 1 < listStack.length) {
            var _blockToClose = listStack[listStack.length - 1];
            closeNestTags += getNestedBlockTags(getBlockHTML(_blockToClose), depth).nestEnd;
            listStack = listStack.slice(0, -1);
          } else {
            openNestTags += getNestedBlockTags(getBlockHTML(block), depth).nestStart;
            listStack.push(block);
          }
        }
      }

      var innerHTML = blockInlineStyles(blockEntities(encodeBlock(block), rawState.entityMap, entityToHTML), styleToHTML);
      var blockHTML = getBlockTags(getBlockHTML(block));
      var html;

      if (typeof blockHTML === 'string') {
        html = blockHTML;
      } else {
        html = blockHTML.start + innerHTML + blockHTML.end;
      }

      if (innerHTML.length === 0 && Object.prototype.hasOwnProperty.call(blockHTML, 'empty')) {
        if (react.isValidElement(blockHTML.empty)) {
          html = server_browser.renderToStaticMarkup(blockHTML.empty);
        } else {
          html = blockHTML.empty;
        }
      }

      return closeNestTags + openNestTags + html;
    }).join('');
    result = listStack.reduce(function (res, nestBlock) {
      return res + getNestedBlockTags(getBlockHTML(nestBlock), nestBlock.depth).nestEnd;
    }, result);
    return result;
  };
};

/* harmony default export */ var esm_convertToHTML = (function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1 && Object.prototype.hasOwnProperty.call(args[0], '_map') && args[0].getBlockMap != null) {
    // skip higher-order function and use defaults
    return convertToHTML({}).apply(void 0, args);
  }

  return convertToHTML.apply(void 0, args);
});
// EXTERNAL MODULE: ./node_modules/.pnpm/immutable@3.7.6/node_modules/immutable/dist/immutable.js
var immutable = __webpack_require__(52724);
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/util/parseHTML.js
var fallback = function fallback(html) {
  var doc = document.implementation.createHTMLDocument('');
  doc.documentElement.innerHTML = html;
  return doc;
};

function parseHTML(html) {
  var doc;

  if (typeof DOMParser !== 'undefined') {
    var parser = new DOMParser();
    doc = parser.parseFromString(html, 'text/html');

    if (doc === null || doc.body === null) {
      doc = fallback(html);
    }
  } else {
    doc = fallback(html);
  }

  return doc.body;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/convertFromHTML.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the /src directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */




var NBSP = '&nbsp;';
var SPACE = ' '; // Arbitrary max indent

var MAX_DEPTH = 4; // used for replacing characters in HTML

/* eslint-disable no-control-regex */

var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
/* eslint-enable no-control-regex */
// Block tag flow is different because LIs do not have
// a deterministic style ;_;

var blockTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'blockquote', 'pre'];
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var handleMiddleware = function handleMiddleware(maybeMiddleware, base) {
  if (maybeMiddleware && maybeMiddleware.__isMiddleware === true) {
    return maybeMiddleware(base);
  }

  return maybeMiddleware;
};

var defaultHTMLToBlock = function defaultHTMLToBlock(nodeName, node, lastList) {
  return undefined;
};

var defaultHTMLToStyle = function defaultHTMLToStyle(nodeName, node, currentStyle) {
  return currentStyle;
};

var defaultHTMLToEntity = function defaultHTMLToEntity(nodeName, node) {
  return undefined;
};

var defaultTextToEntity = function defaultTextToEntity(text) {
  return [];
};

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }

  throw new Error('Got unexpected null or undefined');
};

var sanitizeDraftText = function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
};

function getEmptyChunk() {
  return {
    text: '',
    inlines: [],
    entities: [],
    blocks: []
  };
}

function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);

  if (inEntity) {
    entities[0] = inEntity;
  }

  return {
    text: SPACE,
    inlines: [(0,immutable.OrderedSet)()],
    entities: entities,
    blocks: []
  };
}

function getSoftNewlineChunk(block, depth) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0,immutable.Map)();

  if (flat === true) {
    return {
      text: '\r',
      inlines: [(0,immutable.OrderedSet)()],
      entities: new Array(1),
      blocks: [{
        type: block,
        data: data,
        depth: Math.max(0, Math.min(MAX_DEPTH, depth))
      }],
      isNewline: true
    };
  }

  return {
    text: '\n',
    inlines: [(0,immutable.OrderedSet)()],
    entities: new Array(1),
    blocks: []
  };
}

function getBlockDividerChunk(block, depth) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0,immutable.Map)();
  return {
    text: '\r',
    inlines: [(0,immutable.OrderedSet)()],
    entities: new Array(1),
    blocks: [{
      type: block,
      data: data,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    }]
  };
}

function getBlockTypeForTag(tag, lastList) {
  switch (tag) {
    case 'h1':
      return 'header-one';

    case 'h2':
      return 'header-two';

    case 'h3':
      return 'header-three';

    case 'h4':
      return 'header-four';

    case 'h5':
      return 'header-five';

    case 'h6':
      return 'header-six';

    case 'li':
      if (lastList === 'ol') {
        return 'ordered-list-item';
      }

      return 'unordered-list-item';

    case 'blockquote':
      return 'blockquote';

    case 'pre':
      return 'code-block';

    case 'div':
    case 'p':
      return 'unstyled';

    default:
      return null;
  }
}

function baseCheckBlockType(nodeName, node, lastList) {
  return getBlockTypeForTag(nodeName, lastList);
}

function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];

  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      if (htmlElement.style.fontWeight === 'bold') {
        style.add('BOLD');
      }

      if (htmlElement.style.fontStyle === 'italic') {
        style.add('ITALIC');
      }

      if (htmlElement.style.textDecoration === 'underline') {
        style.add('UNDERLINE');
      }

      if (htmlElement.style.textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }

  return currentStyle;
}

function baseProcessInlineTag(tag, node) {
  var inlineStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0,immutable.OrderedSet)();
  return processInlineTag(tag, node, inlineStyles);
}

function joinChunks(A, B) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var firstInB = B.text.slice(0, 1);
  var lastInA = A.text.slice(-1);
  var adjacentDividers = lastInA === '\r' && firstInB === '\r';
  var isJoiningBlocks = A.text !== '\r' && B.text !== '\r'; // when joining two full blocks like this we want to pop one divider

  var addingNewlineToEmptyBlock = A.text === '\r' && !A.isNewline && B.isNewline; // when joining a newline to an empty block we want to remove the newline

  if (adjacentDividers && (isJoiningBlocks || addingNewlineToEmptyBlock)) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  } // Kill whitespace after blocks if flat mode is on


  if (A.text.slice(-1) === '\r' && flat === true) {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  var isNewline = A.text.length === 0 && B.isNewline;
  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks),
    isNewline: isNewline
  };
}
/*
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */


function containsSemanticBlockMarkup(html) {
  return blockTags.some(function (tag) {
    return html.indexOf("<".concat(tag)) !== -1;
  });
}

function genFragment(node, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, inEntity) {
  var nodeName = node.nodeName.toLowerCase();
  var newBlock = false;
  var nextBlockType = 'unstyled'; // Base Case

  if (nodeName === '#text') {
    var text = node.textContent;

    if (text.trim() === '' && inBlock === null) {
      return getEmptyChunk();
    }

    if (text.trim() === '' && inBlock !== 'code-block') {
      return getWhitespaceChunk(inEntity);
    }

    if (inBlock !== 'code-block') {
      // Can't use empty string because MSWord
      text = text.replace(REGEX_LF, SPACE);
    }

    var entities = Array(text.length).fill(inEntity);
    var offsetChange = 0;
    var textEntities = checkEntityText(text, createEntity, getEntity, mergeEntityData, replaceEntityData).sort(rangeSort);
    textEntities.forEach(function (_ref) {
      var entity = _ref.entity,
          offset = _ref.offset,
          length = _ref.length,
          result = _ref.result;
      var adjustedOffset = offset + offsetChange;

      if (result === null || result === undefined) {
        result = text.substr(adjustedOffset, length);
      }

      var textArray = text.split('');
      textArray.splice.bind(textArray, adjustedOffset, length).apply(textArray, result.split(''));
      text = textArray.join('');
      entities.splice.bind(entities, adjustedOffset, length).apply(entities, Array(result.length).fill(entity));
      offsetChange += result.length - length;
    });
    return {
      text: text,
      inlines: Array(text.length).fill(inlineStyle),
      entities: entities,
      blocks: []
    };
  } // BR tags


  if (nodeName === 'br') {
    var _blockType = inBlock;

    if (_blockType === null) {
      //  BR tag is at top level, treat it as an unstyled block
      return getSoftNewlineChunk('unstyled', depth, true);
    }

    return getSoftNewlineChunk(_blockType || 'unstyled', depth, options.flat);
  }

  var chunk = getEmptyChunk();
  var newChunk = null; // Inline tags

  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
  inlineStyle = processCustomInlineStyles(nodeName, node, inlineStyle); // Handle lists

  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }

    lastList = nodeName;
    inBlock = null;
  } // Block Tags


  var blockInfo = checkBlockType(nodeName, node, lastList, inBlock);
  var blockType;
  var blockDataMap;

  if (blockInfo === false) {
    return getEmptyChunk();
  }

  blockInfo = blockInfo || {};

  if (typeof blockInfo === 'string') {
    blockType = blockInfo;
    blockDataMap = (0,immutable.Map)();
  } else {
    blockType = typeof blockInfo === 'string' ? blockInfo : blockInfo.type;
    blockDataMap = blockInfo.data ? (0,immutable.Map)(blockInfo.data) : (0,immutable.Map)();
  }

  if (!inBlock && (fragmentBlockTags.indexOf(nodeName) !== -1 || blockType)) {
    chunk = getBlockDividerChunk(blockType || getBlockTypeForTag(nodeName, lastList), depth, blockDataMap);
    inBlock = blockType || getBlockTypeForTag(nodeName, lastList);
    newBlock = true;
  } else if (lastList && (inBlock === 'ordered-list-item' || inBlock === 'unordered-list-item') && nodeName === 'li') {
    var listItemBlockType = getBlockTypeForTag(nodeName, lastList);
    chunk = getBlockDividerChunk(listItemBlockType, depth);
    inBlock = listItemBlockType;
    newBlock = true;
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  } else if (inBlock && inBlock !== 'atomic' && blockType === 'atomic') {
    inBlock = blockType;
    newBlock = true;
    chunk = getSoftNewlineChunk(blockType, depth, true, // atomic blocks within non-atomic blocks must always be split out
    blockDataMap);
  } // Recurse through children


  var child = node.firstChild; // hack to allow conversion of atomic blocks from HTML (e.g. <figure><img
  // src="..." /></figure>). since metadata must be stored on an entity text
  // must exist for the entity to apply to. the way chunks are joined strips
  // whitespace at the end so it cannot be a space character.

  if (child == null && inEntity && (blockType === 'atomic' || inBlock === 'atomic')) {
    child = document.createTextNode('a');
  }

  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    entityId = checkEntityNode(nodeName, child, createEntity, getEntity, mergeEntityData, replaceEntityData);
    newChunk = genFragment(child, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, entityId || inEntity);
    chunk = joinChunks(chunk, newChunk, options.flat);
    var sibling = child.nextSibling; // Put in a newline to break up blocks inside blocks

    if (sibling && fragmentBlockTags.indexOf(nodeName) >= 0 && inBlock) {
      var newBlockInfo = checkBlockType(nodeName, child, lastList, inBlock);
      var newBlockType = void 0;
      var newBlockData = void 0;

      if (newBlockInfo !== false) {
        newBlockInfo = newBlockInfo || {};

        if (typeof newBlockInfo === 'string') {
          newBlockType = newBlockInfo;
          newBlockData = (0,immutable.Map)();
        } else {
          newBlockType = newBlockInfo.type || getBlockTypeForTag(nodeName, lastList);
          newBlockData = newBlockInfo.data ? (0,immutable.Map)(newBlockInfo.data) : (0,immutable.Map)();
        }

        chunk = joinChunks(chunk, getSoftNewlineChunk(newBlockType, depth, options.flat, newBlockData), options.flat);
      }
    }

    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }

    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, (0,immutable.Map)()), options.flat);
  }

  return chunk;
}

function getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE);
  var safeBody = DOMBuilder(html);

  if (!safeBody) {
    return null;
  } // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.


  var workingBlocks = containsSemanticBlockMarkup(html) ? blockTags.concat(['div']) : ['div']; // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to sta rt with.

  var chunk = genFragment(safeBody, (0,immutable.OrderedSet)(), 'ul', null, workingBlocks, -1, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options); // join with previous block to prevent weirdness on paste

  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  } // Kill block delimiter at the end


  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  } // If we saw no block tags, put an unstyled one in


  if (chunk.blocks.length === 0) {
    chunk.blocks.push({
      type: 'unstyled',
      data: (0,immutable.Map)(),
      depth: 0
    });
  } // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content


  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({
      type: 'unstyled',
      data: (0,immutable.Map)(),
      depth: 0
    });
  }

  return chunk;
}

function convertFromHTMLtoContentBlocks(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder, generateKey) {
  // Be ABSOLUTELY SURE that the dom builder you pass hare won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
  var chunk = getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder, generateKey);

  if (chunk == null) {
    return [];
  }

  var start = 0;
  return chunk.text.split('\r').map(function (textBlock, blockIndex) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);
    var end = start + textBlock.length;
    var inlines = nullthrows(chunk).inlines.slice(start, end);
    var entities = nullthrows(chunk).entities.slice(start, end);
    var characterList = (0,immutable.List)(inlines.map(function (style, entityIndex) {
      var data = {
        style: style,
        entity: null
      };

      if (entities[entityIndex]) {
        data.entity = entities[entityIndex];
      }

      return Draft.CharacterMetadata.create(data);
    }));
    start = end + 1;
    return new Draft.ContentBlock({
      key: generateKey(),
      type: nullthrows(chunk).blocks[blockIndex].type,
      data: nullthrows(chunk).blocks[blockIndex].data,
      depth: nullthrows(chunk).blocks[blockIndex].depth,
      text: textBlock,
      characterList: characterList
    });
  });
}

var convertFromHTML = function convertFromHTML(_ref2) {
  var _ref2$htmlToStyle = _ref2.htmlToStyle,
      htmlToStyle = _ref2$htmlToStyle === void 0 ? defaultHTMLToStyle : _ref2$htmlToStyle,
      _ref2$htmlToEntity = _ref2.htmlToEntity,
      htmlToEntity = _ref2$htmlToEntity === void 0 ? defaultHTMLToEntity : _ref2$htmlToEntity,
      _ref2$textToEntity = _ref2.textToEntity,
      textToEntity = _ref2$textToEntity === void 0 ? defaultTextToEntity : _ref2$textToEntity,
      _ref2$htmlToBlock = _ref2.htmlToBlock,
      htmlToBlock = _ref2$htmlToBlock === void 0 ? defaultHTMLToBlock : _ref2$htmlToBlock;
  return function (html) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      flat: false
    };
    var DOMBuilder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : parseHTML;
    var generateKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Draft.genKey;
    var contentState = Draft.ContentState.createFromText('');

    var createEntityWithContentState = function createEntityWithContentState() {
      if (contentState.createEntity) {
        var _contentState;

        contentState = (_contentState = contentState).createEntity.apply(_contentState, arguments);
        return contentState.getLastCreatedEntityKey();
      }

      return Draft.Entity.create.apply(Draft.Entity, arguments);
    };

    var getEntityWithContentState = function getEntityWithContentState() {
      if (contentState.getEntity) {
        var _contentState2;

        return (_contentState2 = contentState).getEntity.apply(_contentState2, arguments);
      }

      return Draft.Entity.get.apply(Draft.Entity, arguments);
    };

    var mergeEntityDataWithContentState = function mergeEntityDataWithContentState() {
      if (contentState.mergeEntityData) {
        var _contentState3;

        contentState = (_contentState3 = contentState).mergeEntityData.apply(_contentState3, arguments);
        return;
      }

      Draft.Entity.mergeData.apply(Draft.Entity, arguments);
    };

    var replaceEntityDataWithContentState = function replaceEntityDataWithContentState() {
      if (contentState.replaceEntityData) {
        var _contentState4;

        contentState = (_contentState4 = contentState).replaceEntityData.apply(_contentState4, arguments);
        return;
      }

      Draft.Entity.replaceData.apply(Draft.Entity, arguments);
    };

    var contentBlocks = convertFromHTMLtoContentBlocks(html, handleMiddleware(htmlToStyle, baseProcessInlineTag), handleMiddleware(htmlToEntity, defaultHTMLToEntity), handleMiddleware(textToEntity, defaultTextToEntity), handleMiddleware(htmlToBlock, baseCheckBlockType), createEntityWithContentState, getEntityWithContentState, mergeEntityDataWithContentState, replaceEntityDataWithContentState, options, DOMBuilder, generateKey);
    var blockMap = Draft.BlockMapBuilder.createFromArray(contentBlocks);
    var firstBlockKey = contentBlocks[0].getKey();
    return contentState.merge({
      blockMap: blockMap,
      selectionBefore: Draft.SelectionState.createEmpty(firstBlockKey),
      selectionAfter: Draft.SelectionState.createEmpty(firstBlockKey)
    });
  };
};

/* harmony default export */ var esm_convertFromHTML = (function () {
  if (arguments.length >= 1 && typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
    return convertFromHTML({}).apply(void 0, arguments);
  }

  return convertFromHTML.apply(void 0, arguments);
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/draft-convert@2.1.12_eohllgbpgcuys7z7debz4xshj4/node_modules/draft-convert/esm/index.js




;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/serialization/translateIntoHtmlString.js
/* eslint-disable react/no-danger, react/display-name */ 




/**
 * @type {Function}
 */ var translateIntoHtmlString = esm_convertToHTML({
    /**
   * @param   {Object} block
   * @returns {?ReactElement}
   */ blockToHTML: function(block) {
        if (block.type === "atomic") {
            if (block.data.blockType === src_AtomicBlockIdentifiers.IMAGE) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    src: block.data.imageUrl,
                    alt: block.data.imageUrl
                });
            }
            if (block.data.blockType === src_AtomicBlockIdentifiers.YOUTUBE_VIDEO) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    href: block.data.videoUrl,
                    children: block.data.videoUrl
                });
            }
            if (block.data.blockType === src_AtomicBlockIdentifiers.DIVIDER) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {});
            }
        }
        return null;
    },
    /**
   * @param   {String} style
   * @returns {?ReactElement}
   */ styleToHTML: function(style) {
        if (style === "HIGHLIGHT") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mark", {});
        }
        return null;
    },
    /**
   * @param {Object} entity
   * @param {String} originalText
   * @returns {?ReactElement}
   */ entityToHTML: function(entity, originalText) {
        if (entity.type === src_EntityTypeIdentifiers.LINK) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: entity.data.url,
                target: "_blank",
                title: entity.data.url,
                rel: "noopener noreferrer",
                children: originalText
            });
        }
        if (entity.type === src_EntityTypeIdentifiers.MENTION) {
            var jsonChildren = JSON.stringify({
                type: entity.data.getType(),
                metadata: entity.data.getMetadata(),
                mutability: entity.data.getMutability(),
                displayText: entity.data.getDisplayText(),
                entityType: src_EntityTypeIdentifiers.MENTION
            });
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: jsonChildren
            });
        }
        return null;
    }
});
/* harmony default export */ var serialization_translateIntoHtmlString = (translateIntoHtmlString);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/serialization/translateIntoPlainContentState.js





/**
 * @type {Function}
 */ var translateIntoPlainContentState = esm_convertFromHTML({
    /**
   * @param   {String}      tag
   * @param   {HTMLElement} node
   * @returns {?Object}
   */ htmlToBlock: function(tag, node) {
        if (tag === "hr") {
            return {
                type: "atomic",
                data: {
                    blockType: "divider"
                }
            };
        }
        if (tag === "img") {
            return {
                type: "atomic",
                data: {
                    blockType: src_AtomicBlockIdentifiers.IMAGE,
                    imageUrl: node.getAttribute("src")
                }
            };
        }
        if (tag === "a" && node.href.includes("youtube.com")) {
            return {
                type: "atomic",
                data: {
                    blockType: src_AtomicBlockIdentifiers.YOUTUBE_VIDEO,
                    videoUrl: node.href,
                    videoId: getYoutubeId(node.href)
                }
            };
        }
        return null;
    },
    /**
   * @param   {String}      nodeName
   * @param   {HTMLElement} node
   * @param   {OrderedSet}  currentStyle
   * @returns {OrderedSet}
   */ htmlToStyle: function(nodeName, node, currentStyle) {
        if (nodeName === "mark") {
            return currentStyle.add("HIGHLIGHT");
        }
        return currentStyle;
    },
    /**
   * @param   {String}      nodeName
   * @param   {HTMLElement} node
   * @param   {Function}    createEntity
   * @returns {?String}
   */ htmlToEntity: function(nodeName, node, createEntity) {
        if (nodeName === "a") {
            if (node.hasAttribute("class") && node.getAttribute("class").includes("mention")) {
                return null;
            }
            if (node.href.includes("youtube.com")) {
                return null;
            }
            return createEntity(src_EntityTypeIdentifiers.LINK, "MUTABLE", {
                url: node.href
            });
        }
        if (nodeName === "span") {
            var jsonChildren = JSON.parse(node.textContent);
            if (jsonChildren && jsonChildren.entityType && jsonChildren.entityType === src_EntityTypeIdentifiers.MENTION) {
                return createEntity(src_EntityTypeIdentifiers.MENTION, jsonChildren.mutability, EditorMention.create(jsonChildren.type, jsonChildren.displayText, jsonChildren.metadata, jsonChildren.mutability));
            }
        }
        return null;
    }
});
/* harmony default export */ var serialization_translateIntoPlainContentState = (translateIntoPlainContentState);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/PersistencyUtils.js
/* eslint-disable jsx-a11y/alt-text */ 







/**
 * @type {Function}
 */ var PersistencyUtils_noop = function() {};
/**
 * @type {Object}
 */ var DiscoursePersistencyUtils = {
    /**
   * @return {EditorState}
   */ emptyState: function emptyState() {
        return Draft.EditorState.createEmpty(null);
    },
    /**
   * @param  {EditorState} editorState
   * @return {String}
   */ editorStateToHtml: function editorStateToHtml(editorState) {
        var contentState = editorState.getCurrentContent();
        return serialization_translateIntoHtmlString(contentState);
    },
    /**
   * @param  {?String} htmlString
   * @return {EditorState}
   */ htmlToEditorState: function htmlToEditorState(htmlString) {
        if (!htmlString) {
            return Draft.EditorState.createEmpty(null);
        }
        var translatedState = serialization_translateIntoPlainContentState(htmlString);
        var withoutUglyMentions = replaceUglyMentionsWithTheirDisplayText(translatedState);
        var rawContentState = (0,Draft.convertToRaw)(withoutUglyMentions);
        var strippingBlocks = findEntitiesBlockKeys(translatedState);
        return Draft.EditorState.createWithContent((0,Draft.convertFromRaw)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rawContentState), {
            blocks: rawContentState.blocks.filter(function(block) {
                return strippingBlocks.includes(block.key) === false;
            }).map(function(block) {
                // eslint-disable-next-line
                var key = block.key, other = (0,_object_without_properties/* default */.Z)(block, [
                    "key"
                ]);
                return other;
            })
        })));
    }
};
/**
 * @param   {ContentState} contentState
 * @returns {ContentBlock}
 */ function findMentionsReplacements(contentState) {
    var foundEntityRanges = [];
    contentState.getBlockMap().forEach(function(contentBlock) {
        var lastMentionEntity;
        var lastEntityKey;
        var filterMentionEntityFn = function(character) {
            var entityKey = character.getEntity();
            if (entityKey) {
                var entityAtChar = contentState.getEntity(entityKey);
                if (entityAtChar.getType() === src_EntityTypeIdentifiers.MENTION) {
                    lastMentionEntity = entityAtChar;
                    lastEntityKey = entityKey;
                    return true;
                }
            }
            lastMentionEntity = null;
            lastEntityKey = null;
            return false;
        };
        contentBlock.findEntityRanges(filterMentionEntityFn, function(startAt, endAt) {
            var blockKey = contentBlock.getKey();
            var displayText = lastMentionEntity.getData().getDisplayText();
            var needsReplacement = endAt - startAt > displayText.length;
            if (needsReplacement) {
                foundEntityRanges.push({
                    entityKey: lastEntityKey,
                    displayText: displayText,
                    selection: Draft.SelectionState.createEmpty(blockKey).merge({
                        anchorOffset: startAt,
                        focusOffset: endAt
                    })
                });
            }
        });
    });
    return foundEntityRanges;
}
/**
 * @param   {ContentState} contentState
 * @returns {ContentState}
 */ function replaceUglyMentionsWithTheirDisplayText(contentState) {
    var foundEntityRanges = findMentionsReplacements(contentState);
    if (foundEntityRanges.length === 0) {
        return contentState;
    }
    var modifiedState = contentState;
    foundEntityRanges.forEach(function(entityAtRange) {
        modifiedState = replaceUglyMentionsWithTheirDisplayText(Draft.Modifier.replaceText(modifiedState, entityAtRange.selection, entityAtRange.displayText, null, entityAtRange.entityKey));
    });
    return modifiedState;
}
/**
 * @param   {ContentState} contentState
 * @returns {[]String}
 */ function findEntitiesBlockKeys(contentState) {
    var foundMentions = [];
    contentState.getBlocksAsArray().forEach(function(block) {
        block.findEntityRanges(function(character) {
            if (character.getEntity() !== null) {
                var entity = contentState.getEntity(character.getEntity());
                if (entity.getType() === src_EntityTypeIdentifiers.MENTION) {
                    var metadata = entity.getData().getMetadata();
                    foundMentions.push("@".concat(metadata.slug));
                    return true;
                }
            }
            return false;
        }, PersistencyUtils_noop);
    });
    if (foundMentions.length === 0) {
        return OrderedMap();
    }
    var blocks = contentState.getBlockMap().filter(function(block) {
        var mentions = block.getText().match(/@([\w_-]+)/gi);
        if (Array.isArray(mentions)) {
            return foundMentions.every(function(mention) {
                return mentions.includes(mention);
            });
        } else {
            return false;
        }
    });
    return blocks.map(function(block) {
        return block.getKey();
    });
}
/* harmony default export */ var PersistencyUtils = ((/* unused pure expression or super */ null && (DiscoursePersistencyUtils)));

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(80929);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/mentions/PromiseProvider.js










var PromiseProvider = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PromiseProvider, Component);
    var _super = (0,_create_super/* default */.Z)(PromiseProvider);
    function PromiseProvider() {
        (0,_class_call_check/* default */.Z)(this, PromiseProvider);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "shouldComponentUpdate", function(nextProps) {
            return _this.props.query !== nextProps.query;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "emitSuggestions", function(query) {
            var _props = _this.props, promiseOrCreate = _props.promise, onChange = _props.onChange;
            var promise = (0,_instanceof/* default */.Z)(promiseOrCreate, Promise) ? promiseOrCreate : promiseOrCreate(query);
            if ((0,_instanceof/* default */.Z)(promise, Promise)) {
                promise.then(function(potentialSuggestions) {
                    var nextSuggestions = potentialSuggestions.filter(function(maybeSuggestion) {
                        return (0,_instanceof/* default */.Z)(maybeSuggestion, MentionSuggestion);
                    });
                    onChange(nextSuggestions);
                }, function() {
                    return onChange([]);
                });
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "render", function() {
            return null;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(PromiseProvider, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var query = this.props.query;
                this.emitSuggestions(query);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var query = this.props.query;
                this.emitSuggestions(query);
            }
        }
    ]);
    return PromiseProvider;
}(react.Component);
(0,_define_property/* default */.Z)(PromiseProvider, "propTypes", {
    promise: prop_types_default().oneOfType([
        prop_types_default().instanceOf(Promise),
        (prop_types_default()).func
    ]).isRequired,
    query: (prop_types_default()).string.isRequired,
    onChange: (prop_types_default()).func.isRequired
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/apps/ReplyDisruptorsEditor.js







/**
 * @type {Function}
 */ var ReplyDisruptorsEditor_noop = function() {};
function ReplyDisruptorsEditor(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovlaunchEditor, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: function(param) {
            var editorKey = param.editorKey, editorState = param.editorState, focus = param.focus, focusEditor = param.focusEditor, onChange = param.onChange;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardInlineToolbar, {
                        editorState: editorState,
                        focusEditor: focusEditor,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardMentions, {
                        editorState: editorState,
                        onChange: onChange,
                        children: function(param) {
                            var query = param.query, suggestions = param.suggestions, selectedIndex = param.selectedIndex, onChange = param.onChange, acceptSuggestion = param.acceptSuggestion;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    suggestions.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardMentionsPopover, {
                                        children: suggestions.map(function(suggestion, index) {
                                            var isSelected = selectedIndex === index;
                                            var type = suggestion.getMentionType();
                                            if (type === mentions_MentionTypes.DISRUPTOR) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisruptorSuggestionItem, {
                                                    isSelected: isSelected,
                                                    suggestion: suggestion,
                                                    acceptSuggestion: acceptSuggestion
                                                }, index);
                                            }
                                            return null;
                                        }).filter(Boolean)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Debounce, {
                                        ms: 100,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisruptorsProvider, {
                                            query: query,
                                            onChange: onChange
                                        })
                                    })
                                ]
                            });
                        }
                    }),
                    children({
                        editorKey: editorKey,
                        editorState: editorState,
                        focus: focus,
                        focusEditor: focusEditor,
                        onChange: onChange
                    })
                ]
            });
        }
    }));
};
ReplyDisruptorsEditor.propTypes = {
    children: (prop_types_default()).func
};
ReplyDisruptorsEditor.defaultProps = {
    children: ReplyDisruptorsEditor_noop
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/ArrowDown.js



/**
 * @param   {Number} width
 * @param   {String} backgroundColor
 * @returns {ReactElement}
 */ function ArrowDown(param) {
    var width = param.width, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 0,
            height: 0,
            borderLeft: "".concat(width, " solid transparent"),
            borderRight: "".concat(width, " solid transparent"),
            borderTop: "".concat(width, " solid ").concat(backgroundColor)
        }
    });
};
ArrowDown.propTypes = {
    width: (prop_types_default()).string.isRequired,
    backgroundColor: (prop_types_default()).string.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/toolbar/EditorInlineTooltip.js








function EditorInlineTooltip(param) {
    var position = param.position, visible = param.visible, innerRef = param.innerRef, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("EditorInlineTooltip/rootContainer")), {
        ref: innerRef,
        style: position,
        css: {
            position: "absolute",
            visibility: visible ? "visible" : "hidden",
            transform: "translate(-50%) scale(".concat(visible ? 1 : 0, ")"),
            zIndex: src_CssLayers.INLINE_TOOLBAR
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("EditorInlineTooltip/tray")), {
                    css: {
                        position: "relative",
                        color: "#ffffff",
                        backgroundColor: "#212121",
                        borderRadius: 4,
                        display: "flex",
                        alignItems: "center"
                    },
                    children: children
                })),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDown, {
                    width: "6px",
                    backgroundColor: "#212121"
                })
            ]
        })
    }));
};
EditorInlineTooltip.propTypes = {
    position: prop_types_default().shape({
        top: (prop_types_default()).number.isRequired,
        left: (prop_types_default()).number.isRequired
    }),
    visible: (prop_types_default()).bool.isRequired,
    innerRef: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).any.isRequired
};
EditorInlineTooltip.defaultProps = {
    position: null
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/toolbar/EditorInlineToolbar.js





function EditorInlineToolbar(param) {
    var position = param.position, visible = param.visible, innerRef = param.innerRef, editorState = param.editorState, onChange = param.onChange, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorInlineTooltip, {
        position: position,
        visible: visible,
        innerRef: innerRef,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            onMouseDown: function(event) {
                return event.preventDefault();
            },
            css: wrapperStyle,
            children: children({
                editorState: editorState,
                toggleInlineStyle: toggleInlineStyle(editorState, onChange),
                toggleBlockType: toggleBlockType(editorState, onChange)
            })
        })
    });
};
EditorInlineToolbar.propTypes = {
    innerRef: (prop_types_default()).func.isRequired,
    position: prop_types_default().shape({
        top: (prop_types_default()).number.isRequired,
        left: (prop_types_default()).number.isRequired
    }).isRequired,
    visible: (prop_types_default()).bool.isRequired,
    editorState: (prop_types_default()).object.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).any.isRequired
};
var wrapperStyle = {
    display: "flex",
    flexDirection: "row"
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/toolbar/InlineToolbarSeparator.js



function InlineToolbarSeparator() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            height: 30,
            width: 1,
            opacity: 0.5,
            backgroundColor: darkGray,
            userSelect: "none",
            cursor: "initial"
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/toolbar/ToolbarToggleButton.js







function ToolbarToggleButton(_param) {
    var isActive = _param.isActive, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isActive",
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        css: {
            cursor: "pointer",
            color: isActive ? darkSkyBlue : "#ffffff",
            userSelect: "none",
            boxSizing: "border-box",
            width: 30,
            height: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, props), {
        children: children
    }));
};
ToolbarToggleButton.propTypes = {
    isActive: (prop_types_default()).bool.isRequired,
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/toolbar/index.js






;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/insertEntity.js

/**
 * @param  {EditorState} editorState
 * @param  {String}      entityType
 * @param  {Object}      data
 * @param  {String}      mutability
 * @return {EditorState}
 */ function insertEntity(editorState, entityType, data) {
    var mutability = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "MUTABLE";
    var contentState = editorState.getCurrentContent();
    var contentStateWithEntity = contentState.createEntity(entityType, mutability, data);
    var nextState = Draft.EditorState.set(editorState, {
        currentContent: contentStateWithEntity
    });
    return Draft.RichUtils.toggleLink(nextState, nextState.getSelection(), contentStateWithEntity.getLastCreatedEntityKey());
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/EditorEntityHandling.js



/**
 * @param {EditorState} editorState
 * @param {Function}    onChange
 * @param {Function}    onInsert
 */ function handleInsertEntity(editorState, onChange) {
    return function(entityType, data) {
        var mutability = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "MUTABLE";
        if (entityType) {
            var afterInsert = insertEntity(editorState, entityType, data, mutability);
            onChange(afterInsert);
        }
    };
}
/**
 * @param {EditorState} editorState
 * @param {Function}    onChange
 * @param {Function}    onRemove
 */ function handleRemoveEntity(editorState, onChange) {
    return function() {
        var currentSelection = editorState.getSelection();
        if (currentSelection.isCollapsed() === false) {
            var afterRemove = Draft.RichUtils.toggleLink(editorState, currentSelection, null);
            onChange(afterRemove);
        }
    };
}
function EditorEntityHandling(param) {
    var editorState = param.editorState, onChange = param.onChange, children = param.children;
    return children({
        insertEntity: handleInsertEntity(editorState, onChange),
        removeEntity: handleRemoveEntity(editorState, onChange)
    });
};
EditorEntityHandling.propTypes = {
    editorState: (prop_types_default()).object.isRequired,
    onChange: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/getRelativeParent.js
/**
 * @param   {HTMLElement}  element
 * @returns {?HTMLElement}
 */ function getRelativeParent(element) {
    if (element) {
        var position = window.getComputedStyle(element).getPropertyValue("position");
        if (position !== "static") {
            return element;
        }
        return getRelativeParent(element.parentElement);
    }
    return null;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/EditorSelectionCoordinates.js










var EditorSelectionCoordinates = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(EditorSelectionCoordinates, Component);
    var _super = (0,_create_super/* default */.Z)(EditorSelectionCoordinates);
    function EditorSelectionCoordinates() {
        (0,_class_call_check/* default */.Z)(this, EditorSelectionCoordinates);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            top: -9999,
            left: -9999,
            visible: false
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "isSelectionVisible", function(editorSelection) {
            return editorSelection.getHasFocus() && editorSelection.isCollapsed() === false;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "resetCoordinates", function() {
            return _this.setState({
                top: -9999,
                left: -9999,
                visible: false
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "calculateCoordinatesAndSetState", function(element) {
            // NOTE: we need to "postpone" the calculation so the whole state gets updated/rendered before
            // we ever get to calculate the actual coordinates of `innerRef`
            _this.setState(null, function() {
                var relativeParent = getRelativeParent(element.parentElement);
                var elementHeight = element.clientHeight;
                var relativeRect = (relativeParent || document.body).getBoundingClientRect();
                var visibleSelectionRect = (0,Draft.getVisibleSelectionRect)(window);
                if (visibleSelectionRect) {
                    _this.setState({
                        top: visibleSelectionRect.top - relativeRect.top - elementHeight,
                        left: visibleSelectionRect.left - relativeRect.left + visibleSelectionRect.width / 2,
                        visible: true
                    });
                }
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleSetRef", function(element) {
            _this.innerRef = element;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(EditorSelectionCoordinates, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var editorSelection = this.props.editorSelection;
                if (this.innerRef && this.isSelectionVisible(editorSelection)) {
                    this.calculateCoordinatesAndSetState(this.innerRef);
                }
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(param) {
                var editorSelection = param.editorSelection, ignoreSelectionFocus = param.ignoreSelectionFocus;
                if (this.isSelectionVisible(editorSelection) || ignoreSelectionFocus) {
                    this.calculateCoordinatesAndSetState(this.innerRef);
                } else {
                    this.resetCoordinates();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var _state = this.state, top = _state.top, left = _state.left, visible = _state.visible;
                return children({
                    top: top,
                    left: left,
                    innerRef: this.handleSetRef,
                    visible: visible
                });
            }
        }
    ]);
    return EditorSelectionCoordinates;
}(react.Component);
(0,_define_property/* default */.Z)(EditorSelectionCoordinates, "propTypes", {
    ignoreSelectionFocus: (prop_types_default()).bool,
    editorSelection: (prop_types_default()).any.isRequired,
    children: (prop_types_default()).func.isRequired
});
(0,_define_property/* default */.Z)(EditorSelectionCoordinates, "defaultProps", {
    ignoreSelectionFocus: false
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/FocusOnMount.js








var FocusOnMount = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(FocusOnMount, Component);
    var _super = (0,_create_super/* default */.Z)(FocusOnMount);
    function FocusOnMount() {
        (0,_class_call_check/* default */.Z)(this, FocusOnMount);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleSetRef", function(elementRef) {
            _this.elementRef = elementRef;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(FocusOnMount, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var nextTick = this.props.nextTick;
                if (this.elementRef && typeof this.elementRef.focus === "function") {
                    if (nextTick) {
                        setTimeout(function() {
                            _this.elementRef.focus();
                        });
                    } else {
                        this.elementRef.focus();
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    innerRef: this.handleSetRef
                });
            }
        }
    ]);
    return FocusOnMount;
}(react.Component);
(0,_define_property/* default */.Z)(FocusOnMount, "propTypes", {
    nextTick: (prop_types_default()).bool,
    children: (prop_types_default()).func.isRequired
});
(0,_define_property/* default */.Z)(FocusOnMount, "defaultProps", {
    nextTick: true
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/toolbar/LinkInput.js










/**
 * @param   {String}   currentValue
 * @param   {Function} onInsert
 * @param   {Function} onCancel
 * @returns {Function}
 */ function handleKeyDown(currentValue, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && currentValue) {
            event.preventDefault();
            // TODO: validate properly
            if (/^https?:\/\/(.+)/i.test(currentValue)) {
                onInsert(currentValue);
            }
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}
function LinkInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
        initial: "",
        children: function(param) {
            var value = param.value, set = param.set;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    whiteSpace: "nowrap",
                    zIndex: src_CssLayers.INLINE_TOOLBAR_LINK_INPUT,
                    width: 250,
                    height: 40
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount, {
                    children: function(param) {
                        var innerRef = param.innerRef;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardInlineToolbar/toggle/link/input")), {
                            value: value,
                            ref: innerRef,
                            onChange: function(event) {
                                return set(event.target.value);
                            },
                            spellCheck: false,
                            onKeyDown: handleKeyDown(value, onInsert, onCancel),
                            placeholder: "What's the URL?",
                            css: {
                                border: "none",
                                outline: "none",
                                backgroundColor: "transparent",
                                padding: 10,
                                width: "100%",
                                height: "100%",
                                color: "#ffffff",
                                "&::placeholder": {
                                    color: sealBlue
                                }
                            }
                        }));
                    }
                })
            });
        }
    });
};
LinkInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/conditionalTestId.js

/**
 * @param   {String} actualIdentifier
 * @returns {Object}
 */ function conditionalTestId(enabled, ifTestId, elseTestId) {
    return testId(enabled ? ifTestId : elseTestId);
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/StandardInlineToolbar.js














function StandardInlineToolbar(param) {
    var editorState = param.editorState, focusEditor = param.focusEditor, onChange = param.onChange;
    var currentSelection = editorState.getSelection();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        initial: false,
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    on ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorSelectionCoordinates, {
                        ignoreSelectionFocus: true,
                        editorSelection: currentSelection,
                        children: function(param) {
                            var innerRef = param.innerRef, visible = param.visible, top = param.top, left = param.left;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorInlineTooltip, {
                                innerRef: innerRef,
                                visible: visible,
                                position: {
                                    top: top,
                                    left: left
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorEntityHandling, {
                                    editorState: editorState,
                                    onChange: onChange,
                                    children: function(param) {
                                        var insertEntity = param.insertEntity;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkInput, {
                                            onInsert: function(linkUrl) {
                                                insertEntity("LINK", {
                                                    url: linkUrl
                                                });
                                                setTimeout(focusEditor);
                                                toggle();
                                            },
                                            onCancel: function() {
                                                onChange(Draft.EditorState.forceSelection(editorState, currentSelection));
                                                toggle();
                                            }
                                        });
                                    }
                                })
                            });
                        }
                    }) : null,
                    on ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorSelectionCoordinates, {
                        editorSelection: currentSelection,
                        children: function(param) {
                            var innerRef = param.innerRef, visible = param.visible, top = param.top, left = param.left;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorInlineToolbar, {
                                innerRef: innerRef,
                                visible: visible,
                                editorState: editorState,
                                onChange: onChange,
                                position: {
                                    top: top,
                                    left: left
                                },
                                children: function(param) {
                                    var editorState = param.editorState, toggleBlockType = param.toggleBlockType, toggleInlineStyle = param.toggleInlineStyle;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarToggleButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, conditionalTestId(isInlineStyleActive(editorState, "BOLD"), "StandardInlineToolbar/toggle/bold/active", "StandardInlineToolbar/toggle/bold")), {
                                                onClick: toggleInlineStyle("BOLD"),
                                                isActive: isInlineStyleActive(editorState, "BOLD"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_BoldIcon, {})
                                            })),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineToolbarSeparator, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarToggleButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, conditionalTestId(isInlineStyleActive(editorState, "ITALIC"), "StandardInlineToolbar/toggle/italic/active", "StandardInlineToolbar/toggle/italic")), {
                                                onClick: toggleInlineStyle("ITALIC"),
                                                isActive: isInlineStyleActive(editorState, "ITALIC"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_ItalicIcon, {})
                                            })),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineToolbarSeparator, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarToggleButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, conditionalTestId(isInlineStyleActive(editorState, "UNDERLINE"), "StandardInlineToolbar/toggle/underline/active", "StandardInlineToolbar/toggle/underline")), {
                                                onClick: toggleInlineStyle("UNDERLINE"),
                                                isActive: isInlineStyleActive(editorState, "UNDERLINE"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_UnderlineIcon, {})
                                            })),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineToolbarSeparator, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorEntityHandling, {
                                                editorState: editorState,
                                                onChange: onChange,
                                                children: function(param) {
                                                    var removeEntity = param.removeEntity;
                                                    var isActive = isSelectingEntity(editorState, "LINK");
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarToggleButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, conditionalTestId(isActive, "StandardInlineToolbar/toggle/link/active", "StandardInlineToolbar/toggle/link")), {
                                                        onClick: isActive ? removeEntity : toggle,
                                                        isActive: isActive,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_LinkIcon, {})
                                                    }));
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineToolbarSeparator, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarToggleButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, conditionalTestId(isBlockActive(editorState, "header-three"), "StandardInlineToolbar/toggle/header-three/active", "StandardInlineToolbar/toggle/header-three")), {
                                                onClick: toggleBlockType("header-three"),
                                                isActive: isBlockActive(editorState, "header-three"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    style: {
                                                        fontSize: 13
                                                    },
                                                    children: "H3"
                                                })
                                            })),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineToolbarSeparator, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarToggleButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, conditionalTestId(isBlockActive(editorState, "header-four"), "StandardInlineToolbar/toggle/header-four/active", "StandardInlineToolbar/toggle/header-four")), {
                                                onClick: toggleBlockType("header-four"),
                                                isActive: isBlockActive(editorState, "header-four"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    style: {
                                                        fontSize: 13
                                                    },
                                                    children: "H4"
                                                })
                                            })),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineToolbarSeparator, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarToggleButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, conditionalTestId(isBlockActive(editorState, "blockquote"), "StandardInlineToolbar/toggle/blockquote/active", "StandardInlineToolbar/toggle/blockquote")), {
                                                onClick: toggleBlockType("blockquote"),
                                                isActive: isBlockActive(editorState, "blockquote"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_BlockquoteIcon, {})
                                            })),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineToolbarSeparator, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarToggleButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, conditionalTestId(isBlockActive(editorState, "unordered-list-item"), "StandardInlineToolbar/toggle/unordered-list-item/active", "StandardInlineToolbar/toggle/unordered-list-item")), {
                                                onClick: toggleBlockType("unordered-list-item"),
                                                isActive: isBlockActive(editorState, "unordered-list-item"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulletedListIcon, {})
                                            }))
                                        ]
                                    });
                                }
                            });
                        }
                    })
                ]
            });
        }
    });
};
StandardInlineToolbar.propTypes = {
    editorState: (prop_types_default()).object.isRequired,
    focusEditor: (prop_types_default()).func.isRequired,
    onChange: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/StandardMentionSuggestionItem.js




function StandardMentionSuggestionItem(param) {
    var isSelected = param.isSelected, suggestion = param.suggestion, acceptSuggestion = param.acceptSuggestion, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        onClick: function() {
            return acceptSuggestion(suggestion);
        },
        css: {
            padding: 12,
            cursor: "pointer",
            userSelect: "none",
            "& > *": {
                cursor: "pointer",
                pointerEvents: "none"
            },
            "&:hover": {
                // pre-select
                backgroundColor: isSelected ? "#66a0ff" : "#eef4ff"
            },
            backgroundColor: isSelected ? "#005aee" : null,
            color: isSelected ? "#ffffff" : "inherit",
            "&:first-of-type": {
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4
            },
            "&:last-of-type": {
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4
            }
        },
        children: children
    });
};
StandardMentionSuggestionItem.propTypes = {
    isSelected: (prop_types_default()).bool.isRequired,
    suggestion: prop_types_default().instanceOf(MentionSuggestion).isRequired,
    acceptSuggestion: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/StandardMentions.js







function StandardMentions(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineMentions, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: function(param) {
            var mentionQuery = param.mentionQuery, acceptSuggestion = param.acceptSuggestion, selectedSuggestionIndex = param.selectedSuggestionIndex, offeredSuggestions = param.offeredSuggestions, offerSuggestions = param.offerSuggestions;
            return children({
                query: mentionQuery,
                onChange: offerSuggestions,
                acceptSuggestion: acceptSuggestion,
                suggestions: offeredSuggestions,
                selectedIndex: selectedSuggestionIndex
            });
        }
    }));
};
StandardMentions.propTypes = {
    children: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/StandardMentionsPopover.js




function StandardMentionsPopover(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            border: "solid 1px ".concat(lightestSealBlue),
            backgroundColor: "#ffffff",
            borderRadius: 4
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
            css: {
                listStyle: "none",
                margin: 0,
                padding: 0
            },
            children: children
        })
    });
};
StandardMentionsPopover.propTypes = {
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/GoogleSpreadsheetsInput.js






function GoogleSpreadsheetsInput_handleKeyDown(value, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && value) {
            event.preventDefault();
            var parser = new DOMParser();
            var code = parser.parseFromString(value, "text/html");
            var iframe = code.querySelector("iframe[src]");
            if (!iframe) {
                return;
            }
            var src = iframe.getAttribute("src");
            if (!src.includes("docs.google.com/spreadsheets") && !src.includes("/pubhtml")) {
                return;
            }
            onInsert(src);
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}
function GoogleSpreadsheetsInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        width: 300,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: "",
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        padding: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h5", {
                                            css: {
                                                margin: 0
                                            },
                                            children: "How to embed a Google Spreadsheet?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ol", {
                                            css: {
                                                margin: 0,
                                                padding: 0,
                                                fontSize: 12,
                                                listStyle: "none",
                                                marginTop: 10,
                                                marginLeft: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                    children: "1. Open your Spreadsheet"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                                    children: [
                                                        '2. Under "File", click on ',
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                                            children: "Publish to the Web"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                                    children: [
                                                        '3. In the section "Embed", click ',
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                                            children: "Publish"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                    children: "4. Copy the generated code and paste below"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    ref: innerRef,
                                    value: value,
                                    placeholder: "What's the embed code?",
                                    spellCheck: false,
                                    css: {
                                        border: "none",
                                        outline: "none",
                                        backgroundColor: "transparent",
                                        padding: 10,
                                        width: "100%",
                                        height: "100%",
                                        color: palette_text,
                                        "&::placeholder": {
                                            color: sealBlue
                                        }
                                    },
                                    onChange: function(event) {
                                        return set(event.target.value);
                                    },
                                    onKeyDown: GoogleSpreadsheetsInput_handleKeyDown(value, onInsert, onCancel),
                                    onMouseDown: function(event) {
                                        return event.preventDefault();
                                    }
                                })
                            ]
                        });
                    }
                });
            }
        })
    });
};
GoogleSpreadsheetsInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/icons/PlusIcon.js




var PlusIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 13 13",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M7.75.25h-2.5v5h-5v2.5h5v5h2.5v-5h5v-2.5h-5z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
};
/* harmony default export */ var icons_PlusIcon = (PlusIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/SideContentCircle.js








function SideContentCircle(_param) {
    var size = _param.size, color = _param.color, hoverColor = _param.hoverColor, top = _param.top, left = _param.left, visible = _param.visible, css = _param.css, innerRef = _param.innerRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "color",
        "hoverColor",
        "top",
        "left",
        "visible",
        "css",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: innerRef,
        css: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            width: size,
            height: size,
            borderRadius: "100%",
            position: "absolute",
            visibility: visible ? "visible" : "hidden",
            zIndex: src_CssLayers.SIDE_CONTENT_CIRCLE,
            boxSizing: "border-box",
            border: "2px solid ".concat(color),
            color: color,
            fontSize: 14,
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            cursor: "pointer",
            userSelect: "none",
            padding: 3,
            "&:hover": {
                borderColor: hoverColor,
                color: hoverColor
            }
        }),
        style: {
            top: top,
            left: (size + left) * -1
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_PlusIcon, {})
    }));
};
SideContentCircle.propTypes = {
    size: (prop_types_default()).number.isRequired,
    color: (prop_types_default()).string.isRequired,
    hoverColor: (prop_types_default()).string.isRequired,
    top: (prop_types_default()).number.isRequired,
    left: (prop_types_default()).number.isRequired,
    visible: (prop_types_default()).bool.isRequired,
    css: (prop_types_default()).object
};
SideContentCircle.defaultProps = {
    css: {}
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/SidebarButton.js







function SidebarButton(_param) {
    var children = _param.children, isActive = _param.isActive, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isActive"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        css: {
            color: isActive ? primary : sealBlue,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 10,
            "&:hover": {
                color: palette_text,
                cursor: "pointer"
            }
        },
        children: children
    }));
};
SidebarButton.propTypes = {
    isActive: (prop_types_default()).bool,
    children: (prop_types_default()).any.isRequired
};
SidebarButton.defaultProps = {
    isActive: false
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/SidebarTooltipArrowUp.js






/**
 * @param   {Number} width
 * @param   {String} backgroundColor
 * @returns {ReactElement}
 */ function SidebarTooltipArrowUp(_param) {
    var color = _param.color, borderColor = _param.borderColor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "borderColor"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        css: {
            position: "absolute",
            top: -20,
            "&::before, &::after": {
                position: "absolute",
                border: "1px solid transparent",
                content: " ",
                height: 0,
                width: 0,
                pointerEvents: "none",
                borderColor: "rgba(255, 255, 255, 0)",
                borderBottomColor: "#ffffff"
            },
            ":after": {
                borderColor: "transparent",
                borderBottomColor: color,
                marginLeft: -11,
                borderWidth: 11
            },
            ":before": {
                borderColor: "transparent",
                borderBottomColor: borderColor,
                borderWidth: 10,
                marginLeft: -10
            }
        }
    }));
};
SidebarTooltipArrowUp.propTypes = {
    width: (prop_types_default()).number.isRequired,
    color: (prop_types_default()).string.isRequired,
    borderColor: (prop_types_default()).string.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/SidebarTray.js



function SidebarTray(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            display: "inline-flex",
            flexDirection: "row",
            alignItems: "center",
            width: "auto",
            height: 40
        },
        children: children
    });
};
SidebarTray.propTypes = {
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/TypeformInput.js






function TypeformInput_handleKeyDown(value, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && value) {
            event.preventDefault();
            var parser = new DOMParser();
            var code = parser.parseFromString(value, "text/html");
            var div = code.querySelector("div.typeform-widget[data-url]");
            if (!div) {
                return;
            }
            var src = div.getAttribute("data-url");
            if (!src.includes("typeform.com/to")) {
                return;
            }
            onInsert(src);
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}
function TypeformInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 200
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: "",
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                ref: innerRef,
                                value: value,
                                placeholder: "What's the embed code?",
                                spellCheck: false,
                                css: {
                                    border: "none",
                                    outline: "none",
                                    backgroundColor: "transparent",
                                    padding: 10,
                                    width: "100%",
                                    height: "100%",
                                    color: palette_text,
                                    "&::placeholder": {
                                        color: sealBlue
                                    }
                                },
                                onChange: function(event) {
                                    return set(event.target.value);
                                },
                                onKeyDown: TypeformInput_handleKeyDown(value, onInsert, onCancel),
                                onMouseDown: function(event) {
                                    return event.preventDefault();
                                }
                            })
                        });
                    }
                });
            }
        })
    });
};
TypeformInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/SimplecastInput.js






function SimplecastInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 200
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: "",
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                ref: innerRef,
                                value: value,
                                placeholder: "What's the embed code?",
                                spellCheck: false,
                                css: {
                                    width: "100%",
                                    height: "100%",
                                    padding: 10,
                                    color: palette_text,
                                    backgroundColor: "transparent",
                                    border: "none",
                                    outline: "none",
                                    "&::placeholder": {
                                        color: sealBlue
                                    }
                                },
                                onChange: function(event) {
                                    return set(event.target.value);
                                },
                                onKeyDown: SimplecastInput_handleKeyDown(value, onInsert, onCancel),
                                onMouseDown: function(event) {
                                    return event.preventDefault();
                                }
                            })
                        });
                    }
                });
            }
        })
    });
};
SimplecastInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};
function SimplecastInput_handleKeyDown(value, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && value) {
            event.preventDefault();
            var parser = new DOMParser();
            var code = parser.parseFromString(value, "text/html");
            var iframe = code.querySelector("iframe");
            if (!iframe) {
                return;
            }
            var iframeSrc = iframe.getAttribute("src");
            if (!iframeSrc.includes("player.simplecast.com")) {
                return;
            }
            onInsert({
                src: iframeSrc,
                height: parseFloat(iframe.getAttribute("height")) || 200
            });
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/YoutubeInput.js







/**
 * @param   {String}   currentValue
 * @param   {Function} onInsert
 * @param   {Function} onCancel
 * @returns {Function}
 */ function YoutubeInput_handleKeyDown(currentValue, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && currentValue) {
            event.preventDefault();
            var videoId = getYoutubeId(currentValue);
            if (videoId) {
                onInsert({
                    videoId: videoId,
                    videoUrl: currentValue
                });
            }
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}
function YoutubeInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 200
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            ref: innerRef,
                            value: value,
                            placeholder: "What's the YouTube address?",
                            spellCheck: false,
                            css: {
                                border: "none",
                                outline: "none",
                                backgroundColor: "transparent",
                                padding: 10,
                                width: "100%",
                                height: "100%",
                                color: palette_text,
                                "&::placeholder": {
                                    color: sealBlue
                                }
                            },
                            onChange: function(event) {
                                return set(event.target.value);
                            },
                            onKeyDown: YoutubeInput_handleKeyDown(value, onInsert, onCancel),
                            onMouseDown: function(event) {
                                return event.preventDefault();
                            }
                        });
                    }
                });
            }
        })
    });
};
YoutubeInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/AirtableInput.js






function AirtableInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 200
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: "",
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                ref: innerRef,
                                value: value,
                                placeholder: "What's the embed code?",
                                spellCheck: false,
                                css: {
                                    border: "none",
                                    outline: "none",
                                    backgroundColor: "transparent",
                                    padding: 10,
                                    width: "100%",
                                    height: "100%",
                                    color: palette_text,
                                    "&::placeholder": {
                                        color: sealBlue
                                    }
                                },
                                onChange: function(event) {
                                    return set(event.target.value);
                                },
                                onKeyDown: AirtableInput_handleKeyDown(value, onInsert, onCancel),
                                onMouseDown: function(event) {
                                    return event.preventDefault();
                                }
                            })
                        });
                    }
                });
            }
        })
    });
};
AirtableInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};
function AirtableInput_handleKeyDown(value, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && value) {
            event.preventDefault();
            var parser = new DOMParser();
            var code = parser.parseFromString(value, "text/html");
            var iframe = code.querySelector("iframe[src]");
            if (!iframe) {
                return;
            }
            var src = iframe.getAttribute("src");
            var width = iframe.getAttribute("width");
            var height = iframe.getAttribute("height");
            if (!src.includes("airtable.com/embed")) {
                return;
            }
            onInsert({
                src: src,
                width: parseSize(width),
                height: parseSize(height)
            });
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}
function parseSize(size) {
    if (!size) {
        return null;
    } else if (!/^([\d]+)$/.test(size)) {
        return size;
    } else {
        var parsed = parseInt(size, 10);
        return isNaN(parsed) ? null : parsed;
    }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/index.js











;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/GoogleFormsInput.js






function GoogleFormsInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 200
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: "",
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                ref: innerRef,
                                value: value,
                                placeholder: "What's the embed code?",
                                spellCheck: false,
                                css: {
                                    border: "none",
                                    outline: "none",
                                    backgroundColor: "transparent",
                                    padding: 10,
                                    width: "100%",
                                    height: "100%",
                                    color: palette_text,
                                    "&::placeholder": {
                                        color: sealBlue
                                    }
                                },
                                onChange: function(event) {
                                    return set(event.target.value);
                                },
                                onKeyDown: GoogleFormsInput_handleKeyDown(value, onInsert, onCancel),
                                onMouseDown: function(event) {
                                    return event.preventDefault();
                                }
                            })
                        });
                    }
                });
            }
        })
    });
};
GoogleFormsInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};
function GoogleFormsInput_handleKeyDown(value, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && value) {
            event.preventDefault();
            var parser = new DOMParser();
            var code = parser.parseFromString(value, "text/html");
            var iframe = code.querySelector("iframe[src]");
            if (!iframe) {
                return;
            }
            var src = iframe.getAttribute("src");
            var width = parseInt(iframe.getAttribute("width"), 10);
            var height = parseInt(iframe.getAttribute("height"), 10);
            if (!src.includes("docs.google.com/forms") && !src.includes("/viewform")) {
                return;
            }
            onInsert({
                src: src,
                width: isNaN(width) ? null : width,
                height: isNaN(height) ? null : height
            });
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/NewsletterInput.js




function NewsletterInput(param) {
    var onInsert = param.onInsert;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
            onSubmit: function(event) {
                event.preventDefault();
                event.stopPropagation();
                onInsert({
                    callText: event.target.elements.callText.value || "",
                    buttonText: event.target.elements.buttonText.value || ""
                });
            },
            css: {
                width: 300,
                padding: 8,
                display: "grid",
                gridRowGap: 8
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Call text"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "text",
                            name: "callText",
                            defaultValue: "Subscribe to get the latest updates every week \uD83D\uDE80",
                            css: {
                                margin: 0,
                                padding: 8,
                                border: "solid 1px ".concat(sealBlue),
                                borderRadius: 2
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button text"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "text",
                            name: "buttonText",
                            defaultValue: "Subscribe",
                            css: {
                                margin: 0,
                                padding: 8,
                                border: "solid 1px ".concat(sealBlue),
                                borderRadius: 2
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "submit",
                    css: {
                        margin: 0,
                        padding: 8,
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer"
                    },
                    children: "Insert"
                })
            ]
        })
    });
};
NewsletterInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/CustomButtonInput.js




function CustomButtonInput(param) {
    var onInsert = param.onInsert;
    var ref = (0,react.useState)(""), buttonText = ref[0], setButtonText = ref[1];
    var ref1 = (0,react.useState)(false), buttonTextTouched = ref1[0], setButtonTextTouched = ref1[1];
    var ref2 = (0,react.useState)(""), buttonURL = ref2[0], setButtonURL = ref2[1];
    var ref3 = (0,react.useState)(false), buttonURLTouched = ref3[0], setButtonURLTouched = ref3[1];
    var ref4 = (0,react.useState)("#086BE5"), buttonColor = ref4[0], setButtonColor = ref4[1];
    var ref5 = (0,react.useState)("#FFFFFF"), buttonTextColor = ref5[0], setButtonTextColor = ref5[1];
    var ref6 = (0,react.useState)("#086BE5"), buttonBorderColor = ref6[0], setButtonBorderColor = ref6[1];
    var ref7 = (0,react.useState)(), buttonWidth = ref7[0], setButtonWidth = ref7[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
            onSubmit: function(event) {
                event.preventDefault();
                event.stopPropagation();
                onInsert({
                    buttonText: buttonText,
                    buttonURL: buttonURL,
                    buttonColor: buttonColor,
                    buttonTextColor: buttonTextColor,
                    buttonBorderColor: buttonBorderColor || buttonColor,
                    buttonWidth: buttonWidth,
                    buttonTargetBlank: event.target.elements.targetBlank.checked
                });
            },
            css: {
                width: 300,
                padding: 8,
                display: "grid",
                gridRowGap: 8
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button text"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "text",
                            name: "buttonText",
                            placeholder: "Insert Button text",
                            value: buttonText,
                            onChange: function(e) {
                                setButtonText(e.target.value);
                                setButtonTextTouched(true);
                            },
                            css: {
                                margin: 0,
                                padding: 8,
                                border: "solid 1px",
                                borderColor: buttonTextTouched && !validateText(buttonText) ? red : sealBlue,
                                borderRadius: 2
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "URL"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "text",
                            name: "buttonURL",
                            value: buttonURL,
                            onChange: function(e) {
                                setButtonURL(e.target.value);
                                setButtonURLTouched(true);
                            },
                            placeholder: "Insert Button URL",
                            css: {
                                margin: 0,
                                padding: 8,
                                border: "solid 1px",
                                borderColor: buttonURLTouched && !validateUrl(buttonURL) ? red : sealBlue,
                                borderRadius: 2
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button color"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "color",
                                    value: buttonColor,
                                    onChange: function(e) {
                                        setButtonColor(e.target.value);
                                    },
                                    css: {
                                        height: 30,
                                        width: 60,
                                        border: "solid 1px",
                                        borderColor: validateColor(buttonColor) ? sealBlue : red
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "text",
                                    value: buttonColor,
                                    onChange: function(e) {
                                        var color = e.target.value;
                                        setButtonColor(color);
                                    },
                                    css: {
                                        margin: 0,
                                        padding: 8,
                                        border: "solid 1px",
                                        borderColor: validateColor(buttonColor) ? sealBlue : red,
                                        borderRadius: 2,
                                        height: 30,
                                        width: 220,
                                        marginLeft: 5
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button Text color"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "color",
                                    value: buttonTextColor,
                                    onChange: function(e) {
                                        setButtonTextColor(e.target.value);
                                    },
                                    css: {
                                        height: 30,
                                        width: 60,
                                        border: "solid 1px",
                                        borderColor: validateColor(buttonTextColor) ? sealBlue : red
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "text",
                                    value: buttonTextColor,
                                    onChange: function(e) {
                                        var color = e.target.value;
                                        setButtonTextColor(color);
                                    },
                                    css: {
                                        margin: 0,
                                        padding: 8,
                                        border: "solid 1px",
                                        borderColor: validateColor(buttonTextColor) ? sealBlue : red,
                                        borderRadius: 2,
                                        height: 30,
                                        width: 220,
                                        marginLeft: 5
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button Border color"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "color",
                                    value: buttonBorderColor,
                                    onChange: function(e) {
                                        setButtonBorderColor(e.target.value);
                                    },
                                    css: {
                                        height: 30,
                                        width: 60,
                                        border: "solid 1px",
                                        borderColor: validateColor(buttonBorderColor) ? sealBlue : red
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "text",
                                    value: buttonBorderColor,
                                    onChange: function(e) {
                                        var color = e.target.value;
                                        setButtonBorderColor(color);
                                    },
                                    css: {
                                        margin: 0,
                                        padding: 8,
                                        border: "solid 1px",
                                        borderColor: validateColor(buttonBorderColor) ? sealBlue : red,
                                        borderRadius: 2,
                                        height: 30,
                                        width: 220,
                                        marginLeft: 5
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button Width (%)"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "text",
                            placeholder: "Insert Button Width",
                            value: buttonWidth,
                            onChange: function(e) {
                                setButtonWidth(e.target.value);
                            },
                            css: {
                                margin: 0,
                                padding: 8,
                                border: "solid 1px",
                                borderColor: validateButtonWidth(buttonWidth) ? sealBlue : red,
                                borderRadius: 2
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: 'Target: "_blank"'
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "checkbox",
                            name: "targetBlank",
                            defaultChecked: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "submit",
                    disabled: !validateForm(buttonText, buttonURL, buttonColor, buttonTextColor, buttonBorderColor, buttonWidth),
                    css: {
                        margin: 0,
                        padding: 8,
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer"
                    },
                    children: "Insert"
                })
            ]
        })
    });
};
CustomButtonInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired
};
function validateForm(buttonText, buttonURL, buttonColor, buttonTextColor, buttonBorderColor, buttonWidth) {
    return validateText(buttonText) && validateUrl(buttonURL) && validateColor(buttonColor) && validateColor(buttonTextColor) && validateColor(buttonBorderColor) && validateButtonWidth(buttonWidth);
}
function validateColor(color) {
    return /^#[0-9a-f]{6}$/gi.test(color);
}
function validateText(inputValue) {
    return inputValue && inputValue.length > 0;
}
function validateUrl(url) {
    return /^(?:(http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}/gi.test(url) || /^\/.*/gi.test(url);
}
function validateButtonWidth(width) {
    if (typeof width === "undefined" || width === null || width.length === 0) {
        return true;
    }
    var parsedWidth = parseFloat(width);
    return !isNaN(parsedWidth) && parsedWidth > 0 && parsedWidth <= 100;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/Filestack.js





var API_KEY = "Aqw4lvamTSKiw8gSzioEKz";
var FILESTACK_CONTAINER_ID = "STORY_EDITOR_FILESTACK_CONTAINER_ID";
function Filestack(_param) {
    var onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onChange"
    ]);
    if (true) {
        var FilestackReact = (__webpack_require__(11381)["default"]);
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilestackReact, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            apikey: API_KEY
        }, props), {
            onSuccess: function(param) {
                var filesUploaded = param.filesUploaded;
                if (filesUploaded.length > 0) {
                    onChange(filesUploaded[0].url);
                }
            },
            actionOptions: {
                displayMode: "dropPane",
                container: FILESTACK_CONTAINER_ID,
                customText: {
                    "Drag and Drop, Copy and Paste Files": "Click or Drag & Drop"
                }
            },
            componentDisplayMode: {
                type: "immediate"
            }
        }));
    }
    return null;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/sidebar/ImageInput.js






function ImageInput(param) {
    var onChange = param.onChange, initialValues = param.initialValues, saveButtonText = param.saveButtonText;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 300
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: {
                        url: initialValues ? initialValues.url || "" : "",
                        alt: initialValues ? initialValues.alt || "" : ""
                    },
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                width: "100%",
                                padding: 16,
                                background: "#eeeeee"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        minHeight: "120px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        value && value.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                position: "relative"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                                    src: value.url,
                                                    css: {
                                                        width: "100%",
                                                        borderRadius: 5,
                                                        objectFit: "cover"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        position: "absolute",
                                                        top: -4,
                                                        right: -4,
                                                        width: 28,
                                                        height: 28,
                                                        borderRadius: 25,
                                                        background: "#FE786C",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: 600,
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            top: -4,
                                                            right: -4,
                                                            background: "#FE5F51"
                                                        }
                                                    },
                                                    onClick: function() {
                                                        set({
                                                            url: "",
                                                            alt: value.alt
                                                        });
                                                    },
                                                    children: "X"
                                                })
                                            ]
                                        }),
                                        !value.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            id: FILESTACK_CONTAINER_ID,
                                            css: {
                                                width: "100%",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filestack, {
                                                onChange: function(url) {
                                                    set({
                                                        url: url,
                                                        alt: value.alt
                                                    });
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                        css: {
                                            color: sealBlue
                                        },
                                        children: "Image url"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 4
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                        ref: innerRef,
                                        value: value.url,
                                        placeholder: "Type image url...",
                                        spellCheck: false,
                                        css: {
                                            border: "1px solid ".concat(lightGray),
                                            borderRadius: 2,
                                            outline: "none",
                                            backgroundColor: "white",
                                            padding: 4,
                                            color: palette_text,
                                            width: "100%"
                                        },
                                        onChange: function(event) {
                                            return set({
                                                url: event.target.value,
                                                alt: value.alt
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                        css: {
                                            color: sealBlue
                                        },
                                        children: "Image alt text"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 4
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                        value: value.alt,
                                        placeholder: "Type image alt text...",
                                        spellCheck: false,
                                        css: {
                                            border: "1px solid ".concat(lightGray),
                                            borderRadius: 2,
                                            outline: "none",
                                            backgroundColor: "white",
                                            padding: 4,
                                            color: palette_text,
                                            width: "100%"
                                        },
                                        onChange: function(event) {
                                            return set({
                                                url: value.url,
                                                alt: event.target.value
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                        type: "button",
                                        disabled: !value.url || !value.alt,
                                        css: {
                                            outline: "none",
                                            borderRadius: 4,
                                            cursor: !value.url || !value.alt ? "default" : "pointer",
                                            pointerEvents: !value.url || !value.alt ? "none" : "all",
                                            border: "solid 1px transparent",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: 12,
                                            height: 30,
                                            padding: "0 20px",
                                            backgroundColor: !value.url || !value.alt ? lightGray : primary,
                                            color: "#ffffff",
                                            "&:hover:not(:focus)": {
                                                opacity: 0.8
                                            }
                                        },
                                        onClick: function() {
                                            return onChange(value.url, value.alt);
                                        },
                                        children: saveButtonText || "Add Image"
                                    })
                                })
                            ]
                        });
                    }
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/StandardSidebarTray.js
















function StandardSidebarTray(param) {
    var editorState = param.editorState, onChange = param.onChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
        initial: null,
        children: function(param) {
            var value = param.value, set = param.set;
            var toggle = function(type) {
                return function() {
                    return set(value === type ? null : type);
                };
            };
            var cancel = function() {
                return set(null);
            };
            if (value === src_AtomicBlockIdentifiers.IMAGE) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageInput, {
                    onChange: function(url, alt) {
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.IMAGE, {
                            imageUrl: url,
                            imageAlt: alt
                        }));
                    }
                });
            } else if (value === src_AtomicBlockIdentifiers.YOUTUBE_VIDEO) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarTray, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YoutubeInput, {
                        onCancel: cancel,
                        onInsert: function(param) {
                            var videoId = param.videoId, videoUrl = param.videoUrl;
                            onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.YOUTUBE_VIDEO, {
                                videoId: videoId,
                                videoUrl: videoUrl
                            }));
                        }
                    })
                });
            } else if (value === src_AtomicBlockIdentifiers.GOOGLE_SPREADSHEET) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleSpreadsheetsInput, {
                    onCancel: cancel,
                    onInsert: function(src) {
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.GOOGLE_SPREADSHEET, {
                            src: src,
                            displayHeaders: true
                        }));
                    }
                });
            } else if (value === src_AtomicBlockIdentifiers.GOOGLE_FORMS) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleFormsInput, {
                    onCancel: cancel,
                    onInsert: function(blockData) {
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.GOOGLE_FORMS, blockData));
                    }
                });
            } else if (value === src_AtomicBlockIdentifiers.TYPEFORM) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypeformInput, {
                    onCancel: cancel,
                    onInsert: function(src) {
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.TYPEFORM, {
                            src: src
                        }));
                    }
                });
            } else if (value === src_AtomicBlockIdentifiers.SIMPLECAST) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimplecastInput, {
                    onCancel: cancel,
                    onInsert: function(param) {
                        var src = param.src, height = param.height;
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.SIMPLECAST, {
                            src: src,
                            height: height
                        }));
                    }
                });
            } else if (value === src_AtomicBlockIdentifiers.AIRTABLE) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AirtableInput, {
                    onCancel: cancel,
                    onInsert: function(blockData) {
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.AIRTABLE, blockData));
                    }
                });
            } else if (value === src_AtomicBlockIdentifiers.SOCIAL_MEDIAS) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaInput, {
                    onCancel: cancel,
                    onInsert: function(blockData) {
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.SOCIAL_MEDIAS, blockData));
                    }
                });
            } else if (value === src_AtomicBlockIdentifiers.NEWSLETTER) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterInput, {
                    onCancel: cancel,
                    onInsert: function(blockData) {
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.NEWSLETTER, blockData));
                    }
                });
            } else if (value === src_AtomicBlockIdentifiers.CUSTOM_BUTTON) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomButtonInput, {
                    onCancel: cancel,
                    onInsert: function(blockData) {
                        onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.CUSTOM_BUTTON, blockData));
                    }
                });
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SidebarTray, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/image")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.IMAGE),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_ImageIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, {
                        onClick: toggle(src_AtomicBlockIdentifiers.YOUTUBE_VIDEO),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_VideoIcon, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/divider")), {
                        onClick: function() {
                            onChange(insertAtomicBlock(editorState, src_AtomicBlockIdentifiers.DIVIDER));
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_DividerIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/airtable")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.AIRTABLE),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AirtableIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/googleSpreadsheet")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.GOOGLE_SPREADSHEET),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SpreadsheetIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/googleForms")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.GOOGLE_FORMS),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleFormsIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/typeform")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.TYPEFORM),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypeformIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/simplecast")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.SIMPLECAST),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimplecastIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/socialMedias")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.SOCIAL_MEDIAS),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/newsletter")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.NEWSLETTER),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterIcon, {})
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("StandardSidebarTray/buttons/customButton")), {
                        onClick: toggle(src_AtomicBlockIdentifiers.CUSTOM_BUTTON),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomButtonIcon, {})
                    }))
                ]
            });
        }
    });
};
StandardSidebarTray.propTypes = {
    onChange: (prop_types_default()).func.isRequired,
    editorState: (prop_types_default()).object.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/VerticalBlockCoordinates.js
/* eslint-disable prefer-destructuring */ 









var VerticalBlockCoordinates = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(VerticalBlockCoordinates, Component);
    var _super = (0,_create_super/* default */.Z)(VerticalBlockCoordinates);
    function VerticalBlockCoordinates() {
        (0,_class_call_check/* default */.Z)(this, VerticalBlockCoordinates);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            top: -9999,
            visible: false
        });
        // @link https://github.com/facebook/draft-js/issues/45#issuecomment-190269630
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "calculateCoordinatesAndSetState", function(editorKey, editorState) {
            var currentContent = editorState.getCurrentContent();
            var currentSelection = editorState.getSelection();
            if (currentSelection.isCollapsed() === false) {
                _this.setState({
                    top: -9999,
                    visible: false
                });
                return;
            }
            var currentBlock = currentContent.getBlockForKey(currentSelection.getStartKey());
            var offsetKey = DraftOffsetKey_default().encode(currentBlock.getKey(), 0, 0);
            var blockNode = document.querySelector('[data-offset-key="'.concat(offsetKey, '"]'));
            var editorNode = document.querySelector('[data-editor="'.concat(editorKey, '"]'));
            if (blockNode === null || editorNode === null) {
                return;
            }
            var clientTop = document.documentElement.clientTop;
            var containerTop = editorNode.getBoundingClientRect().top - clientTop;
            var calculatedTop = blockNode.getBoundingClientRect().top - containerTop;
            var visible = isSelectedBlockEmpty(editorState);
            if (_this.state.top !== calculatedTop || _this.state.visible !== visible) {
                _this.setState({
                    top: calculatedTop,
                    visible: visible
                });
            }
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(VerticalBlockCoordinates, [
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(param) {
                var editorKey = param.editorKey, editorState = param.editorState;
                var _this = this;
                setTimeout(function() {
                    _this.calculateCoordinatesAndSetState(editorKey, editorState);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var _state = this.state, top = _state.top, left = _state.left, visible = _state.visible;
                return children({
                    top: top,
                    left: left,
                    visible: visible
                });
            }
        }
    ]);
    return VerticalBlockCoordinates;
}(react.Component);
(0,_define_property/* default */.Z)(VerticalBlockCoordinates, "propTypes", {
    editorKey: (prop_types_default()).string.isRequired,
    editorState: (prop_types_default()).object.isRequired,
    children: (prop_types_default()).func.isRequired
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/defaults/StandardSideToolbar.js












function StandardSideToolbar(param) {
    var editorKey = param.editorKey, editorState = param.editorState, focusEditor = param.focusEditor, onChange = param.onChange, offsetTop = param.offsetTop, offsetLeft = param.offsetLeft, size = param.size;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalBlockCoordinates, {
        editorKey: editorKey,
        editorState: editorState,
        children: function(param) {
            var top = param.top, visible = param.visible;
            if (visible) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                    children: function(param) {
                        var on = param.on, toggle = param.toggle;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                            isOpen: on,
                            boxStyle: {
                                boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                                borderRadius: 4
                            },
                            onClickOutside: function() {
                                toggle();
                                setTimeout(focusEditor);
                            },
                            render: function() {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardSidebarTray, {
                                        editorState: editorState,
                                        onChange: function(nextState) {
                                            toggle();
                                            onChange(nextState);
                                            setTimeout(focusEditor);
                                        }
                                    })
                                });
                            },
                            children: function(param) {
                                var innerRef = param.innerRef;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SideContentCircle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testId("SideContentCircle/root")), {
                                    size: size,
                                    color: sealBlue,
                                    hoverColor: palette_text,
                                    top: top + offsetTop,
                                    left: 10 + offsetLeft,
                                    visible: visible,
                                    onClick: toggle,
                                    onMouseDown: function(event) {
                                        return event.preventDefault();
                                    },
                                    innerRef: innerRef
                                }));
                            }
                        });
                    }
                });
            }
            return null;
        }
    });
};
StandardSideToolbar.propTypes = {
    editorKey: (prop_types_default()).string.isRequired,
    editorState: (prop_types_default()).object.isRequired,
    focus: (prop_types_default()).bool.isRequired,
    focusEditor: (prop_types_default()).func.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    size: (prop_types_default()).number,
    offsetTop: (prop_types_default()).number,
    offsetLeft: (prop_types_default()).number
};
StandardSideToolbar.defaultProps = {
    size: 20,
    offsetTop: 0,
    offsetLeft: 0
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/utils/getReadTime.js

/**
 * @param   {ContentState} contentState
 * @returns {?String}
 */ function getReadTime(contentState) {
    var wordsCount = 0;
    var imagesCount = 0;
    contentState.getBlocksAsArray().forEach(function(block) {
        if (block.getType() === "atomic" && block.getData().get("blockType") === AtomicBlockIdentifiers.IMAGE) {
            imagesCount += 1;
        } else if (block.getText()) {
            var words = block.getText().split(" ").filter(function(word) {
                return word.trim();
            });
            wordsCount += words.length;
        }
    });
    if (wordsCount > 0 || imagesCount > 0) {
        // 275 words per minute
        var textReadTime = wordsCount / 275 * 60;
        var imagesReadTime = 0;
        for(var i = 0, l = imagesCount; i < l; i += 1){
            imagesReadTime += Math.max(12 - i, 3);
        }
        return Math.round(textReadTime + imagesReadTime);
    }
    return null;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/index.js




























// EXTERNAL MODULE: ./node_modules/.pnpm/is-hotkey@0.2.0/node_modules/is-hotkey/lib/index.js
var lib = __webpack_require__(45869);
// EXTERNAL MODULE: ./node_modules/.pnpm/slate@0.80.0/node_modules/slate/dist/index.es.js
var index_es = __webpack_require__(64133);
// EXTERNAL MODULE: ./node_modules/.pnpm/direction@1.0.4/node_modules/direction/index.js
var direction = __webpack_require__(51842);
var direction_default = /*#__PURE__*/__webpack_require__.n(direction);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./node_modules/.pnpm/compute-scroll-into-view@1.0.17/node_modules/compute-scroll-into-view/dist/index.module.js
var index_module = __webpack_require__(48136);
;// CONCATENATED MODULE: ./node_modules/.pnpm/scroll-into-view-if-needed@2.2.29/node_modules/scroll-into-view-if-needed/es/index.js


function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(isTargetAttached ? (0,index_module/* default */.Z)(target, options) : []);
  }

  if (!isTargetAttached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior((0,index_module/* default */.Z)(target, computeOptions), computeOptions.behavior);
}

/* harmony default export */ var es = (scrollIntoView);
// EXTERNAL MODULE: ./node_modules/.pnpm/is-hotkey@0.1.8/node_modules/is-hotkey/lib/index.js
var is_hotkey_lib = __webpack_require__(55626);
;// CONCATENATED MODULE: ./node_modules/.pnpm/slate-react@0.80.0_dh6jzqz47ecci4oixpoierumse/node_modules/slate-react/dist/index.es.js









function index_es_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var IS_REACT_VERSION_17_OR_ABOVE = parseInt(react.version.split('.')[0], 10) >= 17;
var IS_IOS = typeof navigator !== 'undefined' && typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var IS_APPLE = typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
var IS_ANDROID = typeof navigator !== 'undefined' && /Android/.test(navigator.userAgent);
var IS_FIREFOX = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
var IS_SAFARI = typeof navigator !== 'undefined' && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent); // "modern" Edge was released at 79.x

var IS_EDGE_LEGACY = typeof navigator !== 'undefined' && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent);
var IS_CHROME = typeof navigator !== 'undefined' && /Chrome/i.test(navigator.userAgent); // Native `beforeInput` events don't work well with react on Chrome 75
// and older, Chrome 76+ can use `beforeInput` though.

var IS_CHROME_LEGACY = typeof navigator !== 'undefined' && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent); // Firefox did not support `beforeInput` until `v87`.

var IS_FIREFOX_LEGACY = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent); // qq browser

var IS_QQBROWSER = typeof navigator !== 'undefined' && /.*QQBrowser/.test(navigator.userAgent); // UC mobile browser

var IS_UC_MOBILE = typeof navigator !== 'undefined' && /.*UCBrowser/.test(navigator.userAgent); // Wechat browser

var IS_WECHATBROWSER = typeof navigator !== 'undefined' && /.*Wechat/.test(navigator.userAgent); // Check if DOM is available as React does internally.
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js

var CAN_USE_DOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined'); // COMPAT: Firefox/Edge Legacy don't support the `beforeinput` event
// Chrome Legacy doesn't support `beforeinput` correctly

var HAS_BEFORE_INPUT_SUPPORT = !IS_CHROME_LEGACY && !IS_EDGE_LEGACY && // globalThis is undefined in older browsers
typeof globalThis !== 'undefined' && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
typeof globalThis.InputEvent.prototype.getTargetRanges === 'function';

/**
 * Prevent warning on SSR by falling back to useEffect when DOM isn't available
 */

var useIsomorphicLayoutEffect = CAN_USE_DOM ? react.useLayoutEffect : react.useEffect;

/**
 * Leaf content strings.
 */

var index_es_String = props => {
  var {
    isLast,
    leaf,
    parent,
    text
  } = props;
  var editor = useSlateStatic();
  var path = ReactEditor.findPath(editor, text);
  var parentPath = index_es/* Path.parent */.y$.parent(path); // COMPAT: Render text inside void nodes with a zero-width space.
  // So the node can contain selection but the text is not visible.

  if (editor.isVoid(parent)) {
    return /*#__PURE__*/react.createElement(ZeroWidthString, {
      length: index_es/* Node.string */.NB.string(parent).length
    });
  } // COMPAT: If this is the last text node in an empty block, render a zero-
  // width space that will convert into a line break when copying and pasting
  // to support expected plain text.


  if (leaf.text === '' && parent.children[parent.children.length - 1] === text && !editor.isInline(parent) && index_es/* Editor.string */.ML.string(editor, parentPath) === '') {
    return /*#__PURE__*/react.createElement(ZeroWidthString, {
      isLineBreak: true
    });
  } // COMPAT: If the text is empty, it's because it's on the edge of an inline
  // node, so we render a zero-width space so that the selection can be
  // inserted next to it still.


  if (leaf.text === '') {
    return /*#__PURE__*/react.createElement(ZeroWidthString, null);
  } // COMPAT: Browsers will collapse trailing new lines at the end of blocks,
  // so we need to add an extra trailing new lines to prevent that.


  if (isLast && leaf.text.slice(-1) === '\n') {
    return /*#__PURE__*/react.createElement(TextString, {
      isTrailing: true,
      text: leaf.text
    });
  }

  return /*#__PURE__*/react.createElement(TextString, {
    text: leaf.text
  });
};
/**
 * Leaf strings with text in them.
 */


var TextString = props => {
  var {
    text,
    isTrailing = false
  } = props;
  var ref = (0,react.useRef)(null);

  var getTextContent = () => {
    return "".concat(text !== null && text !== void 0 ? text : '').concat(isTrailing ? '\n' : '');
  }; // This is the actual text rendering boundary where we interface with the DOM
  // The text is not rendered as part of the virtual DOM, as since we handle basic character insertions natively,
  // updating the DOM is not a one way dataflow anymore. What we need here is not reconciliation and diffing
  // with previous version of the virtual DOM, but rather diffing with the actual DOM element, and replace the DOM <span> content
  // exactly if and only if its current content does not match our current virtual DOM.
  // Otherwise the DOM TextNode would always be replaced by React as the user types, which interferes with native text features,
  // eg makes native spellcheck opt out from checking the text node.
  // useLayoutEffect: updating our span before browser paint


  useIsomorphicLayoutEffect(() => {
    // null coalescing text to make sure we're not outputing "null" as a string in the extreme case it is nullish at runtime
    var textWithTrailing = getTextContent();

    if (ref.current && ref.current.textContent !== textWithTrailing) {
      ref.current.textContent = textWithTrailing;
    } // intentionally not specifying dependencies, so that this effect runs on every render
    // as this effectively replaces "specifying the text in the virtual DOM under the <span> below" on each render

  }); // Render text content immediately if it's the first-time render
  // Ensure that text content is rendered on server-side rendering

  if (!ref.current) {
    return /*#__PURE__*/react.createElement("span", {
      "data-slate-string": true,
      ref: ref
    }, getTextContent());
  } // the span is intentionally same on every render in virtual DOM, actual rendering happens in the layout effect above


  return /*#__PURE__*/react.createElement("span", {
    "data-slate-string": true,
    ref: ref
  });
};
/**
 * Leaf strings without text, render as zero-width strings.
 */


var ZeroWidthString = props => {
  var {
    length = 0,
    isLineBreak = false
  } = props;
  return /*#__PURE__*/react.createElement("span", {
    "data-slate-zero-width": isLineBreak ? 'n' : 'z',
    "data-slate-length": length
  }, '\uFEFF', isLineBreak ? /*#__PURE__*/react.createElement("br", null) : null);
};

/**
 * Two weak maps that allow us rebuild a path given a node. They are populated
 * at render time such that after a render occurs we can always backtrack.
 */
var NODE_TO_INDEX = new WeakMap();
var NODE_TO_PARENT = new WeakMap();
/**
 * Weak maps that allow us to go between Slate nodes and DOM nodes. These
 * are used to resolve DOM event-related logic into Slate actions.
 */

var EDITOR_TO_WINDOW = new WeakMap();
var EDITOR_TO_ELEMENT = new WeakMap();
var ELEMENT_TO_NODE = new WeakMap();
var NODE_TO_ELEMENT = new WeakMap();
var NODE_TO_KEY = new WeakMap();
var EDITOR_TO_KEY_TO_ELEMENT = new WeakMap();
/**
 * Weak maps for storing editor-related state.
 */

var IS_READ_ONLY = new WeakMap();
var IS_FOCUSED = new WeakMap();
var IS_COMPOSING = new WeakMap();
var IS_ON_COMPOSITION_END = new WeakMap();
var EDITOR_TO_USER_SELECTION = new WeakMap();
/**
 * Weak maps for saving text on composition stage.
 */

var EDITOR_ON_COMPOSITION_TEXT = new WeakMap();
/**
 * Weak map for associating the context `onChange` context with the plugin.
 */

var EDITOR_TO_ON_CHANGE = new WeakMap();
var NODE_TO_RESTORE_DOM = new WeakMap();
/**
 * Symbols.
 */

var PLACEHOLDER_SYMBOL = Symbol('placeholder');

/**
 * Individual leaves in a text node with unique formatting.
 */

var Leaf = props => {
  var {
    leaf,
    isLast,
    text,
    parent,
    renderPlaceholder,
    renderLeaf = props => /*#__PURE__*/react.createElement(DefaultLeaf, Object.assign({}, props))
  } = props;
  var placeholderRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    var placeholderEl = placeholderRef === null || placeholderRef === void 0 ? void 0 : placeholderRef.current;
    var editorEl = document.querySelector('[data-slate-editor="true"]');

    if (!placeholderEl || !editorEl) {
      return;
    }

    editorEl.style.minHeight = "".concat(placeholderEl.clientHeight, "px");
    return () => {
      editorEl.style.minHeight = 'auto';
    };
  }, [placeholderRef, leaf]);
  var children = /*#__PURE__*/react.createElement(index_es_String, {
    isLast: isLast,
    leaf: leaf,
    parent: parent,
    text: text
  });

  if (leaf[PLACEHOLDER_SYMBOL]) {
    var placeholderProps = {
      children: leaf.placeholder,
      attributes: {
        'data-slate-placeholder': true,
        style: {
          position: 'absolute',
          pointerEvents: 'none',
          width: '100%',
          maxWidth: '100%',
          display: 'block',
          opacity: '0.333',
          userSelect: 'none',
          textDecoration: 'none'
        },
        contentEditable: false,
        ref: placeholderRef
      }
    };
    children = /*#__PURE__*/react.createElement(react.Fragment, null, renderPlaceholder(placeholderProps), children);
  } // COMPAT: Having the `data-` attributes on these leaf elements ensures that
  // in certain misbehaving browsers they aren't weirdly cloned/destroyed by
  // contenteditable behaviors. (2019/05/08)


  var attributes = {
    'data-slate-leaf': true
  };
  return renderLeaf({
    attributes,
    children,
    leaf,
    text
  });
};

var MemoizedLeaf = /*#__PURE__*/react.memo(Leaf, (prev, next) => {
  return next.parent === prev.parent && next.isLast === prev.isLast && next.renderLeaf === prev.renderLeaf && next.renderPlaceholder === prev.renderPlaceholder && next.text === prev.text && index_es/* Text.equals */.xv.equals(next.leaf, prev.leaf) && next.leaf[PLACEHOLDER_SYMBOL] === prev.leaf[PLACEHOLDER_SYMBOL];
});
var DefaultLeaf = props => {
  var {
    attributes,
    children
  } = props;
  return /*#__PURE__*/react.createElement("span", Object.assign({}, attributes), children);
};

var _excluded$3 = ["anchor", "focus"],
    _excluded2 = ["anchor", "focus"];
var shallowCompare = (obj1, obj2) => Object.keys(obj1).length === Object.keys(obj2).length && Object.keys(obj1).every(key => obj2.hasOwnProperty(key) && obj1[key] === obj2[key]);
/**
 * Check if a list of decorator ranges are equal to another.
 *
 * PERF: this requires the two lists to also have the ranges inside them in the
 * same order, but this is an okay constraint for us since decorations are
 * kept in order, and the odd case where they aren't is okay to re-render for.
 */

var isDecoratorRangeListEqual = (list, another) => {
  if (list.length !== another.length) {
    return false;
  }

  for (var i = 0; i < list.length; i++) {
    var range = list[i];
    var other = another[i];

    var rangeOwnProps = _objectWithoutProperties(range, _excluded$3);

    var otherOwnProps = _objectWithoutProperties(other, _excluded2);

    if (!index_es/* Range.equals */.e6.equals(range, other) || range[PLACEHOLDER_SYMBOL] !== other[PLACEHOLDER_SYMBOL] || !shallowCompare(rangeOwnProps, otherOwnProps)) {
      return false;
    }
  }

  return true;
};

function useContentKey(node) {
  var contentKeyRef = (0,react.useRef)(0);
  var updateAnimationFrameRef = (0,react.useRef)(null);
  var [, setForceRerenderCounter] = (0,react.useState)(0);
  (0,react.useEffect)(() => {
    NODE_TO_RESTORE_DOM.set(node, () => {
      // Update is already queued and node hasn't re-render yet
      if (updateAnimationFrameRef.current) {
        return;
      }

      updateAnimationFrameRef.current = requestAnimationFrame(() => {
        setForceRerenderCounter(state => state + 1);
        updateAnimationFrameRef.current = null;
      });
      contentKeyRef.current++;
    });
    return () => {
      NODE_TO_RESTORE_DOM.delete(node);
    };
  }, [node]); // Node was restored => clear scheduled update

  if (updateAnimationFrameRef.current) {
    cancelAnimationFrame(updateAnimationFrameRef.current);
    updateAnimationFrameRef.current = null;
  }

  return contentKeyRef.current;
}

/**
 * Text.
 */

var Text = props => {
  var {
    decorations,
    isLast,
    parent,
    renderPlaceholder,
    renderLeaf,
    text
  } = props;
  var editor = useSlateStatic();
  var ref = (0,react.useRef)(null);
  var leaves = index_es/* Text.decorations */.xv.decorations(text, decorations);
  var key = ReactEditor.findKey(editor, text);
  var children = [];

  for (var i = 0; i < leaves.length; i++) {
    var leaf = leaves[i];
    children.push( /*#__PURE__*/react.createElement(MemoizedLeaf, {
      isLast: isLast && i === leaves.length - 1,
      key: "".concat(key.id, "-").concat(i),
      renderPlaceholder: renderPlaceholder,
      leaf: leaf,
      text: text,
      parent: parent,
      renderLeaf: renderLeaf
    }));
  } // Update element-related weak maps with the DOM element ref.


  useIsomorphicLayoutEffect(() => {
    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);

    if (ref.current) {
      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.set(key, ref.current);
      NODE_TO_ELEMENT.set(text, ref.current);
      ELEMENT_TO_NODE.set(ref.current, text);
    } else {
      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.delete(key);
      NODE_TO_ELEMENT.delete(text);
    }
  });
  var contentKey = IS_ANDROID ? useContentKey(text) : undefined;
  return /*#__PURE__*/react.createElement("span", {
    "data-slate-node": "text",
    ref: ref,
    key: contentKey
  }, children);
};

var MemoizedText = /*#__PURE__*/react.memo(Text, (prev, next) => {
  return next.parent === prev.parent && next.isLast === prev.isLast && next.renderLeaf === prev.renderLeaf && next.text === prev.text && isDecoratorRangeListEqual(next.decorations, prev.decorations);
});

/**
 * Element.
 */

var Element = props => {
  var {
    decorations,
    element,
    renderElement = p => /*#__PURE__*/react.createElement(DefaultElement, Object.assign({}, p)),
    renderPlaceholder,
    renderLeaf,
    selection
  } = props;
  var ref = (0,react.useRef)(null);
  var editor = useSlateStatic();
  var readOnly = useReadOnly();
  var isInline = editor.isInline(element);
  var key = ReactEditor.findKey(editor, element);
  var children = useChildren({
    decorations,
    node: element,
    renderElement,
    renderPlaceholder,
    renderLeaf,
    selection
  }); // Attributes that the developer must mix into the element in their
  // custom node renderer component.

  var attributes = {
    'data-slate-node': 'element',
    ref
  };

  if (isInline) {
    attributes['data-slate-inline'] = true;
  } // If it's a block node with inline children, add the proper `dir` attribute
  // for text direction.


  if (!isInline && index_es/* Editor.hasInlines */.ML.hasInlines(editor, element)) {
    var text = index_es/* Node.string */.NB.string(element);
    var dir = direction_default()(text);

    if (dir === 'rtl') {
      attributes.dir = dir;
    }
  } // If it's a void node, wrap the children in extra void-specific elements.


  if (index_es/* Editor.isVoid */.ML.isVoid(editor, element)) {
    attributes['data-slate-void'] = true;

    if (!readOnly && isInline) {
      attributes.contentEditable = false;
    }

    var Tag = isInline ? 'span' : 'div';
    var [[_text]] = index_es/* Node.texts */.NB.texts(element);
    children = /*#__PURE__*/react.createElement(Tag, {
      "data-slate-spacer": true,
      style: {
        height: '0',
        color: 'transparent',
        outline: 'none',
        position: 'absolute'
      }
    }, /*#__PURE__*/react.createElement(MemoizedText, {
      renderPlaceholder: renderPlaceholder,
      decorations: [],
      isLast: false,
      parent: element,
      text: _text
    }));
    NODE_TO_INDEX.set(_text, 0);
    NODE_TO_PARENT.set(_text, element);
  } // Update element-related weak maps with the DOM element ref.


  useIsomorphicLayoutEffect(() => {
    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);

    if (ref.current) {
      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.set(key, ref.current);
      NODE_TO_ELEMENT.set(element, ref.current);
      ELEMENT_TO_NODE.set(ref.current, element);
    } else {
      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.delete(key);
      NODE_TO_ELEMENT.delete(element);
    }
  });
  var content = renderElement({
    attributes,
    children,
    element
  });

  if (IS_ANDROID) {
    var contentKey = useContentKey(element);
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: contentKey
    }, content);
  }

  return content;
};

var MemoizedElement = /*#__PURE__*/react.memo(Element, (prev, next) => {
  return prev.element === next.element && prev.renderElement === next.renderElement && prev.renderLeaf === next.renderLeaf && isDecoratorRangeListEqual(prev.decorations, next.decorations) && (prev.selection === next.selection || !!prev.selection && !!next.selection && index_es/* Range.equals */.e6.equals(prev.selection, next.selection));
});
/**
 * The default element renderer.
 */

var DefaultElement = props => {
  var {
    attributes,
    children,
    element
  } = props;
  var editor = useSlateStatic();
  var Tag = editor.isInline(element) ? 'span' : 'div';
  return /*#__PURE__*/react.createElement(Tag, Object.assign({}, attributes, {
    style: {
      position: 'relative'
    }
  }), children);
};

/**
 * A React context for sharing the editor object.
 */

var EditorContext = /*#__PURE__*/(0,react.createContext)(null);
/**
 * Get the current editor object from the React context.
 */

var useSlateStatic = () => {
  var editor = (0,react.useContext)(EditorContext);

  if (!editor) {
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  }

  return editor;
};

/**
 * A React context for sharing the `decorate` prop of the editable.
 */

var DecorateContext = /*#__PURE__*/(0,react.createContext)(() => []);
/**
 * Get the current `decorate` prop of the editable.
 */

var useDecorate = () => {
  return (0,react.useContext)(DecorateContext);
};

/**
 * A React context for sharing the `selected` state of an element.
 */

var SelectedContext = /*#__PURE__*/(0,react.createContext)(false);
/**
 * Get the current `selected` state of an element.
 */

var useSelected = () => {
  return (0,react.useContext)(SelectedContext);
};

/**
 * Children.
 */

var useChildren = props => {
  var {
    decorations,
    node,
    renderElement,
    renderPlaceholder,
    renderLeaf,
    selection
  } = props;
  var decorate = useDecorate();
  var editor = useSlateStatic();
  var path = ReactEditor.findPath(editor, node);
  var children = [];
  var isLeafBlock = index_es/* Element.isElement */.W_.isElement(node) && !editor.isInline(node) && index_es/* Editor.hasInlines */.ML.hasInlines(editor, node);

  for (var i = 0; i < node.children.length; i++) {
    var p = path.concat(i);
    var n = node.children[i];
    var key = ReactEditor.findKey(editor, n);
    var range = index_es/* Editor.range */.ML.range(editor, p);
    var sel = selection && index_es/* Range.intersection */.e6.intersection(range, selection);
    var ds = decorate([n, p]);

    for (var dec of decorations) {
      var d = index_es/* Range.intersection */.e6.intersection(dec, range);

      if (d) {
        ds.push(d);
      }
    }

    if (index_es/* Element.isElement */.W_.isElement(n)) {
      children.push( /*#__PURE__*/react.createElement(SelectedContext.Provider, {
        key: "provider-".concat(key.id),
        value: !!sel
      }, /*#__PURE__*/react.createElement(MemoizedElement, {
        decorations: ds,
        element: n,
        key: key.id,
        renderElement: renderElement,
        renderPlaceholder: renderPlaceholder,
        renderLeaf: renderLeaf,
        selection: sel
      })));
    } else {
      children.push( /*#__PURE__*/react.createElement(MemoizedText, {
        decorations: ds,
        key: key.id,
        isLast: isLeafBlock && i === node.children.length - 1,
        parent: node,
        renderPlaceholder: renderPlaceholder,
        renderLeaf: renderLeaf,
        text: n
      }));
    }

    NODE_TO_INDEX.set(n, i);
    NODE_TO_PARENT.set(n, node);
  }

  return children;
};

/**
 * Hotkey mappings for each platform.
 */

var HOTKEYS = {
  bold: 'mod+b',
  compose: ['down', 'left', 'right', 'up', 'backspace', 'enter'],
  moveBackward: 'left',
  moveForward: 'right',
  moveWordBackward: 'ctrl+left',
  moveWordForward: 'ctrl+right',
  deleteBackward: 'shift?+backspace',
  deleteForward: 'shift?+delete',
  extendBackward: 'shift+left',
  extendForward: 'shift+right',
  italic: 'mod+i',
  insertSoftBreak: 'shift+enter',
  splitBlock: 'enter',
  undo: 'mod+z'
};
var APPLE_HOTKEYS = {
  moveLineBackward: 'opt+up',
  moveLineForward: 'opt+down',
  moveWordBackward: 'opt+left',
  moveWordForward: 'opt+right',
  deleteBackward: ['ctrl+backspace', 'ctrl+h'],
  deleteForward: ['ctrl+delete', 'ctrl+d'],
  deleteLineBackward: 'cmd+shift?+backspace',
  deleteLineForward: ['cmd+shift?+delete', 'ctrl+k'],
  deleteWordBackward: 'opt+shift?+backspace',
  deleteWordForward: 'opt+shift?+delete',
  extendLineBackward: 'opt+shift+up',
  extendLineForward: 'opt+shift+down',
  redo: 'cmd+shift+z',
  transposeCharacter: 'ctrl+t'
};
var WINDOWS_HOTKEYS = {
  deleteWordBackward: 'ctrl+shift?+backspace',
  deleteWordForward: 'ctrl+shift?+delete',
  redo: ['ctrl+y', 'ctrl+shift+z']
};
/**
 * Create a platform-aware hotkey checker.
 */

var create = key => {
  var generic = HOTKEYS[key];
  var apple = APPLE_HOTKEYS[key];
  var windows = WINDOWS_HOTKEYS[key];
  var isGeneric = generic && (0,is_hotkey_lib/* isKeyHotkey */.TB)(generic);
  var isApple = apple && (0,is_hotkey_lib/* isKeyHotkey */.TB)(apple);
  var isWindows = windows && (0,is_hotkey_lib/* isKeyHotkey */.TB)(windows);
  return event => {
    if (isGeneric && isGeneric(event)) return true;
    if (IS_APPLE && isApple && isApple(event)) return true;
    if (!IS_APPLE && isWindows && isWindows(event)) return true;
    return false;
  };
};
/**
 * Hotkeys.
 */


var Hotkeys = {
  isBold: create('bold'),
  isCompose: create('compose'),
  isMoveBackward: create('moveBackward'),
  isMoveForward: create('moveForward'),
  isDeleteBackward: create('deleteBackward'),
  isDeleteForward: create('deleteForward'),
  isDeleteLineBackward: create('deleteLineBackward'),
  isDeleteLineForward: create('deleteLineForward'),
  isDeleteWordBackward: create('deleteWordBackward'),
  isDeleteWordForward: create('deleteWordForward'),
  isExtendBackward: create('extendBackward'),
  isExtendForward: create('extendForward'),
  isExtendLineBackward: create('extendLineBackward'),
  isExtendLineForward: create('extendLineForward'),
  isItalic: create('italic'),
  isMoveLineBackward: create('moveLineBackward'),
  isMoveLineForward: create('moveLineForward'),
  isMoveWordBackward: create('moveWordBackward'),
  isMoveWordForward: create('moveWordForward'),
  isRedo: create('redo'),
  isSoftBreak: create('insertSoftBreak'),
  isSplitBlock: create('splitBlock'),
  isTransposeCharacter: create('transposeCharacter'),
  isUndo: create('undo')
};

/**
 * A React context for sharing the `readOnly` state of the editor.
 */

var ReadOnlyContext = /*#__PURE__*/(0,react.createContext)(false);
/**
 * Get the current `readOnly` state of the editor.
 */

var useReadOnly = () => {
  return (0,react.useContext)(ReadOnlyContext);
};

/**
 * A React context for sharing the editor object, in a way that re-renders the
 * context whenever changes occur.
 */

var SlateContext = /*#__PURE__*/(0,react.createContext)(null);
/**
 * Get the current editor object from the React context.
 */

var useSlate = () => {
  var context = (0,react.useContext)(SlateContext);

  if (!context) {
    throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
  }

  var [editor] = context;
  return editor;
};

/**
 * Types.
 */
/**
 * Returns the host window of a DOM node
 */

var getDefaultView = value => {
  return value && value.ownerDocument && value.ownerDocument.defaultView || null;
};
/**
 * Check if a DOM node is a comment node.
 */

var isDOMComment = value => {
  return isDOMNode(value) && value.nodeType === 8;
};
/**
 * Check if a DOM node is an element node.
 */

var isDOMElement = value => {
  return isDOMNode(value) && value.nodeType === 1;
};
/**
 * Check if a value is a DOM node.
 */

var isDOMNode = value => {
  var window = getDefaultView(value);
  return !!window && value instanceof window.Node;
};
/**
 * Check if a value is a DOM selection.
 */

var isDOMSelection = value => {
  var window = value && value.anchorNode && getDefaultView(value.anchorNode);
  return !!window && value instanceof window.Selection;
};
/**
 * Check if a DOM node is an element node.
 */

var isDOMText = value => {
  return isDOMNode(value) && value.nodeType === 3;
};
/**
 * Checks whether a paste event is a plaintext-only event.
 */

var isPlainTextOnlyPaste = event => {
  return event.clipboardData && event.clipboardData.getData('text/plain') !== '' && event.clipboardData.types.length === 1;
};
/**
 * Normalize a DOM point so that it always refers to a text node.
 */

var normalizeDOMPoint = domPoint => {
  var [node, offset] = domPoint; // If it's an element node, its offset refers to the index of its children
  // including comment nodes, so try to find the right text child node.

  if (isDOMElement(node) && node.childNodes.length) {
    var isLast = offset === node.childNodes.length;
    var index = isLast ? offset - 1 : offset;
    [node, index] = getEditableChildAndIndex(node, index, isLast ? 'backward' : 'forward'); // If the editable child found is in front of input offset, we instead seek to its end

    isLast = index < offset; // If the node has children, traverse until we have a leaf node. Leaf nodes
    // can be either text nodes, or other void DOM nodes.

    while (isDOMElement(node) && node.childNodes.length) {
      var i = isLast ? node.childNodes.length - 1 : 0;
      node = getEditableChild(node, i, isLast ? 'backward' : 'forward');
    } // Determine the new offset inside the text node.


    offset = isLast && node.textContent != null ? node.textContent.length : 0;
  } // Return the node and offset.


  return [node, offset];
};
/**
 * Determines wether the active element is nested within a shadowRoot
 */

var hasShadowRoot = () => {
  return !!(window.document.activeElement && window.document.activeElement.shadowRoot);
};
/**
 * Get the nearest editable child and index at `index` in a `parent`, preferring
 * `direction`.
 */

var getEditableChildAndIndex = (parent, index, direction) => {
  var {
    childNodes
  } = parent;
  var child = childNodes[index];
  var i = index;
  var triedForward = false;
  var triedBackward = false; // While the child is a comment node, or an element node with no children,
  // keep iterating to find a sibling non-void, non-comment node.

  while (isDOMComment(child) || isDOMElement(child) && child.childNodes.length === 0 || isDOMElement(child) && child.getAttribute('contenteditable') === 'false') {
    if (triedForward && triedBackward) {
      break;
    }

    if (i >= childNodes.length) {
      triedForward = true;
      i = index - 1;
      direction = 'backward';
      continue;
    }

    if (i < 0) {
      triedBackward = true;
      i = index + 1;
      direction = 'forward';
      continue;
    }

    child = childNodes[i];
    index = i;
    i += direction === 'forward' ? 1 : -1;
  }

  return [child, index];
};
/**
 * Get the nearest editable child at `index` in a `parent`, preferring
 * `direction`.
 */

var getEditableChild = (parent, index, direction) => {
  var [child] = getEditableChildAndIndex(parent, index, direction);
  return child;
};
/**
 * Get a plaintext representation of the content of a node, accounting for block
 * elements which get a newline appended.
 *
 * The domNode must be attached to the DOM.
 */

var getPlainText = domNode => {
  var text = '';

  if (isDOMText(domNode) && domNode.nodeValue) {
    return domNode.nodeValue;
  }

  if (isDOMElement(domNode)) {
    for (var childNode of Array.from(domNode.childNodes)) {
      text += getPlainText(childNode);
    }

    var display = getComputedStyle(domNode).getPropertyValue('display');

    if (display === 'block' || display === 'list' || domNode.tagName === 'BR') {
      text += '\n';
    }
  }

  return text;
};
/**
 * Get x-slate-fragment attribute from data-slate-fragment
 */

var catchSlateFragment = /data-slate-fragment="(.+?)"/m;
var getSlateFragmentAttribute = dataTransfer => {
  var htmlData = dataTransfer.getData('text/html');
  var [, fragment] = htmlData.match(catchSlateFragment) || [];
  return fragment;
};
/**
 * Get the x-slate-fragment attribute that exist in text/html data
 * and append it to the DataTransfer object
 */

var getClipboardData = dataTransfer => {
  if (!dataTransfer.getData('application/x-slate-fragment')) {
    var fragment = getSlateFragmentAttribute(dataTransfer);

    if (fragment) {
      var clipboardData = new DataTransfer();
      dataTransfer.types.forEach(type => {
        clipboardData.setData(type, dataTransfer.getData(type));
      });
      clipboardData.setData('application/x-slate-fragment', fragment);
      return clipboardData;
    }
  }

  return dataTransfer;
};

var TRIPLE_CLICK = 3;

var _excluded$2 = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { index_es_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Children = props => /*#__PURE__*/react.createElement(react.Fragment, null, useChildren(props));
/**
 * Editable.
 */


var Editable$1 = props => {
  var {
    autoFocus,
    decorate = defaultDecorate,
    onDOMBeforeInput: propsOnDOMBeforeInput,
    placeholder,
    readOnly = false,
    renderElement,
    renderLeaf,
    renderPlaceholder = props => /*#__PURE__*/react.createElement(DefaultPlaceholder, Object.assign({}, props)),
    scrollSelectionIntoView = defaultScrollSelectionIntoView,
    style = {},
    as: Component = 'div'
  } = props,
      attributes = _objectWithoutProperties(props, _excluded$2);

  var editor = useSlate(); // Rerender editor when composition status changed

  var [isComposing, setIsComposing] = (0,react.useState)(false);
  var ref = (0,react.useRef)(null);
  var deferredOperations = (0,react.useRef)([]); // Update internal state on each render.

  IS_READ_ONLY.set(editor, readOnly); // Keep track of some state for the event handler logic.

  var state = (0,react.useMemo)(() => ({
    hasInsertPrefixInCompositon: false,
    isDraggingInternally: false,
    isUpdatingSelection: false,
    latestElement: null
  }), []); // Whenever the editor updates...

  useIsomorphicLayoutEffect(() => {
    // Update element-related weak maps with the DOM element ref.
    var window;

    if (ref.current && (window = getDefaultView(ref.current))) {
      EDITOR_TO_WINDOW.set(editor, window);
      EDITOR_TO_ELEMENT.set(editor, ref.current);
      NODE_TO_ELEMENT.set(editor, ref.current);
      ELEMENT_TO_NODE.set(ref.current, editor);
    } else {
      NODE_TO_ELEMENT.delete(editor);
    } // Make sure the DOM selection state is in sync.


    var {
      selection
    } = editor;
    var root = ReactEditor.findDocumentOrShadowRoot(editor);
    var domSelection = root.getSelection();

    if (ReactEditor.isComposing(editor) || !domSelection || !ReactEditor.isFocused(editor)) {
      return;
    }

    var hasDomSelection = domSelection.type !== 'None'; // If the DOM selection is properly unset, we're done.

    if (!selection && !hasDomSelection) {
      return;
    } // verify that the dom selection is in the editor


    var editorElement = EDITOR_TO_ELEMENT.get(editor);
    var hasDomSelectionInEditor = false;

    if (editorElement.contains(domSelection.anchorNode) && editorElement.contains(domSelection.focusNode)) {
      hasDomSelectionInEditor = true;
    } // If the DOM selection is in the editor and the editor selection is already correct, we're done.


    if (hasDomSelection && hasDomSelectionInEditor && selection) {
      var slateRange = ReactEditor.toSlateRange(editor, domSelection, {
        exactMatch: true,
        // domSelection is not necessarily a valid Slate range
        // (e.g. when clicking on contentEditable:false element)
        suppressThrow: true
      });

      if (slateRange && index_es/* Range.equals */.e6.equals(slateRange, selection)) {
        return;
      }
    } // when <Editable/> is being controlled through external value
    // then its children might just change - DOM responds to it on its own
    // but Slate's value is not being updated through any operation
    // and thus it doesn't transform selection on its own


    if (selection && !ReactEditor.hasRange(editor, selection)) {
      editor.selection = ReactEditor.toSlateRange(editor, domSelection, {
        exactMatch: false,
        suppressThrow: false
      });
      return;
    } // Otherwise the DOM selection is out of sync, so update it.


    state.isUpdatingSelection = true;
    var newDomRange = selection && ReactEditor.toDOMRange(editor, selection);

    if (newDomRange) {
      if (index_es/* Range.isBackward */.e6.isBackward(selection)) {
        domSelection.setBaseAndExtent(newDomRange.endContainer, newDomRange.endOffset, newDomRange.startContainer, newDomRange.startOffset);
      } else {
        domSelection.setBaseAndExtent(newDomRange.startContainer, newDomRange.startOffset, newDomRange.endContainer, newDomRange.endOffset);
      }

      scrollSelectionIntoView(editor, newDomRange);
    } else {
      domSelection.removeAllRanges();
    }

    setTimeout(() => {
      // COMPAT: In Firefox, it's not enough to create a range, you also need
      // to focus the contenteditable element too. (2016/11/16)
      if (newDomRange && IS_FIREFOX) {
        var el = ReactEditor.toDOMNode(editor, editor);
        el.focus();
      }

      state.isUpdatingSelection = false;
    });
  }); // The autoFocus TextareaHTMLAttribute doesn't do anything on a div, so it
  // needs to be manually focused.

  (0,react.useEffect)(() => {
    if (ref.current && autoFocus) {
      ref.current.focus();
    }
  }, [autoFocus]); // Listen on the native `selectionchange` event to be able to update any time
  // the selection changes. This is required because React's `onSelect` is leaky
  // and non-standard so it doesn't fire until after a selection has been
  // released. This causes issues in situations where another change happens
  // while a selection is being dragged.

  var onDOMSelectionChange = (0,react.useCallback)(throttle_default()(() => {
    if (!ReactEditor.isComposing(editor) && !state.isUpdatingSelection && !state.isDraggingInternally) {
      var root = ReactEditor.findDocumentOrShadowRoot(editor);
      var {
        activeElement
      } = root;
      var el = ReactEditor.toDOMNode(editor, editor);
      var domSelection = root.getSelection();

      if (activeElement === el) {
        state.latestElement = activeElement;
        IS_FOCUSED.set(editor, true);
      } else {
        IS_FOCUSED.delete(editor);
      }

      if (!domSelection) {
        return index_es/* Transforms.deselect */.YR.deselect(editor);
      }

      var {
        anchorNode,
        focusNode
      } = domSelection;
      var anchorNodeSelectable = hasEditableTarget(editor, anchorNode) || isTargetInsideNonReadonlyVoid(editor, anchorNode);
      var focusNodeSelectable = hasEditableTarget(editor, focusNode) || isTargetInsideNonReadonlyVoid(editor, focusNode);

      if (anchorNodeSelectable && focusNodeSelectable) {
        var range = ReactEditor.toSlateRange(editor, domSelection, {
          exactMatch: false,
          suppressThrow: false
        });
        index_es/* Transforms.select */.YR.select(editor, range);
      }
    }
  }, 100), [readOnly]);
  var scheduleOnDOMSelectionChange = (0,react.useMemo)(() => debounce_default()(onDOMSelectionChange, 0), [onDOMSelectionChange]); // Listen on the native `beforeinput` event to get real "Level 2" events. This
  // is required because React's `beforeinput` is fake and never really attaches
  // to the real event sadly. (2019/11/01)
  // https://github.com/facebook/react/issues/11211

  var onDOMBeforeInput = (0,react.useCallback)(event => {
    if (!readOnly && hasEditableTarget(editor, event.target) && !isDOMEventHandled(event, propsOnDOMBeforeInput)) {
      var _EDITOR_TO_USER_SELEC;

      // Some IMEs/Chrome extensions like e.g. Grammarly set the selection immediately before
      // triggering a `beforeinput` expecting the change to be applied to the immediately before
      // set selection.
      scheduleOnDOMSelectionChange.flush();
      onDOMSelectionChange.flush();
      var {
        selection
      } = editor;
      var {
        inputType: type
      } = event;
      var data = event.dataTransfer || event.data || undefined; // These two types occur while a user is composing text and can't be
      // cancelled. Let them through and wait for the composition to end.

      if (type === 'insertCompositionText' || type === 'deleteCompositionText') {
        return;
      }

      var native = false;

      if (type === 'insertText' && selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection) && // Only use native character insertion for single characters a-z or space for now.
      // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
      // causes duplicate inserts.
      event.data && event.data.length === 1 && /[a-z ]/i.test(event.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
      // When there is an inline element, e.g. a link, and you select
      // right after it (the start of the next node).
      selection.anchor.offset !== 0) {
        var _node$parentElement;

        native = true; // Skip native if there are marks, as
        // `insertText` will insert a node, not just text.

        if (editor.marks) {
          native = false;
        } // Chrome also has issues correctly editing the end of anchor elements: https://bugs.chromium.org/p/chromium/issues/detail?id=1259100
        // Therefore we don't allow native events to insert text at the end of anchor nodes.


        var {
          anchor
        } = selection;
        var [node, offset] = ReactEditor.toDOMPoint(editor, anchor);
        var anchorNode = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest('a');

        if (anchorNode && ReactEditor.hasDOMNode(editor, anchorNode)) {
          var _lastText$textContent;

          var {
            document
          } = ReactEditor.getWindow(editor); // Find the last text node inside the anchor.

          var lastText = document.createTreeWalker(anchorNode, NodeFilter.SHOW_TEXT).lastChild();

          if (lastText === node && ((_lastText$textContent = lastText.textContent) === null || _lastText$textContent === void 0 ? void 0 : _lastText$textContent.length) === offset) {
            native = false;
          }
        }
      } // COMPAT: For the deleting forward/backward input types we don't want
      // to change the selection because it is the range that will be deleted,
      // and those commands determine that for themselves.


      if (!type.startsWith('delete') || type.startsWith('deleteBy')) {
        var [targetRange] = event.getTargetRanges();

        if (targetRange) {
          var range = ReactEditor.toSlateRange(editor, targetRange, {
            exactMatch: false,
            suppressThrow: false
          });

          if (!selection || !index_es/* Range.equals */.e6.equals(selection, range)) {
            native = false;
            var selectionRef = editor.selection && index_es/* Editor.rangeRef */.ML.rangeRef(editor, editor.selection);
            index_es/* Transforms.select */.YR.select(editor, range);

            if (selectionRef) {
              EDITOR_TO_USER_SELECTION.set(editor, selectionRef);
            }
          }
        }
      }

      if (!native) {
        event.preventDefault();
      } // COMPAT: If the selection is expanded, even if the command seems like
      // a delete forward/backward command it should delete the selection.


      if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection) && type.startsWith('delete')) {
        var direction = type.endsWith('Backward') ? 'backward' : 'forward';
        index_es/* Editor.deleteFragment */.ML.deleteFragment(editor, {
          direction
        });
        return;
      }

      switch (type) {
        case 'deleteByComposition':
        case 'deleteByCut':
        case 'deleteByDrag':
          {
            index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            break;
          }

        case 'deleteContent':
        case 'deleteContentForward':
          {
            index_es/* Editor.deleteForward */.ML.deleteForward(editor);
            break;
          }

        case 'deleteContentBackward':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor);
            break;
          }

        case 'deleteEntireSoftLine':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
              unit: 'line'
            });
            index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
              unit: 'line'
            });
            break;
          }

        case 'deleteHardLineBackward':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
              unit: 'block'
            });
            break;
          }

        case 'deleteSoftLineBackward':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
              unit: 'line'
            });
            break;
          }

        case 'deleteHardLineForward':
          {
            index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
              unit: 'block'
            });
            break;
          }

        case 'deleteSoftLineForward':
          {
            index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
              unit: 'line'
            });
            break;
          }

        case 'deleteWordBackward':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
              unit: 'word'
            });
            break;
          }

        case 'deleteWordForward':
          {
            index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
              unit: 'word'
            });
            break;
          }

        case 'insertLineBreak':
          index_es/* Editor.insertSoftBreak */.ML.insertSoftBreak(editor);
          break;

        case 'insertParagraph':
          {
            index_es/* Editor.insertBreak */.ML.insertBreak(editor);
            break;
          }

        case 'insertFromComposition':
        case 'insertFromDrop':
        case 'insertFromPaste':
        case 'insertFromYank':
        case 'insertReplacementText':
        case 'insertText':
          {
            var {
              selection: _selection
            } = editor;

            if (_selection) {
              if (index_es/* Range.isExpanded */.e6.isExpanded(_selection)) {
                index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
              }
            }

            if (type === 'insertFromComposition') {
              // COMPAT: in Safari, `compositionend` is dispatched after the
              // `beforeinput` for "insertFromComposition". But if we wait for it
              // then we will abort because we're still composing and the selection
              // won't be updated properly.
              // https://www.w3.org/TR/input-events-2/
              if (ReactEditor.isComposing(editor)) {
                setIsComposing(false);
                IS_COMPOSING.set(editor, false);
              }
            } // use a weak comparison instead of 'instanceof' to allow
            // programmatic access of paste events coming from external windows
            // like cypress where cy.window does not work realibly


            if ((data === null || data === void 0 ? void 0 : data.constructor.name) === 'DataTransfer') {
              ReactEditor.insertData(editor, data);
            } else if (typeof data === 'string') {
              // Only insertText operations use the native functionality, for now.
              // Potentially expand to single character deletes, as well.
              if (native) {
                deferredOperations.current.push(() => index_es/* Editor.insertText */.ML.insertText(editor, data));
              } else {
                index_es/* Editor.insertText */.ML.insertText(editor, data);
              }
            }

            break;
          }
      } // Restore the actual user section if nothing manually set it.


      var toRestore = (_EDITOR_TO_USER_SELEC = EDITOR_TO_USER_SELECTION.get(editor)) === null || _EDITOR_TO_USER_SELEC === void 0 ? void 0 : _EDITOR_TO_USER_SELEC.unref();
      EDITOR_TO_USER_SELECTION.delete(editor);

      if (toRestore && (!editor.selection || !index_es/* Range.equals */.e6.equals(editor.selection, toRestore))) {
        index_es/* Transforms.select */.YR.select(editor, toRestore);
      }
    }
  }, [readOnly, propsOnDOMBeforeInput]); // Attach a native DOM event handler for `beforeinput` events, because React's
  // built-in `onBeforeInput` is actually a leaky polyfill that doesn't expose
  // real `beforeinput` events sadly... (2019/11/04)
  // https://github.com/facebook/react/issues/11211

  useIsomorphicLayoutEffect(() => {
    if (ref.current && HAS_BEFORE_INPUT_SUPPORT) {
      // @ts-ignore The `beforeinput` event isn't recognized.
      ref.current.addEventListener('beforeinput', onDOMBeforeInput);
    }

    return () => {
      if (ref.current && HAS_BEFORE_INPUT_SUPPORT) {
        // @ts-ignore The `beforeinput` event isn't recognized.
        ref.current.removeEventListener('beforeinput', onDOMBeforeInput);
      }
    };
  }, [onDOMBeforeInput]); // Attach a native DOM event handler for `selectionchange`, because React's
  // built-in `onSelect` handler doesn't fire for all selection changes. It's a
  // leaky polyfill that only fires on keypresses or clicks. Instead, we want to
  // fire for any change to the selection inside the editor. (2019/11/04)
  // https://github.com/facebook/react/issues/5785

  useIsomorphicLayoutEffect(() => {
    var window = ReactEditor.getWindow(editor);
    window.document.addEventListener('selectionchange', scheduleOnDOMSelectionChange);
    return () => {
      window.document.removeEventListener('selectionchange', scheduleOnDOMSelectionChange);
    };
  }, [scheduleOnDOMSelectionChange]);
  var decorations = decorate([editor, []]);

  if (placeholder && editor.children.length === 1 && Array.from(index_es/* Node.texts */.NB.texts(editor)).length === 1 && index_es/* Node.string */.NB.string(editor) === '' && !isComposing) {
    var start = index_es/* Editor.start */.ML.start(editor, []);
    decorations.push({
      [PLACEHOLDER_SYMBOL]: true,
      placeholder,
      anchor: start,
      focus: start
    });
  }

  return /*#__PURE__*/react.createElement(ReadOnlyContext.Provider, {
    value: readOnly
  }, /*#__PURE__*/react.createElement(DecorateContext.Provider, {
    value: decorate
  }, /*#__PURE__*/react.createElement(Component, Object.assign({
    role: readOnly ? undefined : 'textbox'
  }, attributes, {
    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
    // have to use hacks to make these replacement-based features work.
    // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
    // mismatch warning app moves to browser. Pass-through consumer props when
    // not CAN_USE_DOM (SSR) and default to falsy value
    spellCheck: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.spellCheck : false,
    autoCorrect: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.autoCorrect : 'false',
    autoCapitalize: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.autoCapitalize : 'false',
    "data-slate-editor": true,
    "data-slate-node": "value",
    // explicitly set this
    contentEditable: !readOnly,
    // in some cases, a decoration needs access to the range / selection to decorate a text node,
    // then you will select the whole text node when you select part the of text
    // this magic zIndex="-1" will fix it
    zindex: -1,
    suppressContentEditableWarning: true,
    ref: ref,
    style: _objectSpread$1({
      // Allow positioning relative to the editable element.
      position: 'relative',
      // Prevent the default outline styles.
      outline: 'none',
      // Preserve adjacent whitespace and new lines.
      whiteSpace: 'pre-wrap',
      // Allow words to break if they are too long.
      wordWrap: 'break-word'
    }, style),
    onBeforeInput: (0,react.useCallback)(event => {
      // COMPAT: Certain browsers don't support the `beforeinput` event, so we
      // fall back to React's leaky polyfill instead just for it. It
      // only works for the `insertText` input type.
      if (!HAS_BEFORE_INPUT_SUPPORT && !readOnly && !isEventHandled(event, attributes.onBeforeInput) && hasEditableTarget(editor, event.target)) {
        event.preventDefault();

        if (!ReactEditor.isComposing(editor)) {
          var text = event.data;
          index_es/* Editor.insertText */.ML.insertText(editor, text);
        }
      }
    }, [readOnly]),
    onInput: (0,react.useCallback)(event => {
      // Flush native operations, as native events will have propogated
      // and we can correctly compare DOM text values in components
      // to stop rendering, so that browser functions like autocorrect
      // and spellcheck work as expected.
      for (var op of deferredOperations.current) {
        op();
      }

      deferredOperations.current = [];
    }, []),
    onBlur: (0,react.useCallback)(event => {
      if (readOnly || state.isUpdatingSelection || !hasEditableTarget(editor, event.target) || isEventHandled(event, attributes.onBlur)) {
        return;
      } // COMPAT: If the current `activeElement` is still the previous
      // one, this is due to the window being blurred when the tab
      // itself becomes unfocused, so we want to abort early to allow to
      // editor to stay focused when the tab becomes focused again.


      var root = ReactEditor.findDocumentOrShadowRoot(editor);

      if (state.latestElement === root.activeElement) {
        return;
      }

      var {
        relatedTarget
      } = event;
      var el = ReactEditor.toDOMNode(editor, editor); // COMPAT: The event should be ignored if the focus is returning
      // to the editor from an embedded editable element (eg. an <input>
      // element inside a void node).

      if (relatedTarget === el) {
        return;
      } // COMPAT: The event should be ignored if the focus is moving from
      // the editor to inside a void node's spacer element.


      if (isDOMElement(relatedTarget) && relatedTarget.hasAttribute('data-slate-spacer')) {
        return;
      } // COMPAT: The event should be ignored if the focus is moving to a
      // non- editable section of an element that isn't a void node (eg.
      // a list item of the check list example).


      if (relatedTarget != null && isDOMNode(relatedTarget) && ReactEditor.hasDOMNode(editor, relatedTarget)) {
        var node = ReactEditor.toSlateNode(editor, relatedTarget);

        if (index_es/* Element.isElement */.W_.isElement(node) && !editor.isVoid(node)) {
          return;
        }
      } // COMPAT: Safari doesn't always remove the selection even if the content-
      // editable element no longer has focus. Refer to:
      // https://stackoverflow.com/questions/12353247/force-contenteditable-div-to-stop-accepting-input-after-it-loses-focus-under-web


      if (IS_SAFARI) {
        var domSelection = root.getSelection();
        domSelection === null || domSelection === void 0 ? void 0 : domSelection.removeAllRanges();
      }

      IS_FOCUSED.delete(editor);
    }, [readOnly, attributes.onBlur]),
    onClick: (0,react.useCallback)(event => {
      if (hasTarget(editor, event.target) && !isEventHandled(event, attributes.onClick) && isDOMNode(event.target)) {
        var node = ReactEditor.toSlateNode(editor, event.target);
        var path = ReactEditor.findPath(editor, node); // At this time, the Slate document may be arbitrarily different,
        // because onClick handlers can change the document before we get here.
        // Therefore we must check that this path actually exists,
        // and that it still refers to the same node.

        if (!index_es/* Editor.hasPath */.ML.hasPath(editor, path) || index_es/* Node.get */.NB.get(editor, path) !== node) {
          return;
        }

        if (event.detail === TRIPLE_CLICK && path.length >= 1) {
          var blockPath = path;

          if (!index_es/* Editor.isBlock */.ML.isBlock(editor, node)) {
            var _block$;

            var block = index_es/* Editor.above */.ML.above(editor, {
              match: n => index_es/* Editor.isBlock */.ML.isBlock(editor, n),
              at: path
            });
            blockPath = (_block$ = block === null || block === void 0 ? void 0 : block[1]) !== null && _block$ !== void 0 ? _block$ : path.slice(0, 1);
          }

          var range = index_es/* Editor.range */.ML.range(editor, blockPath);
          index_es/* Transforms.select */.YR.select(editor, range);
          return;
        }

        if (readOnly) {
          return;
        }

        var _start = index_es/* Editor.start */.ML.start(editor, path);

        var end = index_es/* Editor.end */.ML.end(editor, path);
        var startVoid = index_es/* Editor.void */.ML["void"](editor, {
          at: _start
        });
        var endVoid = index_es/* Editor.void */.ML["void"](editor, {
          at: end
        });

        if (startVoid && endVoid && index_es/* Path.equals */.y$.equals(startVoid[1], endVoid[1])) {
          var _range = index_es/* Editor.range */.ML.range(editor, _start);

          index_es/* Transforms.select */.YR.select(editor, _range);
        }
      }
    }, [readOnly, attributes.onClick]),
    onCompositionEnd: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionEnd)) {
        if (ReactEditor.isComposing(editor)) {
          setIsComposing(false);
          IS_COMPOSING.set(editor, false);
        } // COMPAT: In Chrome, `beforeinput` events for compositions
        // aren't correct and never fire the "insertFromComposition"
        // type that we need. So instead, insert whenever a composition
        // ends since it will already have been committed to the DOM.


        if (!IS_SAFARI && !IS_FIREFOX_LEGACY && !IS_IOS && !IS_QQBROWSER && !IS_WECHATBROWSER && !IS_UC_MOBILE && event.data) {
          index_es/* Editor.insertText */.ML.insertText(editor, event.data);
        }

        if (editor.selection && index_es/* Range.isCollapsed */.e6.isCollapsed(editor.selection)) {
          var leafPath = editor.selection.anchor.path;
          var currentTextNode = index_es/* Node.leaf */.NB.leaf(editor, leafPath);

          if (state.hasInsertPrefixInCompositon) {
            state.hasInsertPrefixInCompositon = false;
            index_es/* Editor.withoutNormalizing */.ML.withoutNormalizing(editor, () => {
              // remove Unicode BOM prefix added in `onCompositionStart`
              var text = currentTextNode.text.replace(/^\uFEFF/, '');
              index_es/* Transforms.delete */.YR["delete"](editor, {
                distance: currentTextNode.text.length,
                reverse: true
              });
              index_es/* Editor.insertText */.ML.insertText(editor, text);
            });
          }
        }
      }
    }, [attributes.onCompositionEnd]),
    onCompositionUpdate: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionUpdate)) {
        if (!ReactEditor.isComposing(editor)) {
          setIsComposing(true);
          IS_COMPOSING.set(editor, true);
        }
      }
    }, [attributes.onCompositionUpdate]),
    onCompositionStart: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionStart)) {
        var {
          selection,
          marks
        } = editor;

        if (selection) {
          if (index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
            index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            return;
          }

          var inline = index_es/* Editor.above */.ML.above(editor, {
            match: n => index_es/* Editor.isInline */.ML.isInline(editor, n),
            mode: 'highest'
          });

          if (inline) {
            var [, inlinePath] = inline;

            if (index_es/* Editor.isEnd */.ML.isEnd(editor, selection.anchor, inlinePath)) {
              var point = index_es/* Editor.after */.ML.after(editor, inlinePath);
              index_es/* Transforms.setSelection */.YR.setSelection(editor, {
                anchor: point,
                focus: point
              });
            }
          } // insert new node in advance to ensure composition text will insert
          // along with final input text
          // add Unicode BOM prefix to avoid normalize removing this node


          if (marks) {
            state.hasInsertPrefixInCompositon = true;
            index_es/* Transforms.insertNodes */.YR.insertNodes(editor, _objectSpread$1({
              text: '\uFEFF'
            }, marks), {
              select: true
            });
          }
        }
      }
    }, [attributes.onCompositionStart]),
    onCopy: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCopy)) {
        event.preventDefault();
        ReactEditor.setFragmentData(editor, event.clipboardData, 'copy');
      }
    }, [attributes.onCopy]),
    onCut: (0,react.useCallback)(event => {
      if (!readOnly && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCut)) {
        event.preventDefault();
        ReactEditor.setFragmentData(editor, event.clipboardData, 'cut');
        var {
          selection
        } = editor;

        if (selection) {
          if (index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
            index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
          } else {
            var node = index_es/* Node.parent */.NB.parent(editor, selection.anchor.path);

            if (index_es/* Editor.isVoid */.ML.isVoid(editor, node)) {
              index_es/* Transforms.delete */.YR["delete"](editor);
            }
          }
        }
      }
    }, [readOnly, attributes.onCut]),
    onDragOver: (0,react.useCallback)(event => {
      if (hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDragOver)) {
        // Only when the target is void, call `preventDefault` to signal
        // that drops are allowed. Editable content is droppable by
        // default, and calling `preventDefault` hides the cursor.
        var node = ReactEditor.toSlateNode(editor, event.target);

        if (index_es/* Editor.isVoid */.ML.isVoid(editor, node)) {
          event.preventDefault();
        }
      }
    }, [attributes.onDragOver]),
    onDragStart: (0,react.useCallback)(event => {
      if (!readOnly && hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDragStart)) {
        var node = ReactEditor.toSlateNode(editor, event.target);
        var path = ReactEditor.findPath(editor, node);
        var voidMatch = index_es/* Editor.isVoid */.ML.isVoid(editor, node) || index_es/* Editor.void */.ML["void"](editor, {
          at: path,
          voids: true
        }); // If starting a drag on a void node, make sure it is selected
        // so that it shows up in the selection's fragment.

        if (voidMatch) {
          var range = index_es/* Editor.range */.ML.range(editor, path);
          index_es/* Transforms.select */.YR.select(editor, range);
        }

        state.isDraggingInternally = true;
        ReactEditor.setFragmentData(editor, event.dataTransfer, 'drag');
      }
    }, [readOnly, attributes.onDragStart]),
    onDrop: (0,react.useCallback)(event => {
      if (!readOnly && hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDrop)) {
        event.preventDefault(); // Keep a reference to the dragged range before updating selection

        var draggedRange = editor.selection; // Find the range where the drop happened

        var range = ReactEditor.findEventRange(editor, event);
        var data = event.dataTransfer;
        index_es/* Transforms.select */.YR.select(editor, range);

        if (state.isDraggingInternally) {
          if (draggedRange && !index_es/* Range.equals */.e6.equals(draggedRange, range) && !index_es/* Editor.void */.ML["void"](editor, {
            at: range,
            voids: true
          })) {
            index_es/* Transforms.delete */.YR["delete"](editor, {
              at: draggedRange
            });
          }
        }

        ReactEditor.insertData(editor, data); // When dragging from another source into the editor, it's possible
        // that the current editor does not have focus.

        if (!ReactEditor.isFocused(editor)) {
          ReactEditor.focus(editor);
        }
      }

      state.isDraggingInternally = false;
    }, [readOnly, attributes.onDrop]),
    onDragEnd: (0,react.useCallback)(event => {
      if (!readOnly && state.isDraggingInternally && attributes.onDragEnd && hasTarget(editor, event.target)) {
        attributes.onDragEnd(event);
      } // When dropping on a different droppable element than the current editor,
      // `onDrop` is not called. So we need to clean up in `onDragEnd` instead.
      // Note: `onDragEnd` is only called when `onDrop` is not called


      state.isDraggingInternally = false;
    }, [readOnly, attributes.onDragEnd]),
    onFocus: (0,react.useCallback)(event => {
      if (!readOnly && !state.isUpdatingSelection && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onFocus)) {
        var el = ReactEditor.toDOMNode(editor, editor);
        var root = ReactEditor.findDocumentOrShadowRoot(editor);
        state.latestElement = root.activeElement; // COMPAT: If the editor has nested editable elements, the focus
        // can go to them. In Firefox, this must be prevented because it
        // results in issues with keyboard navigation. (2017/03/30)

        if (IS_FIREFOX && event.target !== el) {
          el.focus();
          return;
        }

        IS_FOCUSED.set(editor, true);
      }
    }, [readOnly, attributes.onFocus]),
    onKeyDown: (0,react.useCallback)(event => {
      if (!readOnly && hasEditableTarget(editor, event.target)) {
        var {
          nativeEvent
        } = event; // COMPAT: The composition end event isn't fired reliably in all browsers,
        // so we sometimes might end up stuck in a composition state even though we
        // aren't composing any more.

        if (ReactEditor.isComposing(editor) && nativeEvent.isComposing === false) {
          IS_COMPOSING.set(editor, false);
          setIsComposing(false);
        }

        if (isEventHandled(event, attributes.onKeyDown) || ReactEditor.isComposing(editor)) {
          return;
        }

        var {
          selection
        } = editor;
        var element = editor.children[selection !== null ? selection.focus.path[0] : 0];
        var isRTL = direction_default()(index_es/* Node.string */.NB.string(element)) === 'rtl'; // COMPAT: Since we prevent the default behavior on
        // `beforeinput` events, the browser doesn't think there's ever
        // any history stack to undo or redo, so we have to manage these
        // hotkeys ourselves. (2019/11/06)

        if (Hotkeys.isRedo(nativeEvent)) {
          event.preventDefault();
          var maybeHistoryEditor = editor;

          if (typeof maybeHistoryEditor.redo === 'function') {
            maybeHistoryEditor.redo();
          }

          return;
        }

        if (Hotkeys.isUndo(nativeEvent)) {
          event.preventDefault();
          var _maybeHistoryEditor = editor;

          if (typeof _maybeHistoryEditor.undo === 'function') {
            _maybeHistoryEditor.undo();
          }

          return;
        } // COMPAT: Certain browsers don't handle the selection updates
        // properly. In Chrome, the selection isn't properly extended.
        // And in Firefox, the selection isn't properly collapsed.
        // (2017/10/17)


        if (Hotkeys.isMoveLineBackward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'line',
            reverse: true
          });
          return;
        }

        if (Hotkeys.isMoveLineForward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'line'
          });
          return;
        }

        if (Hotkeys.isExtendLineBackward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'line',
            edge: 'focus',
            reverse: true
          });
          return;
        }

        if (Hotkeys.isExtendLineForward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'line',
            edge: 'focus'
          });
          return;
        } // COMPAT: If a void node is selected, or a zero-width text node
        // adjacent to an inline is selected, we need to handle these
        // hotkeys manually because browsers won't be able to skip over
        // the void node with the zero-width space not being an empty
        // string.


        if (Hotkeys.isMoveBackward(nativeEvent)) {
          event.preventDefault();

          if (selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
            index_es/* Transforms.move */.YR.move(editor, {
              reverse: !isRTL
            });
          } else {
            index_es/* Transforms.collapse */.YR.collapse(editor, {
              edge: 'start'
            });
          }

          return;
        }

        if (Hotkeys.isMoveForward(nativeEvent)) {
          event.preventDefault();

          if (selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
            index_es/* Transforms.move */.YR.move(editor, {
              reverse: isRTL
            });
          } else {
            index_es/* Transforms.collapse */.YR.collapse(editor, {
              edge: 'end'
            });
          }

          return;
        }

        if (Hotkeys.isMoveWordBackward(nativeEvent)) {
          event.preventDefault();

          if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
            index_es/* Transforms.collapse */.YR.collapse(editor, {
              edge: 'focus'
            });
          }

          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'word',
            reverse: !isRTL
          });
          return;
        }

        if (Hotkeys.isMoveWordForward(nativeEvent)) {
          event.preventDefault();

          if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
            index_es/* Transforms.collapse */.YR.collapse(editor, {
              edge: 'focus'
            });
          }

          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'word',
            reverse: isRTL
          });
          return;
        } // COMPAT: Certain browsers don't support the `beforeinput` event, so we
        // fall back to guessing at the input intention for hotkeys.
        // COMPAT: In iOS, some of these hotkeys are handled in the


        if (!HAS_BEFORE_INPUT_SUPPORT) {
          // We don't have a core behavior for these, but they change the
          // DOM if we don't prevent them, so we have to.
          if (Hotkeys.isBold(nativeEvent) || Hotkeys.isItalic(nativeEvent) || Hotkeys.isTransposeCharacter(nativeEvent)) {
            event.preventDefault();
            return;
          }

          if (Hotkeys.isSoftBreak(nativeEvent)) {
            event.preventDefault();
            index_es/* Editor.insertSoftBreak */.ML.insertSoftBreak(editor);
            return;
          }

          if (Hotkeys.isSplitBlock(nativeEvent)) {
            event.preventDefault();
            index_es/* Editor.insertBreak */.ML.insertBreak(editor);
            return;
          }

          if (Hotkeys.isDeleteBackward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor, {
                direction: 'backward'
              });
            } else {
              index_es/* Editor.deleteBackward */.ML.deleteBackward(editor);
            }

            return;
          }

          if (Hotkeys.isDeleteForward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor, {
                direction: 'forward'
              });
            } else {
              index_es/* Editor.deleteForward */.ML.deleteForward(editor);
            }

            return;
          }

          if (Hotkeys.isDeleteLineBackward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor, {
                direction: 'backward'
              });
            } else {
              index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
                unit: 'line'
              });
            }

            return;
          }

          if (Hotkeys.isDeleteLineForward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor, {
                direction: 'forward'
              });
            } else {
              index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
                unit: 'line'
              });
            }

            return;
          }

          if (Hotkeys.isDeleteWordBackward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor, {
                direction: 'backward'
              });
            } else {
              index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
                unit: 'word'
              });
            }

            return;
          }

          if (Hotkeys.isDeleteWordForward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor, {
                direction: 'forward'
              });
            } else {
              index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
                unit: 'word'
              });
            }

            return;
          }
        } else {
          if (IS_CHROME || IS_SAFARI) {
            // COMPAT: Chrome and Safari support `beforeinput` event but do not fire
            // an event when deleting backwards in a selected void inline node
            if (selection && (Hotkeys.isDeleteBackward(nativeEvent) || Hotkeys.isDeleteForward(nativeEvent)) && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
              var currentNode = index_es/* Node.parent */.NB.parent(editor, selection.anchor.path);

              if (index_es/* Element.isElement */.W_.isElement(currentNode) && index_es/* Editor.isVoid */.ML.isVoid(editor, currentNode) && index_es/* Editor.isInline */.ML.isInline(editor, currentNode)) {
                event.preventDefault();
                index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
                  unit: 'block'
                });
                return;
              }
            }
          }
        }
      }
    }, [readOnly, attributes.onKeyDown]),
    onPaste: (0,react.useCallback)(event => {
      if (!readOnly && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onPaste)) {
        // COMPAT: Certain browsers don't support the `beforeinput` event, so we
        // fall back to React's `onPaste` here instead.
        // COMPAT: Firefox, Chrome and Safari don't emit `beforeinput` events
        // when "paste without formatting" is used, so fallback. (2020/02/20)
        if (!HAS_BEFORE_INPUT_SUPPORT || isPlainTextOnlyPaste(event.nativeEvent)) {
          event.preventDefault();
          ReactEditor.insertData(editor, event.clipboardData);
        }
      }
    }, [readOnly, attributes.onPaste])
  }), /*#__PURE__*/react.createElement(Children, {
    decorations: decorations,
    node: editor,
    renderElement: renderElement,
    renderPlaceholder: renderPlaceholder,
    renderLeaf: renderLeaf,
    selection: editor.selection
  }))));
};
/**
 * The default placeholder element
 */

var DefaultPlaceholder = _ref => {
  var {
    attributes,
    children
  } = _ref;
  return /*#__PURE__*/react.createElement("span", Object.assign({}, attributes), children);
};
/**
 * A default memoized decorate function.
 */

var defaultDecorate = () => [];
/**
 * A default implement to scroll dom range into view.
 */

var defaultScrollSelectionIntoView = (editor, domRange) => {
  // This was affecting the selection of multiple blocks and dragging behavior,
  // so enabled only if the selection has been collapsed.
  if (!editor.selection || editor.selection && index_es/* Range.isCollapsed */.e6.isCollapsed(editor.selection)) {
    var leafEl = domRange.startContainer.parentElement;
    leafEl.getBoundingClientRect = domRange.getBoundingClientRect.bind(domRange);
    es(leafEl, {
      scrollMode: 'if-needed'
    });
    delete leafEl.getBoundingClientRect;
  }
};
/**
 * Check if the target is in the editor.
 */


var hasTarget = (editor, target) => {
  return isDOMNode(target) && ReactEditor.hasDOMNode(editor, target);
};
/**
 * Check if the target is editable and in the editor.
 */

var hasEditableTarget = (editor, target) => {
  return isDOMNode(target) && ReactEditor.hasDOMNode(editor, target, {
    editable: true
  });
};
/**
 * Check if the target is inside void and in an non-readonly editor.
 */

var isTargetInsideNonReadonlyVoid = (editor, target) => {
  if (IS_READ_ONLY.get(editor)) return false;
  var slateNode = hasTarget(editor, target) && ReactEditor.toSlateNode(editor, target);
  return index_es/* Editor.isVoid */.ML.isVoid(editor, slateNode);
};
/**
 * Check if an event is overrided by a handler.
 */

var isEventHandled = (event, handler) => {
  if (!handler) {
    return false;
  } // The custom event handler may return a boolean to specify whether the event
  // shall be treated as being handled or not.


  var shouldTreatEventAsHandled = handler(event);

  if (shouldTreatEventAsHandled != null) {
    return shouldTreatEventAsHandled;
  }

  return event.isDefaultPrevented() || event.isPropagationStopped();
};
/**
 * Check if a DOM event is overrided by a handler.
 */

var isDOMEventHandled = (event, handler) => {
  if (!handler) {
    return false;
  } // The custom event handler may return a boolean to specify whether the event
  // shall be treated as being handled or not.


  var shouldTreatEventAsHandled = handler(event);

  if (shouldTreatEventAsHandled != null) {
    return shouldTreatEventAsHandled;
  }

  return event.defaultPrevented;
};

/**
 * Returns the number of characters that are the same at the beginning of the
 * String.
 *
 * @param prev  the previous text
 * @param next  the next text
 * @returns the offset of the start of the difference; null if there is no difference
 */

function getDiffStart(prev, next) {
  var length = Math.min(prev.length, next.length);

  for (var i = 0; i < length; i++) {
    if (prev.charAt(i) !== next.charAt(i)) return i;
  }

  if (prev.length !== next.length) return length;
  return null;
}
/**
 * Returns the number of characters that are the same at the end of the String
 * up to `max`. Max prevents double-counting characters when there are
 * multiple duplicate characters around the diff area.
 *
 * @param prev  the previous text
 * @param next  the next text
 * @param max  the max length to test.
 * @returns number of characters that are the same at the end of the string
 */


function getDiffEnd(prev, next, max) {
  var prevLength = prev.length;
  var nextLength = next.length;
  var length = Math.min(prevLength, nextLength, max);

  for (var i = 0; i < length; i++) {
    var prevChar = prev.charAt(prevLength - i - 1);
    var nextChar = next.charAt(nextLength - i - 1);
    if (prevChar !== nextChar) return i;
  }

  if (prev.length !== next.length) return length;
  return null;
}
/**
 * Takes two strings and returns an object representing two offsets. The
 * first, `start` represents the number of characters that are the same at
 * the front of the String. The `end` represents the number of characters
 * that are the same at the end of the String.
 *
 * Returns null if they are identical.
 *
 * @param prev  the previous text
 * @param next  the next text
 * @returns the difference text range; null if there are no differences.
 */


function getDiffOffsets(prev, next) {
  if (prev === next) return null;
  var start = getDiffStart(prev, next);
  if (start === null) return null;
  var maxEnd = Math.min(prev.length - start, next.length - start);
  var end = getDiffEnd(prev, next, maxEnd);
  if (end === null) return null;
  return {
    start,
    end
  };
}
/**
 * Takes a text string and returns a slice from the string at the given text range
 *
 * @param text  the text
 * @param offsets  the text range
 * @returns the text slice at text range
 */


function sliceText(text, offsets) {
  return text.slice(offsets.start, text.length - offsets.end);
}
/**
 * Takes two strings and returns a smart diff that can be used to describe the
 * change in a way that can be used as operations like inserting, removing or
 * replacing text.
 *
 * @param prev the previous text
 * @param next the next text
 * @returns the text difference
 */


function diffText(prev, next) {
  if (prev === undefined || next === undefined) return null;
  var offsets = getDiffOffsets(prev, next);
  if (offsets == null) return null;
  var insertText = sliceText(next, offsets);
  var removeText = sliceText(prev, offsets);
  return {
    start: offsets.start,
    end: prev.length - offsets.end,
    insertText,
    removeText
  };
}
function combineInsertedText(insertedText) {
  return insertedText.reduce((acc, _ref) => {
    var {
      text
    } = _ref;
    return "".concat(acc).concat(text.insertText);
  }, '');
}
function getTextInsertion(editor, domNode) {
  var node = ReactEditor.toSlateNode(editor, domNode);

  if (!index_es/* Text.isText */.xv.isText(node)) {
    return undefined;
  }

  var prevText = node.text;
  var nextText = domNode.textContent; // textContent will pad an extra \n when the textContent ends with an \n

  if (nextText.endsWith('\n')) {
    nextText = nextText.slice(0, nextText.length - 1);
  } // If the text is no different, there is no diff.


  if (nextText !== prevText) {
    var textDiff = diffText(prevText, nextText);

    if (textDiff !== null) {
      var textPath = ReactEditor.findPath(editor, node);
      return {
        text: textDiff,
        path: textPath
      };
    }
  }

  return undefined;
}
function normalizeTextInsertionRange(editor, range, _ref2) {
  var {
    path,
    text
  } = _ref2;
  var insertionRange = {
    anchor: {
      path,
      offset: text.start
    },
    focus: {
      path,
      offset: text.end
    }
  };

  if (!range || !index_es/* Range.isCollapsed */.e6.isCollapsed(range)) {
    return insertionRange;
  }

  var {
    insertText,
    removeText
  } = text;
  var isSingleCharacterInsertion = insertText.length === 1 || removeText.length === 1;
  /**
   * This code handles edge cases that arise from text diffing when the
   * inserted or removed character is a single character, and the character
   * right before or after the anchor is the same as the one being inserted or
   * removed.
   *
   * Take this example: hello|o
   *
   * If another `o` is inserted at the selection's anchor in the example above,
   * it should be inserted at the anchor, but using text diffing, we actually
   * detect that the character was inserted after the second `o`:
   *
   * helloo[o]|
   *
   * Instead, in these very specific edge cases, we assume that the character
   * needs to be inserted after the anchor rather than where the diff was found:
   *
   * hello[o]|o
   */

  if (isSingleCharacterInsertion && index_es/* Path.equals */.y$.equals(range.anchor.path, path)) {
    var [_text] = Array.from(index_es/* Editor.nodes */.ML.nodes(editor, {
      at: range,
      match: index_es/* Text.isText */.xv.isText
    }));

    if (_text) {
      var [node] = _text;
      var {
        anchor
      } = range;
      var characterBeforeAnchor = node.text[anchor.offset - 1];
      var characterAfterAnchor = node.text[anchor.offset];

      if (insertText.length === 1 && insertText === characterAfterAnchor) {
        // Assume text should be inserted at the anchor
        return range;
      }

      if (removeText.length === 1 && removeText === characterBeforeAnchor) {
        // Assume text should be removed right before the anchor
        return {
          anchor: {
            path,
            offset: anchor.offset - 1
          },
          focus: {
            path,
            offset: anchor.offset
          }
        };
      }
    }
  }

  return insertionRange;
}

/**
 * An auto-incrementing identifier for keys.
 */
var n = 0;
/**
 * A class that keeps track of a key string. We use a full class here because we
 * want to be able to use them as keys in `WeakMap` objects.
 */

class Key {
  constructor() {
    this.id = "".concat(n++);
  }

}

var ReactEditor = {
  /**
   * Check if the user is currently composing inside the editor.
   */
  isComposing(editor) {
    return !!IS_COMPOSING.get(editor);
  },

  /**
   * Return the host window of the current editor.
   */
  getWindow(editor) {
    var window = EDITOR_TO_WINDOW.get(editor);

    if (!window) {
      throw new Error('Unable to find a host window element for this editor');
    }

    return window;
  },

  /**
   * Find a key for a Slate node.
   */
  findKey(editor, node) {
    var key = NODE_TO_KEY.get(node);

    if (!key) {
      key = new Key();
      NODE_TO_KEY.set(node, key);
    }

    return key;
  },

  /**
   * Find the path of Slate node.
   */
  findPath(editor, node) {
    var path = [];
    var child = node;

    while (true) {
      var parent = NODE_TO_PARENT.get(child);

      if (parent == null) {
        if (index_es/* Editor.isEditor */.ML.isEditor(child)) {
          return path;
        } else {
          break;
        }
      }

      var i = NODE_TO_INDEX.get(child);

      if (i == null) {
        break;
      }

      path.unshift(i);
      child = parent;
    }

    throw new Error("Unable to find the path for Slate node: ".concat(JSON.stringify(node)));
  },

  /**
   * Find the DOM node that implements DocumentOrShadowRoot for the editor.
   */
  findDocumentOrShadowRoot(editor) {
    var el = ReactEditor.toDOMNode(editor, editor);
    var root = el.getRootNode();

    if ((root instanceof Document || root instanceof ShadowRoot) && root.getSelection != null) {
      return root;
    }

    return el.ownerDocument;
  },

  /**
   * Check if the editor is focused.
   */
  isFocused(editor) {
    return !!IS_FOCUSED.get(editor);
  },

  /**
   * Check if the editor is in read-only mode.
   */
  isReadOnly(editor) {
    return !!IS_READ_ONLY.get(editor);
  },

  /**
   * Blur the editor.
   */
  blur(editor) {
    var el = ReactEditor.toDOMNode(editor, editor);
    var root = ReactEditor.findDocumentOrShadowRoot(editor);
    IS_FOCUSED.set(editor, false);

    if (root.activeElement === el) {
      el.blur();
    }
  },

  /**
   * Focus the editor.
   */
  focus(editor) {
    var el = ReactEditor.toDOMNode(editor, editor);
    var root = ReactEditor.findDocumentOrShadowRoot(editor);
    IS_FOCUSED.set(editor, true);

    if (root.activeElement !== el) {
      el.focus({
        preventScroll: true
      });
    }
  },

  /**
   * Deselect the editor.
   */
  deselect(editor) {
    ReactEditor.toDOMNode(editor, editor);
    var {
      selection
    } = editor;
    var root = ReactEditor.findDocumentOrShadowRoot(editor);
    var domSelection = root.getSelection();

    if (domSelection && domSelection.rangeCount > 0) {
      domSelection.removeAllRanges();
    }

    if (selection) {
      index_es/* Transforms.deselect */.YR.deselect(editor);
    }
  },

  /**
   * Check if a DOM node is within the editor.
   */
  hasDOMNode(editor, target) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      editable = false
    } = options;
    var editorEl = ReactEditor.toDOMNode(editor, editor);
    var targetEl; // COMPAT: In Firefox, reading `target.nodeType` will throw an error if
    // target is originating from an internal "restricted" element (e.g. a
    // stepper arrow on a number input). (2018/05/04)
    // https://github.com/ianstormtaylor/slate/issues/1819

    try {
      targetEl = isDOMElement(target) ? target : target.parentElement;
    } catch (err) {
      if (!err.message.includes('Permission denied to access property "nodeType"')) {
        throw err;
      }
    }

    if (!targetEl) {
      return false;
    }

    return targetEl.closest("[data-slate-editor]") === editorEl && (!editable || targetEl.isContentEditable ? true : typeof targetEl.isContentEditable === 'boolean' && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
    targetEl.closest('[contenteditable="false"]') === editorEl || !!targetEl.getAttribute('data-slate-zero-width'));
  },

  /**
   * Insert data from a `DataTransfer` into the editor.
   */
  insertData(editor, data) {
    editor.insertData(data);
  },

  /**
   * Insert fragment data from a `DataTransfer` into the editor.
   */
  insertFragmentData(editor, data) {
    return editor.insertFragmentData(data);
  },

  /**
   * Insert text data from a `DataTransfer` into the editor.
   */
  insertTextData(editor, data) {
    return editor.insertTextData(data);
  },

  /**
   * Sets data from the currently selected fragment on a `DataTransfer`.
   */
  setFragmentData(editor, data, originEvent) {
    editor.setFragmentData(data, originEvent);
  },

  /**
   * Find the native DOM element from a Slate node.
   */
  toDOMNode(editor, node) {
    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);
    var domNode = index_es/* Editor.isEditor */.ML.isEditor(node) ? EDITOR_TO_ELEMENT.get(editor) : KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.get(ReactEditor.findKey(editor, node));

    if (!domNode) {
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(JSON.stringify(node)));
    }

    return domNode;
  },

  /**
   * Find a native DOM selection point from a Slate point.
   */
  toDOMPoint(editor, point) {
    var [node] = index_es/* Editor.node */.ML.node(editor, point.path);
    var el = ReactEditor.toDOMNode(editor, node);
    var domPoint; // If we're inside a void node, force the offset to 0, otherwise the zero
    // width spacing character will result in an incorrect offset of 1

    if (index_es/* Editor.void */.ML["void"](editor, {
      at: point
    })) {
      point = {
        path: point.path,
        offset: 0
      };
    } // For each leaf, we need to isolate its content, which means filtering
    // to its direct text and zero-width spans. (We have to filter out any
    // other siblings that may have been rendered alongside them.)


    var selector = "[data-slate-string], [data-slate-zero-width]";
    var texts = Array.from(el.querySelectorAll(selector));
    var start = 0;

    for (var text of texts) {
      var domNode = text.childNodes[0];

      if (domNode == null || domNode.textContent == null) {
        continue;
      }

      var {
        length
      } = domNode.textContent;
      var attr = text.getAttribute('data-slate-length');
      var trueLength = attr == null ? length : parseInt(attr, 10);
      var end = start + trueLength;

      if (point.offset <= end) {
        var offset = Math.min(length, Math.max(0, point.offset - start));
        domPoint = [domNode, offset];
        break;
      }

      start = end;
    }

    if (!domPoint) {
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(JSON.stringify(point)));
    }

    return domPoint;
  },

  /**
   * Find a native DOM range from a Slate `range`.
   *
   * Notice: the returned range will always be ordinal regardless of the direction of Slate `range` due to DOM API limit.
   *
   * there is no way to create a reverse DOM Range using Range.setStart/setEnd
   * according to https://dom.spec.whatwg.org/#concept-range-bp-set.
   */
  toDOMRange(editor, range) {
    var {
      anchor,
      focus
    } = range;
    var isBackward = index_es/* Range.isBackward */.e6.isBackward(range);
    var domAnchor = ReactEditor.toDOMPoint(editor, anchor);
    var domFocus = index_es/* Range.isCollapsed */.e6.isCollapsed(range) ? domAnchor : ReactEditor.toDOMPoint(editor, focus);
    var window = ReactEditor.getWindow(editor);
    var domRange = window.document.createRange();
    var [startNode, startOffset] = isBackward ? domFocus : domAnchor;
    var [endNode, endOffset] = isBackward ? domAnchor : domFocus; // A slate Point at zero-width Leaf always has an offset of 0 but a native DOM selection at
    // zero-width node has an offset of 1 so we have to check if we are in a zero-width node and
    // adjust the offset accordingly.

    var startEl = isDOMElement(startNode) ? startNode : startNode.parentElement;
    var isStartAtZeroWidth = !!startEl.getAttribute('data-slate-zero-width');
    var endEl = isDOMElement(endNode) ? endNode : endNode.parentElement;
    var isEndAtZeroWidth = !!endEl.getAttribute('data-slate-zero-width');
    domRange.setStart(startNode, isStartAtZeroWidth ? 1 : startOffset);
    domRange.setEnd(endNode, isEndAtZeroWidth ? 1 : endOffset);
    return domRange;
  },

  /**
   * Find a Slate node from a native DOM `element`.
   */
  toSlateNode(editor, domNode) {
    var domEl = isDOMElement(domNode) ? domNode : domNode.parentElement;

    if (domEl && !domEl.hasAttribute('data-slate-node')) {
      domEl = domEl.closest("[data-slate-node]");
    }

    var node = domEl ? ELEMENT_TO_NODE.get(domEl) : null;

    if (!node) {
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(domEl));
    }

    return node;
  },

  /**
   * Get the target range from a DOM `event`.
   */
  findEventRange(editor, event) {
    if ('nativeEvent' in event) {
      event = event.nativeEvent;
    }

    var {
      clientX: x,
      clientY: y,
      target
    } = event;

    if (x == null || y == null) {
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
    }

    var node = ReactEditor.toSlateNode(editor, event.target);
    var path = ReactEditor.findPath(editor, node); // If the drop target is inside a void node, move it into either the
    // next or previous node, depending on which side the `x` and `y`
    // coordinates are closest to.

    if (index_es/* Editor.isVoid */.ML.isVoid(editor, node)) {
      var rect = target.getBoundingClientRect();
      var isPrev = editor.isInline(node) ? x - rect.left < rect.left + rect.width - x : y - rect.top < rect.top + rect.height - y;
      var edge = index_es/* Editor.point */.ML.point(editor, path, {
        edge: isPrev ? 'start' : 'end'
      });
      var point = isPrev ? index_es/* Editor.before */.ML.before(editor, edge) : index_es/* Editor.after */.ML.after(editor, edge);

      if (point) {
        var _range = index_es/* Editor.range */.ML.range(editor, point);

        return _range;
      }
    } // Else resolve a range from the caret position where the drop occured.


    var domRange;
    var {
      document
    } = ReactEditor.getWindow(editor); // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)

    if (document.caretRangeFromPoint) {
      domRange = document.caretRangeFromPoint(x, y);
    } else {
      var position = document.caretPositionFromPoint(x, y);

      if (position) {
        domRange = document.createRange();
        domRange.setStart(position.offsetNode, position.offset);
        domRange.setEnd(position.offsetNode, position.offset);
      }
    }

    if (!domRange) {
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
    } // Resolve a Slate range from the DOM range.


    var range = ReactEditor.toSlateRange(editor, domRange, {
      exactMatch: false,
      suppressThrow: false
    });
    return range;
  },

  /**
   * Find a Slate point from a DOM selection's `domNode` and `domOffset`.
   */
  toSlatePoint(editor, domPoint, options) {
    var {
      exactMatch,
      suppressThrow
    } = options;
    var [nearestNode, nearestOffset] = exactMatch ? domPoint : normalizeDOMPoint(domPoint);
    var parentNode = nearestNode.parentNode;
    var textNode = null;
    var offset = 0;

    if (parentNode) {
      var _domNode$textContent;

      var editorEl = ReactEditor.toDOMNode(editor, editor);
      var potentialVoidNode = parentNode.closest('[data-slate-void="true"]'); // Need to ensure that the closest void node is actually a void node
      // within this editor, and not a void node within some parent editor. This can happen
      // if this editor is within a void node of another editor ("nested editors", like in
      // the "Editable Voids" example on the docs site).

      var voidNode = potentialVoidNode && editorEl.contains(potentialVoidNode) ? potentialVoidNode : null;
      var leafNode = parentNode.closest('[data-slate-leaf]');
      var domNode = null; // Calculate how far into the text node the `nearestNode` is, so that we
      // can determine what the offset relative to the text node is.

      if (leafNode) {
        textNode = leafNode.closest('[data-slate-node="text"]');

        if (textNode) {
          var window = ReactEditor.getWindow(editor);
          var range = window.document.createRange();
          range.setStart(textNode, 0);
          range.setEnd(nearestNode, nearestOffset);
          var contents = range.cloneContents();
          var removals = [...Array.prototype.slice.call(contents.querySelectorAll('[data-slate-zero-width]')), ...Array.prototype.slice.call(contents.querySelectorAll('[contenteditable=false]'))];
          removals.forEach(el => {
            el.parentNode.removeChild(el);
          }); // COMPAT: Edge has a bug where Range.prototype.toString() will
          // convert \n into \r\n. The bug causes a loop when slate-react
          // attempts to reposition its cursor to match the native position. Use
          // textContent.length instead.
          // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10291116/

          offset = contents.textContent.length;
          domNode = textNode;
        }
      } else if (voidNode) {
        // For void nodes, the element with the offset key will be a cousin, not an
        // ancestor, so find it by going down from the nearest void parent.
        leafNode = voidNode.querySelector('[data-slate-leaf]'); // COMPAT: In read-only editors the leaf is not rendered.

        if (!leafNode) {
          offset = 1;
        } else {
          textNode = leafNode.closest('[data-slate-node="text"]');
          domNode = leafNode;
          offset = domNode.textContent.length;
          domNode.querySelectorAll('[data-slate-zero-width]').forEach(el => {
            offset -= el.textContent.length;
          });
        }
      }

      if (domNode && offset === domNode.textContent.length && (parentNode.hasAttribute('data-slate-zero-width') || IS_FIREFOX && (_domNode$textContent = domNode.textContent) !== null && _domNode$textContent !== void 0 && _domNode$textContent.endsWith('\n\n'))) {
        offset--;
      }
    }

    if (!textNode) {
      if (suppressThrow) {
        return null;
      }

      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(domPoint));
    } // COMPAT: If someone is clicking from one Slate editor into another,
    // the select event fires twice, once for the old editor's `element`
    // first, and then afterwards for the correct `element`. (2017/03/03)


    var slateNode = ReactEditor.toSlateNode(editor, textNode);
    var path = ReactEditor.findPath(editor, slateNode);
    return {
      path,
      offset
    };
  },

  /**
   * Find a Slate range from a DOM range or selection.
   */
  toSlateRange(editor, domRange, options) {
    var {
      exactMatch,
      suppressThrow
    } = options;
    var el = isDOMSelection(domRange) ? domRange.anchorNode : domRange.startContainer;
    var anchorNode;
    var anchorOffset;
    var focusNode;
    var focusOffset;
    var isCollapsed;

    if (el) {
      if (isDOMSelection(domRange)) {
        anchorNode = domRange.anchorNode;
        anchorOffset = domRange.anchorOffset;
        focusNode = domRange.focusNode;
        focusOffset = domRange.focusOffset; // COMPAT: There's a bug in chrome that always returns `true` for
        // `isCollapsed` for a Selection that comes from a ShadowRoot.
        // (2020/08/08)
        // https://bugs.chromium.org/p/chromium/issues/detail?id=447523

        if (IS_CHROME && hasShadowRoot()) {
          isCollapsed = domRange.anchorNode === domRange.focusNode && domRange.anchorOffset === domRange.focusOffset;
        } else {
          isCollapsed = domRange.isCollapsed;
        }
      } else {
        anchorNode = domRange.startContainer;
        anchorOffset = domRange.startOffset;
        focusNode = domRange.endContainer;
        focusOffset = domRange.endOffset;
        isCollapsed = domRange.collapsed;
      }
    }

    if (anchorNode == null || focusNode == null || anchorOffset == null || focusOffset == null) {
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(domRange));
    }

    var anchor = ReactEditor.toSlatePoint(editor, [anchorNode, anchorOffset], {
      exactMatch,
      suppressThrow
    });

    if (!anchor) {
      return null;
    }

    var focus = isCollapsed ? anchor : ReactEditor.toSlatePoint(editor, [focusNode, focusOffset], {
      exactMatch,
      suppressThrow
    });

    if (!focus) {
      return null;
    }

    var range = {
      anchor: anchor,
      focus: focus
    }; // if the selection is a hanging range that ends in a void
    // and the DOM focus is an Element
    // (meaning that the selection ends before the element)
    // unhang the range to avoid mistakenly including the void

    if (index_es/* Range.isExpanded */.e6.isExpanded(range) && index_es/* Range.isForward */.e6.isForward(range) && isDOMElement(focusNode) && index_es/* Editor.void */.ML["void"](editor, {
      at: range.focus,
      mode: 'highest'
    })) {
      range = index_es/* Editor.unhangRange */.ML.unhangRange(editor, range, {
        voids: true
      });
    }

    return range;
  },

  hasRange(editor, range) {
    var {
      anchor,
      focus
    } = range;
    return index_es/* Editor.hasPath */.ML.hasPath(editor, anchor.path) && index_es/* Editor.hasPath */.ML.hasPath(editor, focus.path);
  }

};

function gatherMutationData(editor, mutations) {
  var addedNodes = [];
  var removedNodes = [];
  var insertedText = [];
  var characterDataMutations = [];
  mutations.forEach(mutation => {
    switch (mutation.type) {
      case 'childList':
        {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(addedNode => {
              addedNodes.push(addedNode);
            });
          }

          mutation.removedNodes.forEach(removedNode => {
            removedNodes.push(removedNode);
          });
          break;
        }

      case 'characterData':
        {
          characterDataMutations.push(mutation); // Changes to text nodes should consider the parent element

          var {
            parentNode
          } = mutation.target;

          if (!parentNode) {
            return;
          }

          var textInsertion = getTextInsertion(editor, parentNode);

          if (!textInsertion) {
            return;
          } // If we've already detected a diff at that path, we can return early


          if (insertedText.some(_ref => {
            var {
              path
            } = _ref;
            return index_es/* Path.equals */.y$.equals(path, textInsertion.path);
          })) {
            return;
          } // Add the text diff to the array of detected text insertions that need to be reconciled


          insertedText.push(textInsertion);
        }
    }
  });
  return {
    addedNodes,
    removedNodes,
    insertedText,
    characterDataMutations
  };
}
/**
 * In general, when a line break occurs, there will be more `addedNodes` than `removedNodes`.
 *
 * This isn't always the case however. In some cases, there will be more `removedNodes` than
 * `addedNodes`.
 *
 * To account for these edge cases, the most reliable strategy to detect line break mutations
 * is to check whether a new block was inserted of the same type as the current block.
 */

var isLineBreak = (editor, _ref2) => {
  var {
    addedNodes
  } = _ref2;
  var {
    selection
  } = editor;
  var parentNode = selection ? index_es/* Node.parent */.NB.parent(editor, selection.anchor.path) : null;
  var parentDOMNode = parentNode ? ReactEditor.toDOMNode(editor, parentNode) : null;

  if (!parentDOMNode) {
    return false;
  }

  return addedNodes.some(addedNode => addedNode instanceof HTMLElement && addedNode.tagName === (parentDOMNode === null || parentDOMNode === void 0 ? void 0 : parentDOMNode.tagName));
};
/**
 * So long as we check for line break mutations before deletion mutations,
 * we can safely assume that a set of mutations was a deletion if there are
 * removed nodes.
 */

var isDeletion = (_, _ref3) => {
  var {
    removedNodes
  } = _ref3;
  return removedNodes.length > 0;
};
/**
 * If the selection was expanded and there are removed nodes,
 * the contents of the selection need to be replaced with the diff
 */

var isReplaceExpandedSelection = (_ref4, _ref5) => {
  var {
    selection
  } = _ref4;
  var {
    removedNodes
  } = _ref5;
  return selection ? index_es/* Range.isExpanded */.e6.isExpanded(selection) && removedNodes.length > 0 : false;
};
/**
 * Plain text insertion
 */

var isTextInsertion = (_, _ref6) => {
  var {
    insertedText
  } = _ref6;
  return insertedText.length > 0;
};
/**
 * Edge case. Detect mutations that remove leaf nodes and also update character data
 */

var isRemoveLeafNodes = (_, _ref7) => {
  var {
    addedNodes,
    characterDataMutations,
    removedNodes
  } = _ref7;
  return removedNodes.length > 0 && addedNodes.length === 0 && characterDataMutations.length > 0;
};

/**
 * Based loosely on:
 *
 * https://github.com/facebook/draft-js/blob/master/src/component/handlers/composition/DOMObserver.js
 * https://github.com/ProseMirror/prosemirror-view/blob/master/src/domobserver.js
 *
 * The input manager attempts to map observed mutations on the document to a
 * set of operations in order to reconcile Slate's internal value with the DOM.
 *
 * Mutations are processed synchronously as they come in. Only mutations that occur
 * during a user input loop are processed, as other mutations can occur within the
 * document that were not initiated by user input.
 *
 * The mutation reconciliation process attempts to match mutations to the following
 * patterns:
 *
 * - Text updates
 * - Deletions
 * - Line breaks
 *
 * @param editor
 * @param restoreDOM
 */


class AndroidInputManager {
  constructor(editor, restoreDOM) {
    this.editor = editor;
    this.restoreDOM = restoreDOM;
    /**
     * Handle MutationObserver flush
     *
     * @param mutations
     */

    this.flush = mutations => {

      try {
        this.reconcileMutations(mutations);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err); // Failed to reconcile mutations, restore DOM to its previous state

        this.restoreDOM();
      }
    };
    /**
     * Reconcile a batch of mutations
     *
     * @param mutations
     */


    this.reconcileMutations = mutations => {
      var mutationData = gatherMutationData(this.editor, mutations);
      var {
        insertedText,
        removedNodes
      } = mutationData;

      if (isReplaceExpandedSelection(this.editor, mutationData)) {
        var text = combineInsertedText(insertedText);
        this.replaceExpandedSelection(text);
      } else if (isLineBreak(this.editor, mutationData)) {
        this.insertBreak();
      } else if (isRemoveLeafNodes(this.editor, mutationData)) {
        this.removeLeafNodes(removedNodes);
      } else if (isDeletion(this.editor, mutationData)) {
        this.deleteBackward();
      } else if (isTextInsertion(this.editor, mutationData)) {
        this.insertText(insertedText);
      }
    };
    /**
     * Apply text diff
     */


    this.insertText = insertedText => {
      var {
        selection
      } = this.editor; // If it is in composing or after `onCompositionend`, set `EDITOR_ON_COMPOSITION_TEXT` and return.
      // Text will be inserted on compositionend event.

      if (ReactEditor.isComposing(this.editor) || IS_ON_COMPOSITION_END.get(this.editor)) {
        EDITOR_ON_COMPOSITION_TEXT.set(this.editor, insertedText);
        IS_ON_COMPOSITION_END.set(this.editor, false);
        return;
      } // Insert the batched text diffs


      insertedText.forEach(insertion => {
        var text = insertion.text.insertText;
        var at = normalizeTextInsertionRange(this.editor, selection, insertion);
        index_es/* Transforms.setSelection */.YR.setSelection(this.editor, at);
        index_es/* Editor.insertText */.ML.insertText(this.editor, text);
      });
    };
    /**
     * Handle line breaks
     */


    this.insertBreak = () => {
      var {
        selection
      } = this.editor;
      index_es/* Editor.insertBreak */.ML.insertBreak(this.editor);
      this.restoreDOM();

      if (selection) {
        // Compat: Move selection to the newly inserted block if it has not moved
        setTimeout(() => {
          if (this.editor.selection && index_es/* Range.equals */.e6.equals(selection, this.editor.selection)) {
            index_es/* Transforms.move */.YR.move(this.editor);
          }
        }, 100);
      }
    };
    /**
     * Handle expanded selection being deleted or replaced by text
     */


    this.replaceExpandedSelection = text => {

      index_es/* Editor.deleteFragment */.ML.deleteFragment(this.editor);

      if (text.length) {
        // Selection was replaced by text, insert the entire text diff
        index_es/* Editor.insertText */.ML.insertText(this.editor, text);
      }

      this.restoreDOM();
    };
    /**
     * Handle `backspace` that merges blocks
     */


    this.deleteBackward = () => {
      index_es/* Editor.deleteBackward */.ML.deleteBackward(this.editor);
      ReactEditor.focus(this.editor);
      this.restoreDOM();
    };
    /**
     * Handle mutations that remove specific leaves
     */


    this.removeLeafNodes = nodes => {
      for (var node of nodes) {
        var slateNode = ReactEditor.toSlateNode(this.editor, node);

        if (slateNode) {
          var path = ReactEditor.findPath(this.editor, slateNode);
          index_es/* Transforms.delete */.YR["delete"](this.editor, {
            at: path
          });
          this.restoreDOM();
        }
      }
    };

    this.editor = editor;
    this.restoreDOM = restoreDOM;
  }

}

function useMutationObserver(node, callback, options) {
  var [mutationObserver] = (0,react.useState)(() => new MutationObserver(callback));
  useIsomorphicLayoutEffect(() => {
    // Disconnect mutation observer during render phase
    mutationObserver.disconnect();
  });
  (0,react.useEffect)(() => {
    if (!node.current) {
      throw new Error('Failed to attach MutationObserver, `node` is undefined');
    } // Attach mutation observer after render phase has finished


    mutationObserver.observe(node.current, options); // Clean up after effect

    return mutationObserver.disconnect.bind(mutationObserver);
  });
}

var MUTATION_OBSERVER_CONFIG$1 = {
  childList: true,
  characterData: true,
  subtree: true
};

function findClosestKnowSlateNode(domNode) {
  var _domEl;

  var domEl = isDOMElement(domNode) ? domNode : domNode.parentElement;

  if (domEl && !domEl.hasAttribute('data-slate-node')) {
    domEl = domEl.closest("[data-slate-node]");
  }

  var slateNode = domEl && ELEMENT_TO_NODE.get(domEl);

  if (slateNode) {
    return slateNode;
  } // Unknown dom element with a slate-slate-node attribute => the IME
  // most likely duplicated the node so we have to restore the parent


  return (_domEl = domEl) !== null && _domEl !== void 0 && _domEl.parentElement ? findClosestKnowSlateNode(domEl.parentElement) : null;
}

function useRestoreDom(node, receivedUserInput) {
  var editor = useSlateStatic();
  var mutatedNodes = (0,react.useRef)(new Set());
  var handleDOMMutation = (0,react.useCallback)(mutations => {
    if (!receivedUserInput.current) {
      return;
    }

    mutations.forEach(_ref => {
      var {
        target
      } = _ref;
      var slateNode = findClosestKnowSlateNode(target);

      if (!slateNode) {
        return;
      }

      return mutatedNodes.current.add(slateNode);
    });
  }, []);
  useMutationObserver(node, handleDOMMutation, MUTATION_OBSERVER_CONFIG$1); // Clear mutated nodes on every render

  mutatedNodes.current.clear();
  var restore = (0,react.useCallback)(() => {
    var mutated = Array.from(mutatedNodes.current.values()); // Filter out child nodes of nodes that will be restored anyway

    var nodesToRestore = mutated.filter(n => !mutated.some(m => index_es/* Path.isParent */.y$.isParent(ReactEditor.findPath(editor, m), ReactEditor.findPath(editor, n))));
    nodesToRestore.forEach(n => {
      var _NODE_TO_RESTORE_DOM$;

      (_NODE_TO_RESTORE_DOM$ = NODE_TO_RESTORE_DOM.get(n)) === null || _NODE_TO_RESTORE_DOM$ === void 0 ? void 0 : _NODE_TO_RESTORE_DOM$();
    });
    mutatedNodes.current.clear();
  }, []);
  return restore;
}

function useTrackUserInput() {
  var editor = useSlateStatic();
  var receivedUserInput = (0,react.useRef)(false);
  var animationFrameRef = (0,react.useRef)(null);
  var onUserInput = (0,react.useCallback)(() => {
    if (receivedUserInput.current === false) {
      var window = ReactEditor.getWindow(editor);
      receivedUserInput.current = true;

      if (animationFrameRef.current) {
        window.cancelAnimationFrame(animationFrameRef.current);
      }

      animationFrameRef.current = window.requestAnimationFrame(() => {
        receivedUserInput.current = false;
        animationFrameRef.current = null;
      });
    }
  }, []);
  (0,react.useEffect)(() => {
    // Reset user input tracking on every render
    if (receivedUserInput.current) {
      receivedUserInput.current = false;
    }
  });
  return {
    receivedUserInput,
    onUserInput
  };
}

var MUTATION_OBSERVER_CONFIG = {
  childList: true,
  characterData: true,
  characterDataOldValue: true,
  subtree: true
};
function useAndroidInputManager(node) {
  var editor = useSlateStatic();
  var {
    receivedUserInput,
    onUserInput
  } = useTrackUserInput();
  var restoreDom = useRestoreDom(node, receivedUserInput);
  var inputManager = (0,react.useMemo)(() => new AndroidInputManager(editor, restoreDom), [restoreDom, editor]);
  var timeoutId = (0,react.useRef)(null);
  var isReconciling = (0,react.useRef)(false);
  var flush = (0,react.useCallback)(mutations => {
    if (!receivedUserInput.current) {
      return;
    }

    isReconciling.current = true;
    inputManager.flush(mutations);

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = setTimeout(() => {
      isReconciling.current = false;
      timeoutId.current = null;
    }, 250);
  }, []);
  useMutationObserver(node, flush, MUTATION_OBSERVER_CONFIG);
  return {
    isReconciling,
    onUserInput
  };
}

var _excluded$1 = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "style", "as"];

function index_es_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function index_es_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { index_es_ownKeys(Object(source), true).forEach(function (key) { index_es_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { index_es_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Editable.
 */
// https://github.com/facebook/draft-js/blob/main/src/component/handlers/composition/DraftEditorCompositionHandler.js#L41
// When using keyboard English association function, conpositionEnd triggered too fast, resulting in after `insertText` still maintain association state.

var RESOLVE_DELAY = 20;
var AndroidEditable = props => {
  var {
    autoFocus,
    decorate = defaultDecorate,
    onDOMBeforeInput: propsOnDOMBeforeInput,
    placeholder,
    readOnly = false,
    renderElement,
    renderLeaf,
    renderPlaceholder = props => /*#__PURE__*/react.createElement(DefaultPlaceholder, Object.assign({}, props)),
    style = {},
    as: Component = 'div'
  } = props,
      attributes = _objectWithoutProperties(props, _excluded$1);

  var editor = useSlate(); // Rerender editor when composition status changed

  var [isComposing, setIsComposing] = (0,react.useState)(false);
  var ref = (0,react.useRef)(null);
  var inputManager = useAndroidInputManager(ref); // Update internal state on each render.

  IS_READ_ONLY.set(editor, readOnly); // Keep track of some state for the event handler logic.

  var state = (0,react.useMemo)(() => ({
    isComposing: false,
    isUpdatingSelection: false,
    latestElement: null
  }), []);
  var contentKey = useContentKey(editor); // Whenever the editor updates...

  useIsomorphicLayoutEffect(() => {
    // Update element-related weak maps with the DOM element ref.
    var window;

    if (ref.current && (window = getDefaultView(ref.current))) {
      EDITOR_TO_WINDOW.set(editor, window);
      EDITOR_TO_ELEMENT.set(editor, ref.current);
      NODE_TO_ELEMENT.set(editor, ref.current);
      ELEMENT_TO_NODE.set(ref.current, editor);
    } else {
      NODE_TO_ELEMENT.delete(editor);
    }

    try {
      // Make sure the DOM selection state is in sync.
      var {
        selection
      } = editor;
      var root = ReactEditor.findDocumentOrShadowRoot(editor);
      var domSelection = root.getSelection();

      if (state.isComposing || !domSelection || !ReactEditor.isFocused(editor)) {
        return;
      }

      var hasDomSelection = domSelection.type !== 'None'; // If the DOM selection is properly unset, we're done.

      if (!selection && !hasDomSelection) {
        return;
      } // verify that the dom selection is in the editor


      var editorElement = EDITOR_TO_ELEMENT.get(editor);
      var hasDomSelectionInEditor = false;

      if (editorElement.contains(domSelection.anchorNode) && editorElement.contains(domSelection.focusNode)) {
        hasDomSelectionInEditor = true;
      } // If the DOM selection is in the editor and the editor selection is already correct, we're done.


      if (hasDomSelection && hasDomSelectionInEditor && selection) {
        var slateRange = ReactEditor.toSlateRange(editor, domSelection, {
          exactMatch: true,
          suppressThrow: true
        });

        if (slateRange && index_es/* Range.equals */.e6.equals(slateRange, selection)) {
          return;
        }
      } // when <Editable/> is being controlled through external value
      // then its children might just change - DOM responds to it on its own
      // but Slate's value is not being updated through any operation
      // and thus it doesn't transform selection on its own


      if (selection && !ReactEditor.hasRange(editor, selection)) {
        editor.selection = ReactEditor.toSlateRange(editor, domSelection, {
          exactMatch: false,
          suppressThrow: false
        });
        return;
      } // Otherwise the DOM selection is out of sync, so update it.


      var el = ReactEditor.toDOMNode(editor, editor);
      state.isUpdatingSelection = true;
      var newDomRange = selection && ReactEditor.toDOMRange(editor, selection);

      if (newDomRange) {
        if (index_es/* Range.isBackward */.e6.isBackward(selection)) {
          domSelection.setBaseAndExtent(newDomRange.endContainer, newDomRange.endOffset, newDomRange.startContainer, newDomRange.startOffset);
        } else {
          domSelection.setBaseAndExtent(newDomRange.startContainer, newDomRange.startOffset, newDomRange.endContainer, newDomRange.endOffset);
        }

        var leafEl = newDomRange.startContainer.parentElement;
        leafEl.getBoundingClientRect = newDomRange.getBoundingClientRect.bind(newDomRange);
        es(leafEl, {
          scrollMode: 'if-needed',
          boundary: el
        }); // @ts-ignore

        delete leafEl.getBoundingClientRect;
      } else {
        domSelection.removeAllRanges();
      }

      setTimeout(() => {
        state.isUpdatingSelection = false;
      });
    } catch (_unused) {
      // Failed to update selection, likely due to reconciliation error
      state.isUpdatingSelection = false;
    }
  }); // The autoFocus TextareaHTMLAttribute doesn't do anything on a div, so it
  // needs to be manually focused.

  (0,react.useEffect)(() => {
    if (ref.current && autoFocus) {
      ref.current.focus();
    }
  }, [autoFocus]); // Listen on the native `selectionchange` event to be able to update any time
  // the selection changes. This is required because React's `onSelect` is leaky
  // and non-standard so it doesn't fire until after a selection has been
  // released. This causes issues in situations where another change happens
  // while a selection is being dragged.

  var onDOMSelectionChange = (0,react.useCallback)(throttle_default()(() => {
    try {
      if (!state.isComposing && !state.isUpdatingSelection && !inputManager.isReconciling.current) {
        var root = ReactEditor.findDocumentOrShadowRoot(editor);
        var {
          activeElement
        } = root;
        var el = ReactEditor.toDOMNode(editor, editor);
        var domSelection = root.getSelection();

        if (activeElement === el) {
          state.latestElement = activeElement;
          IS_FOCUSED.set(editor, true);
        } else {
          IS_FOCUSED.delete(editor);
        }

        if (!domSelection) {
          return index_es/* Transforms.deselect */.YR.deselect(editor);
        }

        var {
          anchorNode,
          focusNode
        } = domSelection;
        var anchorNodeSelectable = hasEditableTarget(editor, anchorNode) || isTargetInsideNonReadonlyVoid(editor, anchorNode);
        var focusNodeSelectable = hasEditableTarget(editor, focusNode) || isTargetInsideNonReadonlyVoid(editor, focusNode);

        if (anchorNodeSelectable && focusNodeSelectable) {
          var range = ReactEditor.toSlateRange(editor, domSelection, {
            exactMatch: false,
            suppressThrow: false
          });
          index_es/* Transforms.select */.YR.select(editor, range);
        } else {
          index_es/* Transforms.deselect */.YR.deselect(editor);
        }
      }
    } catch (_unused2) {// Failed to update selection, likely due to reconciliation error
    }
  }, 100), [readOnly]);
  var scheduleOnDOMSelectionChange = (0,react.useMemo)(() => debounce_default()(onDOMSelectionChange, 0), [onDOMSelectionChange]); // Listen on the native `beforeinput` event to get real "Level 2" events. This
  // is required because React's `beforeinput` is fake and never really attaches
  // to the real event sadly. (2019/11/01)
  // https://github.com/facebook/react/issues/11211

  var onDOMBeforeInput = (0,react.useCallback)(event => {
    if (!readOnly && hasEditableTarget(editor, event.target) && !isDOMEventHandled(event, propsOnDOMBeforeInput)) {
      // Some IMEs/Chrome extensions like e.g. Grammarly set the selection immediately before
      // triggering a `beforeinput` expecting the change to be applied to the immediately before
      // set selection.
      scheduleOnDOMSelectionChange.flush();
      inputManager.onUserInput();
    }
  }, [readOnly, propsOnDOMBeforeInput]); // Attach a native DOM event handler for `beforeinput` events, because React's
  // built-in `onBeforeInput` is actually a leaky polyfill that doesn't expose
  // real `beforeinput` events sadly... (2019/11/04)

  useIsomorphicLayoutEffect(() => {
    var node = ref.current; // @ts-ignore The `beforeinput` event isn't recognized.

    node === null || node === void 0 ? void 0 : node.addEventListener('beforeinput', onDOMBeforeInput); // @ts-ignore The `beforeinput` event isn't recognized.

    return () => node === null || node === void 0 ? void 0 : node.removeEventListener('beforeinput', onDOMBeforeInput);
  }, [contentKey, propsOnDOMBeforeInput]); // Attach a native DOM event handler for `selectionchange`, because React's
  // built-in `onSelect` handler doesn't fire for all selection changes. It's a
  // leaky polyfill that only fires on keypresses or clicks. Instead, we want to
  // fire for any change to the selection inside the editor. (2019/11/04)
  // https://github.com/facebook/react/issues/5785

  useIsomorphicLayoutEffect(() => {
    var window = ReactEditor.getWindow(editor);
    window.document.addEventListener('selectionchange', scheduleOnDOMSelectionChange);
    return () => {
      window.document.removeEventListener('selectionchange', scheduleOnDOMSelectionChange);
    };
  }, [scheduleOnDOMSelectionChange]);
  var decorations = decorate([editor, []]);

  if (placeholder && editor.children.length === 1 && Array.from(index_es/* Node.texts */.NB.texts(editor)).length === 1 && index_es/* Node.string */.NB.string(editor) === '' && !isComposing) {
    var start = index_es/* Editor.start */.ML.start(editor, []);
    decorations.push({
      [PLACEHOLDER_SYMBOL]: true,
      placeholder,
      anchor: start,
      focus: start
    });
  }

  return /*#__PURE__*/react.createElement(ReadOnlyContext.Provider, {
    value: readOnly
  }, /*#__PURE__*/react.createElement(DecorateContext.Provider, {
    value: decorate
  }, /*#__PURE__*/react.createElement(Component, Object.assign({
    key: contentKey,
    role: readOnly ? undefined : 'textbox'
  }, attributes, {
    spellCheck: attributes.spellCheck,
    autoCorrect: attributes.autoCorrect,
    autoCapitalize: attributes.autoCapitalize,
    "data-slate-editor": true,
    "data-slate-node": "value",
    contentEditable: readOnly ? undefined : true,
    suppressContentEditableWarning: true,
    ref: ref,
    style: index_es_objectSpread({
      // Allow positioning relative to the editable element.
      position: 'relative',
      // Prevent the default outline styles.
      outline: 'none',
      // Preserve adjacent whitespace and new lines.
      whiteSpace: 'pre-wrap',
      // Allow words to break if they are too long.
      wordWrap: 'break-word'
    }, style),
    onCopy: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCopy)) {
        event.preventDefault();
        ReactEditor.setFragmentData(editor, event.clipboardData, 'copy');
      }
    }, [attributes.onCopy]),
    onCut: (0,react.useCallback)(event => {
      if (!readOnly && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCut)) {
        event.preventDefault();
        ReactEditor.setFragmentData(editor, event.clipboardData, 'cut');
        var {
          selection
        } = editor;

        if (selection) {
          if (index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
            index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
          } else {
            var node = index_es/* Node.parent */.NB.parent(editor, selection.anchor.path);

            if (index_es/* Editor.isVoid */.ML.isVoid(editor, node)) {
              index_es/* Transforms.delete */.YR["delete"](editor);
            }
          }
        }
      }
    }, [readOnly, attributes.onCut]),
    onFocus: (0,react.useCallback)(event => {
      if (!readOnly && !state.isUpdatingSelection && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onFocus)) {
        var root = ReactEditor.findDocumentOrShadowRoot(editor);
        state.latestElement = root.activeElement;
        IS_FOCUSED.set(editor, true);
      }
    }, [readOnly, attributes.onFocus]),
    onBlur: (0,react.useCallback)(event => {
      if (readOnly || state.isUpdatingSelection || !hasEditableTarget(editor, event.target) || isEventHandled(event, attributes.onBlur)) {
        return;
      } // COMPAT: If the current `activeElement` is still the previous
      // one, this is due to the window being blurred when the tab
      // itself becomes unfocused, so we want to abort early to allow to
      // editor to stay focused when the tab becomes focused again.


      var root = ReactEditor.findDocumentOrShadowRoot(editor);

      if (state.latestElement === root.activeElement) {
        return;
      }

      var {
        relatedTarget
      } = event;
      var el = ReactEditor.toDOMNode(editor, editor); // COMPAT: The event should be ignored if the focus is returning
      // to the editor from an embedded editable element (eg. an <input>
      // element inside a void node).

      if (relatedTarget === el) {
        return;
      } // COMPAT: The event should be ignored if the focus is moving from
      // the editor to inside a void node's spacer element.


      if (isDOMElement(relatedTarget) && relatedTarget.hasAttribute('data-slate-spacer')) {
        return;
      } // COMPAT: The event should be ignored if the focus is moving to a
      // non- editable section of an element that isn't a void node (eg.
      // a list item of the check list example).


      if (relatedTarget != null && isDOMNode(relatedTarget) && ReactEditor.hasDOMNode(editor, relatedTarget)) {
        var node = ReactEditor.toSlateNode(editor, relatedTarget);

        if (index_es/* Element.isElement */.W_.isElement(node) && !editor.isVoid(node)) {
          return;
        }
      }

      IS_FOCUSED.delete(editor);
    }, [readOnly, attributes.onBlur]),
    onClick: (0,react.useCallback)(event => {
      if (!readOnly && hasTarget(editor, event.target) && !isEventHandled(event, attributes.onClick) && isDOMNode(event.target)) {
        var node = ReactEditor.toSlateNode(editor, event.target);
        var path = ReactEditor.findPath(editor, node); // At this time, the Slate document may be arbitrarily different,
        // because onClick handlers can change the document before we get here.
        // Therefore we must check that this path actually exists,
        // and that it still refers to the same node.

        if (index_es/* Editor.hasPath */.ML.hasPath(editor, path)) {
          var lookupNode = index_es/* Node.get */.NB.get(editor, path);

          if (lookupNode === node) {
            var _start = index_es/* Editor.start */.ML.start(editor, path);

            var end = index_es/* Editor.end */.ML.end(editor, path);
            var startVoid = index_es/* Editor.void */.ML["void"](editor, {
              at: _start
            });
            var endVoid = index_es/* Editor.void */.ML["void"](editor, {
              at: end
            });

            if (startVoid && endVoid && index_es/* Path.equals */.y$.equals(startVoid[1], endVoid[1])) {
              var range = index_es/* Editor.range */.ML.range(editor, _start);
              index_es/* Transforms.select */.YR.select(editor, range);
            }
          }
        }
      }
    }, [readOnly, attributes.onClick]),
    onCompositionEnd: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionEnd)) {
        scheduleOnDOMSelectionChange.flush();
        setTimeout(() => {
          state.isComposing && setIsComposing(false);
          state.isComposing = false;
          IS_COMPOSING.set(editor, false);
          IS_ON_COMPOSITION_END.set(editor, true);
          var insertedText = EDITOR_ON_COMPOSITION_TEXT.get(editor) || []; // `insertedText` is set in `MutationObserver` constructor.
          // If open phone keyboard association function, `CompositionEvent` will be triggered.

          if (!insertedText.length) {
            return;
          }

          EDITOR_ON_COMPOSITION_TEXT.set(editor, []);
          var {
            selection
          } = editor;
          insertedText.forEach(insertion => {
            var text = insertion.text.insertText;
            var at = normalizeTextInsertionRange(editor, selection, insertion);
            index_es/* Transforms.setSelection */.YR.setSelection(editor, at);
            index_es/* Editor.insertText */.ML.insertText(editor, text);
          });
        }, RESOLVE_DELAY);
      }
    }, [attributes.onCompositionEnd]),
    onCompositionUpdate: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionUpdate)) {
        !state.isComposing && setIsComposing(true);
        state.isComposing = true;
        IS_COMPOSING.set(editor, true);
      }
    }, [attributes.onCompositionUpdate]),
    onCompositionStart: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionStart)) {
        !state.isComposing && setIsComposing(true);
        state.isComposing = true;
        IS_COMPOSING.set(editor, true);
      }
    }, [attributes.onCompositionStart]),
    onPaste: (0,react.useCallback)(event => {
      // this will make application/x-slate-fragment exist when onPaste attributes is passed
      event.clipboardData = getClipboardData(event.clipboardData); // This unfortunately needs to be handled with paste events instead.

      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onPaste) && !readOnly) {
        event.preventDefault();
        ReactEditor.insertData(editor, event.clipboardData);
      }
    }, [readOnly, attributes.onPaste])
  }), useChildren({
    decorations,
    node: editor,
    renderElement,
    renderPlaceholder,
    renderLeaf,
    selection: editor.selection
  }))));
};

/**
 * A React context for sharing the `focused` state of the editor.
 */

var FocusedContext = /*#__PURE__*/(0,react.createContext)(false);
/**
 * Get the current `focused` state of the editor.
 */

var useFocused = () => {
  return (0,react.useContext)(FocusedContext);
};

function isError(error) {
  return error instanceof Error;
}
/**
 * A React context for sharing the editor selector context in a way to control rerenders
 */


var SlateSelectorContext = /*#__PURE__*/(0,react.createContext)({});

var refEquality = (a, b) => a === b;
/**
 * use redux style selectors to prevent rerendering on every keystroke.
 * Bear in mind rerendering can only prevented if the returned value is a value type or for reference types (e.g. objects and arrays) add a custom equality function.
 *
 * Example:
 * ```
 *  const isSelectionActive = useSlateSelector(editor => Boolean(editor.selection));
 * ```
 */


function useSlateSelector(selector) {
  var equalityFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : refEquality;
  var [, forceRender] = useReducer(s => s + 1, 0);
  var context = useContext(SlateSelectorContext);

  if (!context) {
    throw new Error("The `useSlateSelector` hook must be used inside the <Slate> component's context.");
  }

  var {
    getSlate,
    addEventListener
  } = context;
  var latestSubscriptionCallbackError = useRef();
  var latestSelector = useRef(() => null);
  var latestSelectedState = useRef(null);
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(getSlate());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current && isError(err)) {
      err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
    }

    throw err;
  }

  useIsomorphicLayoutEffect(() => {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(() => {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(getSlate());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    var unsubscribe = addEventListener(checkForUpdates);
    checkForUpdates();
    return () => unsubscribe();
  }, // don't rerender on equalityFn change since we want to be able to define it inline
  [addEventListener, getSlate]);
  return selectedState;
}
/**
 * Create selector context with editor updating on every editor change
 */

function getSelectorContext(editor) {
  var eventListeners = (0,react.useRef)([]).current;
  var slateRef = (0,react.useRef)({
    editor
  }).current;
  var onChange = (0,react.useCallback)(editor => {
    slateRef.editor = editor;
    eventListeners.forEach(listener => listener(editor));
  }, []);
  var selectorContext = (0,react.useMemo)(() => {
    return {
      getSlate: () => slateRef.editor,
      addEventListener: callback => {
        eventListeners.push(callback);
        return () => {
          eventListeners.splice(eventListeners.indexOf(callback), 1);
        };
      }
    };
  }, [eventListeners, slateRef]);
  return {
    selectorContext,
    onChange
  };
}

var _excluded = ["editor", "children", "onChange", "value"];
/**
 * A wrapper around the provider to handle `onChange` events, because the editor
 * is a mutable singleton so it won't ever register as "changed" otherwise.
 */

var Slate = props => {
  var {
    editor,
    children,
    onChange,
    value
  } = props,
      rest = _objectWithoutProperties(props, _excluded);

  var unmountRef = (0,react.useRef)(false);
  var [context, setContext] = react.useState(() => {
    if (!index_es/* Node.isNodeList */.NB.isNodeList(value)) {
      throw new Error("[Slate] value is invalid! Expected a list of elements" + "but got: ".concat(JSON.stringify(value)));
    }

    if (!index_es/* Editor.isEditor */.ML.isEditor(editor)) {
      throw new Error("[Slate] editor is invalid! you passed:" + "".concat(JSON.stringify(editor)));
    }

    editor.children = value;
    Object.assign(editor, rest);
    return [editor];
  });
  var {
    selectorContext,
    onChange: handleSelectorChange
  } = getSelectorContext(editor);
  var onContextChange = (0,react.useCallback)(() => {
    if (onChange) {
      onChange(editor.children);
    }

    setContext([editor]);
    handleSelectorChange(editor);
  }, [onChange]);
  EDITOR_TO_ON_CHANGE.set(editor, onContextChange);
  (0,react.useEffect)(() => {
    return () => {
      EDITOR_TO_ON_CHANGE.set(editor, () => {});
      unmountRef.current = true;
    };
  }, []);
  var [isFocused, setIsFocused] = (0,react.useState)(ReactEditor.isFocused(editor));
  (0,react.useEffect)(() => {
    setIsFocused(ReactEditor.isFocused(editor));
  });
  useIsomorphicLayoutEffect(() => {
    var fn = () => setIsFocused(ReactEditor.isFocused(editor));

    if (IS_REACT_VERSION_17_OR_ABOVE) {
      // In React >= 17 onFocus and onBlur listen to the focusin and focusout events during the bubbling phase.
      // Therefore in order for <Editable />'s handlers to run first, which is necessary for ReactEditor.isFocused(editor)
      // to return the correct value, we have to listen to the focusin and focusout events without useCapture here.
      document.addEventListener('focusin', fn);
      document.addEventListener('focusout', fn);
      return () => {
        document.removeEventListener('focusin', fn);
        document.removeEventListener('focusout', fn);
      };
    } else {
      document.addEventListener('focus', fn, true);
      document.addEventListener('blur', fn, true);
      return () => {
        document.removeEventListener('focus', fn, true);
        document.removeEventListener('blur', fn, true);
      };
    }
  }, []);
  return /*#__PURE__*/react.createElement(SlateSelectorContext.Provider, {
    value: selectorContext
  }, /*#__PURE__*/react.createElement(SlateContext.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement(EditorContext.Provider, {
    value: editor
  }, /*#__PURE__*/react.createElement(FocusedContext.Provider, {
    value: isFocused
  }, children))));
};

/**
 * Get the current editor object from the React context.
 * @deprecated Use useSlateStatic instead.
 */

var useEditor = () => {
  var editor = useContext(EditorContext);

  if (!editor) {
    throw new Error("The `useEditor` hook must be used inside the <Slate> component's context.");
  }

  return editor;
};

/**
 * Utilities for single-line deletion
 */

var doRectsIntersect = (rect, compareRect) => {
  var middle = (compareRect.top + compareRect.bottom) / 2;
  return rect.top <= middle && rect.bottom >= middle;
};

var areRangesSameLine = (editor, range1, range2) => {
  var rect1 = ReactEditor.toDOMRange(editor, range1).getBoundingClientRect();
  var rect2 = ReactEditor.toDOMRange(editor, range2).getBoundingClientRect();
  return doRectsIntersect(rect1, rect2) && doRectsIntersect(rect2, rect1);
};
/**
 * A helper utility that returns the end portion of a `Range`
 * which is located on a single line.
 *
 * @param {Editor} editor The editor object to compare against
 * @param {Range} parentRange The parent range to compare against
 * @returns {Range} A valid portion of the parentRange which is one a single line
 */


var findCurrentLineRange = (editor, parentRange) => {
  var parentRangeBoundary = index_es/* Editor.range */.ML.range(editor, index_es/* Range.end */.e6.end(parentRange));
  var positions = Array.from(index_es/* Editor.positions */.ML.positions(editor, {
    at: parentRange
  }));
  var left = 0;
  var right = positions.length;
  var middle = Math.floor(right / 2);

  if (areRangesSameLine(editor, index_es/* Editor.range */.ML.range(editor, positions[left]), parentRangeBoundary)) {
    return index_es/* Editor.range */.ML.range(editor, positions[left], parentRangeBoundary);
  }

  if (positions.length < 2) {
    return index_es/* Editor.range */.ML.range(editor, positions[positions.length - 1], parentRangeBoundary);
  }

  while (middle !== positions.length && middle !== left) {
    if (areRangesSameLine(editor, index_es/* Editor.range */.ML.range(editor, positions[middle]), parentRangeBoundary)) {
      right = middle;
    } else {
      left = middle;
    }

    middle = Math.floor((left + right) / 2);
  }

  return index_es/* Editor.range */.ML.range(editor, positions[right], parentRangeBoundary);
};

/**
 * `withReact` adds React and DOM specific behaviors to the editor.
 *
 * If you are using TypeScript, you must extend Slate's CustomTypes to use
 * this plugin.
 *
 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
 */

var withReact = editor => {
  var e = editor;
  var {
    apply,
    onChange,
    deleteBackward
  } = e; // The WeakMap which maps a key to a specific HTMLElement must be scoped to the editor instance to
  // avoid collisions between editors in the DOM that share the same value.

  EDITOR_TO_KEY_TO_ELEMENT.set(e, new WeakMap());

  e.deleteBackward = unit => {
    if (unit !== 'line') {
      return deleteBackward(unit);
    }

    if (editor.selection && index_es/* Range.isCollapsed */.e6.isCollapsed(editor.selection)) {
      var parentBlockEntry = index_es/* Editor.above */.ML.above(editor, {
        match: n => index_es/* Editor.isBlock */.ML.isBlock(editor, n),
        at: editor.selection
      });

      if (parentBlockEntry) {
        var [, parentBlockPath] = parentBlockEntry;
        var parentElementRange = index_es/* Editor.range */.ML.range(editor, parentBlockPath, editor.selection.anchor);
        var currentLineRange = findCurrentLineRange(e, parentElementRange);

        if (!index_es/* Range.isCollapsed */.e6.isCollapsed(currentLineRange)) {
          index_es/* Transforms.delete */.YR["delete"](editor, {
            at: currentLineRange
          });
        }
      }
    }
  }; // This attempts to reset the NODE_TO_KEY entry to the correct value
  // as apply() changes the object reference and hence invalidates the NODE_TO_KEY entry


  e.apply = op => {
    var matches = [];

    switch (op.type) {
      case 'insert_text':
      case 'remove_text':
      case 'set_node':
      case 'split_node':
        {
          matches.push(...getMatches(e, op.path));
          break;
        }

      case 'set_selection':
        {
          var _EDITOR_TO_USER_SELEC;

          // Selection was manually set, don't restore the user selection after the change.
          (_EDITOR_TO_USER_SELEC = EDITOR_TO_USER_SELECTION.get(editor)) === null || _EDITOR_TO_USER_SELEC === void 0 ? void 0 : _EDITOR_TO_USER_SELEC.unref();
          EDITOR_TO_USER_SELECTION.delete(editor);
          break;
        }

      case 'insert_node':
      case 'remove_node':
        {
          matches.push(...getMatches(e, index_es/* Path.parent */.y$.parent(op.path)));
          break;
        }

      case 'merge_node':
        {
          var prevPath = index_es/* Path.previous */.y$.previous(op.path);
          matches.push(...getMatches(e, prevPath));
          break;
        }

      case 'move_node':
        {
          var commonPath = index_es/* Path.common */.y$.common(index_es/* Path.parent */.y$.parent(op.path), index_es/* Path.parent */.y$.parent(op.newPath));
          matches.push(...getMatches(e, commonPath));
          break;
        }
    }

    apply(op);

    for (var [path, key] of matches) {
      var [node] = index_es/* Editor.node */.ML.node(e, path);
      NODE_TO_KEY.set(node, key);
    }
  };

  e.setFragmentData = data => {
    var {
      selection
    } = e;

    if (!selection) {
      return;
    }

    var [start, end] = index_es/* Range.edges */.e6.edges(selection);
    var startVoid = index_es/* Editor.void */.ML["void"](e, {
      at: start.path
    });
    var endVoid = index_es/* Editor.void */.ML["void"](e, {
      at: end.path
    });

    if (index_es/* Range.isCollapsed */.e6.isCollapsed(selection) && !startVoid) {
      return;
    } // Create a fake selection so that we can add a Base64-encoded copy of the
    // fragment to the HTML, to decode on future pastes.


    var domRange = ReactEditor.toDOMRange(e, selection);
    var contents = domRange.cloneContents();
    var attach = contents.childNodes[0]; // Make sure attach is non-empty, since empty nodes will not get copied.

    contents.childNodes.forEach(node => {
      if (node.textContent && node.textContent.trim() !== '') {
        attach = node;
      }
    }); // COMPAT: If the end node is a void node, we need to move the end of the
    // range from the void node's spacer span, to the end of the void node's
    // content, since the spacer is before void's content in the DOM.

    if (endVoid) {
      var [voidNode] = endVoid;
      var r = domRange.cloneRange();
      var domNode = ReactEditor.toDOMNode(e, voidNode);
      r.setEndAfter(domNode);
      contents = r.cloneContents();
    } // COMPAT: If the start node is a void node, we need to attach the encoded
    // fragment to the void node's content node instead of the spacer, because
    // attaching it to empty `<div>/<span>` nodes will end up having it erased by
    // most browsers. (2018/04/27)


    if (startVoid) {
      attach = contents.querySelector('[data-slate-spacer]');
    } // Remove any zero-width space spans from the cloned DOM so that they don't
    // show up elsewhere when pasted.


    Array.from(contents.querySelectorAll('[data-slate-zero-width]')).forEach(zw => {
      var isNewline = zw.getAttribute('data-slate-zero-width') === 'n';
      zw.textContent = isNewline ? '\n' : '';
    }); // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
    // in the HTML, and can be used for intra-Slate pasting. If it's a text
    // node, wrap it in a `<span>` so we have something to set an attribute on.

    if (isDOMText(attach)) {
      var span = attach.ownerDocument.createElement('span'); // COMPAT: In Chrome and Safari, if we don't add the `white-space` style
      // then leading and trailing spaces will be ignored. (2017/09/21)

      span.style.whiteSpace = 'pre';
      span.appendChild(attach);
      contents.appendChild(span);
      attach = span;
    }

    var fragment = e.getFragment();
    var string = JSON.stringify(fragment);
    var encoded = window.btoa(encodeURIComponent(string));
    attach.setAttribute('data-slate-fragment', encoded);
    data.setData('application/x-slate-fragment', encoded); // Add the content to a <div> so that we can get its inner HTML.

    var div = contents.ownerDocument.createElement('div');
    div.appendChild(contents);
    div.setAttribute('hidden', 'true');
    contents.ownerDocument.body.appendChild(div);
    data.setData('text/html', div.innerHTML);
    data.setData('text/plain', getPlainText(div));
    contents.ownerDocument.body.removeChild(div);
    return data;
  };

  e.insertData = data => {
    if (!e.insertFragmentData(data)) {
      e.insertTextData(data);
    }
  };

  e.insertFragmentData = data => {
    /**
     * Checking copied fragment from application/x-slate-fragment or data-slate-fragment
     */
    var fragment = data.getData('application/x-slate-fragment') || getSlateFragmentAttribute(data);

    if (fragment) {
      var decoded = decodeURIComponent(window.atob(fragment));
      var parsed = JSON.parse(decoded);
      e.insertFragment(parsed);
      return true;
    }

    return false;
  };

  e.insertTextData = data => {
    var text = data.getData('text/plain');

    if (text) {
      var lines = text.split(/\r\n|\r|\n/);
      var split = false;

      for (var line of lines) {
        if (split) {
          index_es/* Transforms.splitNodes */.YR.splitNodes(e, {
            always: true
          });
        }

        e.insertText(line);
        split = true;
      }

      return true;
    }

    return false;
  };

  e.onChange = () => {
    // COMPAT: React doesn't batch `setState` hook calls, which means that the
    // children and selection can get out of sync for one render pass. So we
    // have to use this unstable API to ensure it batches them. (2019/12/03)
    // https://github.com/facebook/react/issues/14259#issuecomment-439702367
    react_dom.unstable_batchedUpdates(() => {
      var onContextChange = EDITOR_TO_ON_CHANGE.get(e);

      if (onContextChange) {
        onContextChange();
      }

      onChange();
    });
  };

  return e;
};

var getMatches = (e, path) => {
  var matches = [];

  for (var [n, p] of index_es/* Editor.levels */.ML.levels(e, {
    at: path
  })) {
    var key = ReactEditor.findKey(e, n);
    matches.push([p, key]);
  }

  return matches;
};

// Components
var Editable = IS_ANDROID ? AndroidEditable : Editable$1;


//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/is-plain-object@5.0.0/node_modules/is-plain-object/dist/is-plain-object.mjs
var is_plain_object = __webpack_require__(33213);
;// CONCATENATED MODULE: ./node_modules/.pnpm/slate-history@0.66.0_slate@0.80.0/node_modules/slate-history/dist/index.es.js



var History = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(value) {
    return (0,is_plain_object/* isPlainObject */.P)(value) && Array.isArray(value.redos) && Array.isArray(value.undos) && (value.redos.length === 0 || index_es/* Operation.isOperationList */.OX.isOperationList(value.redos[0])) && (value.undos.length === 0 || index_es/* Operation.isOperationList */.OX.isOperationList(value.undos[0]));
  }

};

/**
 * Weakmaps for attaching state to the editor.
 */

var HISTORY = new WeakMap();
var SAVING = new WeakMap();
var MERGING = new WeakMap();
var HistoryEditor = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(value) {
    return History.isHistory(value.history) && index_es/* Editor.isEditor */.ML.isEditor(value);
  },

  /**
   * Get the merge flag's current value.
   */
  isMerging(editor) {
    return MERGING.get(editor);
  },

  /**
   * Get the saving flag's current value.
   */
  isSaving(editor) {
    return SAVING.get(editor);
  },

  /**
   * Redo to the previous saved state.
   */
  redo(editor) {
    editor.redo();
  },

  /**
   * Undo to the previous saved state.
   */
  undo(editor) {
    editor.undo();
  },

  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(editor, fn) {
    var prev = HistoryEditor.isMerging(editor);
    MERGING.set(editor, false);
    fn();
    MERGING.set(editor, prev);
  },

  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(editor, fn) {
    var prev = HistoryEditor.isSaving(editor);
    SAVING.set(editor, false);
    fn();
    SAVING.set(editor, prev);
  }

};

/**
 * The `withHistory` plugin keeps track of the operation history of a Slate
 * editor as operations are applied to it, using undo and redo stacks.
 *
 * If you are using TypeScript, you must extend Slate's CustomTypes to use
 * this plugin.
 *
 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
 */

var withHistory = editor => {
  var e = editor;
  var {
    apply
  } = e;
  e.history = {
    undos: [],
    redos: []
  };

  e.redo = () => {
    var {
      history
    } = e;
    var {
      redos
    } = history;

    if (redos.length > 0) {
      var batch = redos[redos.length - 1];
      HistoryEditor.withoutSaving(e, () => {
        index_es/* Editor.withoutNormalizing */.ML.withoutNormalizing(e, () => {
          for (var op of batch) {
            e.apply(op);
          }
        });
      });
      history.redos.pop();
      history.undos.push(batch);
    }
  };

  e.undo = () => {
    var {
      history
    } = e;
    var {
      undos
    } = history;

    if (undos.length > 0) {
      var batch = undos[undos.length - 1];
      HistoryEditor.withoutSaving(e, () => {
        index_es/* Editor.withoutNormalizing */.ML.withoutNormalizing(e, () => {
          var inverseOps = batch.map(index_es/* Operation.inverse */.OX.inverse).reverse();

          for (var op of inverseOps) {
            e.apply(op);
          }
        });
      });
      history.redos.push(batch);
      history.undos.pop();
    }
  };

  e.apply = op => {
    var {
      operations,
      history
    } = e;
    var {
      undos
    } = history;
    var lastBatch = undos[undos.length - 1];
    var lastOp = lastBatch && lastBatch[lastBatch.length - 1];
    var overwrite = shouldOverwrite(op, lastOp);
    var save = HistoryEditor.isSaving(e);
    var merge = HistoryEditor.isMerging(e);

    if (save == null) {
      save = shouldSave(op);
    }

    if (save) {
      if (merge == null) {
        if (lastBatch == null) {
          merge = false;
        } else if (operations.length !== 0) {
          merge = true;
        } else {
          merge = shouldMerge(op, lastOp) || overwrite;
        }
      }

      if (lastBatch && merge) {
        if (overwrite) {
          lastBatch.pop();
        }

        lastBatch.push(op);
      } else {
        var batch = [op];
        undos.push(batch);
      }

      while (undos.length > 100) {
        undos.shift();
      }

      if (shouldClear(op)) {
        history.redos = [];
      }
    }

    apply(op);
  };

  return e;
};
/**
 * Check whether to merge an operation into the previous operation.
 */

var shouldMerge = (op, prev) => {
  if (op.type === 'set_selection') {
    return true;
  }

  if (prev && op.type === 'insert_text' && prev.type === 'insert_text' && op.offset === prev.offset + prev.text.length && index_es/* Path.equals */.y$.equals(op.path, prev.path)) {
    return true;
  }

  if (prev && op.type === 'remove_text' && prev.type === 'remove_text' && op.offset + op.text.length === prev.offset && index_es/* Path.equals */.y$.equals(op.path, prev.path)) {
    return true;
  }

  return false;
};
/**
 * Check whether an operation needs to be saved to the history.
 */


var shouldSave = (op, prev) => {
  if (op.type === 'set_selection' && (op.properties == null || op.newProperties == null)) {
    return false;
  }

  return true;
};
/**
 * Check whether an operation should overwrite the previous one.
 */


var shouldOverwrite = (op, prev) => {
  if (prev && op.type === 'set_selection' && prev.type === 'set_selection') {
    return true;
  }

  return false;
};
/**
 * Check whether an operation should clear the redos stack.
 */


var shouldClear = op => {
  if (op.type === 'set_selection') {
    return false;
  }

  return true;
};


//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/slate-hyperscript@0.77.0_slate@0.80.0/node_modules/slate-hyperscript/dist/index.es.js



function dist_index_es_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/**
 * A weak map to hold anchor tokens.
 */
var ANCHOR = new WeakMap();
/**
 * A weak map to hold focus tokens.
 */

var FOCUS = new WeakMap();
/**
 * All tokens inherit from a single constructor for `instanceof` checking.
 */

class Token {}
/**
 * Anchor tokens represent the selection's anchor point.
 */

class AnchorToken extends Token {
  constructor() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    var {
      offset,
      path
    } = props;
    this.offset = offset;
    this.path = path;
  }

}
/**
 * Focus tokens represent the selection's focus point.
 */

class FocusToken extends Token {
  constructor() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    var {
      offset,
      path
    } = props;
    this.offset = offset;
    this.path = path;
  }

}
/**
 * Add an anchor token to the end of a text node.
 */

var addAnchorToken = (text, token) => {
  var offset = text.text.length;
  ANCHOR.set(text, [offset, token]);
};
/**
 * Get the offset if a text node has an associated anchor token.
 */

var getAnchorOffset = text => {
  return ANCHOR.get(text);
};
/**
 * Add a focus token to the end of a text node.
 */

var addFocusToken = (text, token) => {
  var offset = text.text.length;
  FOCUS.set(text, [offset, token]);
};
/**
 * Get the offset if a text node has an associated focus token.
 */

var getFocusOffset = text => {
  return FOCUS.get(text);
};

function index_es_ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function index_es_objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { index_es_ownKeys$1(Object(source), true).forEach(function (key) { dist_index_es_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { index_es_ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Resolve the descedants of a node by normalizing the children that can be
 * passed into a hyperscript creator function.
 */

var STRINGS = new WeakSet();

var resolveDescendants = children => {
  var nodes = [];

  var addChild = child => {
    if (child == null) {
      return;
    }

    var prev = nodes[nodes.length - 1];

    if (typeof child === 'string') {
      var text = {
        text: child
      };
      STRINGS.add(text);
      child = text;
    }

    if (index_es/* Text.isText */.xv.isText(child)) {
      var c = child; // HACK: fix typescript complaining

      if (index_es/* Text.isText */.xv.isText(prev) && STRINGS.has(prev) && STRINGS.has(c) && index_es/* Text.equals */.xv.equals(prev, c, {
        loose: true
      })) {
        prev.text += c.text;
      } else {
        nodes.push(c);
      }
    } else if (index_es/* Element.isElement */.W_.isElement(child)) {
      nodes.push(child);
    } else if (child instanceof Token) {
      var n = nodes[nodes.length - 1];

      if (!index_es/* Text.isText */.xv.isText(n)) {
        addChild('');
        n = nodes[nodes.length - 1];
      }

      if (child instanceof AnchorToken) {
        addAnchorToken(n, child);
      } else if (child instanceof FocusToken) {
        addFocusToken(n, child);
      }
    } else {
      throw new Error("Unexpected hyperscript child object: ".concat(child));
    }
  };

  for (var child of children.flat(Infinity)) {
    addChild(child);
  }

  return nodes;
};
/**
 * Create an anchor token.
 */


function createAnchor(tagName, attributes, children) {
  return new AnchorToken(attributes);
}
/**
 * Create an anchor and a focus token.
 */

function createCursor(tagName, attributes, children) {
  return [new AnchorToken(attributes), new FocusToken(attributes)];
}
/**
 * Create an `Element` object.
 */

function createElement(tagName, attributes, children) {
  return index_es_objectSpread$1(index_es_objectSpread$1({}, attributes), {}, {
    children: resolveDescendants(children)
  });
}
/**
 * Create a focus token.
 */

function createFocus(tagName, attributes, children) {
  return new FocusToken(attributes);
}
/**
 * Create a fragment.
 */

function createFragment(tagName, attributes, children) {
  return resolveDescendants(children);
}
/**
 * Create a `Selection` object.
 */

function createSelection(tagName, attributes, children) {
  var anchor = children.find(c => c instanceof AnchorToken);
  var focus = children.find(c => c instanceof FocusToken);

  if (!anchor || anchor.offset == null || anchor.path == null) {
    throw new Error("The <selection> hyperscript tag must have an <anchor> tag as a child with `path` and `offset` attributes defined.");
  }

  if (!focus || focus.offset == null || focus.path == null) {
    throw new Error("The <selection> hyperscript tag must have a <focus> tag as a child with `path` and `offset` attributes defined.");
  }

  return index_es_objectSpread$1({
    anchor: {
      offset: anchor.offset,
      path: anchor.path
    },
    focus: {
      offset: focus.offset,
      path: focus.path
    }
  }, attributes);
}
/**
 * Create a `Text` object.
 */

function createText(tagName, attributes, children) {
  var nodes = resolveDescendants(children);

  if (nodes.length > 1) {
    throw new Error("The <text> hyperscript tag must only contain a single node's worth of children.");
  }

  var [node] = nodes;

  if (node == null) {
    node = {
      text: ''
    };
  }

  if (!index_es/* Text.isText */.xv.isText(node)) {
    throw new Error("\n    The <text> hyperscript tag can only contain text content as children.");
  } // COMPAT: If they used the <text> tag we want to guarantee that it won't be
  // merge with other string children.


  STRINGS.delete(node);
  Object.assign(node, attributes);
  return node;
}
/**
 * Create a top-level `Editor` object.
 */

var createEditor = makeEditor => (tagName, attributes, children) => {
  var otherChildren = [];
  var selectionChild;

  for (var child of children) {
    if (index_es/* Range.isRange */.e6.isRange(child)) {
      selectionChild = child;
    } else {
      otherChildren.push(child);
    }
  }

  var descendants = resolveDescendants(otherChildren);
  var selection = {};
  var editor = makeEditor();
  Object.assign(editor, attributes);
  editor.children = descendants; // Search the document's texts to see if any of them have tokens associated
  // that need incorporated into the selection.

  for (var [node, path] of index_es/* Node.texts */.NB.texts(editor)) {
    var anchor = getAnchorOffset(node);
    var focus = getFocusOffset(node);

    if (anchor != null) {
      var [offset] = anchor;
      selection.anchor = {
        path,
        offset
      };
    }

    if (focus != null) {
      var [_offset] = focus;
      selection.focus = {
        path,
        offset: _offset
      };
    }
  }

  if (selection.anchor && !selection.focus) {
    throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<anchor />`. For collapsed selections, use `<cursor />` instead.");
  }

  if (!selection.anchor && selection.focus) {
    throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<focus />`. For collapsed selections, use `<cursor />` instead.");
  }

  if (selectionChild != null) {
    editor.selection = selectionChild;
  } else if (index_es/* Range.isRange */.e6.isRange(selection)) {
    editor.selection = selection;
  }

  return editor;
};

function dist_index_es_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function dist_index_es_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { dist_index_es_ownKeys(Object(source), true).forEach(function (key) { dist_index_es_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { dist_index_es_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * The default creators for Slate objects.
 */

var DEFAULT_CREATORS = {
  anchor: createAnchor,
  cursor: createCursor,
  editor: createEditor(index_es/* createEditor */.Jh),
  element: createElement,
  focus: createFocus,
  fragment: createFragment,
  selection: createSelection,
  text: createText
};
/**
 * Create a Slate hyperscript function with `options`.
 */

var createHyperscript = function createHyperscript() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    elements = {}
  } = options;
  var elementCreators = normalizeElements(elements);

  var creators = dist_index_es_objectSpread(dist_index_es_objectSpread(dist_index_es_objectSpread({}, DEFAULT_CREATORS), elementCreators), options.creators);

  var jsx = createFactory(creators);
  return jsx;
};
/**
 * Create a Slate hyperscript function with `options`.
 */


var createFactory = creators => {
  var jsx = function jsx(tagName, attributes) {
    for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      children[_key - 2] = arguments[_key];
    }

    var creator = creators[tagName];

    if (!creator) {
      throw new Error("No hyperscript creator found for tag: <".concat(tagName, ">"));
    }

    if (attributes == null) {
      attributes = {};
    }

    if (!(0,is_plain_object/* isPlainObject */.P)(attributes)) {
      children = [attributes].concat(children);
      attributes = {};
    }

    children = children.filter(child => Boolean(child)).flat();
    var ret = creator(tagName, attributes, children);
    return ret;
  };

  return jsx;
};
/**
 * Normalize a dictionary of element shorthands into creator functions.
 */


var normalizeElements = elements => {
  var creators = {};

  var _loop = function _loop(tagName) {
    var props = elements[tagName];

    if (typeof props !== 'object') {
      throw new Error("Properties specified for a hyperscript shorthand should be an object, but for the custom element <".concat(tagName, ">  tag you passed: ").concat(props));
    }

    creators[tagName] = (tagName, attributes, children) => {
      return createElement('element', dist_index_es_objectSpread(dist_index_es_objectSpread({}, props), attributes), children);
    };
  };

  for (var tagName in elements) {
    _loop(tagName);
  }

  return creators;
};

/**
 * The default hyperscript factory that ships with Slate, without custom tags.
 */

var jsx = createHyperscript();


//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Airtable.js






function Airtable_Airtable(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var embedUrl = element.embedUrl, embedWidth = element.embedWidth, embedHeight = element.embedHeight;
    var parsed = query_string.parseUrl(embedUrl);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
                    children: function(isMobile) {
                        var embedQuery = query_string.stringify((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, parsed.query), {
                            layout: isMobile ? "card" : undefined
                        }));
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                border: "1px solid #ccc",
                                borderRadius: 4,
                                overflow: "hidden",
                                marginTop: 10
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                                src: "".concat(parsed.url, "?").concat(embedQuery),
                                frameBorder: "0",
                                css: {
                                    width: "100%"
                                },
                                style: {
                                    embedWidth: embedWidth,
                                    embedHeight: embedHeight
                                }
                            })
                        });
                    }
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Blockquote.js




function Blockquote(param) {
    var attributes = param.attributes, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("blockquote", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        style: (0,src_object_spread/* default */.Z)({
            paddingLeft: 10,
            fontSize: 22,
            color: "#04346e",
            fontStyle: "italic",
            margin: "35px 0px 35px 60px !important"
        }, style)
    }, attributes), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/CustomButton.js




function CustomButton_CustomButton(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var buttonText = element.buttonText, buttonURL = element.buttonURL, buttonColor = element.buttonColor, buttonTextColor = element.buttonTextColor, buttonBorderColor = element.buttonBorderColor, buttonWidth = element.buttonWidth, buttonTargetBlank = element.buttonTargetBlank;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginTop: 10,
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center"
                },
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    href: buttonURL,
                    target: buttonTargetBlank ? "_blank" : "_self",
                    rel: "noreferrer",
                    type: "button",
                    css: {
                        margin: 0,
                        padding: "5px 15px",
                        color: buttonTextColor,
                        fontSize: 20,
                        letterSpacing: 0.6,
                        backgroundColor: buttonColor,
                        border: "1px solid",
                        borderColor: buttonBorderColor,
                        borderRadius: 4,
                        minWidth: 200,
                        width: buttonWidth ? "".concat(buttonWidth, "%") : undefined,
                        textDecoration: "none",
                        cursor: "pointer"
                    },
                    children: buttonText
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Divider.js





function Divider_Divider(param) {
    var attributes = param.attributes, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                css: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                    css: {
                        margin: 0,
                        padding: 0,
                        border: "none",
                        width: "100%",
                        borderBottom: "1px solid ".concat(palette/* lightestSealBlue */.ks)
                    }
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Headers.js
/* eslint-disable react/display-name */ 



var HeaderOne = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var attributes = param.attributes, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        css: {
            fontSize: 40,
            color: "#086be5",
            fontWeight: 700
        },
        style: style
    }, attributes), {
        children: children
    }));
});
var HeaderTwo = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var attributes = param.attributes, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        css: {
            fontSize: 32,
            color: "#20252d",
            fontWeight: 600
        },
        style: style
    }, attributes), {
        children: children
    }));
});
var HeaderThree = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var attributes = param.attributes, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        css: {
            fontSize: 32,
            lineHeight: "34px",
            color: "#20252d",
            fontWeight: 600,
            marginTop: "50px"
        },
        style: style
    }, attributes), {
        children: children
    }));
});
var HeaderFour = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var attributes = param.attributes, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        css: {
            fontSize: 24,
            lineHeight: "34px",
            color: "#20252d",
            fontWeight: 700,
            marginTop: "50px"
        },
        style: style
    }, attributes), {
        children: children
    }));
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/GoogleForms.js




function GoogleForms_GoogleForms(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var spreadsheetUrl = element.spreadsheetUrl, width = element.width, height = element.height;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        paddingTop: 20,
                        paddingBottom: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                        src: spreadsheetUrl,
                        frameBorder: "0",
                        css: {
                            width: width || "100%",
                            height: height || 436
                        }
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/GoogleSpreadsheet.js









var DEFAULT_EMBED_HEIGHT = 200;
function GoogleSpreadsheet_GoogleSpreadsheet(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var editor = useSlate();
    var readOnly = useReadOnly();
    var spreadsheetUrl = element.spreadsheetUrl, adjustedSize = element.adjustedSize, displayHeaders = element.displayHeaders;
    var normalizedUrl = spreadsheetUrl.replace("&amp;", "&");
    var parsed = query_string.parseUrl(normalizedUrl);
    var options = {};
    if (!displayHeaders) {
        options = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
            widget: false,
            chrome: false
        });
    }
    var embedQuery = query_string.stringify((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        embedded: true
    }));
    var embedUrl = "".concat(parsed.url.replace("/pubhtml", "/pub"), "?").concat(embedQuery);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        css: {
            paddingTop: 10
        }
    }, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                children: readOnly ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                    src: embedUrl,
                    frameBorder: "0",
                    style: {
                        width: "100%",
                        height: adjustedSize || DEFAULT_EMBED_HEIGHT
                    }
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            paddingTop: 10,
                            width: "90%",
                            borderBottom: displayHeaders ? "none" : "solid 1px ".concat(palette/* lightSealBlue */.oz)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    marginBottom: displayHeaders ? 0 : 10,
                                    display: "flex",
                                    width: "100%",
                                    userSelect: "none",
                                    border: "solid 1px $palette.lightSealBlue}",
                                    borderRadius: 4,
                                    borderBottomLeftRadius: displayHeaders ? 0 : 4,
                                    borderBottomRightRadius: displayHeaders ? 0 : 4,
                                    alignItems: "center",
                                    padding: 20
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                                    css: {
                                                        fontWeight: 600,
                                                        fontSize: 16
                                                    },
                                                    children: "Size"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        marginLeft: 5
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                                        onChange: function(event) {
                                                            var size = parseInt(event.target.value);
                                                            if (size) {
                                                                var newProperties = {
                                                                    adjustedSize: (0,lodash.clamp)(size, 100, 800)
                                                                };
                                                                index_es/* Transforms.setNodes */.YR.setNodes(editor, newProperties);
                                                            }
                                                        },
                                                        placeholder: "200",
                                                        css: {
                                                            outline: "none",
                                                            border: "solid 1px $palette.lightSealBlue}",
                                                            borderRadius: 4,
                                                            type: "text",
                                                            padding: 5,
                                                            width: 60,
                                                            textAlign: "center",
                                                            fontSize: 14
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                display: "flex",
                                                alignItems: "center",
                                                marginLeft: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                                    css: {
                                                        fontWeight: 600
                                                    },
                                                    children: "Headers?"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        marginLeft: 5
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                                        type: "checkbox",
                                                        defaultChecked: displayHeaders,
                                                        onChange: function(event) {
                                                            var newProperties = {
                                                                displayHeaders: event.target.checked
                                                            };
                                                            index_es/* Transforms.setNodes */.YR.setNodes(editor, newProperties);
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                                src: embedUrl,
                                frameBorder: "0",
                                style: {
                                    width: "70%",
                                    height: adjustedSize || DEFAULT_EMBED_HEIGHT
                                }
                            })
                        ]
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/GovlaunchProject.js





function GovlaunchProject_GovlaunchProject(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var slug = element.slug, countryCode = element.countryCode, title = element.title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
                    children: function(isMobile) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                paddingTop: 20,
                                paddingBottom: 20
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    padding: isMobile ? 8 : 16,
                                    border: "1px solid #BDDAFD",
                                    backgroundColor: "#ffffff"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                    href: "/projects/".concat(slug),
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        textDecoration: "none"
                                    },
                                    children: [
                                        countryCode && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                            src: "https://static.govlaunch.com/flags/squared/".concat(countryCode, ".svg"),
                                            alt: "".concat(countryCode, " flag"),
                                            width: 64,
                                            height: 48,
                                            css: {
                                                width: 64,
                                                height: 48,
                                                marginRight: isMobile ? 12 : 24,
                                                aspectRatio: "4 / 3",
                                                alignSelf: "flex-start"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                            css: {
                                                margin: 0,
                                                color: "#086BE5",
                                                fontWeight: "bold",
                                                fontSize: isMobile ? 14 : 18,
                                                lineHeight: "24px"
                                            },
                                            children: title
                                        })
                                    ]
                                })
                            })
                        });
                    }
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Image.js
/* eslint-disable react/display-name */ 





var Image_Image = function(param) {
    var attributes = param.attributes, children = param.children, element = param.element, style = param.style;
    var selected = useSelected();
    var focused = useFocused();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        style: parseImageStyle(element, style),
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    src: element.url,
                    alt: element.alt,
                    css: {
                        width: element.width ? "".concat(element.width, "px") : "100%",
                        height: element.height ? "".concat(element.height, "px") : undefined,
                        boxShadow: selected && focused ? "0 0 0 3px ".concat(palette/* sealBlue */.N9) : "none"
                    }
                })
            })
        ]
    }));
};
function parseImageStyle(element, style) {
    if (!element.align) {
        return (0,src_object_spread/* default */.Z)({}, style);
    }
    return (0,src_object_spread/* default */.Z)({
        display: "flex",
        flexDirection: "column",
        alignItems: parseAlignment(element.align)
    }, style);
}
function parseAlignment(align) {
    if (align === "left") {
        return "start";
    }
    if (align === "right") {
        return "end";
    }
    return align;
}
/* harmony default export */ var elements_Image = (Image_Image);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Link.js
/* eslint-disable react/display-name */ 




var InlineChromiumBugfix = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
        contentEditable: false,
        style: {
            fontSize: 0
        },
        children: [
            "$",
            String.fromCodePoint(160)
        ]
    });
};
var Link_Link = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var attributes = param.attributes, element = param.element, children = param.children, style = param.style;
    var url = element.url;
    var selected = useSelected();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        css: {
            fontSize: 20,
            lineHeight: "34px",
            color: "#0071bb",
            textDecoration: "none",
            boxShadow: selected ? "0 0 0 3px #ddd" : undefined
        },
        href: url
    }, attributes), {
        style: style,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineChromiumBugfix, {}),
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InlineChromiumBugfix, {})
        ]
    }));
});
/* harmony default export */ var elements_Link = (Link_Link);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Paragraph.js
/* eslint-disable react/display-name */ 



var Paragraph = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var attributes = param.attributes, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        css: {
            fontSize: 20,
            lineHeight: "34px",
            marginTop: 25
        },
        style: style
    }, attributes), {
        children: children
    }));
});
/* harmony default export */ var elements_Paragraph = (Paragraph);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Typeform.js





function Typeform_Typeform(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var src = element.src;
    var typeformEmbed = __webpack_require__(58978);
    var reference = typeformEmbed.makePopup(src, {
        mode: "popup",
        autoClose: 3000,
        hideHeaders: true,
        hideFooters: true
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        position: "relative",
                        marginTop: 10
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                        type: "button",
                        css: {
                            border: "none",
                            padding: 10,
                            paddingLeft: 20,
                            paddingRight: 20,
                            borderRadius: 8,
                            fontSize: 14,
                            textAlign: "center",
                            outline: 0,
                            cursor: "pointer",
                            backgroundColor: palette/* innovatorBlue */.LD,
                            textTransform: "uppercase",
                            color: palette/* white */.ix
                        },
                        onClick: function() {
                            if (reference) {
                                reference.open();
                            }
                        },
                        children: "Launch and Answer"
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/YoutubeVideoElement.js






var YoutubeVideoElement_iframeClass = /*#__PURE__*/ css({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
});
function YoutubeVideoElement(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var videoId = element.videoId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    position: "relative",
                    "& > div": {
                        display: "block",
                        position: "relative",
                        width: "100%",
                        height: 0,
                        // https://css-tricks.com/aspect-ratio-boxes/
                        paddingBottom: "56.25%"
                    }
                },
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm, {
                    id: videoId,
                    videoId: videoId,
                    className: YoutubeVideoElement_iframeClass.toString(),
                    opts: {
                        width: "100%",
                        height: "100%",
                        playerVars: {
                            controls: 2,
                            modestbranding: 1,
                            showinfo: 0,
                            wmode: "transparent",
                            autohide: 1,
                            mode: "opaque",
                            rel: 0
                        }
                    }
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/Simplecast.js




function Simplecast_Simplecast(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var embedUrl = element.src, height = element.height;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        border: "1px solid #ccc",
                        borderRadius: 4,
                        overflow: "hidden",
                        marginTop: 10,
                        display: "flex"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                        src: embedUrl,
                        frameBorder: "0",
                        css: {
                            width: "100%",
                            height: height
                        },
                        style: {
                            width: "100%",
                            height: height
                        }
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/icons/SocialMediasIcon.js




var SocialMediasIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 481.6 481.6",
        style: {
            verticalAlign: "bottom"
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M381.6 309.4c-27.7 0-52.4 13.2-68.2 33.6l-132.3-73.9c3.1-8.9 4.8-18.5 4.8-28.4 0-10-1.7-19.5-4.9-28.5l132.2-73.8c15.7 20.5 40.5 33.8 68.3 33.8 47.4 0 86.1-38.6 86.1-86.1S429 0 381.5 0s-86.1 38.6-86.1 86.1c0 10 1.7 19.6 4.9 28.5l-132.1 73.8c-15.7-20.6-40.5-33.8-68.3-33.8-47.4 0-86.1 38.6-86.1 86.1s38.7 86.1 86.2 86.1c27.8 0 52.6-13.3 68.4-33.9l132.2 73.9c-3.2 9-5 18.7-5 28.7 0 47.4 38.6 86.1 86.1 86.1s86.1-38.6 86.1-86.1-38.7-86.1-86.2-86.1zm0-282.3c32.6 0 59.1 26.5 59.1 59.1s-26.5 59.1-59.1 59.1-59.1-26.5-59.1-59.1 26.6-59.1 59.1-59.1zM100 299.8c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.6 59.1-59.1 59.1zm281.6 154.7c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.5 59.1-59.1 59.1z"
            })
        })
    }));
};
/* harmony default export */ var icons_SocialMediasIcon = (SocialMediasIcon);
var TwitterIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: 512,
        width: 512,
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M21.552 7.749c0-.217-.008-.428-.018-.636A9.822 9.822 0 0024 4.559v-.001c-.893.391-1.843.651-2.835.777a4.894 4.894 0 002.165-2.719 9.845 9.845 0 01-3.12 1.191 4.919 4.919 0 00-8.511 3.364c0 .39.033.765.114 1.122-4.09-.2-7.71-2.16-10.142-5.147a4.962 4.962 0 00-.674 2.487c0 1.704.877 3.214 2.186 4.089A4.863 4.863 0 01.96 9.116v.054a4.943 4.943 0 003.942 4.835c-.752.206-1.678.198-2.221.078.637 1.948 2.447 3.381 4.597 3.428a9.89 9.89 0 01-6.101 2.098c-.403 0-.79-.018-1.177-.067a13.856 13.856 0 007.548 2.208c9.054 0 14.004-7.5 14.004-14.001z",
            fill: "#55acee"
        })
    }));
};
var FacebookIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 512,
        height: 512,
        viewBox: "126.445 2.281 589 589"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 420.945,
                cy: 296.781,
                r: 294.5,
                fill: "#3c5a9a"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M516.704 92.677h-65.239c-38.715 0-81.777 16.283-81.777 72.402.189 19.554 0 38.281 0 59.357H324.9v71.271h46.174v205.177h84.847V294.353h56.002l5.067-70.117h-62.531s.14-31.191 0-40.249c0-22.177 23.076-20.907 24.464-20.907 10.981 0 32.332.032 37.813 0V92.677h-.032z",
                fill: "#fff"
            })
        ]
    }));
};
var InstagramIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: 512,
        width: 512,
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "sa42uhshzxfa",
                gradientTransform: "matrix(0 -1.982 -1.844 0 -132.522 -51.077)",
                gradientUnits: "userSpaceOnUse",
                x1: -37.106,
                x2: -26.555,
                y1: -72.705,
                y2: -84.047,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#fd5"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.5,
                        stopColor: "#ff543e"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#c837ab"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1.5 1.633C-.386 3.592 0 5.673 0 11.995c0 5.25-.916 10.513 3.878 11.752 1.497.385 14.761.385 16.256-.002 1.996-.515 3.62-2.134 3.842-4.957.031-.394.031-13.185-.001-13.587-.236-3.007-2.087-4.74-4.526-5.091C18.89.029 18.778.005 15.91 0 5.737.005 3.507-.448 1.5 1.633z",
                fill: "url(#sa42uhshzxfa)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M11.998 3.139c-3.631 0-7.079-.323-8.396 3.057-.544 1.396-.465 3.209-.465 5.805 0 2.278-.073 4.419.465 5.804 1.314 3.382 4.79 3.058 8.394 3.058 3.477 0 7.062.362 8.395-3.058.545-1.41.465-3.196.465-5.804 0-3.462.191-5.697-1.488-7.375-1.7-1.7-3.999-1.487-7.374-1.487zm-.794 1.597c7.574-.012 8.538-.854 8.006 10.843-.189 4.137-3.339 3.683-7.211 3.683-7.06 0-7.263-.202-7.263-7.265 0-7.145.56-7.257 6.468-7.263zm5.524 1.471a1.063 1.063 0 100 2.126 1.063 1.063 0 000-2.126zm-4.73 1.243a4.55 4.55 0 10.001 9.101 4.55 4.55 0 00-.001-9.101zm0 1.597c3.905 0 3.91 5.908 0 5.908-3.904 0-3.91-5.908 0-5.908z",
                fill: "#fff"
            })
        ]
    }));
};
var YouTubeIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: 2500,
        width: 2496,
        viewBox: "0 0.03 2498 2502.47"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 1864.11v.11c1.5 55.5 2 111.32 11.32 166.47 9.92 58.35 24.1 115.25 51.15 168.21q54.86 107.52 150.21 181.66c45.52 35.5 95.25 63.69 150.3 81.47 80.26 25.89 163.07 35.81 247.09 36.3 52.42.33 104.81 1.64 157.25 1.42 380.82-1.6 761.65 2.75 1142.49-2.35 50.53-.68 100.24-6.85 149.84-15.92 95.06-17.4 179.07-58 250.95-122.09 83.77-74.71 140.29-166.16 165.81-276.52 16.69-72.14 20.87-145.32 21.58-218.77v-14.65c0-5.68-2.16-1247.91-2.36-1264.33-.55-45.1-3.88-89.87-12.33-134.25-10.29-54.08-24.82-106.78-50.71-155.7-27.35-51.7-61.6-98.17-104-138.79-64.89-62.23-139.78-106.23-227-129.51-78.74-21-159.07-25.68-240-25.6a2.45 2.45 0 01-.45-1.24H636.4c0 .42 0 .83-.07 1.24-45.93.84-91.92.49-137.61 6.16-50.05 6.22-99.63 15.59-147 33.09-74.62 27.6-139.46 70.59-194.84 128-62.75 65-107 140.22-130.44 227.79C5.49 474.44.93 554.12.82 634.37",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 .79h2498v2498H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1293.24 1938.65l-409.54-7.49c-132.6-2.61-265.53 2.6-395.53-24.44-197.76-40.4-211.77-238.49-226.43-404.65-20.2-233.6-12.38-471.44 25.74-703.09C309 669 393.69 591.44 524.66 583c442.12-30.63 887.18-27 1328.32-12.71 46.59 1.31 93.5 8.47 139.44 16.62 226.77 39.75 232.3 264.23 247 453.2 14.66 190.92 8.47 382.82-19.55 572.44-22.48 157-65.49 288.66-247 301.37-227.42 16.62-449.62 30-677.68 25.74.01-1.01-1.3-1.01-1.95-1.01zm-240.77-397.48c171.38-98.4 339.49-195.16 509.89-292.9-171.7-98.4-339.49-195.16-509.89-292.9z",
                fill: "red"
            })
        ]
    }));
};
var ApplePodcastIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 300,
        height: 300,
        viewBox: "0 0 300 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "rsiai149sasjl",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0,
                                stopColor: "#822cbe"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 1,
                                stopColor: "#d772fb"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("linearGradient", {
                        id: "xalfsqai4",
                        x1: 458.9,
                        x2: 456.36,
                        y1: 303.81,
                        xlinkHref: "#rsiai149sasjl",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(-309.21)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                width: 300,
                height: 300,
                fill: "url(#xalfsqai4)",
                ry: 66.74
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#fff",
                d: "M140.84 262.64c-8.95-3.2-10.87-7.55-14.54-33.04-4.27-29.63-5.2-47.97-2.73-53.78 3.28-7.7 12.18-12.07 24.63-12.12 12.35-.05 21.33 4.36 24.63 12.12 2.48 5.8 1.55 24.15-2.72 53.78-2.9 20.7-4.5 25.93-8.5 29.45-5.5 4.87-13.3 6.22-20.7 3.6zm-38.23-30.4c-30.9-15.2-50.7-40.92-57.9-75.14-1.8-8.83-2.1-29.9-.4-38 4.5-21.75 13.1-38.76 27.4-53.8 20.6-21.72 47.1-33.2 76.6-33.2 29.2 0 55.6 11.27 75.7 32.34 15.3 15.9 23.9 32.73 28.3 54.9 1.5 7.38 1.5 27.5.1 35.8-4.6 26.24-19.2 50.14-40.5 66.2-7.6 5.74-26.2 15.76-29.2 15.76-1.1 0-1.2-1.14-.7-5.75.9-7.4 1.8-8.94 6-10.7 6.7-2.8 18.1-10.92 25.1-17.94 12.1-12 21-27.7 25.1-44.2 2.6-10.3 2.3-33.2-.6-43.8-9.1-33.7-36.6-59.9-70.3-66.9-9.8-2-27.6-2-37.5 0-34.1 7-62.3 34.5-70.9 69.1-2.3 9.4-2.3 32.3 0 41.7 5.7 22.9 20.5 43.9 39.9 56.4 3.8 2.5 8.4 5.1 10.3 5.9 4.2 1.8 5.1 3.3 5.9 10.7.5 4.5.4 5.8-.7 5.8-.7 0-5.8-2.2-11.2-4.8zm.4-40.68c-10.4-8.3-19.6-23.02-23.4-37.46-2.3-8.72-2.3-25.3.1-34 6.3-23.48 23.6-41.68 47.6-50.23 8.2-2.9 26.4-3.55 36.5-1.32 34.8 7.75 59.5 42.6 54.7 77.17-1.9 13.93-6.7 25.37-15.2 36-4.2 5.37-14.4 14.38-16.2 14.38-.3 0-.6-3.4-.6-7.54V181l5.2-6.2c19.6-23.48 18.2-56.28-3.2-77.8-8.3-8.38-17.9-13.3-30.3-15.57-8-1.48-9.7-1.48-18.1-.1-12.75 2.08-22.63 7.02-31.4 15.7-21.5 21.3-22.9 54.27-3.3 77.77l5.16 6.2v7.6c0 4.2-.33 7.6-.74 7.6-.4 0-3.3-2-6.4-4.5zm34.7-40.83c-8.9-4.14-13.7-11.95-13.8-22.13 0-9.15 5.1-17.13 13.9-21.8 5.6-2.94 15.5-2.94 21.1.02 6.1 3.17 11.1 9.32 13 15.74 5.8 19.72-15.1 37-34 28.17z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 149.89,
                cy: 129.67,
                r: 24.94,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#fff",
                d: "M152.28 164.27c1.73.23 5.17.68 8.35 1.7 3.2 1 6.1 2.57 8.36 4.18 2.2 1.6 3.8 3.26 4.8 5.28 1 2.02 1.5 4.42 1.8 8.35.2 3.94.2 9.4-.7 19.6-.9 10.17-2.7 25.08-4.1 34.63-1.4 9.6-2.4 13.8-3.7 16.9-1.3 3.2-3 5.3-4.9 6.8-1.9 1.5-4.1 2.4-6.2 2.9-2.1.5-4 .5-5.8.5-1.8 0-3.5 0-5.8-.5s-5.3-1.4-7.5-3.2c-2.3-1.8-3.8-4.4-5-7.8-1.2-3.4-2.1-7.5-3.3-15.7-1.2-8.2-2.8-20.4-3.8-29.7s-1.4-15.7-1.48-20c-.1-4.3.1-6.43.6-8.5.5-2 1.3-3.9 2.4-5.5 1.1-1.6 2.54-3 4-4.1 1.43-1.1 2.9-1.9 4.66-2.52 1.74-.7 3.83-1.3 6.4-1.8 2.6-.5 5.6-1 7.14-1.2 1.54-.23 1.54-.23 3.26 0z"
            })
        ]
    }));
};
var SpotifyIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 2931 2931",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M1465.5 0C656.1 0 0 656.1 0 1465.5S656.1 2931 1465.5 2931 2931 2274.9 2931 1465.5C2931 656.2 2274.9.1 1465.5 0zm672.1 2113.6c-26.3 43.2-82.6 56.7-125.6 30.4-344.1-210.3-777.3-257.8-1287.4-141.3-49.2 11.3-98.2-19.5-109.4-68.7-11.3-49.2 19.4-98.2 68.7-109.4C1242.1 1697.1 1721 1752 2107.3 1988c43 26.5 56.7 82.6 30.3 125.6zm179.3-398.9c-33.1 53.8-103.5 70.6-157.2 37.6-393.8-242.1-994.4-312.2-1460.3-170.8-60.4 18.3-124.2-15.8-142.6-76.1-18.2-60.4 15.9-124.1 76.2-142.5 532.2-161.5 1193.9-83.3 1646.2 194.7 53.8 33.1 70.8 103.4 37.7 157.1zm15.4-415.6c-472.4-280.5-1251.6-306.3-1702.6-169.5-72.4 22-149-18.9-170.9-91.3-21.9-72.4 18.9-149 91.4-171 517.7-157.1 1378.2-126.8 1922 196 65.1 38.7 86.5 122.8 47.9 187.8-38.5 65.2-122.8 86.7-187.8 48z",
            fill: "#2ebd59"
        })
    }));
};
var GooglePlayIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 408 466.9",
        width: "1em",
        height: "1em"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "rsoirai413",
                gradientUnits: "userSpaceOnUse",
                y1: 112.094,
                x2: 261.746,
                y2: 112.094,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#63be6b"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.506,
                        stopColor: "#5bbc6a"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#4ab96a"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M261.7 142.3L15 1.3C11.9-.5 8-.4 5 1.4c-3.1 1.8-5 5-5 8.6 0 0 .1 13 .2 34.4l179.7 179.7 81.8-81.8z",
                fill: "url(#rsoirai413)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "rsarioai24",
                gradientUnits: "userSpaceOnUse",
                x1: 0.152,
                y1: 223.393,
                x2: 179.896,
                y2: 223.393,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#3ec6f2"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#45afe3"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M.2 44.4C.5 121.6 1.4 309 1.8 402.3L180 224.1.2 44.4z",
                fill: "url(#rsarioai24)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "rs9a00134fdaf",
                gradientUnits: "userSpaceOnUse",
                x1: 179.896,
                y1: 229.464,
                x2: 407.976,
                y2: 229.464,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#faa51a"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.387,
                        stopColor: "#fab716"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.741,
                        stopColor: "#fac412"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#fac80f"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M402.9 223l-141.2-80.7-81.9 81.8 92.4 92.4L403 240.3c3.1-1.8 5-5.1 5-8.6 0-3.6-2-6.9-5.1-8.7z",
                fill: "url(#rs9a00134fdaf)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "rlajrsj4123",
                gradientUnits: "userSpaceOnUse",
                x1: 1.744,
                y1: 345.521,
                x2: 272.296,
                y2: 345.521,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#ec3b50"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#e7515b"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1.7 402.3c.2 33.3.3 54.6.3 54.6 0 3.6 1.9 6.9 5 8.6 3.1 1.8 6.9 1.8 10 0l255.3-148.9-92.4-92.4L1.7 402.3z",
                fill: "url(#rlajrsj4123)"
            })
        ]
    }));
};
var SoundCloudIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: "1em",
        width: "1em",
        viewBox: "0 0 2499.998 1386.695"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "fosafk421",
                x1: "50.107%",
                x2: "50.107%",
                y1: "2.721%",
                y2: "98.004%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#f80"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#f30"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 1137.737c0 31.024 11.247 54.481 33.737 70.382 22.491 15.898 46.533 21.52 72.126 16.868 24.041-4.653 40.91-13.185 50.607-25.593 9.693-12.408 14.542-32.962 14.542-61.657V800.372c0-24.044-8.336-44.403-25.012-61.075-16.672-16.676-37.03-25.012-61.074-25.012-23.267 0-43.237 8.336-59.912 25.012C8.339 755.969 0 776.327 0 800.372zm267.566 144.253c0 22.495 7.95 39.36 23.848 50.608 15.9 11.247 36.26 16.868 61.075 16.868 25.593 0 46.338-5.624 62.238-16.868 15.898-11.245 23.849-28.113 23.849-50.608V495.58c0-23.267-8.34-43.239-25.012-59.912-16.675-16.672-37.033-25.011-61.075-25.011-23.266 0-43.239 8.339-59.911 25.011-16.676 16.676-25.012 36.645-25.012 59.912zm266.403 37.227c0 22.492 8.143 39.36 24.43 50.607 16.286 11.245 37.226 16.869 62.822 16.869 24.816 0 45.174-5.624 61.072-16.869 15.9-11.247 23.851-28.115 23.851-50.607V601.442c0-24.041-8.339-44.595-25.012-61.657-16.675-17.061-36.644-25.59-59.911-25.59-24.044 0-44.595 8.529-61.657 25.59-17.061 17.062-25.593 37.616-25.593 61.657v717.775zm267.566 3.49c0 42.657 28.695 63.986 86.086 63.986 57.39 0 86.084-21.329 86.084-63.986V159.377c0-65.147-19.776-101.985-59.33-110.517-25.593-6.205-50.8 1.163-75.616 22.103-24.818 20.94-37.227 50.41-37.227 88.413v1163.331zm272.222 33.737V90.74c0-40.328 12.02-64.37 36.063-72.127C1161.78 6.205 1213.356 0 1264.543 0c118.657 0 229.176 27.92 331.547 83.76 102.373 55.84 185.165 132.038 248.37 228.594 63.21 96.56 99.854 203.001 109.936 319.337 47.308-20.165 97.717-30.247 151.23-30.247 108.578 0 201.452 38.39 278.618 115.17 77.168 76.782 115.754 169.072 115.754 276.875 0 108.578-38.586 201.256-115.754 278.036-77.166 76.78-169.651 115.17-277.455 115.17l-1012.097-1.163c-6.983-2.327-12.218-6.594-15.708-12.797s-5.227-11.638-5.227-16.291z",
                fill: "url(#fosafk421)"
            })
        ]
    }));
};
var DeezerIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 46.9 24.5",
        width: "1em",
        height: "1em"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M38.3 13.9v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1zm0-3.3v-1h8.6v2.1h-8.6V4.2zm0-3.1V0h8.6v2.2h-8.6V1.1z",
                fill: "#b1e3fa"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.1 13.9v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1zm0-3.3v-1h8.6v2.1h-8.6V4.2z",
                fill: "#f7bacf"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M28.7 13.9v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1z",
                fill: "#e7ee9f"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M9.6 23.5v-1H18v2H9.6v-1zm0-3.3v-1H18v2H9.6v-1zm0-3.2v-1H18v2H9.6v-1z",
                fill: "#feea3a"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 13.9v-1h8.4v2H0v-1zm0-3.2v-1h8.4v2H0v-1z",
                fill: "#fe9d7f"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M38.4 23.5v-1h8.4v2h-8.4v-1zm0-3.3v-1h8.4v2h-8.4v-1zm0-3.2v-1h8.4v2h-8.4v-1z",
                fill: "#4ec2f6"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M28.8 23.5v-1h8.4v2h-8.4v-1zm0-3.3v-1h8.4v2h-8.4v-1zm0-3.2v-1h8.4v2h-8.4v-1z",
                fill: "#ccdb38"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.2 23.5v-1h8.4v2h-8.4v-1zm0-3.3v-1h8.4v2h-8.4v-1zm0-3.2v-1h8.4v2h-8.4v-1z",
                fill: "#fe3f80"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 23.5v-1h8.4v2H0v-1zm0-3.3v-1h8.4v2H0v-1zM0 17v-1h8.4v2H0v-1z",
                fill: "#fe3d02"
            })
        ]
    }));
};
var IHeartRadioIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 95,
        height: 72,
        viewBox: "0 0 95 72"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    x1: "50.019%",
                    y1: "100.052%",
                    x2: "50.019%",
                    y2: "-.056%",
                    id: "sa4w14varfsaf4",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#881214",
                            offset: "0%"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#CA1B21",
                            offset: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M69.2.6c-8.9 0-16.8 4.7-21.4 11.6C43.2 5.2 35.3.6 26.4.6 12.3.6.8 12 .8 26.2c0 7.9 4.3 15.7 10 20.4.2.3 14.5 13.4 27.1 25V52.8c0-12.8 19.6-12.7 19.6 0v18.9l25.7-24.2c6.3-5.1 11.6-12.4 11.6-21.4C94.8 12 83.4.6 69.2.6zM24.9 46.3c-.3.4-.8.6-1.3.6-.4 0-.8-.1-1.2-.4-7.6-6.8-11.5-13.8-11.5-21v-.1c0-6.2 3.8-13.1 8.7-16.3.8-.5 1.9-.3 2.4.6.5.8.3 1.9-.6 2.4-4 2.5-7.1 8.3-7.1 13.3v.1c0 6.1 3.5 12.3 10.3 18.3.8.6.9 1.7.3 2.5zm11.4-6.6c-.3.6-.9.9-1.5.9-.3 0-.6-.1-.9-.2-5.2-2.9-8.7-8.6-8.7-14.2v-.1c0-5.3 3-10.1 7.7-12.6.9-.5 1.9-.1 2.4.7.5.9.1 1.9-.7 2.4-3.5 1.9-5.8 5.5-5.8 9.5 0 4.4 2.8 8.8 6.9 11.1.7.6 1 1.6.6 2.5zm11.6-4.5c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.5 7.7-7.7 7.7zm13.9 5.2c-.3.2-.6.2-.9.2-.6 0-1.2-.3-1.5-.9-.5-.9-.2-1.9.7-2.4C64.2 35 67 30.5 67 26.2c0-4-2.2-7.6-5.8-9.5-.9-.5-1.2-1.5-.7-2.4.5-.9 1.5-1.2 2.4-.7 4.7 2.5 7.6 7.3 7.7 12.6v.1c-.2 5.5-3.6 11.2-8.8 14.1zm23-15c0 7.2-3.9 14.2-11.5 21-.3.3-.8.4-1.2.4-.5 0-1-.2-1.3-.6-.6-.7-.6-1.9.2-2.5 6.8-6.1 10.3-12.2 10.3-18.3v-.1c0-5-3.1-10.8-7.1-13.3-.8-.5-1.1-1.6-.6-2.4.5-.8 1.6-1.1 2.4-.6 5 3.2 8.8 10.2 8.8 16.4z",
                fill: "url(#sa4w14varfsaf4)",
                fillRule: "nonzero"
            })
        ]
    }));
};
var OvercastIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 800,
        height: 800,
        viewBox: "0 0 800 800"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M400 800C178.33 800 0 621.67 0 400S178.33 0 400 0s400 178.33 400 400-178.33 400-400 400zm0-158.33l30-30-30-115-30 115 30 30zM361.67 640l-15 56.67 35-35-20-21.67zm76.66 0l-20 20 35 35-15-55zm28.34 103.33L400 676.67l-66.67 66.66C355 746.67 376.67 750 400 750s45-1.67 66.67-6.67zM400 50C206.67 50 50 206.67 50 400c0 153.33 98.33 283.33 235 330l75-278.33C343.33 440 333.33 420 333.33 398.33c0-36.66 30-66.66 66.67-66.66s66.67 30 66.67 66.66c0 21.67-10 40-26.67 53.34L515 730c136.67-46.67 235-176.67 235-330 0-193.33-156.67-350-350-350zm228.33 523.33c-8.33 10-23.33 13.34-35 5C581.67 570 580 555 588.33 545c0 0 45-60 45-145s-45-145-45-145c-8.33-10-6.66-25 5-33.33 11.67-8.34 26.67-5 35 5 3.34 3.33 55 71.66 55 173.33 0 101.67-51.66 170-55 173.33zm-121.66-65c-10-10-8.34-28.33 1.66-38.33 0 0 25-26.67 25-70s-25-68.33-25-70c-10-10-10-26.67-1.66-38.33 10-11.67 25-11.67 35-1.67 1.66 1.67 41.66 43.33 41.66 110s-40 108.33-41.66 110c-10 10-25 8.33-35-1.67zm-213.34 0c-10 10-25 11.67-35 1.67-1.66-3.33-41.66-43.33-41.66-110s40-106.67 41.66-110c10-10 26.67-10 35 1.67 10 10 8.34 28.33-1.66 38.33 0 1.67-25 26.67-25 70s25 70 25 70c10 10 11.66 26.67 1.66 38.33zm-86.66 70c-11.67 8.34-26.67 5-35-5-3.34-3.33-55-71.66-55-173.33 0-101.67 51.66-170 55-173.33 8.33-10 23.33-13.34 35-5C218.33 230 220 245 211.67 255c0 0-45 60-45 145s45 145 45 145c8.33 10 5 25-5 33.33z",
            fill: "#FC7E0F",
            fillRule: "evenodd"
        })
    }));
};
var SticherIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: 727,
        height: 301,
        viewBox: "0 0 727 301"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fillRule: "nonzero",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M449.533 2.04c1.955-2.353 4.67-1.495 7.076-1.495C494.557.492 532.506.537 570.445.483c4.918-.008 8.925-.486 8.899 6.918-.354 86.652-.399 173.314-.522 259.975-7.793 2.088-15.746.876-23.61.92-31.375.177-62.76-.3-94.127.3-9.279.178-11.18-2.803-11.145-11.472.318-81.106.194-162.204.159-243.31.009-3.919.575-7.89-.566-11.774z",
                    fill: "#EA8924"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M149.76 269.207c-4.457-2.318-2.007-6.369-2.007-9.465-.16-77.294-.018-154.587-.292-231.881-.027-8.005 1.389-11.066 10.411-10.933 37.568.566 75.145.38 112.721.106 6.67-.044 9.35 1.176 9.324 8.677-.284 79.09-.16 158.18-.257 237.269 0 2.087 1.751 5.2-2.07 6.21-14.993-1.876-30.058-.806-45.069-.735-27.598.16-55.197-1.114-82.76.752z",
                    fill: "#622368"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M427.383 169.1c0 40.646-.177 81.292.16 121.93.061 7.465-2.009 9.783-9.651 9.705-35.781-.373-71.57-.382-107.352 0-7.678.078-9.677-2.284-9.66-9.75.249-80.93.249-161.85-.008-242.779-.027-7.563 2.14-9.695 9.713-9.615 35.78.371 71.57.389 107.351-.012 7.678-.086 9.677 2.179 9.606 9.662-.345 40.293-.159 80.576-.159 120.86z",
                    fill: "#F8C517"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M127.23 172.302c0 34.499-.256 68.997.187 103.477.106 8.475-2.3 10.996-10.925 10.88-35.383-.477-70.774-.46-106.157-.008-8.253.106-10.243-2.38-10.208-10.34.3-69.705.292-139.418.009-209.122-.027-7.599 2.158-9.65 9.695-9.571 35.745.371 71.5.416 107.245-.018 8.067-.097 10.456 1.973 10.35 10.146-.452 34.843-.186 69.704-.195 104.556z",
                    fill: "#3791C3"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M599.618 151.453c0-32.004.16-64.007-.124-96.011-.062-6.785 1.54-9.324 8.996-9.235 36.497.398 73.004.336 109.501.044 6.696-.053 8.51 2.017 8.492 8.563-.221 64.37-.221 128.74-.009 193.11.018 6.44-1.486 8.678-8.377 8.607-36.497-.345-73.003-.371-109.5.02-7.29.077-9.165-2.17-9.103-9.078.283-32.004.124-64.016.124-96.02z",
                    fill: "#C23727"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M449.533 2.04c3.034 3.848 1.583 8.342 1.592 12.508.097 79.496.07 159.002.07 238.498 0 14.268.01 14.268 14.844 14.277l112.791.053c-1.105 3.618-4.175 2.114-6.333 2.114-38.665.106-77.33-.044-115.985.204-6.095.035-7.961-1.646-7.943-7.82.194-85.21.132-170.43.177-255.64-.01-1.398.513-2.796.787-4.194z",
                    fill: "#E98300"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M149.76 269.207c2.274-2.494 5.3-1.858 8.121-1.866 37.196-.027 74.384-.027 111.58 0 2.822 0 5.856-.646 8.12 1.866h-127.82z",
                    fill: "#590960"
                })
            ]
        })
    }));
};
var SocialMediasIcon_SimplecastIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 86 84"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#000000",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M85.01 0v83.99H.736V0H85.01zm-5.618 5.6H6.353v72.79h73.04V5.6z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M17.59 16.798V67.19h50.566zM64.182 52.432L32.401 20.758l3.972-3.96 31.783 31.674zM64.182 36.594l-15.89-15.837 3.972-3.96 15.892 15.838z"
                })
            ]
        })
    }));
};
var PandoraIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 843.26 1000"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "A",
                        y1: "500",
                        x2: "843.26",
                        y2: "500",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#413c98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".18",
                                stopColor: "#443c98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".34",
                                stopColor: "#4f3b96"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".48",
                                stopColor: "#603b94"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".61",
                                stopColor: "#783991"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".74",
                                stopColor: "#98388c"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".87",
                                stopColor: "#be3687"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".99",
                                stopColor: "#eb3481"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        id: "B",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M449.23 0H0v1000h268.2a45.22 45.22 0 0 0 45.22-45.22V762.7h67.15c328.35 0 462.68-185.06 462.68-401.5C843.26 94.05 640.27 0 449.23 0z",
                            fill: "url(#A)"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "C",
                        x1: "598.505",
                        y1: "71.422",
                        x2: "761.131",
                        y2: "-139.192",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#c41d63"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".24",
                                stopColor: "#c62063"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".44",
                                stopColor: "#cb2a63"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".62",
                                stopColor: "#d33b64"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".79",
                                stopColor: "#df5365"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".95",
                                stopColor: "#ee7166"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#f47d66"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "D",
                        x1: "557.819",
                        y1: "123.987",
                        x2: "721.771",
                        y2: "-86.24",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#414ea1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".27",
                                stopColor: "#4453a4"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".58",
                                stopColor: "#4b61ad"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".92",
                                stopColor: "#5878bc"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#5b7fc0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "E",
                        x1: "519.037",
                        y1: "177.251",
                        x2: "684.329",
                        y2: "-33.363",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#56b0e3"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".45",
                                stopColor: "#4d7ec3"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#413c98"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "F",
                        x1: "596.613",
                        y1: "429.301",
                        x2: "748.328",
                        y2: "-136.878",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#00aaea"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".61",
                                stopColor: "#2964b6"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#413c98"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "G",
                        x1: "437.436",
                        y1: "433.821",
                        x2: "607.359",
                        y2: "-89.343",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".22",
                                stopColor: "#425ba9"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".37",
                                stopColor: "#3d61ad"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".57",
                                stopColor: "#3072ba"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".79",
                                stopColor: "#1a8ecf"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00aee7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "H",
                        x1: "28.189",
                        y1: "-329.032",
                        x2: "689.324",
                        y2: "453.649",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#293689"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".26",
                                stopColor: "#2b3689"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".41",
                                stopColor: "#343689"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".53",
                                stopColor: "#423688"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".63",
                                stopColor: "#563687"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".73",
                                stopColor: "#6f3586"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".82",
                                stopColor: "#8f3585"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".9",
                                stopColor: "#b53583"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".98",
                                stopColor: "#df3482"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "I",
                        x1: "408.184",
                        y1: "442.757",
                        x2: "573.195",
                        y2: "19.462",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#c62338"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".36",
                                stopColor: "#c6243a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".53",
                                stopColor: "#c62842"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".67",
                                stopColor: "#c72f4f"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".78",
                                stopColor: "#c73861"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".88",
                                stopColor: "#c84479"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".97",
                                stopColor: "#c95396"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#c958a1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "J",
                        x1: "167.139",
                        y1: "321.511",
                        x2: "728.281",
                        y2: "117.268",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".25",
                                stopColor: "#425ba9"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".89",
                                stopColor: "#0aa3de"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00b0e7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "K",
                        x1: "345.986",
                        y1: "434.319",
                        x2: "538.637",
                        y2: "100.694",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#c92338"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".25",
                                stopColor: "#cb263b"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".46",
                                stopColor: "#cf2e46"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".66",
                                stopColor: "#d83b57"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".84",
                                stopColor: "#e34f6f"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#f0648a"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "L",
                        x1: "-24.791",
                        y1: "275.326",
                        x2: "561.941",
                        y2: "61.783",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#425ba9"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".07",
                                stopColor: "#3d61ae"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".7",
                                stopColor: "#1199d7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00afe7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "M",
                        x1: "353.527",
                        y1: "643.141",
                        x2: "466.772",
                        y2: "1.165",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#bd1e2b"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".2",
                                stopColor: "#c02330"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".43",
                                stopColor: "#c9313d"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".69",
                                stopColor: "#d94954"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".95",
                                stopColor: "#ee6a74"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#f2717a"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "N",
                        x1: "-81.814",
                        y1: "294.842",
                        x2: "551.931",
                        y2: "124.696",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#283889"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".14",
                                stopColor: "#2c3889"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".29",
                                stopColor: "#383888"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".43",
                                stopColor: "#4c3788"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".57",
                                stopColor: "#683786"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".71",
                                stopColor: "#8c3685"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".85",
                                stopColor: "#b83583"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".99",
                                stopColor: "#eb3481"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "O",
                        x1: "283.758",
                        y1: "659.553",
                        x2: "436.133",
                        y2: "91.049",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#c12539"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".28",
                                stopColor: "#c92d3e"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".72",
                                stopColor: "#df444c"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#f05657"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "P",
                        x1: "-102.753",
                        y1: "347.74",
                        x2: "779.458",
                        y2: "424.946",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#283889"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".11",
                                stopColor: "#333889"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".29",
                                stopColor: "#503787"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".53",
                                stopColor: "#803685"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".82",
                                stopColor: "#c23583"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "Q",
                        x1: "234.353",
                        y1: "689.516",
                        x2: "404.145",
                        y2: "167.057",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#c2243a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".21",
                                stopColor: "#c72b3d"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".51",
                                stopColor: "#d43d46"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".87",
                                stopColor: "#e95c55"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#f2695b"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "R",
                        x1: "-178.283",
                        y1: "216.789",
                        x2: "728.668",
                        y2: "639.72",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#283889"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".12",
                                stopColor: "#3b3888"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".37",
                                stopColor: "#6b3686"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".71",
                                stopColor: "#b93582"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".84",
                                stopColor: "#d93481"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "S",
                        x1: "-112.667",
                        y1: "149.996",
                        x2: "672.901",
                        y2: "809.258",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#d91f35"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".07",
                                stopColor: "#dc283a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".3",
                                stopColor: "#e64548"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".54",
                                stopColor: "#ed5953"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".77",
                                stopColor: "#f16559"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#f2695b"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "T",
                        x1: "362.868",
                        y1: "773.704",
                        x2: "505.099",
                        y2: "468.64",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#362a86"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".11",
                                stopColor: "#3d2a86"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".27",
                                stopColor: "#522c85"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".47",
                                stopColor: "#742d84"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".69",
                                stopColor: "#a33083"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".94",
                                stopColor: "#de3381"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "U",
                        x1: "149.09",
                        y1: "661.285",
                        x2: "329.066",
                        y2: "404.291",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#413c98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".17",
                                stopColor: "#3353a8"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".54",
                                stopColor: "#177ec6"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".83",
                                stopColor: "#0699d9"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00a3e0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "V",
                        x1: "-89.96",
                        y1: "647.646",
                        x2: "504.552",
                        y2: "430.108",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#d91f35"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".29",
                                stopColor: "#df304a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".89",
                                stopColor: "#ed5b7f"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#f0648a"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "W",
                        x1: "153.836",
                        y1: "751.183",
                        x2: "273.991",
                        y2: "421.102",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#362a87"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".11",
                                stopColor: "#3c2a87"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".27",
                                stopColor: "#4e2b86"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".45",
                                stopColor: "#6c2d85"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".65",
                                stopColor: "#942f84"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".86",
                                stopColor: "#c83282"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("linearGradient", {
                        id: "X",
                        x1: "101.233",
                        y1: "793.155",
                        x2: "293.625",
                        y2: "380.647",
                        xlinkHref: "#U"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "Y",
                        x1: "-191.12",
                        y1: "660.996",
                        x2: "496.927",
                        y2: "514.743",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#c11d2a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".15",
                                stopColor: "#c12031"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".36",
                                stopColor: "#c32943"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".6",
                                stopColor: "#c53861"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".87",
                                stopColor: "#c74d8b"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#c958a1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "Z",
                        x1: "110.079",
                        y1: "864.105",
                        x2: "222.288",
                        y2: "445.194",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#362a87"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".16",
                                stopColor: "#3a2a87"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".31",
                                stopColor: "#452b87"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".45",
                                stopColor: "#582c86"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".59",
                                stopColor: "#732d85"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".73",
                                stopColor: "#952f84"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".87",
                                stopColor: "#bf3183"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "a",
                        x1: "60.484",
                        y1: "846.296",
                        x2: "252.876",
                        y2: "433.788",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#413c98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".2",
                                stopColor: "#2b5fb1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".41",
                                stopColor: "#187dc5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".61",
                                stopColor: "#0b92d4"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".81",
                                stopColor: "#039fdd"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00a3e0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "b",
                        x1: "-134.539",
                        y1: "236.068",
                        x2: "373.775",
                        y2: "1116.556",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#413c98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".08",
                                stopColor: "#5a3b95"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".23",
                                stopColor: "#87398f"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".39",
                                stopColor: "#ac378a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".55",
                                stopColor: "#c93686"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".7",
                                stopColor: "#dd3583"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".85",
                                stopColor: "#ea3482"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "c",
                        x1: "19.743",
                        y1: "899.443",
                        x2: "212.135",
                        y2: "486.935",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#423996"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".11",
                                stopColor: "#3947a0"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".52",
                                stopColor: "#1a79c3"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".83",
                                stopColor: "#0797d8"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00a3e0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "d",
                        x1: "-322.572",
                        y1: "141.001",
                        x2: "188.197",
                        y2: "1025.518",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#28388a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".13",
                                stopColor: "#2c388a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".27",
                                stopColor: "#3a3889"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".42",
                                stopColor: "#4f3788"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".57",
                                stopColor: "#6e3787"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".73",
                                stopColor: "#963685"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".88",
                                stopColor: "#c53583"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#ee3481"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "e",
                        x1: "-251.323",
                        y1: "865.971",
                        x2: "400.804",
                        y2: "628.668",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#413c98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".23",
                                stopColor: "#3056aa"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".75",
                                stopColor: "#0e8ed1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00a3e0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "f",
                        x1: "-32.022",
                        y1: "970.406",
                        x2: "152.49",
                        y2: "579.59",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#cc1a29"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".26",
                                stopColor: "#cc1b2c"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".43",
                                stopColor: "#cc2035"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".58",
                                stopColor: "#cb2844"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".72",
                                stopColor: "#cb335a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".85",
                                stopColor: "#ca4276"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".97",
                                stopColor: "#c95398"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#c958a1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "g",
                        x1: "-237.389",
                        y1: "897.008",
                        x2: "342.726",
                        y2: "685.91",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#413c98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".37",
                                stopColor: "#2b60b1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00a5e1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "h",
                        x1: "-303.759",
                        y1: "911.259",
                        x2: "378.379",
                        y2: "689.676",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#293789"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".21",
                                stopColor: "#2c3789"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".37",
                                stopColor: "#363788"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".51",
                                stopColor: "#463788"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".65",
                                stopColor: "#5d3786"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".77",
                                stopColor: "#7a3785"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".89",
                                stopColor: "#9e3783"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#c63781"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "i",
                        x1: "-52.699",
                        y1: "994.509",
                        x2: "85.616",
                        y2: "734.32",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#413c98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".25",
                                stopColor: "#443b96"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".41",
                                stopColor: "#4c3a91"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".55",
                                stopColor: "#5b3787"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".67",
                                stopColor: "#70337a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".78",
                                stopColor: "#8b2e68"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".89",
                                stopColor: "#ac2853"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".99",
                                stopColor: "#d3203a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#d91f36"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "j",
                        x1: "-95.379",
                        y1: "980.164",
                        x2: "84.596",
                        y2: "723.17",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#3a499e"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".21",
                                stopColor: "#374da1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".42",
                                stopColor: "#3059aa"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".63",
                                stopColor: "#236db8"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".84",
                                stopColor: "#18c"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00a3e0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "k",
                        x1: "-280.433",
                        y1: "428.352",
                        x2: "231.614",
                        y2: "1315.314",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#392e83"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".33",
                                stopColor: "#403386",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".61",
                                stopColor: "#554291",
                                stopOpacity: ".84"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".86",
                                stopColor: "#785aa2",
                                stopOpacity: ".64"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#916caf",
                                stopOpacity: ".5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "l",
                        x1: "-139.933",
                        y1: "1112.028",
                        x2: "52.458",
                        y2: "699.52",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".22",
                                stopColor: "#005cab"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".4",
                                stopColor: "#0060ae"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".59",
                                stopColor: "#006cb7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".77",
                                stopColor: "#0080c5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".95",
                                stopColor: "#009bda"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00a5e1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "m",
                        x1: "-311.628",
                        y1: "490.949",
                        x2: "200.577",
                        y2: "1377.948",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#423895"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".26",
                                stopColor: "#403b97"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".45",
                                stopColor: "#3b449d"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".6",
                                stopColor: "#3153a8"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".75",
                                stopColor: "#2469b7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".88",
                                stopColor: "#1385cb"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00a5e1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "n",
                        x1: "-181.205",
                        y1: "1140.381",
                        x2: "12.154",
                        y2: "776.789",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".24",
                                stopColor: "#1d62af"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".51",
                                stopColor: "#1f64b1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".66",
                                stopColor: "#256cb6"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".78",
                                stopColor: "#2f7abf"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".88",
                                stopColor: "#3d8dcc"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".97",
                                stopColor: "#4fa6dc"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#56b0e3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "o",
                        x1: "-250.909",
                        y1: "1166.498",
                        x2: "-85.829",
                        y2: "957.169",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#4250a2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".64",
                                stopColor: "#5a6eb4"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#6981c0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "p",
                        x1: "-292.008",
                        y1: "1217.466",
                        x2: "-126.921",
                        y2: "1008.129",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#464da1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".46",
                                stopColor: "#5762ad"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#6f80be"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "q",
                        x1: "-333.107",
                        y1: "1268.434",
                        x2: "-168.02",
                        y2: "1059.097",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#474b9f"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".38",
                                stopColor: "#565ba9"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#767ebd"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "r",
                        x1: "-374.213",
                        y1: "1319.395",
                        x2: "-209.126",
                        y2: "1110.059",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#4c489e"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".33",
                                stopColor: "#5955a5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".93",
                                stopColor: "#7b78b9"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#7f7cbb"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "s",
                        x1: "-415.312",
                        y1: "1370.363",
                        x2: "-250.225",
                        y2: "1161.027",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#51459c"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".3",
                                stopColor: "#5c50a2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".82",
                                stopColor: "#796db2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#8579b8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "t",
                        x1: "-456.41",
                        y1: "1421.331",
                        x2: "-291.323",
                        y2: "1211.995",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#55429a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".26",
                                stopColor: "#5e4a9f"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".68",
                                stopColor: "#7861ab"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#8f76b6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "u",
                        x1: "-497.509",
                        y1: "1472.299",
                        x2: "-332.422",
                        y2: "1262.963",
                        xlinkHref: "#v",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0",
                                stopColor: "#5c3e98"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".24",
                                stopColor: "#64459c"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".62",
                                stopColor: "#7b59a6"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#9873b3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("linearGradient", {
                        id: "v",
                        gradientUnits: "userSpaceOnUse"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M449.23 0H0v1000h268.2a45.22 45.22 0 0 0 45.22-45.22V762.7h67.15c328.35 0 462.68-185.06 462.68-401.5C843.26 94.05 640.27 0 449.23 0z",
                fill: "url(#A)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#B)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M394-406.66l14.5 4.25a88.23 88.23 0 0 1 51.13 39.79l20.54 34.74a88.28 88.28 0 0 0 51.14 39.79l38.73 11.36a88.23 88.23 0 0 1 51.13 39.79l20.54 34.74a88.28 88.28 0 0 0 51.14 39.79L731.6-151a88.28 88.28 0 0 1 51.14 39.79l20.53 34.75a88.3 88.3 0 0 0 51.14 39.78l38.73 11.36a88.36 88.36 0 0 1 51.14 39.79l20.63 34.9A88.26 88.26 0 0 0 1015.73 89l39.2 11.66a88.36 88.36 0 0 1 50.35 38.91l7.82 12.93a88.3 88.3 0 0 1-5.9 100L1055.3 319a88.27 88.27 0 0 1-123.82 15.41l-668.43-520a88.27 88.27 0 0 1-15.47-123.87l51.9-66.7a88.25 88.25 0 0 1 94.51-30.5z",
                        fill: "url(#C)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M961 132.78a88.56 88.56 0 0 0 15.32 6.22l39.1 11.66a88.3 88.3 0 0 1 50.44 39.11l7.8 12.95a88.29 88.29 0 0 1-6.08 99.82L1015.62 369a88.28 88.28 0 0 1-123.85 15.28L223.92-136.45a88.27 88.27 0 0 1-15.34-123.89l52-66.64a88.26 88.26 0 0 1 94.55-30.39l14.5 4.27a88.23 88.23 0 0 1 51.09 39.84l20.5 34.77a88.3 88.3 0 0 0 51.09 39.84l38.68 11.4a88.26 88.26 0 0 1 51.1 39.85l20.5 34.76a88.2 88.2 0 0 0 51.09 39.84l38.72 11.4a88.26 88.26 0 0 1 51.09 39.84L764-26.78a88.23 88.23 0 0 0 51.1 39.84l38.72 11.4a88.23 88.23 0 0 1 51.09 39.84l20.6 34.9a88.23 88.23 0 0 0 35.5 33.57",
                        fill: "url(#D)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M316.2-308.08l14.5 4.3a88.24 88.24 0 0 1 51.05 39.89l20.46 34.8a88.3 88.3 0 0 0 51.05 39.9L492-177.76a88.27 88.27 0 0 1 51 39.89l20.46 34.8a88.27 88.27 0 0 0 51 39.9l38.7 11.45a88.21 88.21 0 0 1 51 39.89L724.75 23a88.27 88.27 0 0 0 51 39.9l38.75 11.4a88.21 88.21 0 0 1 51 39.89l20.53 34.9a88.25 88.25 0 0 0 50.83 39.84l39 11.64a88.3 88.3 0 0 1 50.52 39.31l7.75 13a88.27 88.27 0 0 1-6.25 99.67l-52 66.5a88.26 88.26 0 0 1-123.87 15.15L184.77-87.3a88.26 88.26 0 0 1-15.19-123.9l52-66.6a88.27 88.27 0 0 1 94.62-30.29z",
                        fill: "url(#E)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M390.3-232.78l14.5 4.3a88.3 88.3 0 0 1 51 39.95l20.42 34.82a88.27 88.27 0 0 0 51 40l38.7 11.5a88.3 88.3 0 0 1 51 39.95l20.42 34.8a88.27 88.27 0 0 0 51 40l38.7 11.5a88.3 88.3 0 0 1 51 40L798.5 98.7a88.3 88.3 0 0 0 51 40l38.7 11.5a88.3 88.3 0 0 1 51 40l20.5 34.8a88.32 88.32 0 0 0 50.85 39.91l38.92 11.64a88.25 88.25 0 0 1 50.61 39.45l7.72 13a88.3 88.3 0 0 1-6.43 99.53l-52.1 66.47a88.27 88.27 0 0 1-123.9 15L258.65-12.14a88.26 88.26 0 0 1-15.06-123.92l52.1-66.53a88.26 88.26 0 0 1 94.62-30.19z",
                        fill: "url(#F)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M238.4-209.5l14.5 4.32a88.27 88.27 0 0 1 51 40l20.4 34.83a88.24 88.24 0 0 0 51 40l38.6 11.55a88.26 88.26 0 0 1 51 40L485.22-4a88.33 88.33 0 0 0 51 40l38.68 11.53a88.24 88.24 0 0 1 51 40l20.4 34.83a88.31 88.31 0 0 0 51 40L735.86 174a88.26 88.26 0 0 1 51 40l20.42 34.9a88.29 88.29 0 0 0 50.86 40l38.83 11.63a88.24 88.24 0 0 1 50.7 39.71l7.68 13a88.27 88.27 0 0 1-6.61 99.38L896.53 519a88.27 88.27 0 0 1-123.92 14.9L106.48 11a88.27 88.27 0 0 1-14.92-123.94l52.18-66.47a88.28 88.28 0 0 1 94.65-30.09z",
                        fill: "url(#G)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M120.25-343.07l13.9 6a88.27 88.27 0 0 1 46 45.64l16.22 37a88.27 88.27 0 0 0 46 45.64l37.08 15.93a88.31 88.31 0 0 1 46 45.64l16.2 37a88.27 88.27 0 0 0 46 45.64l37.05 15.82a88.29 88.29 0 0 1 46 45.64l16.22 37a88.24 88.24 0 0 0 46 45.64L570 95.42a88.25 88.25 0 0 1 46 45.63l16.24 37a88.27 88.27 0 0 0 45.89 45.59l37.22 16.05A88.24 88.24 0 0 1 761.07 285l6.12 13.82a88.26 88.26 0 0 1-18.07 97.94l-59.5 59.93a88.28 88.28 0 0 1-124.82.46L-36.3-139.33a88.27 88.27 0 0 1-.48-124.83l59.53-60a88.27 88.27 0 0 1 97.5-18.91z",
                        fill: "url(#H)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M185-128.48l14.74 3.4a88.29 88.29 0 0 1 53.4 36.69l22.55 33.47a88.29 88.29 0 0 0 53.4 36.69l39.34 9a88.3 88.3 0 0 1 53.4 36.69L444.4 61a88.23 88.23 0 0 0 53.4 36.69l39.33 9.06a88.23 88.23 0 0 1 53.4 36.69l22.56 33.47a88.28 88.28 0 0 0 53.4 36.69l39.33 9.05a88.23 88.23 0 0 1 53.4 36.69l22.58 33.5a88.21 88.21 0 0 0 53.35 36.67l39.4 9.1a88.32 88.32 0 0 1 53.26 36.55l8.47 12.53a88.26 88.26 0 0 1-.37 99.45l-47.85 69.63a88.28 88.28 0 0 1-122.73 22.73L67.38 100A88.29 88.29 0 0 1 44.61-22.8l47.86-69.65A88.27 88.27 0 0 1 185-128.48z",
                        fill: "url(#I)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M221.13-195.22l13.75 6.28a88.28 88.28 0 0 1 44.94 46.67l15.38 37.32a88.25 88.25 0 0 0 44.94 46.67l36.7 16.77a88.28 88.28 0 0 1 44.94 46.67l15.38 37.32a88.25 88.25 0 0 0 44.94 46.67l36.7 16.77a88.25 88.25 0 0 1 44.94 46.67l15.38 37.32a88.25 88.25 0 0 0 44.94 46.67l36.7 16.77A88.25 88.25 0 0 1 705.73 300l15.4 37.35A88.28 88.28 0 0 0 766 384l36.78 16.83a88.24 88.24 0 0 1 44.83 46.51l5.8 14a88.27 88.27 0 0 1-20.34 97.35l-60.87 58.6a88.26 88.26 0 0 1-124.8-2.37L60 4.92a88.26 88.26 0 0 1 2.35-124.81l60.87-58.62a88.29 88.29 0 0 1 97.91-16.71z",
                        fill: "url(#J)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M160.58-110.9l14.48 4.35a88.3 88.3 0 0 1 50.88 40.11l20.3 34.88a88.25 88.25 0 0 0 50.87 40.12l38.66 11.6a88.27 88.27 0 0 1 50.88 40.12L407 95.16a88.24 88.24 0 0 0 50.88 40.12l38.65 11.6A88.27 88.27 0 0 1 547.38 187l20.3 34.88A88.24 88.24 0 0 0 618.57 262l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.3 88.3 0 0 0 50.88 40.11l38.65 11.62a88.27 88.27 0 0 1 50.88 40.12l7.6 13.06a88.27 88.27 0 0 1-7 99.08l-52.3 66.4a88.28 88.28 0 0 1-124 14.66L28.2 109.3a88.26 88.26 0 0 1-14.66-124L65.86-81a88.25 88.25 0 0 1 94.72-29.91z",
                        fill: "url(#K)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M26.75-237.33l14 5.77a88.25 88.25 0 0 1 46.65 45l16.75 36.72a88.3 88.3 0 0 0 46.65 45l37.3 15.4a88.28 88.28 0 0 1 46.64 45l16.73 36.62a88.28 88.28 0 0 0 46.64 45l37.3 15.4a88.28 88.28 0 0 1 46.65 45l16.75 36.73a88.25 88.25 0 0 0 46.65 45l37.3 15.4a88.25 88.25 0 0 1 46.65 45l16.75 36.72a88.32 88.32 0 0 0 46.64 45l37.32 15.4a88.28 88.28 0 0 1 46.64 45l6.28 13.75a88.28 88.28 0 0 1-16.76 97.9l-58.65 60.84a88.26 88.26 0 0 1-124.81 2.29L-126.83-31.34a88.27 88.27 0 0 1-2.29-124.81L-70.47-217a88.28 88.28 0 0 1 97.22-20.33z",
                        fill: "url(#L)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M129.3-57.77l14.48 4.36a88.24 88.24 0 0 1 50.87 40.11L215 21.58a88.31 88.31 0 0 0 50.84 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.31 88.31 0 0 0 50.88 40.12L465.22 200a88.25 88.25 0 0 1 50.87 40.12L536.4 275a88.24 88.24 0 0 0 50.87 40.11l38.66 11.62a88.25 88.25 0 0 1 50.87 40.12l20.32 34.88A88.28 88.28 0 0 0 748 441.88l38.66 11.62a88.28 88.28 0 0 1 50.87 40.11l7.6 13.07a88.29 88.29 0 0 1-7 99.08l-52.33 66.36a88.28 88.28 0 0 1-124 14.66l-665-524.33a88.28 88.28 0 0 1-14.66-124l52.43-66.33a88.26 88.26 0 0 1 94.72-29.89z",
                        fill: "url(#M)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M9.87-203.47l13.73 6.32a88.32 88.32 0 0 1 44.81 46.8L83.67-113a88.29 88.29 0 0 0 44.81 46.8l36.66 16.87A88.32 88.32 0 0 1 210-2.51l15.26 37.37A88.32 88.32 0 0 0 270 81.66l36.66 16.87a88.29 88.29 0 0 1 44.81 46.8l15.27 37.37a88.27 88.27 0 0 0 44.8 46.8l36.67 16.87a88.31 88.31 0 0 1 44.8 46.8l15.27 37.37a88.31 88.31 0 0 0 44.8 46.8l36.67 16.87A88.32 88.32 0 0 1 634.58 441l5.7 14a88.27 88.27 0 0 1-20.67 97.15l-61 58.44a88.26 88.26 0 0 1-124.8-2.72L-151.85-3.8a88.28 88.28 0 0 1 2.72-124.81l61-58.44a88.28 88.28 0 0 1 98-16.42z",
                        fill: "url(#N)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M79.1-4.62L93.58-.27a88.25 88.25 0 0 1 50.87 40.12l20.32 34.88a88.25 88.25 0 0 0 50.87 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.32 34.88a88.25 88.25 0 0 0 50.87 40.12L415 253.2a88.25 88.25 0 0 1 50.87 40.12l20.32 34.88a88.28 88.28 0 0 0 50.87 40.11l38.66 11.62a88.31 88.31 0 0 1 50.9 40.08l20.3 34.87A88.25 88.25 0 0 0 697.8 495l38.66 11.62a88.33 88.33 0 0 1 50.88 40.11l7.6 13.07a88.29 88.29 0 0 1-7 99.08l-52.32 66.35a88.28 88.28 0 0 1-124 14.67l-665-524.33a88.29 88.29 0 0 1-14.66-124l52.33-66.35A88.26 88.26 0 0 1 79.1-4.62z",
                        fill: "url(#O)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M99.15-21.38l13.93 5.87a88.31 88.31 0 0 1 46.31 45.32l16.47 36.84A88.31 88.31 0 0 0 222.17 112l37.2 15.67A88.33 88.33 0 0 1 305.68 173l16.47 36.85a88.31 88.31 0 0 0 46.31 45.32l37.2 15.67A88.24 88.24 0 0 1 452 316.1l16.44 36.9a88.26 88.26 0 0 0 46.31 45.31l37.2 15.67a88.28 88.28 0 0 1 46.31 45.32l16.48 36.85c9.13 20.42 24.07 44.86 44.7 53.55l39.72 33.1c20.63 8.68 33.9 2.74 43 23.17l9.93 9.93c14.8 33.1 6.46 72.2-18.9 98.1l-59.1 60.4a88.27 88.27 0 0 1-124.83 1.35L-56 183.46a88.27 88.27 0 0 1-1.32-124.83l59.1-60.4a88.28 88.28 0 0 1 97.37-19.61z",
                        fill: "url(#P)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M38.36 48.53l14.48 4.35A88.25 88.25 0 0 1 103.71 93l20.3 34.88A88.31 88.31 0 0 0 174.9 168l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.29 88.29 0 0 0 50.88 40.11l38.66 11.62a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.33 88.33 0 0 0 50.88 40.11L535 433.07a88.28 88.28 0 0 1 50.87 40.11l20.32 34.88a88.25 88.25 0 0 0 50.87 40.12l38.66 11.62a88.28 88.28 0 0 1 50.87 40.11l7.6 13.1a88.29 88.29 0 0 1-7 99.08l-52.33 66.35a88.26 88.26 0 0 1-124 14.66L-94 268.75a88.29 88.29 0 0 1-14.66-124l52.33-66.36a88.27 88.27 0 0 1 94.69-29.86z",
                        fill: "url(#Q)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M41.78 17.6l13.85 6.06a88.25 88.25 0 0 1 45.7 45.92l16 37.06A88.24 88.24 0 0 0 163 152.57l37 16.16a88.27 88.27 0 0 1 45.7 45.93l16 37.06a88.27 88.27 0 0 0 45.7 45.93l37 16.16a88.29 88.29 0 0 1 45.71 45.93l16 37.06a88.31 88.31 0 0 0 45.7 45.93l37 16.16a88.27 88.27 0 0 1 45.7 45.93l16 37.06c8.87 20.55 19 48.46 39.48 57.43l43.13 4.7a88.25 88.25 0 0 1 45.7 45.92l6 13.9A88.25 88.25 0 0 1 666 761.3l-59.9 59.6a88.26 88.26 0 0 1-124.83-.3L-116 220.36a88.27 88.27 0 0 1 .31-124.84l59.9-59.6A88.26 88.26 0 0 1 41.78 17.6z",
                        fill: "url(#R)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-2.4 101.68L12.1 106A88.24 88.24 0 0 1 63 146.15L83.28 181a88.27 88.27 0 0 0 50.88 40.12l38.65 11.6a88.24 88.24 0 0 1 50.88 40.12l20.3 34.9a88.3 88.3 0 0 0 50.88 40.11l38.66 11.62a88.25 88.25 0 0 1 50.87 40.12l20.3 34.87a88.27 88.27 0 0 0 50.88 40.12l38.66 11.62a88.28 88.28 0 0 1 50.87 40.11l20.3 34.88a88.31 88.31 0 0 0 50.88 40.12L655 613a88.24 88.24 0 0 1 50.87 40.11l7.6 13.07a88.27 88.27 0 0 1-7 99.07l-52.33 66.36a88.26 88.26 0 0 1-124 14.66l-665-524.33a88.28 88.28 0 0 1-14.66-124l52.32-66.36a88.29 88.29 0 0 1 94.8-29.9z",
                        fill: "url(#S)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M99.54 288.47l15 2.2a88.27 88.27 0 0 1 56.2 32.24l25.2 31.53a88.27 88.27 0 0 0 56.2 32.24L292 392.5a88.27 88.27 0 0 1 56.2 32.24l25.2 31.53a88.27 88.27 0 0 0 56.2 32.24l39.94 5.84a88.27 88.27 0 0 1 56.2 32.24L551 558.13a88.27 88.27 0 0 0 56.2 32.24l39.94 5.84a88.31 88.31 0 0 1 56.2 32.24L728.5 660a88.26 88.26 0 0 0 56.2 32.25l39.93 5.83a88.29 88.29 0 0 1 56.2 32.24l9.44 11.8a88.28 88.28 0 0 1 7.61 99l-42.06 73.3a88.26 88.26 0 0 1-120.49 32.64L.8 525.68a88.26 88.26 0 0 1-32.64-120.49l42.05-73.3a88.28 88.28 0 0 1 89.33-43.42z",
                        fill: "url(#T)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-43.13 154.83l14.48 4.35a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.26 88.26 0 0 0 50.88 40.11l38.65 11.62A88.27 88.27 0 0 1 183 326l20.3 34.88A88.3 88.3 0 0 0 254.14 401l38.65 11.62a88.3 88.3 0 0 1 50.88 40.11l20.33 34.9a88.27 88.27 0 0 0 50.88 40.12l38.65 11.62a88.27 88.27 0 0 1 50.88 40.11l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.65 11.6a88.24 88.24 0 0 1 50.88 40.12l7.6 13.07a88.27 88.27 0 0 1-7 99.07L613.4 884.7a88.27 88.27 0 0 1-124 14.66L-175.5 375a88.27 88.27 0 0 1-14.66-124l52.32-66.36a88.29 88.29 0 0 1 94.72-29.81z",
                        fill: "url(#U)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-40.44 130.8l14 5.65a88.28 88.28 0 0 1 47 44.59l17.05 36.58a88.28 88.28 0 0 0 47 44.59l37.44 15.1a88.31 88.31 0 0 1 47 44.59l17 36.58a88.31 88.31 0 0 0 47 44.59l37.44 15.1a88.28 88.28 0 0 1 47 44.59l17 36.58a88.28 88.28 0 0 0 47 44.59L419.1 559a88.23 88.23 0 0 1 47 44.58l17 36.6a88.23 88.23 0 0 0 47 44.58l37.43 15.1a88.28 88.28 0 0 1 47 44.59l6.48 13.72a88.26 88.26 0 0 1-16 98l-58.15 61.3a88.27 88.27 0 0 1-124.79 3.3L-192.34 338a88.27 88.27 0 0 1-3.3-124.79l58.15-61.3a88.28 88.28 0 0 1 97.05-21.09z",
                        fill: "url(#V)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-142.6 277.27l15.07 1.15a88.23 88.23 0 0 1 58.3 28.26l27.32 29.7a88.24 88.24 0 0 0 58.3 28.27l40.25 3a88.33 88.33 0 0 1 58.3 28.34l27.32 29.7a88.29 88.29 0 0 0 58.3 28.29l40.25 3a88.24 88.24 0 0 1 58.29 28.27L326.42 515a88.29 88.29 0 0 0 58.29 28.27l40.25 3a88.29 88.29 0 0 1 58.3 28.27l27.32 29.7a88.28 88.28 0 0 0 58.3 28.26l40.25 3.06a88.28 88.28 0 0 1 58.3 28.26L677.66 675a88.26 88.26 0 0 1 14.45 98.27l-36.87 76a88.27 88.27 0 0 1-117.94 40.95l-762-369.46a88.27 88.27 0 0 1-40.91-117.94l36.86-76a88.28 88.28 0 0 1 86.14-49.55z",
                        fill: "url(#W)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-83.87 208l14.48 4.35a88.27 88.27 0 0 1 50.88 40.12l20.3 34.86a88.3 88.3 0 0 0 50.88 40.11l38.65 11.62a88.27 88.27 0 0 1 50.88 40.12l20.3 34.87a88.27 88.27 0 0 0 50.88 40.12l38.65 11.62a88.3 88.3 0 0 1 50.88 40.11l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.65 11.62a88.26 88.26 0 0 1 50.88 40.11L484 667.5a88.27 88.27 0 0 0 50.88 40.12l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l7.6 13.07a88.25 88.25 0 0 1-7 99.07l-52.32 66.36a88.27 88.27 0 0 1-124 14.66l-665-524.33a88.27 88.27 0 0 1-14.66-124l52.32-66.36A88.29 88.29 0 0 1-83.87 208z",
                        fill: "url(#X)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-78.22 175.8l13.82 6.13a88.25 88.25 0 0 1 45.45 46.17l15.8 37.15a88.22 88.22 0 0 0 45.45 46.17l36.9 16.37A88.29 88.29 0 0 1 124.64 374l15.78 37.15a88.29 88.29 0 0 0 45.45 46.17l36.9 16.37a88.22 88.22 0 0 1 45.45 46.17L284 557a88.25 88.25 0 0 0 45.45 46.17l36.9 16.36a88.31 88.31 0 0 1 45.45 46.18l15.78 37.14A88.29 88.29 0 0 0 473.05 749l36.9 16.36a88.25 88.25 0 0 1 45.45 46.17l5.92 13.92A88.28 88.28 0 0 1 542 922.86l-60.22 59.3a88.27 88.27 0 0 1-124.83-1l-594.1-603.46a88.27 88.27 0 0 1 1-124.83l60.22-59.28a88.27 88.27 0 0 1 97.7-17.79z",
                        fill: "url(#Y)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-185.5 340l15.06 1.36a88.32 88.32 0 0 1 57.88 29.12l26.88 30.1a88.28 88.28 0 0 0 57.88 29.11l40.2 3.64a88.32 88.32 0 0 1 57.88 29.12l26.88 30.1A88.32 88.32 0 0 0 155 521.65l40.2 3.64a88.25 88.25 0 0 1 57.88 29.12L280 584.5a88.32 88.32 0 0 0 57.88 29.12l40.2 3.64A88.21 88.21 0 0 1 436 646.38l26.9 30.1a88.21 88.21 0 0 0 57.88 29.11l40.2 3.64a88.27 88.27 0 0 1 57.88 29.12l10.07 11.28a88.25 88.25 0 0 1 13 98.46l-38 75.5a88.27 88.27 0 0 1-118.53 39.19l-756.5-380.55a88.26 88.26 0 0 1-39.18-118.52l38-75.5A88.27 88.27 0 0 1-185.51 340z",
                        fill: "url(#Z)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-124.6 261.13l14.48 4.35a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.3 88.3 0 0 0 50.88 40.11L50.6 392.2a88.3 88.3 0 0 1 50.88 40.11l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.65 11.62a88.3 88.3 0 0 1 50.88 40.11l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.62 11.6a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l7.6 13.06a88.27 88.27 0 0 1-7 99.08L532 991a88.27 88.27 0 0 1-124 14.66l-665-524.32a88.27 88.27 0 0 1-14.66-124l52.33-66.34a88.28 88.28 0 0 1 94.72-29.87z",
                        fill: "url(#a)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-114.62 266l13.86 6.05A88.25 88.25 0 0 1-55 318l16 37a88.31 88.31 0 0 0 45.68 45.93l37 16.15A88.24 88.24 0 0 1 89.39 463l16 37.05A88.22 88.22 0 0 0 151.1 546l37 16.15A88.31 88.31 0 0 1 233.81 608l16 37.06A88.31 88.31 0 0 0 295.53 691l37 16.15A88.24 88.24 0 0 1 378.24 753l16 37.05A88.24 88.24 0 0 0 440 836l37 16.15a88.31 88.31 0 0 1 45.72 45.91l6 13.88a88.28 88.28 0 0 1-18.75 97.54L450 1069.1a88.28 88.28 0 0 1-124.84-.26l-597.55-600a88.27 88.27 0 0 1 .28-124.85l59.88-59.63A88.26 88.26 0 0 1-114.62 266z",
                        fill: "url(#b)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-165.35 314.28l14.48 4.35A88.27 88.27 0 0 1-100 358.75l20.3 34.88a88.27 88.27 0 0 0 50.89 40.11l38.65 11.62a88.3 88.3 0 0 1 50.88 40.11L81 520.35a88.24 88.24 0 0 0 50.88 40.12l38.65 11.62a88.26 88.26 0 0 1 50.88 40.11l20.3 34.88a88.24 88.24 0 0 0 50.88 40.12l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.68 11.6a88.27 88.27 0 0 1 50.88 40.12l7.6 13.06a88.27 88.27 0 0 1-7 99.08l-52.32 66.36a88.27 88.27 0 0 1-124 14.66l-665-524.33a88.26 88.26 0 0 1-14.66-124l52.32-66.36a88.28 88.28 0 0 1 94.82-29.85z",
                        fill: "url(#c)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-285.37 164.18l13.6 6.6a88.27 88.27 0 0 1 43.87 47.68l14.52 37.66a88.23 88.23 0 0 0 43.87 47.68l36.32 17.6a88.23 88.23 0 0 1 43.87 47.68l14.52 37.66a88.27 88.27 0 0 0 43.87 47.68L5.4 472a88.27 88.27 0 0 1 43.87 47.7l14.52 37.66A88.27 88.27 0 0 0 107.65 605L144 622.64a88.27 88.27 0 0 1 43.87 47.68l14.5 37.68a88.27 88.27 0 0 0 43.87 47.68l36.32 17.6a88.27 88.27 0 0 1 43.87 47.68l5.44 14.1a88.27 88.27 0 0 1-22.6 96.72l-62.2 57.2a88.27 88.27 0 0 1-124.73-5.19L-451 360.6a88.27 88.27 0 0 1 5.2-124.73l62.2-57.2a88.25 88.25 0 0 1 98.24-14.48z",
                        fill: "url(#d)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-206.1 367.43l14.48 4.35a88.31 88.31 0 0 1 50.88 40.12l20.3 34.87a88.25 88.25 0 0 0 50.87 40.12l38.66 11.62A88.33 88.33 0 0 1 20 538.62l20.3 34.88a88.25 88.25 0 0 0 50.87 40.12l38.66 11.6a88.31 88.31 0 0 1 50.88 40.12l20.3 34.88a88.25 88.25 0 0 0 50.87 40.12L290.55 752a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.24 88.24 0 0 0 50.88 40.12l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l7.6 13.06a88.28 88.28 0 0 1-7 99.08l-52.32 66.36a88.29 88.29 0 0 1-124 14.66l-665-524.33a88.27 88.27 0 0 1-14.67-124l52.33-66.36a88.27 88.27 0 0 1 94.81-29.89z",
                        fill: "url(#e)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-226.43 404.1l14.6 3.93a88.32 88.32 0 0 1 52 38.63l21.3 34.28a88.26 88.26 0 0 0 52 38.62l39 10.5a88.32 88.32 0 0 1 52 38.63L25.82 603a88.26 88.26 0 0 0 52 38.62l39 10.5a88.26 88.26 0 0 1 52 38.62L190.14 725a88.32 88.32 0 0 0 52 38.63l39 10.5a88.26 88.26 0 0 1 52 38.63L354.47 847a88.23 88.23 0 0 0 52 38.63l39 10.5a88.28 88.28 0 0 1 52 38.63l8 12.84a88.26 88.26 0 0 1-4.09 99.23L451 1114.66a88.27 88.27 0 0 1-123.5 18.24l-679.88-504.85a88.28 88.28 0 0 1-18.25-123.5l50.38-67.84a88.27 88.27 0 0 1 93.82-32.62z",
                        fill: "url(#f)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-185.13 383.24l13.92 5.9A88.22 88.22 0 0 1-125 434.56l16.4 36.88a88.27 88.27 0 0 0 46.2 45.42l37.16 15.75A88.29 88.29 0 0 1 21 578l16.4 36.88a88.29 88.29 0 0 0 46.2 45.42l37.16 15.75a88.27 88.27 0 0 1 46.21 45.42l16.4 36.88a88.27 88.27 0 0 0 46.21 45.42l37.16 15.76A88.29 88.29 0 0 1 312.9 865l16.4 36.9a88.25 88.25 0 0 0 46.21 45.41l37.16 15.7a88.27 88.27 0 0 1 46.21 45.42l6.14 13.8A88.27 88.27 0 0 1 447.3 1120l-59.24 60.27a88.27 88.27 0 0 1-124.83 1.08L-340.7 587.73a88.27 88.27 0 0 1-1.08-124.83l59.24-60.27a88.27 88.27 0 0 1 97.41-19.39z",
                        fill: "url(#g)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-243.52 420.58l14.48 4.35A88.28 88.28 0 0 1-178.17 465l20.32 34.88A88.25 88.25 0 0 0-107 540l38.66 11.62a88.24 88.24 0 0 1 50.87 40.11l20.34 34.92a88.25 88.25 0 0 0 50.87 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.32 34.88a88.25 88.25 0 0 0 50.87 40.12l38.66 11.6A88.31 88.31 0 0 1 304 845.23l20.3 34.88a88.24 88.24 0 0 0 50.87 40.11l38.66 11.62A88.31 88.31 0 0 1 464.72 972l7.6 13.06a88.28 88.28 0 0 1-7 99.08L413 1150.46a88.29 88.29 0 0 1-124 14.66L-376 640.8a88.28 88.28 0 0 1-14.66-124l52.33-66.36a88.26 88.26 0 0 1 94.81-29.85z",
                        fill: "url(#h)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-317.77 531.43l15 2.2A88.32 88.32 0 0 1-246.66 566l25.14 31.57a88.28 88.28 0 0 0 56.15 32.33l39.93 5.9a88.29 88.29 0 0 1 56.14 32.31l25.15 31.57A88.24 88.24 0 0 0 12 732l39.93 5.9a88.29 88.29 0 0 1 56.14 32.33l25.15 31.58a88.28 88.28 0 0 0 56.15 32.33l39.93 5.9a88.24 88.24 0 0 1 56.14 32.33L310.6 904a88.24 88.24 0 0 0 56.15 32.33l39.92 5.9a88.28 88.28 0 0 1 56.15 32.33l9.42 11.83a88.27 88.27 0 0 1 7.45 99l-42.17 73.23A88.27 88.27 0 0 1 317 1191.06L-416.9 768.5a88.28 88.28 0 0 1-32.45-120.55l42.17-73.23a88.29 88.29 0 0 1 89.4-43.28z",
                        fill: "url(#i)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-287.57 473.73l14.48 4.35a88.28 88.28 0 0 1 50.87 40.11l20.3 34.88A88.31 88.31 0 0 0-151 593.19l38.66 11.6a88.25 88.25 0 0 1 50.84 40.12l20.3 34.88a88.31 88.31 0 0 0 50.88 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.32 34.88a88.25 88.25 0 0 0 50.87 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.32 34.88a88.28 88.28 0 0 0 50.87 40.11L369.8 985a88.25 88.25 0 0 1 50.87 40.12l7.6 13.06a88.29 88.29 0 0 1-7 99.08L369 1203.6a88.28 88.28 0 0 1-124 14.66l-665-524.33a88.28 88.28 0 0 1-14.66-124l52.33-66.36a88.24 88.24 0 0 1 94.76-29.85z",
                        fill: "url(#j)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-229.65 446.4l13.4 7a88.23 88.23 0 0 1 42.38 49l13.35 38.1a88.35 88.35 0 0 0 42.39 49l35.76 18.7a88.28 88.28 0 0 1 42.38 49l13.35 38.1a88.31 88.31 0 0 0 42.38 49L51.5 763a88.31 88.31 0 0 1 42.38 49l13.35 38.1a88.28 88.28 0 0 0 42.38 49l35.77 18.72a88.32 88.32 0 0 1 42.38 49l13.35 38.2a88.23 88.23 0 0 0 42.38 49l35.76 18.7a88.23 88.23 0 0 1 42.38 49l5 14.27a88.28 88.28 0 0 1-25.56 96l-63.92 55.28a88.28 88.28 0 0 1-124.51-9l-553.9-640.63a88.28 88.28 0 0 1 9-124.51l63.92-55.27a88.28 88.28 0 0 1 98.69-11.45z",
                        fill: "url(#k)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-325 526.87l14.47 4.36a88.23 88.23 0 0 1 50.88 40.11l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12L-149.8 658a88.24 88.24 0 0 1 50.88 40.12l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.07l20.3 34.88a88.29 88.29 0 0 0 50.9 40.11l38.66 11.62a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.33 88.33 0 0 0 50.88 40.11l38.66 11.62a88.28 88.28 0 0 1 50.87 40.11l7.6 13.07a88.29 88.29 0 0 1-7 99.08l-52.33 66.36a88.28 88.28 0 0 1-124 14.66l-665-524.33a88.28 88.28 0 0 1-14.66-124l52.33-66.36a88.26 88.26 0 0 1 94.8-29.86z",
                        fill: "url(#l)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-260.3 508.7l13.4 7a88.3 88.3 0 0 1 42.31 49.07l13.3 38.1A88.26 88.26 0 0 0-149 652l35.73 18.77a88.22 88.22 0 0 1 42.31 49.07l13.3 38.1A88.24 88.24 0 0 0-15.35 807l35.74 18.76a88.29 88.29 0 0 1 42.3 49.08l13.3 38.1A88.31 88.31 0 0 0 118.3 962l35.7 18.78a88.22 88.22 0 0 1 42.31 49.07l13.3 38.1a88.24 88.24 0 0 0 42.3 49.07l35.74 18.77a88.24 88.24 0 0 1 42.3 49.07l5 14.27a88.28 88.28 0 0 1-25.71 95.94l-64 55.18a88.27 88.27 0 0 1-124.5-9.22l-552.92-641.37A88.26 88.26 0 0 1-423 575.18l64-55.18a88.26 88.26 0 0 1 98.71-11.3z",
                        fill: "url(#m)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-367.94 580l14.58 4.35a88.76 88.76 0 0 1 51.22 40.12l20.45 34.88a88.76 88.76 0 0 0 51.22 40.12l38.92 11.6a88.79 88.79 0 0 1 51.22 40.12l20.44 34.88a88.79 88.79 0 0 0 51.22 40.12l38.92 11.6A88.76 88.76 0 0 1 21.47 878l20.45 34.88a88.79 88.79 0 0 0 51.22 40.11l38.9 11.62a88.78 88.78 0 0 1 51.23 40.12l20.44 34.87a88.79 88.79 0 0 0 51.22 40.12l38.92 11.62a88.79 88.79 0 0 1 51.22 40.11l7.66 13.07a87.81 87.81 0 0 1-7 99.08l-52.68 66.35a89.27 89.27 0 0 1-124.81 14.67L-501.2 800.24a87.88 87.88 0 0 1-14.76-124l52.67-66.35A89.22 89.22 0 0 1-367.94 580z",
                        fill: "url(#n)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-450.9 684.14l14.48 4.35a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.33 88.33 0 0 0 50.88 40.11L-115 942a88.25 88.25 0 0 1 50.9 40.07l20.3 34.87a88.31 88.31 0 0 0 50.88 40.12l38.66 11.62a88.28 88.28 0 0 1 50.87 40.11l20.32 34.88a88.25 88.25 0 0 0 50.87 40.12l38.66 11.62a88.24 88.24 0 0 1 50.87 40.11l7.6 13.07a88.27 88.27 0 0 1-7 99.07l-52.3 66.34a88.26 88.26 0 0 1-124 14.66l-665-524.33a88.28 88.28 0 0 1-14.66-124l52.4-66.33a88.27 88.27 0 0 1 94.72-29.86z",
                        fill: "url(#o)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-492 735.1l14.48 4.35a88.31 88.31 0 0 1 50.88 40.12l20.3 34.88a88.24 88.24 0 0 0 50.87 40.11l38.66 11.62a88.31 88.31 0 0 1 50.88 40.12l20.3 34.88a88.28 88.28 0 0 0 50.87 40.11l38.66 11.62a88.3 88.3 0 0 1 50.89 40.08l20.3 34.88A88.24 88.24 0 0 0-34 1108l38.65 11.62a88.3 88.3 0 0 1 50.88 40.11l20.3 34.88a88.24 88.24 0 0 0 50.88 40.12l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l7.6 13.07a88.27 88.27 0 0 1-7 99.07l-52.3 66.4a88.27 88.27 0 0 1-124 14.66l-665-524.33a88.26 88.26 0 0 1-14.66-124L-586.7 765A88.28 88.28 0 0 1-492 735.11z",
                        fill: "url(#p)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-533.1 786.08l14.48 4.35a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.3 88.3 0 0 0 50.88 40.11l38.65 11.62A88.27 88.27 0 0 1-307 957.28l20.3 34.88a88.3 88.3 0 0 0 50.88 40.11l38.65 11.62a88.3 88.3 0 0 1 50.87 40.11l20.3 34.88A88.27 88.27 0 0 0-75.1 1159l38.65 11.62a88.26 88.26 0 0 1 50.88 40.11l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l7.6 13.07a88.25 88.25 0 0 1-7 99.07l-52.3 66.4a88.27 88.27 0 0 1-124 14.66l-665-524.33a88.27 88.27 0 0 1-14.66-124L-627.8 816a88.29 88.29 0 0 1 94.72-29.92z",
                        fill: "url(#q)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-574.18 837.05l14.48 4.35a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.3 88.3 0 0 0 50.88 40.11l38.64 11.62a88.28 88.28 0 0 1 50.87 40.11l20.3 34.88a88.31 88.31 0 0 0 50.88 40.12l38.66 11.62a88.28 88.28 0 0 1 50.89 40.14l20.3 34.88A88.31 88.31 0 0 0-116.2 1210l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.31 88.31 0 0 0 50.88 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l7.6 13.06a88.28 88.28 0 0 1-7 99.08l-52.33 66.36a88.27 88.27 0 0 1-124 14.66l-665-524.33a88.28 88.28 0 0 1-14.66-124l52.33-66.36a88.27 88.27 0 0 1 94.82-29.88z",
                        fill: "url(#r)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-615.28 888l14.48 4.35a88.31 88.31 0 0 1 50.88 40.12l20.3 34.88a88.28 88.28 0 0 0 50.87 40.11l38.66 11.62a88.33 88.33 0 0 1 50.88 40.11l20.3 34.88a88.25 88.25 0 0 0 50.89 40.14l38.66 11.62a88.26 88.26 0 0 1 50.88 40.11l20.3 34.88a88.25 88.25 0 0 0 50.87 40.12l38.66 11.6a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.24 88.24 0 0 0 50.88 40.12l38.65 11.6A88.27 88.27 0 0 1 93 1439.4l7.6 13.06a88.28 88.28 0 0 1-7 99.08l-52.33 66.36a88.27 88.27 0 0 1-124 14.66l-665-524.33a88.26 88.26 0 0 1-14.66-124L-710 917.9a88.28 88.28 0 0 1 94.72-29.9z",
                        fill: "url(#s)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-656.38 939l14.48 4.35a88.3 88.3 0 0 1 50.9 40.1l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.65 11.62a88.3 88.3 0 0 1 50.88 40.11l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.65 11.6a88.27 88.27 0 0 1 50.88 40.12l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12L1 1450.25a88.27 88.27 0 0 1 50.88 40.12l7.6 13.06a88.27 88.27 0 0 1-7 99.08l-52.3 66.36a88.28 88.28 0 0 1-124 14.66l-665-524.33a88.27 88.27 0 0 1-14.66-124l52.32-66.36A88.29 88.29 0 0 1-656.38 939z",
                        fill: "url(#t)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M-697.47 990l14.48 4.35a88.28 88.28 0 0 1 50.87 40.11l20.3 34.88a88.27 88.27 0 0 0 50.88 40.12l38.66 11.62a88.24 88.24 0 0 1 50.87 40.11l20.3 34.88a88.31 88.31 0 0 0 50.88 40.12l38.66 11.6a88.25 88.25 0 0 1 50.87 40.12l20.3 34.88a88.31 88.31 0 0 0 50.88 40.12l38.66 11.6a88.25 88.25 0 0 1 50.83 40.08l20.3 34.88a88.29 88.29 0 0 0 50.88 40.11l38.66 11.62a88.25 88.25 0 0 1 50.87 40.12l7.6 13.06a88.28 88.28 0 0 1-7 99.08L-41 1719.84a88.28 88.28 0 0 1-124 14.66l-665-524.33a88.28 88.28 0 0 1-14.66-124l52.33-66.36A88.24 88.24 0 0 1-697.47 990z",
                        fill: "url(#u)"
                    })
                ]
            })
        ]
    }));
};
var AmazonMusicIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 200 200",
        enableBackground: "new 0 0 200 200",
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "SVGID_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "100",
                y1: "-1.000444e-11",
                x2: "100",
                y2: "200",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: "0",
                        stopColor: "#4400FF"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: "0.1611",
                        stopColor: "#4301FB"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: "0.3279",
                        stopColor: "#4104EE"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: "0.4976",
                        stopColor: "#3E08DA"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: "0.6691",
                        stopColor: "#390FBD"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: "0.8403",
                        stopColor: "#331898"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: "1",
                        stopColor: "#2C216E"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                fill: "url(#SVGID_1_)",
                width: "200",
                height: "200"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M32.1,120.6c0.5-0.3,0.9-0.6,1.4-0.9c1.2-0.6,2.4-1.3,3.6-1.8c0.5-0.2,1.1-0.6,1.7-0.5 c0.6-0.4,1.4-0.3,2.1-0.5c1.3-0.4,2.7-0.4,4.1-0.2c1.3,0.2,2.7,0.6,3.8,1.3c1,0.7,1.7,1.5,2.3,2.6c0,0.1,0.1,0.2,0.2,0.3 c0.2-0.1,0.4-0.1,0.5-0.2c1.3-0.9,2.6-1.6,4-2.3c0.5-0.2,1-0.4,1.5-0.6c0.7-0.2,1.3-0.4,2-0.7c0,0,0,0,0.1,0c1.1,0,2.2-0.5,3.3-0.5 c0.6,0,1.2,0,1.8,0c0.5,0,1,0.2,1.5,0.3c0.1,0,0.3,0.1,0.4,0.1c1.1,0.1,2,0.7,2.9,1.3c0.7,0.5,1.2,1.1,1.7,1.8 c0.4,0.6,0.8,1.3,0.9,2.2c0,0.1,0,0.2,0.1,0.3c0.3,0.6,0.3,1.2,0.3,1.9c0.2,7.5,0.1,14.9,0.1,22.4c0,0.4,0,0.8-0.1,1.1 c0,0.3-0.2,0.5-0.5,0.6c-0.3,0.1-0.7,0.2-1,0.2c-1,0-1.9,0-2.9,0c-0.2,0-0.5,0-0.7-0.1c-0.7-0.2-0.8-0.4-0.8-1.2 c0-6.9,0-13.9,0-20.8c0-0.4-0.1-0.9-0.2-1.3c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.7-0.4-1.3-0.9-1.8c-0.5-0.5-1-1-1.7-1.3 c-0.1,0-0.2-0.1-0.3-0.1c-0.8,0-1.5,0-2.3-0.1c-0.5,0-1,0-1.5,0c-0.1,0-0.2,0-0.3,0c-0.8,0.2-1.7,0.4-2.5,0.7 c-0.4,0.1-0.9,0.3-1.3,0.5c-0.9,0.4-1.8,0.9-2.7,1.3c-0.2,0.1-0.3,0.3-0.3,0.5c0,7.7,0,15.3,0,23c0,0.7-0.2,0.9-0.8,1.1 c-0.3,0.1-0.6,0.2-0.9,0.2c-0.9,0-1.8,0-2.7,0c-0.1,0-0.3,0-0.4,0c-0.8-0.1-1-0.4-1.1-1.2c0-1,0-2,0-3c0-5.5,0-11.1,0-16.6 c0-0.7-0.1-1.4-0.2-2.1c0-0.1-0.1-0.3-0.1-0.4c-0.1-1.3-0.7-2.3-1.6-3.1c-0.6-0.5-1.2-0.8-2-0.8c-1.2-0.1-2.3,0.1-3.5,0 c-0.1,0-0.1,0-0.2,0c-0.8,0.2-1.6,0.4-2.4,0.7c-0.4,0.1-0.8,0.3-1.2,0.4c-0.8,0.2-1.5,0.7-2.2,1.1c-0.5,0.2-0.7,0.6-0.7,1.2 c0,6.8,0,13.6,0,20.4c0,0.6,0,1.2,0,1.8c0,1-0.5,1.6-1.5,1.6c-1,0-2,0-3,0c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.3-0.6-0.3-1 c0-3.9,0-7.8,0-11.6c0-5.5,0-11.1,0-16.6c0-0.7,0.2-1.2,0.8-1.4c0.2-0.1,0.4-0.1,0.6-0.1c0.8,0,1.6,0,2.4,0c0.8,0,1.5,0.7,1.5,1.5 C31.6,119.5,31.8,120,32.1,120.6z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M56.7,55.3c0.1-0.2,0.3-0.4,0.4-0.7c0.3-0.8,0.9-1.5,1.5-2c0.4-0.3,0.8-0.7,1.3-0.9c0.7-0.3,1.3-0.6,2.1-0.6 c0.7,0.1,1.4,0,2.1,0c0.3,0,0.5,0.1,0.8,0.2c1,0.3,1.8,1,2.5,1.8c0.6,0.6,1.1,1.3,1.3,2.1c0.4,0,0.5-0.2,0.6-0.5 c0.8-1.6,2-2.6,3.6-3.3c0.8-0.4,1.7-0.3,2.5-0.3c0.2,0,0.4,0,0.5,0c0.5,0,1,0.1,1.6,0.3c0.7,0.2,1.2,0.5,1.8,0.9 c0.7,0.4,1.3,1.1,1.6,1.8c0.6,1.2,0.9,2.5,0.9,3.9c0,5.9,0,11.8,0,17.6c0,0.7-0.4,1.2-1.2,1.2c-1.4,0-2.7,0-4.1,0c-0.7,0-1-0.4-1-1 c0-3.8,0-7.6,0-11.4c0-1.4,0-2.8,0-4.2c0-0.8-0.2-1.5-0.6-2.2c-0.3-0.6-0.9-1.1-1.7-1.1c-0.2,0-0.5,0-0.7,0 c-0.7-0.1-1.3,0.2-1.8,0.6c-0.3,0.2-0.5,0.5-0.7,0.8c-0.4,0.7-0.7,1.5-0.7,2.4c0,5,0,10,0,15c0,0.6-0.5,1.1-1.1,1.1 c-1.4,0-2.8,0-4.2,0c-0.7,0-1-0.4-1-1.1c0-4.9,0-9.7,0-14.6c0-1-0.2-1.9-0.5-2.7c-0.2-0.7-0.8-1.2-1.4-1.4 c-0.4-0.2-0.9-0.1-1.3-0.1c-0.6,0-1.3,0.1-1.8,0.6c-0.5,0.5-0.7,1-0.9,1.6c-0.3,0.8-0.3,1.7-0.3,2.5c0,4.7,0,9.3,0,14 c0,0.9-0.4,1.3-1.3,1.3c-1.3,0-2.6,0-3.9,0c-0.7,0-1.1-0.3-1.1-1.1c0-4,0-7.9,0-11.9c0-3.8,0-7.6,0-11.4c0-0.7,0.3-0.9,0.9-0.9 c1.3,0,2.6,0,3.9,0c0.7,0,0.9,0.2,0.9,0.9c0,0.8,0,1.5,0,2.3C56.5,54.9,56.4,55.1,56.7,55.3z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M107.1,132.9c0,3.6,0,7.2,0,10.8c0,1.2,0,2.3,0,3.5c0,0.4-0.1,0.8-0.5,1.1c-0.2,0.1-0.5,0.3-0.8,0.3 c-0.9,0-1.7,0-2.6,0c-0.6,0-1.1-0.4-1.3-1c-0.2-0.6-0.4-1.2-0.4-1.9c0-0.4-0.3-0.5-0.6-0.3c-0.9,0.6-1.8,1.2-2.8,1.7 c-0.8,0.4-1.6,0.7-2.4,1.1c-0.6,0.3-1.3,0.5-1.9,0.7c-0.1,0-0.3,0.1-0.4,0.1c-0.5,0.1-1,0.2-1.6,0.3c-0.1,0-0.2,0.1-0.2,0.1 c-1.5,0-2.9,0-4.4,0c-0.3,0-0.6-0.3-0.9-0.3c-1.4-0.1-2.5-1-3.6-1.7c-0.1-0.1-0.2-0.2-0.3-0.3c-0.6-0.8-1.2-1.7-1.6-2.7 c-0.5-1.5-0.8-3-0.8-4.5c0-7,0-14,0-21c0-1.1,0.5-1.3,1.3-1.3c1.2,0,2.5,0,3.7,0c0.9,0,1.2,0.4,1.2,1.3c0,1.6,0,3.1,0,4.7 c0,5.4,0,10.8,0,16.2c0,0.4,0.1,0.8,0.2,1.2c0.2,0.5,0.2,1.1,0.6,1.6c0.5,0.7,1,1.3,1.8,1.7c0.9,0.4,1.9,0.4,2.8,0.6 c0.2,0,0.4,0,0.6-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.2,0,0.5,0,0.6-0.1c0.4-0.2,0.9-0.3,1.4-0.3c0.4,0,0.8-0.2,1.2-0.4 c0.9-0.4,1.8-0.9,2.7-1.4c1.3-0.7,1.1-0.8,1.1-1.9c0-6.6,0-13.2,0-19.8c0-0.8,0-1.6,0-2.4c0-0.6,0.1-0.6,0.7-0.7 c0.4-0.1,0.8-0.1,1.2-0.1c0.9,0,1.8,0,2.7,0c1.4,0.1,1.4,0.1,1.4,1.4c0.1,1.3,0,2.6,0,3.9c0,2.4,0,4.9,0,7.3 C107.1,130.9,107.1,131.9,107.1,132.9C107.1,132.9,107.1,132.9,107.1,132.9z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M45.2,63.5c0,1.3,0,2.7,0,4c0,0.8,0.1,1.5,0.1,2.3c0,0.2,0.1,0.4,0.2,0.6c0.3,0.7,0.6,1.3,1.2,1.9 c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8c-1,0.9-2,1.8-3.1,2.7c-0.5,0.5-1.2,0.4-1.8,0c-0.7-0.6-1.4-1.4-1.9-2.2 c-0.3-0.5-0.4-0.5-0.9-0.1c-0.8,0.7-1.5,1.6-2.6,2c-0.7,0.3-1.4,0.8-2.2,0.7c-0.2,0-0.4,0-0.6,0.1c-1,0.3-2,0.3-3.1,0 c-0.1,0-0.2-0.1-0.3-0.1c-1.5-0.1-2.7-0.9-3.7-2.1c-0.5-0.6-0.8-1.3-1.1-1.9c-0.1-1.3-0.7-2.5-0.4-3.8c0.1-0.6,0.2-1.2,0.4-1.8 c0.3-0.7,0.6-1.4,1-2c0.7-0.9,1.5-1.8,2.6-2.3c0.5-0.2,1-0.4,1.5-0.6c0.2-0.1,0.4-0.2,0.5-0.2c0.1,0,0.2-0.1,0.3-0.1 c0.6,0,1-0.2,1.6-0.4c0.1,0,0.2-0.1,0.3-0.1c1.5-0.1,3-0.5,4.6-0.5c0.7,0,0.7-0.1,0.7-0.8c0-0.5,0-1,0-1.4c0.1-0.8-0.1-1.4-0.6-2 c-0.5-0.6-1.1-1.1-1.9-1.1c-0.6,0-1.3-0.1-1.9,0.1c-1,0.2-1.8,0.7-2.3,1.7c-0.2,0.4-0.3,0.8-0.5,1.3c-0.1,0.3-0.4,0.5-0.8,0.5 c-1.4-0.1-2.9-0.1-4.2-0.5c-0.7-0.2-0.9-0.5-0.6-1.2c0.2-0.4,0.3-0.7,0.4-1.2c0-0.2,0.2-0.4,0.3-0.6c0.5-1.1,1.3-2,2.2-2.7 c0.5-0.4,1.1-0.7,1.7-1c0.6-0.3,1.2-0.5,1.8-0.7c0.1,0,0.2-0.1,0.3-0.1c0.9-0.1,1.8-0.3,2.8-0.4c0.9-0.1,1.8,0,2.7,0.2 c0.1,0,0.3,0.1,0.4,0.1c1.2,0,2.2,0.5,3.2,1c1.3,0.7,2.3,1.7,2.8,3.1c0.5,1.3,0.6,2.7,0.6,4.1C45.2,60.7,45.2,62.1,45.2,63.5z M38.7,66.5c0-0.6,0-1.2,0-1.7c0-0.3-0.1-0.5-0.4-0.5c-0.6,0-1.2,0.1-1.8,0.2c-0.5,0.1-0.9,0.2-1.4,0.3c-0.5,0.2-1.1,0.4-1.5,0.7 c-0.8,0.6-1.4,1.3-1.7,2.3c-0.5,1.4-0.1,2.6,0.6,3.8c0.5,0.7,1.9,1.3,2.6,1c0.3-0.1,0.5-0.2,0.8-0.3c0.5-0.3,1.1-0.5,1.4-1 c0.8-1.2,1.5-2.4,1.4-4C38.7,67.1,38.7,66.8,38.7,66.5z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M105.9,63.1c0,1.6,0,3.1,0,4.7c0,1.6,0.4,3,1.5,4.3c0.1,0.2,0.2,0.3,0.3,0.5c0.2,0.5,0.2,0.9-0.2,1.3 c-1,0.9-1.9,1.7-2.9,2.6c-0.3,0.3-0.7,0.6-1.2,0.5c-0.2,0-0.4-0.1-0.5-0.2c-0.6-0.6-1.2-1.2-1.8-1.9c-0.2-0.2-0.3-0.4-0.4-0.6 c-0.2-0.4-0.4-0.4-0.8-0.1c-0.2,0.2-0.4,0.4-0.5,0.6c-0.8,0.8-1.8,1.3-2.8,1.8c-0.5,0.2-1.1,0.3-1.6,0.4c-1.4,0.3-2.6,0.2-4,0 c-1-0.2-1.8-0.6-2.6-1.1c-0.8-0.5-1.3-1.3-1.7-2.2c-0.7-1.5-0.8-3-0.7-4.6c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.2-0.4,0.2-0.6 c0.2-1,0.6-1.9,1.3-2.6c0.7-0.8,1.4-1.5,2.3-2c0.5-0.3,1-0.6,1.6-0.7c0.2,0,0.3-0.1,0.5-0.2c0.1,0,0.2-0.1,0.3-0.1 c0.9,0,1.8-0.6,2.7-0.5c1.2-0.3,2.5-0.4,3.8-0.4c0.7,0,0.8-0.2,0.8-0.9c0-0.4,0-0.8,0-1.3c0.1-0.7-0.1-1.3-0.5-1.9 c-0.5-0.8-1.2-1.3-2.1-1.3c-0.6,0-1.2,0-1.7,0.1c-0.5,0.1-0.9,0.3-1.3,0.6c-0.7,0.5-1.2,1.2-1.5,2.1c-0.1,0.6-0.4,0.8-1,0.7 c-1.4-0.1-2.9-0.2-4.2-0.5c-0.5-0.1-0.5-0.1-0.5-0.7c0-0.3,0-0.6,0.2-0.9c0.1-0.1,0.1-0.2,0.1-0.3c0.5-2,1.9-3.3,3.5-4.4 c0.6-0.4,1.3-0.7,2-0.9c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.1,0.6-0.2c0.5-0.1,1.1-0.2,1.6-0.3c1.3-0.2,2.5-0.2,3.7,0.1 c0.1,0,0.3,0.1,0.4,0.1c1.2-0.1,2.2,0.5,3.2,1c1.3,0.7,2.3,1.8,2.9,3.3c0.4,1.2,0.4,2.3,0.4,3.5C106,60.3,105.9,61.7,105.9,63.1z M99.6,66.4c0-0.5,0-1.1,0-1.6c0-0.4-0.1-0.5-0.5-0.5c-0.6,0-1.2,0-1.8,0.2c-0.7,0.2-1.5,0.2-2.2,0.6c-0.5,0.3-1,0.5-1.4,0.9 c-0.9,0.9-1.3,2-1.2,3.2c0.1,1.4,0.5,2.6,2,3.2c0.5,0.2,0.9,0.2,1.3,0.1c1.3-0.3,2.3-1.1,2.9-2.4c0.2-0.5,0.3-1,0.5-1.4 c0.2-0.4,0.2-0.8,0.2-1.3C99.6,67.2,99.6,66.8,99.6,66.4z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M161.7,55.7c0.4-0.2,0.6-0.4,0.7-0.7c0.4-1.1,1-2,1.9-2.7c0.4-0.4,1-0.6,1.5-0.9c0.7-0.4,1.5-0.3,2.3-0.4 c0.5,0,1,0,1.5,0c0.1,0,0.2,0,0.2,0c1.2,0.4,2.3,0.9,3.2,1.8c0.7,0.8,1.1,1.8,1.5,2.7c0,0.1,0,0.2,0,0.2c0.1,1,0.2,2,0.4,3 c0,0.3,0.1,0.6,0.1,0.8c0,4,0,8,0,12c0,1.3,0,2.5,0,3.8c0,0.5-0.3,0.9-0.6,1.2c-0.1,0.1-0.3,0.1-0.4,0.1c-1.5,0-2.9,0-4.4,0 c-0.6,0-0.9-0.3-0.9-1c0-2.1,0-4.3,0-6.4c0-2.7,0-5.5,0-8.2c0-0.9-0.2-1.8-0.5-2.6c-0.2-0.7-0.8-1.1-1.3-1.6c0,0-0.1-0.1-0.1-0.1 c-0.8-0.1-1.6-0.3-2.4,0.1c-0.7,0.4-1.3,1-1.6,1.8c-0.6,1.4-0.8,2.9-0.8,4.4c0,4.1,0,8.3,0,12.4c0,0.1,0,0.2,0,0.4 c0,0.5-0.4,0.9-0.9,0.9c-1.5,0-2.9,0-4.4,0c-0.5,0-1-0.5-1-1.1c0-0.5,0-1.1,0-1.6c0-5.4,0-10.8,0-16.2c0-1.8,0-3.5,0-5.3 c0-0.7,0.4-1.1,1.1-1.1c1.3,0,2.5,0,3.8,0c0.7,0,1,0.2,1,0.9c0,0.9,0,1.8-0.1,2.7C161.7,55.2,161.7,55.4,161.7,55.7z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M152.3,64.1c0,1.1-0.1,2.1-0.1,3.1c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.2,0.4-0.2,0.6c0.1,0.8-0.3,1.4-0.6,2 c-0.3,0.9-0.8,1.7-1.3,2.5c-0.9,1.3-1.9,2.5-3.4,3.2c-0.4,0.2-0.9,0.5-1.3,0.7c0,0-0.1,0-0.1,0c-1,0-1.8,0.6-2.8,0.5 c-0.5-0.1-1,0-1.4,0c-0.5,0-1,0-1.4-0.3c-0.1,0-0.1-0.1-0.2-0.1c-1,0-1.7-0.6-2.5-1c-0.2-0.1-0.5-0.3-0.7-0.5 c-0.6-0.6-1.3-1.2-1.8-1.9c-0.4-0.5-0.8-1.1-1.1-1.8c-0.4-0.9-0.8-1.9-1.1-2.9c0,0,0,0,0-0.1c-0.2-1-0.4-1.9-0.5-2.9 c-0.1-1.3,0-2.6,0-3.9c0-0.3,0.1-0.7,0.2-1c0.1-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.1-0.7,0.2-1c0.2-0.6,0.4-1.2,0.6-1.7 c0.1-0.4,0.3-0.7,0.5-1c1-1.7,2.3-3.2,4-4.2c0.5-0.3,1-0.4,1.5-0.6c0.1,0,0.1,0,0.2,0c0.9-0.5,1.9-0.3,2.9-0.4c0.6,0,1.2,0,1.7,0 c0.1,0,0.2,0,0.3,0c0.7,0.2,1.3,0.5,2,0.7c0.7,0.2,1.3,0.7,2,1.1c0.7,0.4,1.3,1,1.7,1.7c0.4,0.6,0.7,1.1,1.1,1.7 c0.4,0.6,0.6,1.4,0.9,2.1c0.3,0.6,0.3,1.3,0.5,1.9c0.3,0.7,0.3,1.4,0.3,2.2C152.2,63,152.2,63.6,152.3,64.1z M145.6,64.3 C145.6,64.3,145.6,64.3,145.6,64.3c0-1.1,0-2.2,0-3.3c0-0.4-0.1-0.8-0.2-1.2c-0.1-0.3-0.2-0.6-0.2-0.9c-0.1-0.7-0.4-1.4-0.8-2 c-0.2-0.4-0.6-0.7-1.1-0.8c-0.1,0-0.2-0.1-0.3-0.2c-0.6-0.3-1.3-0.4-2-0.1c-1.5,0.6-2.2,1.8-2.5,3.3c-0.1,0.4-0.1,0.7-0.2,1.1 c-0.1,0.5-0.2,0.9-0.2,1.4c0,1.4,0,2.8,0,4.2c0,0.6,0.2,1.3,0.3,1.9c0.1,0.7,0.2,1.5,0.5,2.2c0.2,0.7,0.5,1.3,1,1.8 c0.9,1,2.6,1,3.6,0.3c0.9-0.7,1.4-1.7,1.7-2.8c0-0.2,0-0.3,0.1-0.5c0.3-0.5,0.3-1,0.3-1.6C145.6,66.2,145.6,65.2,145.6,64.3z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M122.5,149.3c-0.5,0-0.9,0-1.4,0c-0.7,0-1.4,0-2.1-0.3c-0.1,0-0.2-0.1-0.2-0.1c-1,0-1.9-0.3-2.8-0.5 c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.5-0.1-0.7-0.2c-0.7-0.3-1.6-0.5-2.1-1.2c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.7,0-1.5,0-2.2 c0-0.8,0.6-1.1,1.2-0.8c0.4,0.1,0.7,0.2,1.1,0.3c0.7,0.2,1.5,0.4,2.2,0.6c0.2,0,0.3,0.1,0.5,0.1c0.7,0.1,1.5,0.3,2.2,0.4 c0.3,0,0.6,0.1,0.9,0.1c1.2,0,2.4,0,3.6,0c0.3,0,0.7-0.1,1-0.2c0.6-0.2,1.2-0.3,1.7-0.6c0.8-0.5,1.4-1.1,1.7-2 c0.2-0.5,0.3-0.9,0.4-1.5c0.1-1.6-0.7-2.6-2-3.4c-1-0.6-2.1-1.1-3.2-1.4c-0.5-0.2-1-0.4-1.4-0.6c-0.5-0.2-1.1-0.4-1.6-0.6 c-1.4-0.5-2.7-1-3.9-1.8c-1.2-0.8-2.2-1.7-2.9-2.9c-0.3-0.5-0.7-1-0.6-1.6c0-0.1,0-0.2-0.1-0.2c-0.4-0.6-0.4-1.2-0.3-1.9 c0-0.5,0-1,0-1.5c0-0.4,0-0.9,0.3-1.2c0-0.1,0.1-0.1,0.1-0.2c0.1-0.9,0.6-1.6,1.1-2.3c0.7-1,1.6-1.7,2.6-2.4 c0.9-0.5,1.8-0.9,2.8-1.2c0.8-0.3,1.7-0.4,2.6-0.5c1.1-0.1,2.3,0,3.4,0c0.3,0,0.5,0.1,0.8,0.2c0.5,0.1,1,0.2,1.5,0.2 c0.1,0,0.2,0,0.2,0c0.7,0.2,1.5,0.4,2.2,0.6c0.5,0.2,1,0.4,1.6,0.6c0.5,0.2,0.8,0.6,0.8,1.2c0,0.7,0,1.5,0,2.2 c0,0.5-0.2,0.7-0.7,0.8c-0.4,0-0.9,0-1.3-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.2-1.1-0.3c-0.2,0-0.3-0.1-0.5-0.1 c-0.7,0-1.4-0.1-2.1-0.3c-1.2-0.3-2.5-0.2-3.7-0.1c-0.3,0-0.6,0.2-1,0.3c-0.2,0.1-0.5,0.1-0.7,0.2c-0.3,0.1-0.6,0.2-0.9,0.4 c-1,0.4-1.4,1.3-1.9,2.1c-0.1,0.1-0.1,0.3-0.1,0.5c0,0.4,0,0.8,0,1.1c0,0.7,0.3,1.3,0.7,1.8c0.9,1,1.9,1.5,3.1,2 c0.9,0.3,1.8,0.7,2.7,1.1c0.4,0.1,0.7,0.3,1.1,0.4c0.6,0.2,1.1,0.4,1.7,0.6c0.3,0.1,0.6,0.3,1,0.4c1.2,0.6,2.5,1.2,3.5,2.1 c0.8,0.7,1.6,1.6,1.9,2.6c0.3,0.9,0.7,1.7,0.5,2.7c-0.1,0.4,0,0.9,0,1.4c0,0.5-0.1,1-0.3,1.5c-0.2,0.5-0.2,1-0.5,1.5 c-0.4,0.7-0.8,1.4-1.3,2c-0.8,0.9-1.8,1.6-2.8,2.2c-0.5,0.3-1,0.4-1.5,0.6c-0.6,0.2-1.2,0.5-1.8,0.4c0,0-0.1,0-0.1,0 c-1,0.5-2.1,0.3-3.2,0.4C122.8,149.3,122.6,149.3,122.5,149.3C122.5,149.3,122.5,149.3,122.5,149.3z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M90.8,95.4c-1.3,0.1-2.7,0.2-4,0.3c-1.4,0.1-2.9,0-4.3-0.1c-0.8-0.1-1.6-0.1-2.4-0.1c-0.5,0-1.1-0.1-1.6-0.2 c-0.6-0.1-1.3-0.2-1.9-0.2c-0.1,0-0.2,0-0.2,0c-1-0.2-2.1-0.5-3.1-0.7c-0.1,0-0.2-0.1-0.3-0.1c-0.7,0-1.4-0.2-2.1-0.4 c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2,0-0.3,0-0.5-0.1c-0.3-0.1-0.5-0.1-0.8-0.2c-0.1,0-0.3-0.1-0.4-0.1c-1.2-0.3-2.3-0.7-3.5-1.2 c-0.8-0.4-1.7-0.6-2.5-1c-0.3-0.1-0.7-0.3-1-0.5c-1.3-0.6-2.6-1.3-3.8-2c-1.2-0.6-2.3-1.4-3.4-2.1c-1.1-0.7-2.2-1.5-3.3-2.2 c-0.2-0.1-0.3-0.2-0.5-0.3c-1.2-1-2.4-2.1-3.6-3.1c-0.4-0.3-0.5-0.6-0.3-0.8c0.2-0.3,0.6-0.3,0.9-0.2c0.4,0.2,0.8,0.3,1.2,0.6 c1.1,0.6,2.3,1.2,3.4,1.8c0.7,0.3,1.4,0.6,2.1,0.9c0.8,0.4,1.6,0.8,2.5,1.1c0.4,0.2,0.8,0.3,1.2,0.4c0.6,0.2,1.1,0.4,1.7,0.6 c0.5,0.2,1,0.4,1.5,0.7c0.1,0,0.1,0.1,0.2,0.1c0.6,0.2,1.1,0.3,1.7,0.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0.1,0.5,0.1,0.7,0.2 c0.1,0,0.2,0,0.2,0c0.6,0.2,1.2,0.4,1.8,0.7c0.1,0,0.1,0.1,0.2,0.1c0.8,0,1.5,0.4,2.3,0.5c0.1,0,0.1,0,0.2,0 c0.8,0.3,1.7,0.4,2.6,0.6c0.4,0.1,0.9,0.2,1.3,0.2c0,0,0.1,0,0.1,0c1.2,0.3,2.3,0.4,3.5,0.6c0.6,0.1,1.3,0.2,1.9,0.2 c0.7,0,1.5,0.1,2.2,0.2c0.5,0.1,1,0.2,1.5,0.2c3.1,0,6.3,0,9.4,0c0.7,0,1.5-0.1,2.2-0.2c0.3,0,0.5-0.1,0.8-0.1c1.5,0,3-0.4,4.5-0.5 c1-0.1,1.9-0.3,2.9-0.5c0.5-0.1,1-0.3,1.6-0.3c0.2,0,0.3-0.1,0.5-0.1c0.4-0.1,0.7-0.2,1.1-0.3c0.3-0.1,0.6-0.2,0.9-0.2 c0.1,0,0.1-0.1,0.2-0.1c0.6,0,1.2-0.3,1.8-0.5c0.4-0.1,0.8-0.2,1.1-0.3c0,0,0.1,0,0.1,0c0.6,0.1,1.2-0.4,1.8-0.5 c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0,0.3-0.1,0.5-0.1 c0.9-0.4,1.7-0.7,2.6-1.1c0.4-0.2,0.8-0.3,1.2-0.4c0.6-0.2,1.5,0.2,1.6,0.8c0,0.1,0,0.3-0.1,0.4c-0.2,0.3-0.4,0.6-0.7,0.8 c-1.2,0.8-2.3,1.6-3.5,2.3c-1.2,0.7-2.4,1.3-3.6,1.8c-1.1,0.5-2.3,1-3.4,1.5c-0.5,0.2-1.1,0.4-1.6,0.5c-0.6,0.2-1.2,0.5-1.8,0.6 c-0.7,0.2-1.3,0.6-2.1,0.6c0,0,0,0-0.1,0c-0.7,0.2-1.5,0.4-2.2,0.7c-0.1,0-0.1,0.1-0.2,0.1c-1,0-1.8,0.5-2.8,0.5 c-0.3,0-0.6,0.1-0.9,0.2c-0.4,0.1-0.8,0.2-1.2,0.2c-0.6,0.1-1.3,0.1-1.9,0.2C91.9,95.3,91.4,95.4,90.8,95.4 C90.8,95.5,90.8,95.5,90.8,95.4z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M153,133.1c0-1.1,0-2.1,0-3.2c0-0.1,0-0.2,0-0.2c0.3-1,0.3-2,0.7-3c0-0.1,0.1-0.1,0.1-0.2c0.3-1.6,1-3,1.9-4.3 c0.5-0.7,1.1-1.4,1.8-2c0.7-0.6,1.4-1.3,2.2-1.7c0.8-0.4,1.5-0.9,2.4-1c0.2,0,0.3-0.1,0.4-0.2c0.2-0.1,0.4-0.1,0.6-0.2 c0.7-0.1,1.3-0.2,2-0.4c0.2,0,0.5-0.1,0.7-0.1c0.6,0,1.2,0,1.8,0c0.8,0,1.6,0,2.4,0.3c0.3,0.1,0.6,0.1,0.8,0.1 c0.3,0.1,0.6,0.2,1,0.3c0.1,0,0.2,0.1,0.3,0.1c0.6,0,1,0.3,1.5,0.5c0.7,0.2,0.9,0.5,0.9,1.2c0,0.9,0,1.7,0,2.6 c0,0.6-0.1,0.7-0.7,0.7c-0.3,0-0.7-0.1-1-0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.5-0.1-1-0.3-1.4-0.4c-0.2,0-0.4-0.1-0.6-0.1 c-1.3,0-2.7,0-4,0c-0.1,0-0.1,0-0.2,0c-0.8,0.2-1.5,0.4-2.3,0.7c-0.3,0.1-0.6,0.3-1,0.5c-1.4,0.7-2.2,1.8-2.8,3.1 c-0.3,0.6-0.5,1.2-0.7,1.8c0,0.1,0,0.1,0,0.2c-0.1,1.5-0.6,3-0.4,4.5c0.1,1,0,2.1,0,3.1c0,0.4,0.1,0.8,0.2,1.2 c0.1,0.3,0.1,0.6,0.1,0.9c0,0.2,0,0.4,0.1,0.5c0.5,1.3,0.9,2.5,1.7,3.6c0.4,0.6,1,1.1,1.6,1.4c0.3,0.1,0.5,0.3,0.8,0.4 c0.4,0.2,0.8,0.4,1.3,0.4c0.1,0,0.2,0,0.2,0.1c0.5,0.4,1.2,0.3,1.8,0.3c1.1,0,2.1,0,3.2,0c0.5,0,0.9-0.1,1.4-0.2 c0.2,0,0.3-0.1,0.5-0.1c0.5,0,0.9-0.1,1.3-0.3c0.3-0.1,0.7-0.1,1.1-0.1c0.4,0,0.7,0.4,0.7,0.8c0.1,0.8,0.1,1.6,0,2.4 c-0.1,0.7-0.6,1.2-1.3,1.4c-0.5,0.1-0.9,0.3-1.4,0.5c-0.5,0.2-1,0.2-1.5,0.3c-1.3,0.4-2.7,0.3-4,0.3c-0.4,0-0.8,0-1.3,0 c-0.4,0-0.9-0.1-1.3-0.2c-0.5-0.1-1-0.1-1.5-0.3c-0.5-0.1-1-0.3-1.5-0.5c-0.7-0.3-1.5-0.7-2.1-1.1c-1.7-1.1-3-2.5-4-4.3 c-0.4-0.8-0.8-1.7-1.1-2.5c-0.3-0.7-0.3-1.5-0.5-2.2c-0.1-0.3-0.1-0.5-0.2-0.8c-0.2-0.5-0.2-1-0.2-1.6C153,135,153,134,153,133.1 C153,133.1,153,133.1,153,133.1z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M119.8,68.5c0.2,0,0.4,0.1,0.6,0.1c0.8,0,1.5,0.1,2.3,0.3c0.4,0.1,0.8,0.1,1.2,0.1c0.1,0,0.1,0,0.2,0 c0.8,0.2,1.5,0.4,2.3,0.6c0.5,0.2,1,0.4,1.5,0.6c0.4,0.2,0.7,0.5,1,0.8c0.1,0.1,0.1,0.3,0.1,0.5c0,1.3,0,2.6,0,3.9 c0,0.5-0.1,0.6-0.6,0.6c-0.4,0-0.7-0.1-1-0.2c-0.5-0.3-1-0.6-1.7-0.7c-0.1,0-0.2-0.1-0.4-0.2c-0.3-0.1-0.6-0.2-0.9-0.3 c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.7-0.1-1-0.2c-0.5,0-1-0.1-1.4-0.1c-0.7,0-1.3,0-2,0c-0.6,0-1.3,0.1-1.9,0.1 c-0.2,0-0.3,0-0.5,0c-0.8,0.2-1.5,0.5-2.3,0.7c-0.8,0.2-1.5,0.6-2.2,0.9c-0.8,0.4-1.5-0.1-1.5-1c0-1,0-2,0-3c0-1.2,0.5-2.2,1.2-3.1 c0.8-1.1,1.6-2.3,2.4-3.5c0.6-0.8,1.2-1.7,1.8-2.5c0.4-0.6,0.8-1.1,1.2-1.7c0.8-1.2,1.6-2.4,2.5-3.6c0.1-0.2,0.3-0.3,0.4-0.5 c0.1-0.2,0.2-0.3,0.3-0.6c-0.3,0-0.5-0.1-0.7-0.1c-2.3,0-4.6,0-6.9,0c-0.8,0-1.2-0.4-1.2-1.2c0-0.9,0-1.8,0-2.7 c0-0.2,0.1-0.4,0.1-0.6c0.1-0.4,0.4-0.5,0.8-0.5c2.7,0,5.5,0,8.2,0c2.1,0,4.3,0,6.4,0c0.1,0,0.2,0,0.3,0c0.8,0,1,0.2,1,1 c0,0.9,0,1.7,0,2.6c0,0.5-0.3,0.9-0.6,1.3c-0.6,0.9-1.3,1.8-2,2.8c-0.5,0.7-0.9,1.4-1.4,2.1c-0.7,1-1.4,2-2.1,3 c-0.6,0.9-1.3,1.8-1.9,2.7c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.2-0.2,0.3-0.3,0.5C119.7,68.4,119.7,68.4,119.8,68.5z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M140.9,133c0-4.8,0-9.5,0-14.3c0-0.3,0-0.5,0-0.8c0-0.3,0.2-0.5,0.5-0.5c0.1,0,0.2-0.1,0.3-0.1 c1.5,0,2.9,0,4.4,0c0.5,0,0.8,0.4,0.9,1c0,0.2,0,0.3,0,0.5c0,4.6,0,9.2,0,13.8c0,4.8,0,9.5,0,14.3c0,0.2,0,0.3,0,0.5 c0,0.9-0.5,1.4-1.4,1.4c-1.2,0.1-2.4,0-3.6,0c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.2-0.7-0.3-0.7-0.9c0-1.2,0-2.5,0-3.7 C140.9,140.3,140.9,136.6,140.9,133C140.9,133,140.9,133,140.9,133z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M116.9,80.9c-1-0.1-2.4,0.1-3.8,0.3c-0.6,0.1-1.3,0.1-2,0.1c-0.1,0-0.3-0.1-0.4-0.2c0-0.1,0-0.3,0.1-0.4 c0.4-0.3,0.9-0.7,1.4-0.9c0.7-0.4,1.6-0.7,2.3-1c0.6-0.2,1.2-0.4,1.8-0.4c0.1,0,0.2,0,0.3-0.1c0.6-0.3,1.3-0.3,2-0.3c1,0,2,0,3,0 c0.3,0,0.7,0.1,1,0.1c0.5,0.1,0.9,0.3,1.4,0.3c0.7,0,1.3,0.7,1.4,1.6c0,0.4,0,0.9-0.1,1.3c-0.1,0.6-0.2,1.2-0.3,1.8 c0,0.2-0.1,0.5-0.2,0.7c-0.2,0.3-0.2,0.7-0.3,1.1c-0.1,0.6-0.3,1.1-0.6,1.6c-0.3,0.7-0.7,1.4-1.1,2.1c-0.8,1.5-1.8,2.7-3.1,3.7 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4-0.1-0.4-0.3c0-0.3,0-0.6,0.1-0.8c0.2-0.4,0.3-0.7,0.4-1.2c0.1-0.3,0.2-0.6,0.4-0.9 c0.2-0.5,0.4-1.1,0.6-1.6c0.1-0.3,0.1-0.6,0.2-0.8c0.4-0.7,0.4-1.6,0.7-2.4c0.2-0.7,0.2-1.4,0.1-2.1c-0.1-0.5-0.5-0.8-1-1 C119.8,80.8,118.6,80.9,116.9,80.9z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFFFFF",
                        d: "M139.7,107.6c0-0.4,0-0.8,0-1.2c0,0,0,0,0-0.1c0.1-0.7,1.4-2.1,2.2-2.3c0.9-0.1,1.9-0.2,2.8,0 c0.6,0.2,1.3,0.5,1.6,1.1c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.8,0.6,1.7,0.4,2.6c-0.1,0.5-0.2,0.9-0.5,1.3c-0.8,1.4-2.1,1.7-3.5,1.7 c-0.2,0-0.4-0.1-0.6-0.1c-0.5,0-0.9-0.2-1.3-0.5c-0.6-0.4-0.9-1-1.3-1.5c0-0.1-0.1-0.2-0.1-0.3C139.7,108.5,139.7,108,139.7,107.6 C139.7,107.6,139.7,107.6,139.7,107.6z"
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/SocialMediasInput.js






function SocialMediasInput(param) {
    var initialValues = param.initialValues, onInsert = param.onInsert;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
            onSubmit: function(event) {
                event.preventDefault();
                event.stopPropagation();
                var socialMedias = Object.keys(SocialMediasInput_SocialMedias).map(function(socialMedia) {
                    return {
                        socialMedia: socialMedia,
                        url: (event.target.elements["url[".concat(socialMedia, "]")].value || "").trim()
                    };
                }).filter(function(param) {
                    var url = param.url;
                    return url !== "";
                });
                onInsert({
                    socialMedias: socialMedias
                });
            },
            css: {
                width: 300,
                padding: 8,
                display: "grid",
                gridRowGap: 8
            },
            children: [
                Object.entries(SocialMediasInput_SocialMedias).map(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], name = _param[1].name;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "grid",
                            alignItems: "center",
                            gridTemplateColumns: "1fr 1fr"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                type: "url",
                                name: "url[".concat(key, "]"),
                                placeholder: "What's the URL?",
                                defaultValue: initialValues !== null ? initialValues[key] : "",
                                css: {
                                    margin: 0,
                                    padding: 8,
                                    border: "solid 1px ".concat(palette/* sealBlue */.N9),
                                    borderRadius: 2
                                }
                            })
                        ]
                    }, key);
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "submit",
                    css: {
                        margin: 0,
                        padding: 8,
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer"
                    },
                    children: "Submit"
                })
            ]
        })
    });
};
SocialMediasInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    initialValues: prop_types_default().shape({
        twitter: (prop_types_default()).string,
        facebook: (prop_types_default()).string,
        instagram: (prop_types_default()).string,
        youtube: (prop_types_default()).string,
        applePodcast: (prop_types_default()).string,
        spotify: (prop_types_default()).string,
        googlePlay: (prop_types_default()).string,
        soundCloud: (prop_types_default()).string,
        deezer: (prop_types_default()).string,
        iHeartRadio: (prop_types_default()).string,
        overcast: (prop_types_default()).string,
        stitcher: (prop_types_default()).string,
        simplecast: (prop_types_default()).string
    })
};
SocialMediasInput.defaultProps = {
    initialValues: null
};
var SocialMediasInput_SocialMedias = {
    twitter: {
        name: "Twitter",
        icon: TwitterIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    facebook: {
        name: "Facebook",
        icon: FacebookIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    instagram: {
        name: "Instagram",
        icon: InstagramIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    youtube: {
        name: "YouTube",
        icon: YouTubeIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    applePodcast: {
        name: "Apple Podcast",
        icon: ApplePodcastIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    spotify: {
        name: "Spotify",
        icon: SpotifyIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    googlePlay: {
        name: "Google Play",
        icon: GooglePlayIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    soundCloud: {
        name: "SoundCloud",
        icon: SoundCloudIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    deezer: {
        name: "Deezer",
        icon: DeezerIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    iHeartRadio: {
        name: "iHeartRadio",
        icon: IHeartRadioIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    overcast: {
        name: "Overcast",
        icon: OvercastIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    stitcher: {
        name: "Stitcher",
        icon: SticherIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    simplecast: {
        name: "Simplecast",
        icon: SocialMediasIcon_SimplecastIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    pandora: {
        name: "Pandora",
        icon: PandoraIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    },
    amazonmusic: {
        name: "Amazon Music",
        icon: AmazonMusicIcon,
        iconProps: {
            width: 32,
            height: 32
        }
    }
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/Button.js
/* eslint-disable react/display-name */ 




var Button = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var active = _param.active, reversed = _param.reversed, props = (0,_object_without_properties/* default */.Z)(_param, [
        "active",
        "reversed"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: ref,
        css: {
            cursor: "pointer",
            color: "".concat(reversed ? active ? "white" : "#aaa" : active ? "black" : "#ccc")
        }
    }));
});
/* harmony default export */ var components_Button = (Button);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/icons/EditSocialMediasIcon.js




function EditSocialMediasIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: {
            fill: "none",
            verticalAlign: "bottom"
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"
        })
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/EditSocialMediasButton.js












function EditSocialMediasButton(param) {
    var element = param.element;
    var editor = useSlate();
    var initialValues = element.socialMedias;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediasInput, {
                            initialValues: initialValues.reduce(function(values, currentValue) {
                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), (0,_define_property/* default */.Z)({}, currentValue.socialMedia, currentValue.url));
                            }, {}),
                            onInsert: function(param) {
                                var socialMedias = param.socialMedias;
                                var socialMediasNewProperties = {
                                    socialMedias: socialMedias
                                };
                                var elementPath = ReactEditor.findPath(editor, element);
                                index_es/* Transforms.setNodes */.YR.setNodes(editor, socialMediasNewProperties, {
                                    at: elementPath
                                });
                                toggle();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                toggle();
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditSocialMediasIcon, {
                            height: "24px",
                            width: "24px"
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/SocialMedias.js







function elements_SocialMedias_SocialMedias(param) {
    var attributes = param.attributes, element = param.element, children = param.children;
    var readOnly = useReadOnly();
    var socialMedias = element.socialMedias;
    if (!Array.isArray(socialMedias)) {
        return null;
    }
    if (socialMedias.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "none",
                    userSelect: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                contentEditable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridRowGap: 16,
                        gridColumnGap: 8,
                        gridTemplateColumns: "repeat(auto-fit, 32px)",
                        position: "relative"
                    },
                    children: [
                        socialMedias.map(function(param) {
                            var socialMedia = param.socialMedia, url = param.url;
                            if (SocialMediasInput_SocialMedias[socialMedia]) {
                                var Icon = SocialMediasInput_SocialMedias[socialMedia].icon;
                                if (Icon) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        href: url,
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        title: SocialMediasInput_SocialMedias[socialMedia].name,
                                        css: {
                                            display: "inline-flex",
                                            userSelect: "none",
                                            "& > svg": {
                                                display: "block"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, (0,src_object_spread/* default */.Z)({}, SocialMediasInput_SocialMedias[socialMedia].iconProps))
                                    }, socialMedia);
                                }
                            }
                            return null;
                        }).filter(Boolean),
                        !readOnly && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditSocialMediasButton, {
                            element: element
                        })
                    ]
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/UnorderedListItem.js
/* eslint-disable react/display-name */ 



var UnorderedListItem = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var attributes = param.attributes, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        css: {
            fontSize: 20,
            lineHeight: "34px",
            marginTop: 0
        },
        style: style
    }, attributes), {
        children: children
    }));
});
/* harmony default export */ var elements_UnorderedListItem = (UnorderedListItem);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/fieldValidation.js
function fieldValidation_validateColor(color) {
    return /^#[0-9a-f]{6}$/gi.test(color);
}
function fieldValidation_validateText(inputValue) {
    return inputValue && inputValue.length > 0;
}
function fieldValidation_validateUrl(url) {
    return /^(?:(http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}/gi.test(url) || /^\/.*/gi.test(url);
}
function validateEmail(email) {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/i.test(email);
}
function fieldValidation_validateButtonWidth(width) {
    if (typeof width === "undefined" || width === null || width.length === 0) {
        return true;
    }
    var parsedWidth = parseFloat(width);
    return !isNaN(parsedWidth) && parsedWidth > 0 && parsedWidth <= 100;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/elements/SubscribeEmbed.js









function SubscribeEmbed(param) {
    var attributes = param.attributes, element = param.element, children = param.children, onEmailSubscribe = param.onEmailSubscribe;
    var ref = (0,react.useRef)();
    var ref1 = (0,react.useState)(false), touched = ref1[0], setTouched = ref1[1];
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(""), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(false), showSuccess = ref4[0], setShowSucess = ref4[1];
    var title = element.title, description = element.description, titleFontSize = element.titleFontSize, descriptionFontSize = element.descriptionFontSize, textBoxWidth = element.textBoxWidth, buttonText = element.buttonText, buttonTextColor = element.buttonTextColor, buttonColor = element.buttonColor, buttonWidth = element.buttonWidth, buttonBorderColor = element.buttonBorderColor;
    var borderColor = touched ? validateEmail(email) ? palette/* lightGray */.l2 : palette/* red */.Q6 : palette/* lightGray */.l2;
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setError(false);
            setShowSucess(false);
        }, 10000);
    }, [
        error,
        showSuccess
    ]);
    var errorMsg = "Unable to subscribe ".concat(email);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        contentEditable: false,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    userSelect: "none",
                    display: "none"
                },
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                },
                onClick: function() {
                    return ref.current.focus();
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            fontWeight: 600,
                            fontSize: titleFontSize || "24px",
                            textAlign: "center"
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
                        children: function(isMobile) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    width: "100%",
                                    marginTop: "16px",
                                    display: "flex",
                                    flexDirection: isMobile ? "column" : "row",
                                    alignItems: "center",
                                    justifyContent: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                        ref: ref,
                                        type: "text",
                                        value: email,
                                        placeholder: "Email address",
                                        css: {
                                            padding: "8px",
                                            width: isMobile ? "80%" : "".concat(textBoxWidth, "%"),
                                            minWidth: "240px",
                                            color: palette/* darkGray */.O5,
                                            border: "1px solid ".concat(borderColor),
                                            borderRadius: 2
                                        },
                                        onChange: function(event) {
                                            setEmail(event.target.value);
                                            setTouched(true);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            marginTop: isMobile ? "12px" : "0px",
                                            marginLeft: isMobile ? "0px" : "12px",
                                            padding: "5px 16px",
                                            color: buttonTextColor,
                                            fontSize: 18,
                                            letterSpacing: 0.6,
                                            backgroundColor: buttonColor,
                                            border: "1px solid",
                                            borderColor: buttonBorderColor,
                                            borderRadius: 2,
                                            width: buttonWidth ? "".concat(buttonWidth, "%") : undefined,
                                            minWidth: "160px",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            textAlign: "center",
                                            "&:hover": {
                                                opacity: 0.8
                                            }
                                        },
                                        onClick: function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
                                                var result;
                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            event.stopPropagation();
                                                            event.preventDefault();
                                                            if (validateEmail(email)) {
                                                                _ctx.next = 4;
                                                                break;
                                                            }
                                                            return _ctx.abrupt("return");
                                                        case 4:
                                                            if (!onEmailSubscribe) {
                                                                _ctx.next = 15;
                                                                break;
                                                            }
                                                            _ctx.prev = 5;
                                                            _ctx.next = 8;
                                                            return onEmailSubscribe(email);
                                                        case 8:
                                                            result = _ctx.sent;
                                                            if (result) {
                                                                setShowSucess(true);
                                                            } else {
                                                                setError(errorMsg);
                                                            }
                                                            _ctx.next = 15;
                                                            break;
                                                        case 12:
                                                            _ctx.prev = 12;
                                                            _ctx.t0 = _ctx["catch"](5);
                                                            setError(errorMsg);
                                                        case 15:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee, null, [
                                                    [
                                                        5,
                                                        12
                                                    ]
                                                ]);
                                            }));
                                            return function(event) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }(),
                                        children: buttonText
                                    })
                                ]
                            });
                        }
                    }),
                    error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            marginTop: "16px",
                            fontWeight: 500,
                            fontSize: "16px",
                            color: palette/* red */.Q6,
                            textAlign: "center"
                        },
                        children: [
                            error,
                            " ⚠"
                        ]
                    }),
                    showSuccess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            marginTop: "16px",
                            fontWeight: 500,
                            fontSize: "16px",
                            color: palette/* greenSuccess */.CU,
                            textAlign: "center"
                        },
                        children: [
                            "Subscribed successfully with ",
                            email,
                            " ✔"
                        ]
                    }),
                    description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            marginTop: "32px",
                            fontWeight: 500,
                            fontSize: descriptionFontSize || "16px",
                            textAlign: "center"
                        },
                        children: description
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/Element.js





















var ELEMENT_PARAGRAPH = "paragraph";
var ELEMENT_BLOCK_QUOTE = "block-quote";
var ELEMENT_CODE = "code";
var ELEMENT_BULLETED_LIST = "bulleted-list";
var ELEMENT_HEADING_ONE = "heading-one";
var ELEMENT_HEADING_TWO = "heading-two";
var ELEMENT_HEADING_THREE = "heading-three";
var ELEMENT_HEADING_FOUR = "heading-four";
var ELEMENT_LIST_ITEM = "list-item";
var ELEMENT_NUMBERED_LIST = "numbered-list";
var ELEMENT_LINK = "link";
var ELEMENT_IMAGE = "image";
var ELEMENT_CUSTOM_BUTTON = "custom-button";
var ELEMENT_GOVLAUNCH_PROJECT = "govlaunch-project";
var ELEMENT_YOUTUBE_VIDEO = "youtube-video";
var ELEMENT_DIVIDER = "divider";
var ELEMENT_AIRTABLE = "airtable";
var ELEMENT_GOOGLE_SPREADSHEET = "google-spreadsheet";
var ELEMENT_TYPEFORM = "typeform";
var ELEMENT_GOOGLE_FORMS = "google-forms";
var ELEMENT_SIMPLECAST = "simplecast";
var ELEMENT_SOCIAL_MEDIAS = "social-medias";
var ELEMENT_SUBSCRIBE_BUTTON = "subscribe-button";
var EMPTY_CHILDREN = {
    children: [
        {
            text: ""
        }, 
    ]
};
function getNewParagraph() {
    return {
        type: ELEMENT_PARAGRAPH,
        children: [
            {
                text: ""
            }, 
        ]
    };
}
function Element_Element(props) {
    var attributes = props.attributes, children = props.children, element = props.element;
    var style = {
        textAlign: element.align,
        fontFamily: "proxima-nova, Helvetica, Arial, sans-serif"
    };
    switch(element.type){
        case ELEMENT_BLOCK_QUOTE:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Blockquote, {
                attributes: attributes,
                style: style,
                children: children
            });
        case ELEMENT_CODE:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("pre", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("code", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
                    children: children
                }))
            });
        case ELEMENT_BULLETED_LIST:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                style: (0,src_object_spread/* default */.Z)({
                    paddingLeft: "20px"
                }, style)
            }, attributes), {
                children: children
            }));
        case ELEMENT_HEADING_ONE:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderOne, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case ELEMENT_HEADING_TWO:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderTwo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case ELEMENT_HEADING_THREE:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderThree, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case ELEMENT_HEADING_FOUR:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderFour, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case ELEMENT_LIST_ITEM:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(elements_UnorderedListItem, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case ELEMENT_NUMBERED_LIST:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ol", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                style: (0,src_object_spread/* default */.Z)({
                    paddingLeft: "20px"
                }, style)
            }, attributes), {
                children: children
            }));
        case ELEMENT_LINK:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(elements_Link, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                element: element
            }, attributes), {
                style: style,
                children: children
            }));
        case ELEMENT_IMAGE:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(elements_Image, {
                attributes: attributes,
                children: children,
                element: element,
                style: style
            });
        case ELEMENT_YOUTUBE_VIDEO:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YoutubeVideoElement, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_DIVIDER:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider_Divider, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_AIRTABLE:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Airtable_Airtable, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_GOOGLE_SPREADSHEET:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleSpreadsheet_GoogleSpreadsheet, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_GOOGLE_FORMS:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleForms_GoogleForms, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_TYPEFORM:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typeform_Typeform, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_SIMPLECAST:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Simplecast_Simplecast, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_SOCIAL_MEDIAS:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(elements_SocialMedias_SocialMedias, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_CUSTOM_BUTTON:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomButton_CustomButton, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_GOVLAUNCH_PROJECT:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovlaunchProject_GovlaunchProject, {
                attributes: attributes,
                children: children,
                element: element
            });
        case ELEMENT_SUBSCRIBE_BUTTON:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribeEmbed, {
                attributes: attributes,
                children: children,
                element: element,
                onEmailSubscribe: props.onEmailSubscribe
            });
        default:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(elements_Paragraph, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
    }
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/withHtml.js
/* eslint-disable object-curly-newline */ 


var ELEMENT_TAGS = {
    A: function(el) {
        return {
            type: ELEMENT_LINK,
            url: el.getAttribute("href")
        };
    },
    BLOCKQUOTE: function() {
        return {
            type: ELEMENT_BLOCK_QUOTE
        };
    },
    H1: function() {
        return {
            type: ELEMENT_HEADING_ONE
        };
    },
    H2: function() {
        return {
            type: ELEMENT_HEADING_TWO
        };
    },
    H3: function() {
        return {
            type: ELEMENT_HEADING_THREE
        };
    },
    H4: function() {
        return {
            type: ELEMENT_HEADING_FOUR
        };
    },
    H5: function() {
        return {
            type: ELEMENT_HEADING_FOUR
        };
    },
    H6: function() {
        return {
            type: ELEMENT_HEADING_FOUR
        };
    },
    IMG: function(el) {
        return {
            type: ELEMENT_IMAGE,
            url: el.getAttribute("src")
        };
    },
    LI: function() {
        return {
            type: ELEMENT_LIST_ITEM
        };
    },
    OL: function() {
        return {
            type: ELEMENT_NUMBERED_LIST
        };
    },
    P: function() {
        return {
            type: ELEMENT_PARAGRAPH
        };
    },
    PRE: function() {
        return {
            type: ELEMENT_CODE
        };
    },
    UL: function() {
        return {
            type: ELEMENT_BULLETED_LIST
        };
    }
};
// COMPAT: `B` is omitted here because Google Docs uses `<b>` in weird ways.
var TEXT_TAGS = {
    CODE: function() {
        return {
            code: true
        };
    },
    DEL: function() {
        return {
            strikethrough: true
        };
    },
    EM: function() {
        return {
            italic: true
        };
    },
    I: function() {
        return {
            italic: true
        };
    },
    S: function() {
        return {
            strikethrough: true
        };
    },
    STRONG: function() {
        return {
            bold: true
        };
    },
    U: function() {
        return {
            underline: true
        };
    }
};
var deserialize = function(el) {
    if (el.nodeType === 3) {
        return el.textContent;
    } else if (el.nodeType !== 1) {
        return null;
    } else if (el.nodeName === "BR") {
        return "\n";
    }
    var nodeName = el.nodeName;
    var parent = el;
    if (nodeName === "PRE" && el.childNodes[0] && el.childNodes[0].nodeName === "CODE") {
        parent = el.childNodes[0];
    }
    var children = Array.from(parent.childNodes).map(deserialize).flat();
    if (children.length === 0) {
        children = [
            {
                text: ""
            }
        ];
    }
    if (el.nodeName === "BODY") {
        return jsx("fragment", {}, children);
    }
    if (ELEMENT_TAGS[nodeName]) {
        var attrs = ELEMENT_TAGS[nodeName](el);
        return jsx("element", attrs, children);
    }
    if (TEXT_TAGS[nodeName]) {
        var attrs1 = TEXT_TAGS[nodeName](el);
        return children.map(function(child) {
            return jsx("text", attrs1, child);
        });
    }
    return children;
};
var withHtml = function(editor) {
    var insertData = editor.insertData, isInline = editor.isInline, isVoid = editor.isVoid;
    editor.isInline = function(element) {
        return element.type === "link" ? true : isInline(element);
    };
    editor.isVoid = function(element) {
        return element.type === "image" || element.type === ELEMENT_SUBSCRIBE_BUTTON ? true : isVoid(element);
    };
    editor.insertData = function(data) {
        var html = data.getData("text/html");
        if (html) {
            var parsed = new DOMParser().parseFromString(html, "text/html");
            var fragments = deserialize(parsed.body);
            var safeFragments = sanitizeFragment(fragments);
            try {
                index_es/* Transforms.insertFragment */.YR.insertFragment(editor, safeFragments);
            } catch (e) {
                ;
            }
            return;
        }
        insertData(data);
    };
    return editor;
};
/* harmony default export */ var slate_withHtml = (withHtml);
function sanitizeFragment(fragments) {
    var result = fragments;
    for(var i = 0; i < fragments.length; i++){
        if (fragments[i].type === ELEMENT_BULLETED_LIST && fragments[i].children && fragments[i].children.length > 0) {
            result[i].children = fixOrRemoveEmptyListItems(fragments[i].children);
        }
    }
    return result;
}
function fixOrRemoveEmptyListItems(list) {
    var result = list;
    for(var i = 0; i < list.length; i++){
        if (!list[i].type && list[i].text && list[i].text === "\n") {
            result[i] = null;
        }
    }
    return result.filter(Boolean);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/withCorrectVoidBehaviour.js


var withCorrectVoidBehavior = function(editor) {
    var deleteBackward = editor.deleteBackward, insertBreak = editor.insertBreak, deleteForward = editor.deleteForward;
    // if current selection is void node, insert a default node below
    editor.insertBreak = function() {
        if (!editor.selection || !index_es/* Range.isCollapsed */.e6.isCollapsed(editor.selection)) {
            return insertBreak();
        }
        var selectedNodePath = index_es/* Path.parent */.y$.parent(editor.selection.anchor.path);
        var selectedNode = index_es/* Node.get */.NB.get(editor, selectedNodePath);
        if (!index_es/* Editor.isVoid */.ML.isVoid(editor, selectedNode) && index_es/* Path.hasPrevious */.y$.hasPrevious(selectedNodePath) && (selectedNode.type === ELEMENT_SOCIAL_MEDIAS || selectedNode.type === ELEMENT_DIVIDER || selectedNode.type === ELEMENT_SIMPLECAST || selectedNode.type === ELEMENT_GOVLAUNCH_PROJECT || selectedNode.type === ELEMENT_CUSTOM_BUTTON || selectedNode.type === ELEMENT_SUBSCRIBE_BUTTON)) {
            var previousNodePath = index_es/* Path.previous */.y$.previous(selectedNodePath);
            index_es/* Transforms.select */.YR.select(editor, previousNodePath);
            index_es/* Editor.insertNode */.ML.insertNode(editor, getNewParagraph());
            return;
        }
        if (index_es/* Editor.isVoid */.ML.isVoid(editor, selectedNode)) {
            index_es/* Editor.insertNode */.ML.insertNode(editor, getNewParagraph());
            return;
        }
        insertBreak();
    };
    // if prev node is a void node, remove the current node and select the void node
    editor.deleteBackward = function(unit) {
        if (!editor.selection || !index_es/* Range.isCollapsed */.e6.isCollapsed(editor.selection) || editor.selection.anchor.offset !== 0) {
            return deleteBackward(unit);
        }
        var parentPath = index_es/* Path.parent */.y$.parent(editor.selection.anchor.path);
        var parentNode = index_es/* Node.get */.NB.get(editor, parentPath);
        var parentIsEmpty = index_es/* Node.string */.NB.string(parentNode).length === 0;
        if (parentIsEmpty && index_es/* Path.hasPrevious */.y$.hasPrevious(parentPath)) {
            var prevNodePath = index_es/* Path.previous */.y$.previous(parentPath);
            var prevNode = index_es/* Node.get */.NB.get(editor, prevNodePath);
            if (index_es/* Editor.isVoid */.ML.isVoid(editor, prevNode)) {
                return index_es/* Transforms.removeNodes */.YR.removeNodes(editor);
            }
        }
        // never ever delete the first node
        if (editor.selection.anchor.path[0] === 0 && editor.children.length === 1) {
            index_es/* Transforms.removeNodes */.YR.removeNodes(editor);
            return index_es/* Transforms.insertNodes */.YR.insertNodes(editor, getNewParagraph());
        }
        if (editor.selection.anchor.path[0] === 0 && editor.children.length > 1) {
            return index_es/* Transforms.removeNodes */.YR.removeNodes(editor);
        }
        deleteBackward(unit);
    };
    editor.deleteForward = function(unit) {
        // never ever delete the first node
        if (editor.selection.anchor.path[0] === 0 && editor.children.length === 1) {
            index_es/* Transforms.removeNodes */.YR.removeNodes(editor);
            index_es/* Transforms.insertNodes */.YR.insertNodes(editor, getNewParagraph());
        } else {
            deleteForward(unit);
        }
    };
    return editor;
};
/* harmony default export */ var withCorrectVoidBehaviour = (withCorrectVoidBehavior);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/buttonActions.js



var LIST_TYPES = [
    ELEMENT_NUMBERED_LIST,
    ELEMENT_BULLETED_LIST
];
var TEXT_ALIGN_TYPES = [
    "left",
    "center",
    "right",
    "justify"
];
var toggleBlock = function(editor, format) {
    var isActive = buttonActions_isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type");
    var isList = LIST_TYPES.includes(format);
    index_es/* Transforms.unwrapNodes */.YR.unwrapNodes(editor, {
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && LIST_TYPES.includes(n.type) && !TEXT_ALIGN_TYPES.includes(format);
        },
        split: true
    });
    var newProperties;
    if (TEXT_ALIGN_TYPES.includes(format)) {
        newProperties = {
            align: isActive ? undefined : format
        };
    } else {
        newProperties = {
            type: isActive ? ELEMENT_PARAGRAPH : isList ? ELEMENT_LIST_ITEM : format
        };
    }
    index_es/* Transforms.setNodes */.YR.setNodes(editor, newProperties);
    if (!isActive && isList) {
        var block = {
            type: format,
            children: []
        };
        index_es/* Transforms.wrapNodes */.YR.wrapNodes(editor, block);
    }
};
function isBlockType(editor, type) {
    var selection = editor.selection;
    if (!selection) return false;
    var ref = (0,_sliced_to_array/* default */.Z)(Array.from(index_es/* Editor.nodes */.ML.nodes(editor, {
        at: index_es/* Editor.unhangRange */.ML.unhangRange(editor, selection),
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === type;
        }
    })), 1), match = ref[0];
    return !!match;
}
var toggleMark = function(editor, format) {
    var isActive = isMarkActive(editor, format);
    if (isActive) {
        index_es/* Editor.removeMark */.ML.removeMark(editor, format);
    } else {
        index_es/* Editor.addMark */.ML.addMark(editor, format, true);
    }
};
var buttonActions_isBlockActive = function(editor, format) {
    var blockType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    var selection = editor.selection;
    if (!selection) return false;
    var ref = (0,_sliced_to_array/* default */.Z)(Array.from(index_es/* Editor.nodes */.ML.nodes(editor, {
        at: index_es/* Editor.unhangRange */.ML.unhangRange(editor, selection),
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n[blockType] === format;
        }
    })), 1), match = ref[0];
    return !!match;
};
var isMarkActive = function(editor, format) {
    var marks = index_es/* Editor.marks */.ML.marks(editor);
    return marks ? marks[format] === true : false;
};
function setOrInsertElement(editor, node) {
    if (isEmptyParagraph(editor)) {
        index_es/* Transforms.setNodes */.YR.setNodes(editor, node);
    } else {
        index_es/* Transforms.insertNodes */.YR.insertNodes(editor, node);
    }
    index_es/* Transforms.insertNodes */.YR.insertNodes(editor, getNewParagraph());
}
function isEmptyParagraph(editor) {
    if (editor.children.length === 1 && editor.children[0].type === "paragraph" && editor.children[0].children[0].text === "") {
        return true;
    }
    return false;
}
function isLinkActive(editor) {
    var ref = (0,_sliced_to_array/* default */.Z)(index_es/* Editor.nodes */.ML.nodes(editor, {
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === ELEMENT_LINK;
        }
    }), 1), link = ref[0];
    return !!link;
}
function unwrapLink(editor) {
    index_es/* Transforms.unwrapNodes */.YR.unwrapNodes(editor, {
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === "link";
        }
    });
}
function wrapLink(editor, url) {
    if (isLinkActive(editor)) {
        unwrapLink(editor);
    }
    var selection = editor.selection;
    var isCollapsed = selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection);
    var link = {
        type: ELEMENT_LINK,
        url: url,
        children: isCollapsed ? [
            {
                text: url
            }, 
        ] : []
    };
    if (isCollapsed) {
        index_es/* Transforms.insertNodes */.YR.insertNodes(editor, link);
    } else {
        index_es/* Transforms.wrapNodes */.YR.wrapNodes(editor, link, {
            split: true
        });
        index_es/* Transforms.collapse */.YR.collapse(editor, {
            edge: "end"
        });
    }
}
function insertLink(editor, url) {
    if (editor.selection) {
        wrapLink(editor, url);
    }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/Leaf.js




var Leaf_Leaf = function(param) {
    var attributes = param.attributes, children = param.children, leaf = param.leaf;
    if (leaf.bold) {
        children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
            children: children
        });
    }
    if (leaf.code) {
        children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("code", {
            children: children
        });
    }
    if (leaf.italic) {
        children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("em", {
            children: children
        });
    }
    if (leaf.underline) {
        children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("u", {
            children: children
        });
    }
    if (leaf.strikethrough) {
        children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("del", {
            children: children
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, attributes), {
        children: children
    }));
};
/* harmony default export */ var slate_Leaf = (Leaf_Leaf);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/Toolbar.js
/* eslint-disable react/display-name */ 




var Toolbar = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: ref,
        css: {
            width: "100%",
            padding: "0rem 1rem 0.5rem 1rem",
            borderBottom: "2px solid #eee",
            marginBottom: "0.5rem",
            display: "flex",
            flexDirection: "column"
        },
        children: children
    }));
});
/* harmony default export */ var components_Toolbar = (Toolbar);

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(62081);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(82269);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(93706);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.8.1_psntm5zmlvip7zjgnrjqfe3wg4/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(28321);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+emotion-icon@4.1.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/emotion-icon/index.esm.js




var index_esm_excluded = ["children", "iconAttrs", "iconVerticalAlign", "iconViewBox", "size", "title"];

function index_esm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function index_esm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { index_esm_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { index_esm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var EmotionIconBaseBase = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var children = props.children,
      iconAttrs = props.iconAttrs,
      iconVerticalAlign = props.iconVerticalAlign,
      iconViewBox = props.iconViewBox,
      size = props.size,
      title = props.title,
      otherProps = (0,objectWithoutProperties/* default */.Z)(props, index_esm_excluded);

  var iconProps = index_esm_objectSpread(index_esm_objectSpread({
    viewBox: iconViewBox,
    height: props.height !== undefined ? props.height : size,
    width: props.width !== undefined ? props.width : size,
    'aria-hidden': title == null ? 'true' : undefined,
    focusable: 'false',
    role: title != null ? 'img' : undefined
  }, iconAttrs), otherProps);

  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({}, iconProps, {
    ref: ref
  }), title && /*#__PURE__*/react.createElement("title", {
    key: "icon-title"
  }, title), children);
});
var EmotionIconBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(EmotionIconBaseBase,  true ? {
  target: "ex0cdmw0"
} : 0)("display:inline-block;vertical-align:", function (props) {
  return props.iconVerticalAlign;
}, ";overflow:hidden;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatBold/FormatBold.esm.js



var FormatBold = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
  }));
});
FormatBold.displayName = 'FormatBold';
var FormatBoldDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatItalic/FormatItalic.esm.js



var FormatItalic = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
  }));
});
FormatItalic.displayName = 'FormatItalic';
var FormatItalicDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatUnderlined/FormatUnderlined.esm.js



var FormatUnderlined = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
  }));
});
FormatUnderlined.displayName = 'FormatUnderlined';
var FormatUnderlinedDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/Code/Code.esm.js



var Code = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
  }));
});
Code.displayName = 'Code';
var CodeDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/Looks3/Looks3.esm.js



var Looks3 = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M.01 0h24v24h-24z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15a2 2 0 01-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4a2 2 0 012 2v1.5z"
  }));
});
Looks3.displayName = 'Looks3';
var Looks3Dimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/Looks4/Looks4.esm.js



var Looks4 = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"
  }));
});
Looks4.displayName = 'Looks4';
var Looks4Dimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatQuote/FormatQuote.esm.js



var FormatQuote = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
  }));
});
FormatQuote.displayName = 'FormatQuote';
var FormatQuoteDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatListNumbered/FormatListNumbered.esm.js



var FormatListNumbered = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
  }));
});
FormatListNumbered.displayName = 'FormatListNumbered';
var FormatListNumberedDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatListBulleted/FormatListBulleted.esm.js



var FormatListBulleted = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
  }));
});
FormatListBulleted.displayName = 'FormatListBulleted';
var FormatListBulletedDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatAlignLeft/FormatAlignLeft.esm.js



var FormatAlignLeft = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
  }));
});
FormatAlignLeft.displayName = 'FormatAlignLeft';
var FormatAlignLeftDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatAlignCenter/FormatAlignCenter.esm.js



var FormatAlignCenter = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
  }));
});
FormatAlignCenter.displayName = 'FormatAlignCenter';
var FormatAlignCenterDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatAlignRight/FormatAlignRight.esm.js



var FormatAlignRight = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
  }));
});
FormatAlignRight.displayName = 'FormatAlignRight';
var FormatAlignRightDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/FormatAlignJustify/FormatAlignJustify.esm.js



var FormatAlignJustify = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
  }));
});
FormatAlignJustify.displayName = 'FormatAlignJustify';
var FormatAlignJustifyDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/InsertPhoto/InsertPhoto.esm.js



var InsertPhoto = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
  }));
});
InsertPhoto.displayName = 'InsertPhoto';
var InsertPhotoDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/Settings/Settings.esm.js



var Settings = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.488.488 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
  }));
});
Settings.displayName = 'Settings';
var SettingsDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/Link/Link.esm.js



var Link_esm_Link = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
  }));
});
Link_esm_Link.displayName = 'Link';
var LinkDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion-icons+material@3.14.0_bgqmsvm4hz6izcmpcwescmz73y/node_modules/@emotion-icons/material/Mail/Mail.esm.js



var Mail = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/react.createElement(EmotionIconBase, (0,esm_extends/* default */.Z)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
  }));
});
Mail.displayName = 'Mail';
var MailDimensions = {
  height: 24,
  width: 24
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/icons/DividerIcon.js




var DividerIcon_DividerIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 34,
        height: 4,
        viewBox: "0 0 34 4"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    id: "a",
                    width: 180,
                    height: 41,
                    y: 10,
                    rx: 4
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(-136 -29)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                fill: "#FFF",
                                xlinkHref: "#a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 179,
                                height: 40,
                                x: 0.5,
                                y: 10.5,
                                stroke: "#F2F2F2",
                                rx: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        fill: "currentColor",
                        fillRule: "nonzero",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M3.89 1.617L2.474.203a.5.5 0 0 0-.707 0L.354 1.617a.5.5 0 0 0 0 .707l1.414 1.414a.5.5 0 0 0 .707 0l1.414-1.414a.5.5 0 0 0 0-.707zm29.698 0L32.173.203a.5.5 0 0 0-.707 0l-1.414 1.414a.5.5 0 0 0 0 .707l1.414 1.414a.5.5 0 0 0 .707 0l1.415-1.414a.5.5 0 0 0 0-.707z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M3.182 2.324a.5.5 0 0 1 .353-.853h26.87a.5.5 0 0 1 0 1H3.535a.498.498 0 0 1-.353-.147z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_icons_DividerIcon = (DividerIcon_DividerIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/icons/VideoIcon.js




var VideoIcon_VideoIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 20,
        viewBox: "0 0 24 20",
        style: {
            verticalAlign: "bottom"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    id: "a",
                    width: 180,
                    height: 41,
                    y: 10,
                    rx: 4
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(-53 -21)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                fill: "#FFF",
                                xlinkHref: "#a"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 179,
                                height: 40,
                                x: 0.5,
                                y: 10.5,
                                stroke: "#F2F2F2",
                                rx: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "currentColor",
                        fillRule: "nonzero",
                        d: "M18.5 0h-13A5.506 5.506 0 0 0 0 5.5v9C0 17.533 2.467 20 5.5 20h13c3.033 0 5.5-2.467 5.5-5.5v-9C24 2.467 21.533 0 18.5 0zm-1.729 10.42l-7 4.5a.495.495 0 0 1-.511.019A.501.501 0 0 1 9 14.5v-9a.501.501 0 0 1 .77-.42l7 4.5a.498.498 0 0 1 .001.84z"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_icons_VideoIcon = (VideoIcon_VideoIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/icons/SimplecastIcon.js




var SimplecastIcon_SimplecastIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 86 84",
        style: {
            verticalAlign: "bottom"
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "currentColor",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M85.01 0v83.99H.736V0H85.01zm-5.618 5.6H6.353v72.79h73.04V5.6z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M17.59 16.798V67.19h50.566zM64.182 52.432L32.401 20.758l3.972-3.96 31.783 31.674zM64.182 36.594l-15.89-15.837 3.972-3.96 15.892 15.838z"
                })
            ]
        })
    }));
};
/* harmony default export */ var icons_SimplecastIcon = (SimplecastIcon_SimplecastIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/icons/CustomButtonIcon.js




var CustomButtonIcon_CustomButtonIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "18px",
        height: "18px",
        viewBox: "0 0 18 18",
        fill: "none",
        style: {
            verticalAlign: "bottom"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M4 6C2.34315 6 1 4.65685 1 3C1 1.34315 2.34315 0 4 0H11C12.6569 0 14 1.34315 14 3C14 4.65685 12.6569 6 11 6H9V3.5C9 2.11929 7.88071 1 6.5 1C5.11929 1 4 2.11929 4 3.5V6Z",
                fill: "#cccccc"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M6.5 2C5.67157 2 5 2.67157 5 3.5V8.05001C3.85888 8.28164 3 9.29052 3 10.5C3 12.9853 5.01472 15 7.5 15H8C10.7614 15 13 12.7614 13 10V9.14706C13 7.96127 12.0387 7 10.8529 7H8V3.5C8 2.67157 7.32843 2 6.5 2Z",
                fill: "#cccccc"
            })
        ]
    }));
};
/* harmony default export */ var icons_CustomButtonIcon = (CustomButtonIcon_CustomButtonIcon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/Icon.js
/* eslint-disable react/display-name */ 










var ICON_FORMAT_BOLD = "format_bold";
var ICON_FORMAT_ITALIC = "format_italic";
var ICON_FORMAT_UNDERLINE = "format_underlined";
var ICON_FORMAT_CODE = "code";
var ICON_HEADING_THREE = "looks_3";
var ICON_HEADING_FOUR = "looks_4";
var ICON_FORMAT_QUOTE = "format_quote";
var ICON_FORMAT_LIST_NUMBERED = "format_list_numbered";
var ICON_FORMAT_LIST_BULLETED = "format_list_bulleted";
var ICON_FORMAT_ALIGN_LEFT = "format_align_left";
var ICON_FORMAT_ALIGN_CENTER = "format_align_center";
var ICON_FORMAT_ALIGN_RIGHT = "format_align_right";
var ICON_FORMAT_ALIGN_JUSTIFY = "format_align_justify";
var ICON_IMAGE = "image";
var ICON_IMAGE_EDIT = "image_edit";
var ICON_INSERT_DIVIDER = "divider";
var ICON_YOUTUBE_VIDEO = "youtube_video";
var ICON_SIMPLECAST = "simplecast";
var ICON_SOCIAL_MEDIAS = "social_media";
var ICON_CUSTOM_BUTTON = "custom_buton";
var ICON_LINK = "link";
var ICON_SUBSCRIBE_BUTTON = "subscribe_button";
var Icon = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var iconName = _param.iconName, props = (0,_object_without_properties/* default */.Z)(_param, [
        "iconName"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: ref,
        css: {
            borderRadius: "4px",
            padding: "4px 4px 6px 4px",
            "&:hover": {
                background: "#f3f3f3"
            }
        },
        children: [
            iconName === ICON_FORMAT_BOLD && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatBold, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_ITALIC && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatItalic, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_UNDERLINE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatUnderlined, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_CODE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Code, {
                size: "24px"
            }),
            iconName === ICON_HEADING_THREE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Looks3, {
                size: "24px"
            }),
            iconName === ICON_HEADING_FOUR && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Looks4, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_QUOTE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatQuote, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_LIST_NUMBERED && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatListNumbered, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_LIST_BULLETED && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatListBulleted, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_ALIGN_LEFT && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatAlignLeft, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_ALIGN_CENTER && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatAlignCenter, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_ALIGN_RIGHT && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatAlignRight, {
                size: "24px"
            }),
            iconName === ICON_FORMAT_ALIGN_JUSTIFY && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormatAlignJustify, {
                size: "24px"
            }),
            iconName === ICON_IMAGE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertPhoto, {
                size: "24px"
            }),
            iconName === ICON_IMAGE_EDIT && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Settings, {
                size: "24px"
            }),
            iconName === ICON_INSERT_DIVIDER && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_icons_DividerIcon, {
                width: "24px"
            }),
            iconName === ICON_YOUTUBE_VIDEO && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_icons_VideoIcon, {
                height: "24px",
                width: "24px"
            }),
            iconName === ICON_SIMPLECAST && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_SimplecastIcon, {
                width: "24px",
                height: "24px"
            }),
            iconName === ICON_SOCIAL_MEDIAS && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_SocialMediasIcon, {
                width: "24px",
                height: "24px"
            }),
            iconName === ICON_CUSTOM_BUTTON && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_CustomButtonIcon, {
                height: "24px",
                width: "24px"
            }),
            iconName === ICON_LINK && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link_esm_Link, {
                height: "24px",
                width: "24px"
            }),
            iconName === ICON_SUBSCRIBE_BUTTON && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mail, {
                height: "24px",
                width: "24px"
            })
        ]
    }));
});
/* harmony default export */ var components_Icon = (Icon);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/BlockButton.js






var BlockButton = function(param) {
    var format = param.format, icon = param.icon;
    var editor = useSlate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
        active: buttonActions_isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type"),
        onMouseDown: function(event) {
            event.preventDefault();
            toggleBlock(editor, format);
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
            iconName: icon
        })
    });
};
/* harmony default export */ var toolbar_BlockButton = (BlockButton);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/utils/FocusOnMount.js








var FocusOnMount_FocusOnMount = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(FocusOnMount, Component);
    var _super = (0,_create_super/* default */.Z)(FocusOnMount);
    function FocusOnMount() {
        (0,_class_call_check/* default */.Z)(this, FocusOnMount);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleSetRef", function(elementRef) {
            _this.elementRef = elementRef;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(FocusOnMount, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var nextTick = this.props.nextTick;
                if (this.elementRef && typeof this.elementRef.focus === "function") {
                    if (nextTick) {
                        setTimeout(function() {
                            _this.elementRef.focus();
                        });
                    } else {
                        this.elementRef.focus();
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    innerRef: this.handleSetRef
                });
            }
        }
    ]);
    return FocusOnMount;
}(react.Component);
(0,_define_property/* default */.Z)(FocusOnMount_FocusOnMount, "propTypes", {
    nextTick: (prop_types_default()).bool,
    children: (prop_types_default()).func.isRequired
});
(0,_define_property/* default */.Z)(FocusOnMount_FocusOnMount, "defaultProps", {
    nextTick: true
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/utils/Filestack.js





var Filestack_API_KEY = "Aqw4lvamTSKiw8gSzioEKz";
var Filestack_FILESTACK_CONTAINER_ID = "STORY_EDITOR_FILESTACK_CONTAINER_ID";
function Filestack_Filestack(_param) {
    var onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onChange"
    ]);
    if (true) {
        var FilestackReact = (__webpack_require__(11381)["default"]);
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilestackReact, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            apikey: Filestack_API_KEY
        }, props), {
            onSuccess: function(param) {
                var filesUploaded = param.filesUploaded;
                if (filesUploaded.length > 0) {
                    onChange(filesUploaded[0].url);
                }
            },
            actionOptions: {
                displayMode: "dropPane",
                container: Filestack_FILESTACK_CONTAINER_ID,
                customText: {
                    "Drag and Drop, Copy and Paste Files": "Click or Drag & Drop"
                }
            },
            componentDisplayMode: {
                type: "immediate"
            }
        }));
    }
    return null;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/ImageInput.js






function ImageInput_ImageInput(param) {
    var onChange = param.onChange, initialValues = param.initialValues, saveButtonText = param.saveButtonText;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 300
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount_FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: {
                        url: initialValues ? initialValues.url || "" : "",
                        alt: initialValues ? initialValues.alt || "" : "",
                        width: initialValues ? initialValues.width || "" : "",
                        height: initialValues ? initialValues.height || "" : ""
                    },
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                width: "100%",
                                padding: 16,
                                background: "#eeeeee"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        minHeight: "120px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        value && value.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                position: "relative"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                                    src: value.url,
                                                    css: {
                                                        width: "100%",
                                                        borderRadius: 5,
                                                        objectFit: "cover"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        position: "absolute",
                                                        top: -4,
                                                        right: -4,
                                                        width: 28,
                                                        height: 28,
                                                        borderRadius: 25,
                                                        background: "#FE786C",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: 600,
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            top: -4,
                                                            right: -4,
                                                            background: "#FE5F51"
                                                        }
                                                    },
                                                    onClick: function() {
                                                        set({
                                                            url: "",
                                                            alt: value.alt,
                                                            width: value.width,
                                                            height: value.height
                                                        });
                                                    },
                                                    children: "X"
                                                })
                                            ]
                                        }),
                                        !value.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            id: Filestack_FILESTACK_CONTAINER_ID,
                                            css: {
                                                width: "100%",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filestack_Filestack, {
                                                onChange: function(url) {
                                                    set({
                                                        url: url,
                                                        alt: value.alt,
                                                        width: value.width,
                                                        height: value.height
                                                    });
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                        css: {
                                            color: palette/* sealBlue */.N9
                                        },
                                        children: "Image url"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 4
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                        ref: innerRef,
                                        value: value.url,
                                        placeholder: "Type image url...",
                                        spellCheck: false,
                                        css: {
                                            border: "1px solid ".concat(palette/* lightGray */.l2),
                                            borderRadius: 2,
                                            outline: "none",
                                            backgroundColor: "white",
                                            padding: 4,
                                            color: palette/* text */.fL,
                                            width: "100%"
                                        },
                                        onChange: function(event) {
                                            return set({
                                                url: event.target.value,
                                                alt: value.alt,
                                                width: value.width,
                                                height: value.height
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                        css: {
                                            color: palette/* sealBlue */.N9
                                        },
                                        children: "Image alt text"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 4
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                        value: value.alt,
                                        placeholder: "Type image alt text...",
                                        spellCheck: false,
                                        css: {
                                            border: "1px solid ".concat(palette/* lightGray */.l2),
                                            borderRadius: 2,
                                            outline: "none",
                                            backgroundColor: "white",
                                            padding: 4,
                                            color: palette/* text */.fL,
                                            width: "100%"
                                        },
                                        onChange: function(event) {
                                            return set({
                                                url: value.url,
                                                alt: event.target.value,
                                                width: value.width,
                                                height: value.height
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        marginTop: 8,
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                                    css: {
                                                        color: palette/* sealBlue */.N9
                                                    },
                                                    children: "Width"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                                    type: "number",
                                                    value: value.width,
                                                    placeholder: "Set width...",
                                                    spellCheck: false,
                                                    css: {
                                                        marginTop: 4,
                                                        border: "1px solid ".concat(palette/* lightGray */.l2),
                                                        borderRadius: 2,
                                                        outline: "none",
                                                        backgroundColor: "white",
                                                        padding: 4,
                                                        color: palette/* text */.fL,
                                                        width: "95%"
                                                    },
                                                    onChange: function(event) {
                                                        return set({
                                                            url: value.url,
                                                            alt: value.alt,
                                                            width: event.target.value,
                                                            height: value.height
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                                    css: {
                                                        color: palette/* sealBlue */.N9
                                                    },
                                                    children: "Height"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                                    type: "number",
                                                    value: value.height,
                                                    placeholder: "Set height...",
                                                    spellCheck: false,
                                                    css: {
                                                        marginTop: 4,
                                                        border: "1px solid ".concat(palette/* lightGray */.l2),
                                                        borderRadius: 2,
                                                        outline: "none",
                                                        backgroundColor: "white",
                                                        padding: 4,
                                                        color: palette/* text */.fL,
                                                        width: "95%"
                                                    },
                                                    onChange: function(event) {
                                                        return set({
                                                            url: value.url,
                                                            alt: value.alt,
                                                            width: value.width,
                                                            height: event.target.value
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                        type: "button",
                                        disabled: !value.url || !value.alt,
                                        css: {
                                            outline: "none",
                                            borderRadius: 4,
                                            cursor: !value.url || !value.alt ? "default" : "pointer",
                                            pointerEvents: !value.url || !value.alt ? "none" : "all",
                                            border: "solid 1px transparent",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: 12,
                                            height: 30,
                                            padding: "0 20px",
                                            backgroundColor: !value.url || !value.alt ? palette/* lightGray */.l2 : palette/* primary */.T$,
                                            color: "#ffffff",
                                            "&:hover:not(:focus)": {
                                                opacity: 0.8
                                            }
                                        },
                                        onClick: function() {
                                            return onChange(value.url, value.alt, value.width, value.height);
                                        },
                                        children: saveButtonText || "Add Image"
                                    })
                                })
                            ]
                        });
                    }
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/InsertImageButton.js











function InsertImageButton() {
    var editor = useSlateStatic();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageInput_ImageInput, {
                            onChange: function(url, alt, width, height) {
                                var image = (0,src_object_spread/* default */.Z)({
                                    type: ELEMENT_IMAGE,
                                    url: url,
                                    alt: alt,
                                    width: width,
                                    height: height
                                }, EMPTY_CHILDREN);
                                setOrInsertElement(editor, image);
                                toggle();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                toggle();
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
                            iconName: ICON_IMAGE
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/InsertYoutubeVideoButton.js












function InsertYoutubeVideoButton() {
    var editor = useSlate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount_FocusOnMount, {
                            nextTick: false,
                            children: function(param) {
                                var innerRef = param.innerRef;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        display: "inline-flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        width: "auto",
                                        minWidth: 240,
                                        height: 40
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                        ref: innerRef,
                                        placeholder: "What's the YouTube address?",
                                        spellCheck: false,
                                        css: {
                                            border: "none",
                                            outline: "none",
                                            backgroundColor: "transparent",
                                            padding: 10,
                                            width: "100%",
                                            height: "100%",
                                            color: palette/* text */.fL,
                                            "&::placeholder": {
                                                color: palette/* sealBlue */.N9
                                            }
                                        },
                                        onKeyDown: function(event) {
                                            var currentValue = event.target.value;
                                            if (event.key === "Enter" && currentValue) {
                                                event.preventDefault();
                                                var videoId = InsertYoutubeVideoButton_getYoutubeId(currentValue);
                                                if (!videoId) {
                                                    return;
                                                }
                                                var youtubeVideo = (0,src_object_spread/* default */.Z)({
                                                    type: ELEMENT_YOUTUBE_VIDEO,
                                                    videoId: videoId,
                                                    videoUrl: currentValue
                                                }, EMPTY_CHILDREN);
                                                setOrInsertElement(editor, youtubeVideo);
                                                toggle();
                                            }
                                            if (event.key === "Escape") {
                                                toggle();
                                            }
                                        }
                                    })
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                toggle();
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
                            iconName: ICON_YOUTUBE_VIDEO
                        })
                    })
                ]
            });
        }
    });
};
/**
 * https://gist.github.com/takien/4077195#gistcomment-2184219
 * @param   {String} urlString
 * @returns {String}
 */ function InsertYoutubeVideoButton_getYoutubeId(urlString) {
    var urlAfterSplit = urlString.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== urlAfterSplit[2] ? urlAfterSplit[2].split(/[^0-9a-z_-]/i)[0] : null;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/CustomButtonInput.js





function CustomButtonInput_CustomButtonInput(param) {
    var onInsert = param.onInsert;
    var ref = (0,react.useState)(""), buttonText = ref[0], setButtonText = ref[1];
    var ref1 = (0,react.useState)(false), buttonTextTouched = ref1[0], setButtonTextTouched = ref1[1];
    var ref2 = (0,react.useState)(""), buttonURL = ref2[0], setButtonURL = ref2[1];
    var ref3 = (0,react.useState)(false), buttonURLTouched = ref3[0], setButtonURLTouched = ref3[1];
    var ref4 = (0,react.useState)("#086BE5"), buttonColor = ref4[0], setButtonColor = ref4[1];
    var ref5 = (0,react.useState)("#FFFFFF"), buttonTextColor = ref5[0], setButtonTextColor = ref5[1];
    var ref6 = (0,react.useState)("#086BE5"), buttonBorderColor = ref6[0], setButtonBorderColor = ref6[1];
    var ref7 = (0,react.useState)(), buttonWidth = ref7[0], setButtonWidth = ref7[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
            onSubmit: function(event) {
                event.preventDefault();
                event.stopPropagation();
                onInsert({
                    buttonText: buttonText,
                    buttonURL: buttonURL,
                    buttonColor: buttonColor,
                    buttonTextColor: buttonTextColor,
                    buttonBorderColor: buttonBorderColor || buttonColor,
                    buttonWidth: buttonWidth,
                    buttonTargetBlank: event.target.elements.targetBlank.checked
                });
            },
            css: {
                width: 300,
                padding: 8,
                display: "grid",
                gridRowGap: 8
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button text"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "text",
                            name: "buttonText",
                            placeholder: "Insert Button text",
                            value: buttonText,
                            onChange: function(e) {
                                setButtonText(e.target.value);
                                setButtonTextTouched(true);
                            },
                            css: {
                                margin: 0,
                                padding: 8,
                                border: "solid 1px",
                                borderColor: buttonTextTouched && !fieldValidation_validateText(buttonText) ? palette/* red */.Q6 : palette/* sealBlue */.N9,
                                borderRadius: 2
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "URL"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "text",
                            name: "buttonURL",
                            value: buttonURL,
                            onChange: function(e) {
                                setButtonURL(e.target.value);
                                setButtonURLTouched(true);
                            },
                            placeholder: "Insert Button URL",
                            css: {
                                margin: 0,
                                padding: 8,
                                border: "solid 1px",
                                borderColor: buttonURLTouched && !fieldValidation_validateUrl(buttonURL) ? palette/* red */.Q6 : palette/* sealBlue */.N9,
                                borderRadius: 2
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button color"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "color",
                                    value: buttonColor,
                                    onChange: function(e) {
                                        setButtonColor(e.target.value);
                                    },
                                    css: {
                                        height: 30,
                                        width: 60,
                                        border: "solid 1px",
                                        borderColor: fieldValidation_validateColor(buttonColor) ? palette/* sealBlue */.N9 : palette/* red */.Q6
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "text",
                                    value: buttonColor,
                                    onChange: function(e) {
                                        var color = e.target.value;
                                        setButtonColor(color);
                                    },
                                    css: {
                                        margin: 0,
                                        padding: 8,
                                        border: "solid 1px",
                                        borderColor: fieldValidation_validateColor(buttonColor) ? palette/* sealBlue */.N9 : palette/* red */.Q6,
                                        borderRadius: 2,
                                        height: 30,
                                        width: 220,
                                        marginLeft: 5
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button Text color"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "color",
                                    value: buttonTextColor,
                                    onChange: function(e) {
                                        setButtonTextColor(e.target.value);
                                    },
                                    css: {
                                        height: 30,
                                        width: 60,
                                        border: "solid 1px",
                                        borderColor: fieldValidation_validateColor(buttonTextColor) ? palette/* sealBlue */.N9 : palette/* red */.Q6
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "text",
                                    value: buttonTextColor,
                                    onChange: function(e) {
                                        var color = e.target.value;
                                        setButtonTextColor(color);
                                    },
                                    css: {
                                        margin: 0,
                                        padding: 8,
                                        border: "solid 1px",
                                        borderColor: fieldValidation_validateColor(buttonTextColor) ? palette/* sealBlue */.N9 : palette/* red */.Q6,
                                        borderRadius: 2,
                                        height: 30,
                                        width: 220,
                                        marginLeft: 5
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button Border color"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "color",
                                    value: buttonBorderColor,
                                    onChange: function(e) {
                                        setButtonBorderColor(e.target.value);
                                    },
                                    css: {
                                        height: 30,
                                        width: 60,
                                        border: "solid 1px",
                                        borderColor: fieldValidation_validateColor(buttonBorderColor) ? palette/* sealBlue */.N9 : palette/* red */.Q6
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "text",
                                    value: buttonBorderColor,
                                    onChange: function(e) {
                                        var color = e.target.value;
                                        setButtonBorderColor(color);
                                    },
                                    css: {
                                        margin: 0,
                                        padding: 8,
                                        border: "solid 1px",
                                        borderColor: fieldValidation_validateColor(buttonBorderColor) ? palette/* sealBlue */.N9 : palette/* red */.Q6,
                                        borderRadius: 2,
                                        height: 30,
                                        width: 220,
                                        marginLeft: 5
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr",
                        gridRowGap: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Button Width (%)"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "text",
                            placeholder: "Insert Button Width",
                            value: buttonWidth,
                            onChange: function(e) {
                                setButtonWidth(e.target.value);
                            },
                            css: {
                                margin: 0,
                                padding: 8,
                                border: "solid 1px",
                                borderColor: fieldValidation_validateButtonWidth(buttonWidth) ? palette/* sealBlue */.N9 : palette/* red */.Q6,
                                borderRadius: 2
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: 'Target: "_blank"'
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            type: "checkbox",
                            name: "targetBlank",
                            defaultChecked: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "submit",
                    disabled: !CustomButtonInput_validateForm(buttonText, buttonURL, buttonColor, buttonTextColor, buttonBorderColor, buttonWidth),
                    css: {
                        margin: 0,
                        padding: 8,
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer"
                    },
                    children: "Insert"
                })
            ]
        })
    });
};
CustomButtonInput_CustomButtonInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired
};
function CustomButtonInput_validateForm(buttonText, buttonURL, buttonColor, buttonTextColor, buttonBorderColor, buttonWidth) {
    return fieldValidation_validateText(buttonText) && fieldValidation_validateUrl(buttonURL) && fieldValidation_validateColor(buttonColor) && fieldValidation_validateColor(buttonTextColor) && fieldValidation_validateColor(buttonBorderColor) && fieldValidation_validateButtonWidth(buttonWidth);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/InsertCustomButtonButton.js











function InsertCustomButtonButton() {
    var editor = useSlate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomButtonInput_CustomButtonInput, {
                            onInsert: function(customButtonData) {
                                var buttonText = customButtonData.buttonText, buttonURL = customButtonData.buttonURL, buttonColor = customButtonData.buttonColor, buttonTextColor = customButtonData.buttonTextColor, buttonBorderColor = customButtonData.buttonBorderColor, buttonWidth = customButtonData.buttonWidth, buttonTargetBlank = customButtonData.buttonTargetBlank;
                                var customButton = [
                                    (0,src_object_spread/* default */.Z)({
                                        type: ELEMENT_CUSTOM_BUTTON,
                                        buttonText: buttonText,
                                        buttonURL: buttonURL,
                                        buttonColor: buttonColor,
                                        buttonTextColor: buttonTextColor,
                                        buttonBorderColor: buttonBorderColor,
                                        buttonWidth: buttonWidth,
                                        buttonTargetBlank: buttonTargetBlank
                                    }, EMPTY_CHILDREN),
                                    getNewParagraph(), 
                                ];
                                index_es/* Transforms.insertNodes */.YR.insertNodes(editor, customButton);
                                toggle();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                toggle();
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
                            iconName: ICON_CUSTOM_BUTTON
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/MarkButton.js






var MarkButton = function(param) {
    var format = param.format, icon = param.icon;
    var editor = useSlate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
        active: isMarkActive(editor, format),
        onMouseDown: function(event) {
            event.preventDefault();
            toggleMark(editor, format);
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
            iconName: icon
        })
    });
};
/* harmony default export */ var toolbar_MarkButton = (MarkButton);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/InsertDividerButton.js








function InsertDividerButton() {
    var editor = useSlate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
        onMouseDown: function(event) {
            event.preventDefault();
            // check for left click
            if (event.button === 0) {
                var divider = [
                    (0,src_object_spread/* default */.Z)({
                        type: ELEMENT_DIVIDER
                    }, EMPTY_CHILDREN),
                    getNewParagraph(), 
                ];
                index_es/* Transforms.insertNodes */.YR.insertNodes(editor, divider);
            }
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
            iconName: ICON_INSERT_DIVIDER
        })
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/SimplecastInput.js






function SimplecastInput_SimplecastInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 200
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount_FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: "",
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                ref: innerRef,
                                value: value,
                                placeholder: "What's the embed code?",
                                spellCheck: false,
                                css: {
                                    width: "100%",
                                    height: "100%",
                                    padding: 10,
                                    color: palette/* text */.fL,
                                    backgroundColor: "transparent",
                                    border: "none",
                                    outline: "none",
                                    "&::placeholder": {
                                        color: palette/* sealBlue */.N9
                                    }
                                },
                                onChange: function(event) {
                                    return set(event.target.value);
                                },
                                onKeyDown: inputs_SimplecastInput_handleKeyDown(value, onInsert, onCancel),
                                onMouseDown: function(event) {
                                    return event.preventDefault();
                                }
                            })
                        });
                    }
                });
            }
        })
    });
};
SimplecastInput_SimplecastInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};
function inputs_SimplecastInput_handleKeyDown(value, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && value) {
            event.preventDefault();
            var parser = new DOMParser();
            var code = parser.parseFromString(value, "text/html");
            var iframe = code.querySelector("iframe");
            if (!iframe) {
                return;
            }
            var iframeSrc = iframe.getAttribute("src");
            if (!iframeSrc.includes("player.simplecast.com")) {
                return;
            }
            onInsert({
                src: iframeSrc,
                height: parseFloat(iframe.getAttribute("height")) || 200
            });
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/InsertSimplecastButton.js











function InsertSimplecastButton() {
    var editor = useSlate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimplecastInput_SimplecastInput, {
                            onInsert: function(param) {
                                var src = param.src, height = param.height;
                                var simplecastEmbed = (0,src_object_spread/* default */.Z)({
                                    type: ELEMENT_SIMPLECAST,
                                    src: src,
                                    height: height
                                }, EMPTY_CHILDREN);
                                setOrInsertElement(editor, simplecastEmbed);
                                toggle();
                            },
                            onCancel: function() {
                                return toggle();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                toggle();
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
                            iconName: ICON_SIMPLECAST
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/InsertSocialMediasButton.js











function InsertSocialMediasButton() {
    var editor = useSlate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediasInput, {
                            onInsert: function(param) {
                                var socialMedias = param.socialMedias;
                                var socialMediasElement = (0,src_object_spread/* default */.Z)({
                                    type: ELEMENT_SOCIAL_MEDIAS,
                                    socialMedias: socialMedias
                                }, EMPTY_CHILDREN);
                                setOrInsertElement(editor, socialMediasElement);
                                toggle();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                toggle();
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
                            iconName: ICON_SOCIAL_MEDIAS
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/LinkInput.js






/**
 * @param   {String}   currentValue
 * @param   {Function} onInsert
 * @param   {Function} onCancel
 * @returns {Function}
 */ function LinkInput_handleKeyDown(currentValue, onInsert, onCancel) {
    return function(event) {
        if (event.key === "Enter" && currentValue) {
            event.preventDefault();
            // TODO: validate properly
            if (/^https?:\/\/(.+)/i.test(currentValue)) {
                onInsert(currentValue);
            }
        }
        if (event.key === "Escape") {
            onCancel();
        }
    };
}
function LinkInput_LinkInput(param) {
    var onInsert = param.onInsert, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: 250
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FocusOnMount_FocusOnMount, {
            nextTick: false,
            children: function(param) {
                var innerRef = param.innerRef;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: "",
                    children: function(param) {
                        var value = param.value, set = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                            ref: innerRef,
                            value: value,
                            placeholder: "What's the URL?",
                            spellCheck: false,
                            css: {
                                width: "100%",
                                height: "100%",
                                padding: 10,
                                color: palette/* text */.fL,
                                backgroundColor: "transparent",
                                border: "none",
                                outline: "none",
                                "&::placeholder": {
                                    color: palette/* sealBlue */.N9
                                }
                            },
                            onChange: function(event) {
                                return set(event.target.value);
                            },
                            onKeyDown: LinkInput_handleKeyDown(value, onInsert, onCancel),
                            onMouseDown: function(event) {
                                return event.preventDefault();
                            }
                        });
                    }
                });
            }
        })
    });
};
LinkInput_LinkInput.propTypes = {
    onInsert: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/ToggleLinkButton.js










function ToggleLinkButton() {
    var editor = useSlate();
    var isLinkActive = isBlockType(editor, ELEMENT_LINK);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkInput_LinkInput, {
                            onInsert: function(url) {
                                insertLink(editor, url);
                                toggle();
                            },
                            onCancel: function() {
                                return toggle();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        active: isLinkActive,
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                if (isLinkActive) {
                                    unwrapLink(editor);
                                } else {
                                    toggle();
                                }
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
                            iconName: ICON_LINK
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/ToolbarLine.js


function ToolbarLine(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
            "& > div": {
                marginRight: "0.5rem"
            }
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/ColorInput.js







function ColorInput(param) {
    var fieldName = param.fieldName, label = param.label, placeholder = param.placeholder, data = param.data, setData = param.setData, required = param.required;
    var ref = (0,react.useState)(false), touched = ref[0], setTouched = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: label
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                        type: "color",
                        value: data[fieldName],
                        onChange: function(e) {
                            setData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, fieldName, e.target.value)));
                            setTouched(true);
                        },
                        css: {
                            height: 30,
                            width: 60,
                            border: "solid 1px",
                            borderColor: getBorderColor(data[fieldName], touched, required)
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                        type: "text",
                        placeholder: placeholder,
                        value: data[fieldName],
                        onChange: function(e) {
                            setData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, fieldName, e.target.value)));
                            setTouched(true);
                        },
                        css: {
                            margin: 0,
                            padding: 8,
                            border: "solid 1px",
                            borderColor: getBorderColor(data[fieldName], touched, required),
                            borderRadius: 2,
                            height: 30,
                            width: 220,
                            marginLeft: 4
                        }
                    })
                ]
            })
        ]
    });
};
function getBorderColor(text, touched, required) {
    if (!required && !touched) {
        return palette/* sealBlue */.N9;
    }
    if (required && touched && !fieldValidation_validateColor(text)) {
        return palette/* red */.Q6;
    }
    return palette/* sealBlue */.N9;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/TextInput.js







function TextInput(param) {
    var fieldName = param.fieldName, label = param.label, placeholder = param.placeholder, data = param.data, setData = param.setData, required = param.required;
    var ref = (0,react.useState)(false), touched = ref[0], setTouched = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: label
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                type: "text",
                name: fieldName,
                placeholder: placeholder,
                value: data[fieldName],
                onChange: function(e) {
                    setData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, fieldName, e.target.value)));
                    if (required) {
                        setTouched(true);
                    }
                },
                css: {
                    margin: 0,
                    padding: 8,
                    border: "solid 1px",
                    borderColor: TextInput_getBorderColor(data[fieldName], touched, required),
                    borderRadius: 2
                }
            })
        ]
    });
};
function TextInput_getBorderColor(text, touched, required) {
    if (!required && !touched) {
        return palette/* sealBlue */.N9;
    }
    if (required && touched && !fieldValidation_validateText(text)) {
        return palette/* red */.Q6;
    }
    return palette/* sealBlue */.N9;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/NumberInput.js







function NumberInput(param) {
    var fieldName = param.fieldName, label = param.label, placeholder = param.placeholder, data = param.data, setData = param.setData, minValue = param.minValue, maxValue = param.maxValue;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: label
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                type: "number",
                name: fieldName,
                placeholder: placeholder,
                value: data[fieldName],
                onChange: function(e) {
                    setData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, fieldName, e.target.value)));
                },
                css: {
                    margin: 0,
                    padding: 8,
                    border: "solid 1px",
                    borderColor: fieldValidation_validateButtonWidth(data[fieldName]) ? palette/* sealBlue */.N9 : palette/* red */.Q6,
                    borderRadius: 2
                },
                min: minValue || 10,
                max: maxValue || 100
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/inputs/SubscribeBoxInput.js






function SubscribeBoxInput(param) {
    var onInsert = param.onInsert;
    var ref = (0,react.useState)({
        title: "Get productivity tips delivered straight to your inbox",
        titleFontSize: 24,
        description: "We'll email you 1-3 times per week and never share your information",
        descriptionFontSize: 16,
        textBoxWidth: 30,
        buttonText: "Subscribe",
        buttonColor: "#086BE5",
        buttonTextColor: "#FFFFFF",
        buttonBorderColor: "#086BE5",
        buttonWidth: 20
    }), data = ref[0], setData = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: function(event) {
            event.preventDefault();
            event.stopPropagation();
            onInsert(data);
        },
        css: {
            width: 300,
            padding: 8,
            display: "grid",
            gridRowGap: 8
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput, {
                fieldName: "title",
                label: "Title",
                placeholder: "Type title...",
                data: data,
                setData: setData,
                required: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberInput, {
                fieldName: "titleFontSize",
                label: "Title font size",
                data: data,
                setData: setData,
                required: true,
                minValue: 4,
                maxValue: 64
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput, {
                fieldName: "description",
                label: "Description",
                placeholder: "Type description...",
                data: data,
                setData: setData
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberInput, {
                fieldName: "descriptionFontSize",
                label: "Description font size",
                data: data,
                setData: setData,
                required: true,
                minValue: 4,
                maxValue: 64
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput, {
                fieldName: "buttonText",
                label: "Button Text",
                placeholder: "Type button text...",
                data: data,
                setData: setData,
                required: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColorInput, {
                fieldName: "buttonColor",
                label: "Button Color",
                placeholder: "Type button color...",
                data: data,
                setData: setData,
                required: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColorInput, {
                fieldName: "buttonTextColor",
                label: "Button Text Color",
                placeholder: "Type button text color...",
                data: data,
                setData: setData,
                required: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColorInput, {
                fieldName: "buttonBorderColor",
                label: "Button Border Color",
                placeholder: "Type button border color...",
                data: data,
                setData: setData,
                required: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberInput, {
                fieldName: "textBoxWidth",
                label: "Text width %",
                data: data,
                setData: setData,
                required: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberInput, {
                fieldName: "buttonWidth",
                label: "Button width %",
                data: data,
                setData: setData,
                required: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                type: "submit",
                disabled: !SubscribeBoxInput_validateForm(data),
                css: {
                    margin: 0,
                    padding: 8,
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer"
                },
                children: "Insert"
            })
        ]
    });
};
function SubscribeBoxInput_validateForm(data) {
    return fieldValidation_validateText(data.title) && fieldValidation_validateButtonWidth(data.textBoxWidth) && fieldValidation_validateText(data.buttonText) && fieldValidation_validateColor(data.buttonColor) && fieldValidation_validateColor(data.buttonTextColor) && fieldValidation_validateColor(data.buttonBorderColor) && fieldValidation_validateButtonWidth(data.buttonWidth);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/InsertSubscribeButton.js











function InsertSubscribeButton() {
    var editor = useSlate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribeBoxInput, {
                            onInsert: function(embed) {
                                var subscribeEmbed = [
                                    (0,src_object_spread/* default */.Z)({
                                        type: ELEMENT_SUBSCRIBE_BUTTON
                                    }, embed, EMPTY_CHILDREN),
                                    getNewParagraph(), 
                                ];
                                index_es/* Transforms.insertNodes */.YR.insertNodes(editor, subscribeEmbed);
                                toggle();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                toggle();
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
                            iconName: ICON_SUBSCRIBE_BUTTON
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/EditorToolbar.js















function EditorToolbar(param) {
    var extraToolbarIcons = param.extraToolbarIcons;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components_Toolbar, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ToolbarLine, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_MarkButton, {
                        format: "bold",
                        icon: ICON_FORMAT_BOLD
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_MarkButton, {
                        format: "italic",
                        icon: ICON_FORMAT_ITALIC
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_MarkButton, {
                        format: "underline",
                        icon: ICON_FORMAT_UNDERLINE
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "heading-three",
                        icon: ICON_HEADING_THREE
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "heading-four",
                        icon: ICON_HEADING_FOUR
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "block-quote",
                        icon: ICON_FORMAT_QUOTE
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "numbered-list",
                        icon: ICON_FORMAT_LIST_NUMBERED
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "bulleted-list",
                        icon: ICON_FORMAT_LIST_BULLETED
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "left",
                        icon: ICON_FORMAT_ALIGN_LEFT
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "center",
                        icon: ICON_FORMAT_ALIGN_CENTER
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "right",
                        icon: ICON_FORMAT_ALIGN_RIGHT
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(toolbar_BlockButton, {
                        format: "justify",
                        icon: ICON_FORMAT_ALIGN_JUSTIFY
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ToolbarLine, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleLinkButton, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertImageButton, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertDividerButton, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertYoutubeVideoButton, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertSimplecastButton, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertSocialMediasButton, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertCustomButtonButton, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertSubscribeButton, {}),
                    extraToolbarIcons
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/Portal.js

var Portal = function(param) {
    var children = param.children;
    return typeof document === "object" ? /*#__PURE__*/ react_dom.createPortal(children, document.body) : null;
};
/* harmony default export */ var components_Portal = (Portal);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/positionHoverMenu.js
function positionHoverMenu(element) {
    var MIN_LEFT_OFFSET = 10;
    var domSelection = window.getSelection();
    var domRange = domSelection.getRangeAt(0);
    var rect = domRange.getBoundingClientRect();
    var leftOffset = rect.left + window.pageXOffset - element.offsetWidth / 2 + rect.width / 2;
    if (leftOffset < MIN_LEFT_OFFSET) {
        leftOffset = MIN_LEFT_OFFSET;
    }
    element.style.opacity = "1";
    element.style.top = "".concat(rect.top + window.pageYOffset - element.offsetHeight, "px");
    element.style.left = "".concat(leftOffset, "px");
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/utils/getParentNode.js

function getParentNode(editor) {
    var selection = editor.selection;
    if (!selection) {
        return null;
    }
    var parentPath = index_es/* Path.parent */.y$.parent(selection.anchor.path);
    var parentNode = index_es/* Node.get */.NB.get(editor, parentPath);
    return parentNode;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/toolbar/EditImageButton.js












function EditImageButton() {
    var editor = useSlateStatic();
    var parentNode = getParentNode(editor);
    if (!parentNode) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                        isOpen: on,
                        style: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            borderRadius: 4
                        },
                        onRequestClose: function() {
                            return toggle();
                        },
                        appElement: document.body,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageInput_ImageInput, {
                            saveButtonText: "Edit Image",
                            initialValues: {
                                url: parentNode.url,
                                alt: parentNode.alt || "",
                                width: parentNode.width || "",
                                height: parentNode.height || ""
                            },
                            onChange: function(url, alt, width, height) {
                                var image = (0,src_object_spread/* default */.Z)({
                                    type: ELEMENT_IMAGE,
                                    url: url,
                                    alt: alt,
                                    width: width,
                                    height: height
                                }, EMPTY_CHILDREN);
                                index_es/* Transforms.setNodes */.YR.setNodes(editor, image);
                                toggle();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button, {
                        onMouseDown: function(event) {
                            event.preventDefault();
                            // check for left click
                            if (event.button === 0) {
                                toggle();
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Icon, {
                            iconName: ICON_IMAGE_EDIT
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/HoverMenu.js
/* eslint-disable react/display-name */ 




var HoverMenu = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        css: {
            padding: "0.5rem 0.5rem 0.5rem",
            position: "absolute",
            zIndex: 9000,
            top: "-10000px",
            left: "-10000px",
            marginTop: "-0.5rem",
            opacity: 0,
            backgroundColor: "#fff",
            borderRadius: "4px",
            transition: "opacity 0.25s",
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        }
    }, props), {
        children: children
    }));
});
/* harmony default export */ var components_HoverMenu = (HoverMenu);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/components/utils/getSelectionType.js

function getSelectionType(editor) {
    var selection = editor.selection;
    if (!selection) {
        return null;
    }
    var parentPath = index_es/* Path.parent */.y$.parent(selection.anchor.path);
    var parentNode = index_es/* Node.get */.NB.get(editor, parentPath);
    return parentNode.type;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/EditorSelectionHoverToolbar.js











var EditorSelectionHoverToolbar = function() {
    var ref = (0,react.useRef)();
    var editor = useSlate();
    var inFocus = useFocused();
    var selectionType = getSelectionType(editor);
    (0,react.useEffect)(function() {
        var element = ref.current;
        var selection = editor.selection;
        if (!element || !selection) {
            return;
        }
        if ((selectionType === ELEMENT_PARAGRAPH || selectionType === ELEMENT_BULLETED_LIST || selectionType === ELEMENT_NUMBERED_LIST || selectionType === ELEMENT_LIST_ITEM || selectionType === ELEMENT_BLOCK_QUOTE) && (!selection || !inFocus || index_es/* Range.isCollapsed */.e6.isCollapsed(selection) || index_es/* Editor.string */.ML.string(editor, selection) === "" || selection.anchor.path[0] < 1)) {
            element.removeAttribute("style");
            return;
        }
        if (selectionType === ELEMENT_IMAGE) {
            positionHoverMenu(element);
        }
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Portal, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_HoverMenu, {
            ref: ref,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarLine, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditImageButton, {})
            })
        })
    });
/*
  return (
    <Portal>
      <HoverMenu ref={ref}>
        <ToolbarLine>
          {(selectionType === ELEMENT_PARAGRAPH ||
            selectionType === ELEMENT_LIST_ITEM ||
            selectionType === ELEMENT_BULLETED_LIST ||
            selectionType === ELEMENT_NUMBERED_LIST ||
            selectionType === ELEMENT_BLOCK_QUOTE) && (
            <>
              <MarkButton format="bold" icon={ICON_FORMAT_BOLD} />
              <MarkButton format="italic" icon={ICON_FORMAT_ITALIC} />
              <MarkButton format="underline" icon={ICON_FORMAT_UNDERLINE} />
              <BlockButton format="heading-three" icon={ICON_HEADING_THREE} />
              <BlockButton format="heading-four" icon={ICON_HEADING_FOUR} />
              <BlockButton format="block-quote" icon={ICON_FORMAT_QUOTE} />
              <BlockButton format="numbered-list" icon={ICON_FORMAT_LIST_NUMBERED} />
              <BlockButton format="bulleted-list" icon={ICON_FORMAT_LIST_BULLETED} />
              <BlockButton format="left" icon={ICON_FORMAT_ALIGN_LEFT} />
              <BlockButton format="center" icon={ICON_FORMAT_ALIGN_CENTER} />
              <BlockButton format="right" icon={ICON_FORMAT_ALIGN_RIGHT} />
              <BlockButton format="justify" icon={ICON_FORMAT_ALIGN_JUSTIFY} />
              <ToggleLinkButton />
            </>
          )}
          {selectionType === ELEMENT_IMAGE && (
            <>
              <EditImageButton />
              <BlockButton format="left" icon={ICON_FORMAT_ALIGN_LEFT} />
              <BlockButton format="center" icon={ICON_FORMAT_ALIGN_CENTER} />
              <BlockButton format="right" icon={ICON_FORMAT_ALIGN_RIGHT} />
            </>
          )}
        </ToolbarLine>
      </HoverMenu>
    </Portal>
  );
  */ };
/* harmony default export */ var slate_EditorSelectionHoverToolbar = (EditorSelectionHoverToolbar);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/src/slate/SlateEditor.js















var SlateEditor_HOTKEYS = {
    "mod+b": "bold",
    "mod+i": "italic",
    "mod+u": "underline",
    "mod+`": "code"
};
function getEditorStyle(readOnly, maxContentHeight) {
    if (readOnly) {
        return {
            height: "100%"
        };
    }
    return {
        maxHeight: maxContentHeight || 600,
        overflowY: "auto",
        height: "100%"
    };
}
function SlateEditor(param) {
    var value = param.value, onChange = param.onChange, readOnly = param.readOnly, placeholder = param.placeholder, minContentHeight = param.minContentHeight, maxContentHeight = param.maxContentHeight, containerStyle = param.containerStyle, extraToolbarIcons = param.extraToolbarIcons, onEmailSubscribe = param.onEmailSubscribe;
    var renderElement = (0,react.useCallback)(function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Element_Element, (0,src_object_spread/* default */.Z)({
            onEmailSubscribe: onEmailSubscribe
        }, props));
    }, []);
    var renderLeaf = (0,react.useCallback)(function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(slate_Leaf, (0,src_object_spread/* default */.Z)({}, props));
    }, []);
    var editor = (0,react.useMemo)(function() {
        return withCorrectVoidBehaviour(slate_withHtml(withHistory(withReact((0,index_es/* createEditor */.Jh)()))));
    }, []);
    var slateEditorValue = validateEditorInputValue(value) ? value : [
        getNewParagraph()
    ];
    // TODO:
    // value prop gets used only once when the editor initializes
    // so if we change it from external source (say we embed a govlaunch story from the admin)
    // nothing is going to happen, so we need to mutate editor.children
    editor.children = slateEditorValue;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (0,src_object_spread/* default */.Z)({
            width: "100%",
            height: "100%"
        }, containerStyle),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
            children: function(isMobile) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Slate, {
                    editor: editor,
                    value: slateEditorValue,
                    onChange: function(value) {
                        return onChange(value);
                    },
                    readOnly: readOnly,
                    children: [
                        !readOnly && !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(slate_EditorSelectionHoverToolbar, {}),
                        !readOnly && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorToolbar, {
                            extraToolbarIcons: extraToolbarIcons
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                minHeight: minContentHeight
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Editable, {
                                renderElement: renderElement,
                                renderLeaf: renderLeaf,
                                placeholder: placeholder || "Type something or insert an element from the toolbar...",
                                readOnly: readOnly,
                                spellCheck: false,
                                autoFocus: true,
                                onKeyDown: function(event) {
                                    if (readOnly) {
                                        return;
                                    }
                                    // eslint-disable-next-line no-unused-vars
                                    for(var hotkey in SlateEditor_HOTKEYS){
                                        if ((0,lib/* default */.ZP)(hotkey, event)) {
                                            event.preventDefault();
                                            var mark = SlateEditor_HOTKEYS[hotkey];
                                            toggleMark(editor, mark);
                                        }
                                    }
                                },
                                style: getEditorStyle(readOnly, maxContentHeight)
                            })
                        })
                    ]
                });
            }
        })
    });
};
function validateEditorInputValue(value) {
    if (!value || !Array.isArray(value) || value.length === 0) {
        return false;
    }
    for(var i = 0; i < value.length; i++){
        var node = value[i];
        if (typeof node.type === "undefined" || !node.type) {
            return false;
        }
        if (typeof node.children === "undefined" || !node.children || !Array.isArray(node.children)) {
            return false;
        }
    //TODO: figure out how to recursively validate children object structure
    }
    return true;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+editor@3.0.10_jlxgchltuxfiobzx3yzzl7ypqe/node_modules/@govlaunch/editor/index.js







/***/ }),

/***/ 21241:
/***/ (function(module) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),

/***/ 56644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _PlayerStates = __webpack_require__(69000);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),

/***/ 78868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _debug = __webpack_require__(27185);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(38078);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(2732);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(56644);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports["default"] = YouTubePlayer;
module.exports = exports['default'];

/***/ }),

/***/ 69000:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),

/***/ 2732:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports["default"] = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),

/***/ 38078:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports["default"] = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),

/***/ 70905:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(21241);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(32425);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(78868);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports["default"] = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),

/***/ 32425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _loadScript = __webpack_require__(27499);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),

/***/ 36846:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P2": function() { return /* binding */ ln; },
/* harmony export */   "Uy": function() { return /* binding */ fn; },
/* harmony export */   "_x": function() { return /* binding */ dn; },
/* harmony export */   "mv": function() { return /* binding */ r; }
/* harmony export */ });
/* unused harmony exports Immer, applyPatches, castDraft, castImmutable, current, enableAllPlugins, enableES5, enableMapSet, enablePatches, freeze, immerable, isDraftable, nothing, original, produceWithPatches, setAutoFreeze, setUseProxies */
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?(n.delete(r),n.add(t)):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0),n)}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function O(n){g(n),n.p.forEach(S),n.p=null}function g(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.O=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.g||b("ES5").S(e,r,o),o?(i[Q].P&&(O(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(r,i){return A(n,e,o,r,i,t)})),x(n,o,!1),t&&n.u&&b("Patches").R(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s){if( false&&0,r(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!r(v))return;e.m=!1}if(t(c)&&!y(c)){if(!e.h.F&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),n.h.F&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function R(n,r,t){var e=s(r)?b("MapSet").N(r,t):v(r)?b("MapSet").T(r,t):n.g?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function D(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=F(r,c),u.I=!1}else e=F(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function F(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function N(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.O&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:i,o:null,O:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.D,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=""+i[s];0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},R:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.D,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.D,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=R(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.O&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,O:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.D.set(n,!0),t.o.set(n,r),t.D.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.D.set(n,!1):r.D.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.D=new Map,i(n.t,(function(r){n.D.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=R(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,O:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{N:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){N(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=R(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.D[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&"number"!=typeof t&&(void 0!==t||r in n.o)||(n.o[r]=t,n.D[r]=!0,!0)},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.D[r]=!1,E(n),k(n)):delete n.D[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.g=B,this.F=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=R(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?O(c):g(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.F&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.F=n},i.setUseProxies=function(r){r&&!B&&n(20),this.g=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (fn)));
//# sourceMappingURL=immer.esm.js.map


/***/ }),

/***/ 33213:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ isPlainObject; }
/* harmony export */ });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}




/***/ })

}]);